import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { _ as _extends } from "@swc/helpers/_/_extends";
import { _ as _object_destructuring_empty } from "@swc/helpers/_/_object_destructuring_empty";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, useEffect, useCallback } from "react";
import { Link, useParams, NavLink, useNavigate } from "react-router-dom";
import Select from "react-select";
import { useDropzone } from "react-dropzone";
import { Container, Row, Col, Badge, Tabs, Tab, Form, Button, Card, CardBody, Collapse, InputGroup, Modal, Stack, Dropdown, DropdownButton, Table, ProgressBar, Alert, Spinner } from "react-bootstrap";
import { Box, LinearProgress } from "@mui/material";
import ButtonMui from "@mui/material/Button";
import { Formik } from "formik";
import * as yup from "yup";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { ReactSearchAutocomplete } from "react-search-autocomplete";
import { NumericFormat } from "react-number-format";
import { Buffer } from "buffer";
import { NumberFormatFloat, NumberFormat, getPrefixName, filterTextAndNum, mapProvinceThToOptions, mapSubDistrictThToOptions, mapDistrictThToOptions, getInfoAdminSystem, mapMstToOptions, formatThaiDate, formatNumber } from "utils/HelperFunction";
import DataTableLayout from "layouts/DatatableLayout";
import DownloadExcel from "utils/DownloadExcel";
import moment from "moment";
import { nanoid } from "nanoid";
import { useAppDispatch, useAppSelector } from "../../redux/store/configureStore";
import { useGlobalModalContext } from "contexts/GlobalModalContext";
import { useGlobalLoaderContext } from "contexts/GlobalLoaderContext";
import { defaultOption } from "constants/ui/options";
import PrintIcon from "@mui/icons-material/Print";
import { deepOrange, green } from "@mui/material/colors";
import Avatar from "@mui/material/Avatar";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import InfoIcon from "@mui/icons-material/Info";
import { StepperLabelWizard } from "layouts/StepperLabelWizard";
import ModalSuccessCustom from "layouts/ModalSuccessCustom";
import { ModalAllder } from "layouts/ModalAllder";
import BillingPdf from "./BillingPdf";
import InvoicePdf from "./InvoicePdf";
import { contractInvoiceData, contractHistoryData } from "mocks/contractData";
import { getAllMstBusiness } from "../../redux/handlers/master/getAllMstBusiness.handler";
import { getAllProvince } from "../../redux/handlers/master/getAllProvince.handler";
import { getAllDistrict } from "../../redux/handlers/master/getAllDistrict.handler";
import { getAllSubDistrict } from "../../redux/handlers/master/getAllSubDistrict.handler";
import { getAllMstBank } from "../../redux/handlers/master/getAllMstBank.handler";
import { getAllMstBrand } from "../../redux/handlers/master/getAllMstBrand.handler";
import { getContractBankById, clearGetContractBankById } from "../../redux/handlers/contract/getContractBankById.handler";
import { getContractProductInfo, clearGetContractProductInfo } from "../../redux/handlers/contract/getContractProductInfo.handler";
import { getAllBranchByPosition } from "../../redux/handlers/contract/getAllBranchByPosition.handler";
import { getAllBranchByAdPoint } from "../../redux/handlers/contract/getAllBranchByAdPoint.handler";
import { createContractNew, clearCreateContractNew } from "../../redux/handlers/contract/createContractNew.handler";
import { updateContract, clearUpdateContract } from "../../redux/handlers/contract/updateContract.handler";
import { getContractById, clearGetContractById } from "../../redux/handlers/contract/getContractById.handler";
import { getContractProductById, clearGetContractProductById } from "../../redux/handlers/contract/getContractProductById.handler";
import { getContractPlacementById, clearGetContractPlacementById } from "../../redux/handlers/contract/getContractPlacementById.handler";
import { getContractAdsById, clearGetContractAdsById } from "../../redux/handlers/contract/getContractAdsById.handler";
import { updateContractStatus, clearUpdateContractStatus } from "../../redux/handlers/contract/updateContractStatus.handler";
import { uploadContractFileDoc, clearUploadContractFileDoc } from "../../redux/handlers/contract/uploadContractFileDoc.handler";
import { updateApproveFile, clearUpdateApproveFile } from "../../redux/handlers/contract/updateApproveFile.handler";
import { getContractFileById, clearGetContractFileById } from "../../redux/handlers/contract/getContractFileById.handler";
import { updateContractFile, clearUpdateContractFile } from "../../redux/handlers/contract/updateContractFile.handler";
import { getContractBankInfo, clearGetContractBankInfo } from "../../redux/handlers/contract/getContractBankInfo.handler";
import { getContractBillingInfo, clearGetContractBillingInfo } from "../../redux/handlers/contract/getContractBillingInfo.handler";
import { getBillingByID } from "../../redux/handlers/billing/getBillingByID.handler";
import { getInvoiceByID } from "../../redux/handlers/invoice/getInvoiceByID.handler";
import DownloadFile from "utils/DownloadFile";
import { Page, Text, View, Document, StyleSheet, Font, Image, pdf, PDFDownloadLink } from "@react-pdf/renderer";
import { saveAs } from "file-saver";
import thsarabun from "fonts/THSarabunNew.ttf";
import thsarabunBold from "fonts/THSarabunNewBold.ttf";
Font.register({
    family: "THSarabun",
    fonts: [
        {
            src: thsarabun
        },
        {
            src: thsarabunBold,
            fontWeight: "bold"
        }
    ]
});
export function ContractNewCreate() {
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var _useState = _sliced_to_array(useState({
        ct_contract_paytype: 1,
        ct_contract_initialcosttype: 1,
        ct_contract_placementtype: 1,
        ct_contract_adverttype: 1
    }), 2), formdata = _useState[0], setFormdata = _useState[1];
    var _useState1 = _sliced_to_array(useState("create"), 2), mode = _useState1[0], setMode = _useState1[1];
    var _useState2 = _sliced_to_array(useState(false), 2), formdisabled = _useState2[0], setFormdisabled = _useState2[1];
    var _useState3 = _sliced_to_array(useState(0), 2), businessId = _useState3[0], setBusinessId = _useState3[1];
    var _useState4 = _sliced_to_array(useState(1), 2), activeBt = _useState4[0], setActiveBt = _useState4[1];
    var _useState5 = _sliced_to_array(useState(0), 2), statusCt = _useState5[0], setStatusCt = _useState5[1];
    var _useState6 = _sliced_to_array(useState(0), 2), statusQuot = _useState6[0], setStatusQuot = _useState6[1];
    var _useState7 = _sliced_to_array(useState(""), 2), contractCode = _useState7[0], setContractCode = _useState7[1];
    var _useState8 = _sliced_to_array(useState(false), 2), editDisabled = _useState8[0], setEditDisabled = _useState8[1];
    var _useState9 = _sliced_to_array(useState(false), 2), resetProduct = _useState9[0], setResetProduct = _useState9[1];
    var _useState10 = _sliced_to_array(useState(null), 2), quoteId = _useState10[0], setQuoteId = _useState10[1];
    var _useState11 = _sliced_to_array(useState(""), 2), quoteCode = _useState11[0], setQuoteCode = _useState11[1];
    var contractID = useParams().contractID;
    var _useState12 = _sliced_to_array(useState([]), 2), bankInfoSl = _useState12[0], setBankInfoSl = _useState12[1];
    var _useState13 = _sliced_to_array(useState(false), 2), reloadBank = _useState13[0], setReloadBank = _useState13[1];
    var _useState14 = _sliced_to_array(useState({}), 2), dataPrintNew = _useState14[0], setDataPrintNew = _useState14[1];
    var _useState15 = _sliced_to_array(useState([
        "สร้างสัญญา",
        "รออนุมัติสัญญา",
        "อนุมัติแล้ว",
        "ยืนยันสัญญา",
        "กำลังดำเนินการ",
        "หมดอายุ"
    ]), 2), steps = _useState15[0], setSteps = _useState15[1];
    var schema = yup.object().shape({
        ct_contract_memid: yup.string().required(),
        ct_contract_businessid: yup.string().required(),
        ct_contract_busbankid: yup.string().required(),
        ct_contract_businesstype: yup.string().required(),
        ct_contract_taxid: yup.string().required(),
        ct_contract_categoryid: yup.string().required(),
        ct_contract_comprefixid: yup.string().required(),
        ct_contract_comprefixname: yup.string().required(),
        ct_contract_name: yup.string().required(),
        ct_contract_suffixname: yup.string().required(),
        ct_contract_vatcode: yup.string().required(),
        ct_contract_branchname: yup.string().required(),
        ct_contract_prefixid: yup.string().required(),
        ct_contract_fname: yup.string().required(),
        ct_contract_lname: yup.string().required(),
        ct_contract_address: yup.string().required(),
        ct_contract_provinceid: yup.string().required(),
        ct_contract_subprovinceid: yup.string().required(),
        ct_contract_districtid: yup.string().required(),
        ct_contract_zipcodeid: yup.string().required(),
        ct_contract_mainfname: yup.string().required(),
        ct_contract_mainlname: yup.string().required(),
        ct_contract_mainphone: yup.string().required(),
        ct_contract_mainemail: yup.string().required(),
        ct_contract_brandid: yup.string().required(),
        ct_contract_branchn: yup.string().required(),
        ct_contract_accountname: yup.string().required(),
        ct_contract_accountno: yup.string().required(),
        ct_contract_duration: yup.string().required(),
        ct_contract_startdate: yup.string().required(),
        ct_contract_enddate: yup.string().required(),
        //ct_contract_initialcoststatus: yup.string().required(),
        ct_contract_initialcosttype: yup.string().required(),
        //ct_contract_initialcostsku: yup.string().required(),
        ct_contract_pdinitalcost: yup.string().required(),
        ct_contract_pddiscount: yup.string().required(),
        ct_contract_pdtax: yup.string().required(),
        ct_contract_pdpretax: yup.string().required(),
        ct_contract_pdnet: yup.string().required(),
        ct_contract_paytype: yup.string().required(),
        //ct_contract_placementstatus: yup.string().required(),
        ct_contract_placementtype: yup.string().required(),
        //ct_contract_placementsku: yup.string().required(),
        ct_contract_plmmonth: yup.string().required(),
        ct_contract_plmcost: yup.string().required(),
        ct_contract_plmtax: yup.string().required(),
        ct_contract_plmpretax: yup.string().required(),
        //ct_contract_advertstatus: yup.string().required(),
        ct_contract_adverttype: yup.string().required(),
        //ct_contract_advertsku: yup.string().required(),
        ct_contract_adost: yup.string().required(),
        ct_contract_addiscount: yup.string().required(),
        ct_contract_adtax: yup.string().required(),
        ct_contract_adpretax: yup.string().required(),
        ct_contract_adnet: yup.string().required(),
        ct_contract_salescomm: yup.string().required(),
        ct_contract_wholesalescomm: yup.string().required(),
        //ct_contract_additional: yup.string().required(),
        ct_contract_status: yup.string().required(),
        //ct_contract_approveid: yup.string().required(),
        //ct_contract_approvedate: yup.string().required(),
        ct_contract_totallist: yup.string().required()
    });
    var getContractByIdReducer = useAppSelector(function(state) {
        return state.getContractByIdReducer;
    });
    var getContractBankInfoReducer = useAppSelector(function(state) {
        return state.getContractBankInfoReducer;
    });
    var getData = function() {
        if (contractID && contractID > 0) {
            dispatch(getContractById({
                contractid: parseInt(contractID, 10)
            }, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
            dispatch(getContractBankInfo({
                contractid: parseInt(contractID, 10)
            }, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
            setMode("updated");
            setEditDisabled(true);
        }
    };
    useEffect(function() {
        setIsLoading(getContractByIdReducer.isFetching || getContractBankInfoReducer.isFetching);
        if (getContractByIdReducer.data && !getContractByIdReducer.isError) {
            var datas = getContractByIdReducer.data.data;
            if (!datas) {
                return navigate("/404", {
                    replace: true
                });
            }
            var dataWithReplacements = Object.entries(datas).reduce(function(acc, param) {
                var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
                acc[key] = value === null ? "" : value;
                return acc;
            }, {});
            if (dataWithReplacements && dataWithReplacements[0]) {
                setFormdata(dataWithReplacements[0]);
                setDataPrintNew(function(prev) {
                    return _object_spread_props(_object_spread({}, prev), {
                        formData: dataWithReplacements[0]
                    });
                });
            } else if (dataWithReplacements) {
                setFormdata(dataWithReplacements);
                setDataPrintNew(function(prev) {
                    return _object_spread_props(_object_spread({}, prev), {
                        formData: dataWithReplacements
                    });
                });
            }
        }
        if (getContractBankInfoReducer.data && !getContractBankInfoReducer.isError) {
            var dataBankSl = getContractBankInfoReducer.data.data;
            setBankInfoSl(dataBankSl.map(function(item) {
                return _object_spread({}, item);
            }));
            setDataPrintNew(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    ctBank: dataBankSl && dataBankSl.length > 0 ? dataBankSl : []
                });
            });
            setReloadBank(true);
        }
    }, [
        getContractByIdReducer,
        getContractBankInfoReducer
    ]);
    useEffect(function() {
        if (contractID) {
            getData();
        }
    }, [
        contractID
    ]);
    useEffect(function() {
        if (!formdata) return;
        if (formdata && formdata != "" && formdata != null) {
            setBusinessId(formdata.ct_contract_businessid && formdata.ct_contract_businessid > 0 ? parseInt(formdata.ct_contract_businessid, 10) : 0);
            if (formdata.ct_contract_status && formdata.ct_contract_status > 0) {
                if (formdata.ct_contract_status == 8) {
                    setActiveBt(6);
                } else if (formdata.ct_contract_status == 7) {
                    setActiveBt(5);
                } else if (formdata.ct_contract_status == 6) {
                    setActiveBt(4);
                } else if (formdata.ct_contract_status == 4) {
                    setActiveBt(3);
                } else if (formdata.ct_contract_status == 5) {
                    setActiveBt(parseInt(4, 10));
                    setSteps([
                        "สร้างสัญญา",
                        "รออนุมัติสัญญา",
                        "อนุมัติแล้ว",
                        "ยกเลิกเอกสาร",
                        "กำลังดำเนินการ",
                        "หมดอายุ"
                    ]);
                } else if (formdata.ct_contract_status <= 3) {
                    setActiveBt(parseInt(formdata.ct_contract_status, 10));
                } else {
                    setActiveBt(0);
                }
                setStatusCt(parseInt(formdata.ct_contract_status, 10));
            }
            if (formdata.ct_contract_code && formdata.ct_contract_code != "" && formdata.ct_contract_code != null) {
                setContractCode(formdata.ct_contract_code);
            }
        }
        var quoteSt = formdata === null || formdata === void 0 ? void 0 : formdata.ct_contract_statusquotation;
        var isValid = quoteSt && quoteSt > 0;
        if (isValid && quoteSt !== statusQuot) {
            setStatusQuot(quoteSt);
        }
        var quote_id = formdata === null || formdata === void 0 ? void 0 : formdata.qr_quotation_id;
        var isValid_qid = quote_id && quote_id > 0;
        if (isValid_qid && quoteId !== quote_id) {
            setQuoteId(quote_id);
        }
        var quote_code = formdata === null || formdata === void 0 ? void 0 : formdata.qr_quotation_code;
        var isValid_qcode = quote_code && quote_code != "" && quote_code != null;
        if (isValid_qcode && quoteCode !== quote_code) {
            setQuoteCode(quote_code);
        }
        //console.log("formdata : ",formdata);
        if (formdata && formdata != "" && bankInfoSl && bankInfoSl.length > 0 && reloadBank) {
            setFormdata(_object_spread_props(_object_spread({}, formdata), {
                ct_bank: bankInfoSl
            }));
            setReloadBank(false);
        }
    }, [
        formdata,
        bankInfoSl,
        reloadBank
    ]);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx("nav", {
                "aria-label": "breadcrumb",
                className: "mt-2 mb-4",
                children: /*#__PURE__*/ _jsxs("ol", {
                    className: "breadcrumb fs-16 ps-0",
                    children: [
                        /*#__PURE__*/ _jsx("li", {
                            className: "breadcrumb-item ",
                            children: /*#__PURE__*/ _jsx("a", {
                                href: "/manage_contract/new",
                                className: "tc-7  text-decoration-none",
                                children: "จัดการสัญญา"
                            })
                        }),
                        /*#__PURE__*/ _jsxs("li", {
                            className: "breadcrumb-item active tc-1 ",
                            "aria-current": "page",
                            children: [
                                " ",
                                mode && mode == "updated" ? "สัญญาเลขที่ " + contractCode : "สร้างสัญญาใหม่",
                                " "
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "mb-4",
                children: /*#__PURE__*/ _jsx("h3", {
                    className: "h3",
                    children: mode && mode == "updated" ? "สัญญาเลขที่ " + contractCode : "สร้างสัญญา"
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "mb-4",
                children: /*#__PURE__*/ _jsx(StepperLabelWizard, {
                    dataLabel: steps,
                    activeStep: activeBt
                })
            }),
            /*#__PURE__*/ _jsx(DetailPartner, {
                mode: mode,
                partnerData: formdata,
                setPartnerData: setFormdata,
                schema: schema,
                editDisabled: editDisabled,
                setEditDisabled: setEditDisabled,
                businessId: businessId,
                setBusinessId: setBusinessId,
                statusCt: statusCt,
                statusQuot: statusQuot,
                quoteId: quoteId,
                quoteCode: quoteCode,
                resetProduct: resetProduct,
                setResetProduct: setResetProduct
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "mb-4",
                children: /*#__PURE__*/ _jsx(DocTabs, {
                    step: activeBt,
                    role: "admin",
                    mode: mode,
                    formdata: formdata,
                    setFormdata: setFormdata,
                    schema: schema,
                    editDisabled: editDisabled,
                    setEditDisabled: setEditDisabled,
                    activeBt: activeBt,
                    businessId: businessId,
                    statusCt: statusCt,
                    dataPrintNew: dataPrintNew,
                    setDataPrintNew: setDataPrintNew,
                    bankInfoSl: bankInfoSl,
                    resetProduct: resetProduct,
                    setResetProduct: setResetProduct
                })
            })
        ]
    });
}
var DetailPartner = function(_param) {
    var partnerData = _param.partnerData, setPartnerData = _param.setPartnerData, props = _object_without_properties(_param, [
        "partnerData",
        "setPartnerData"
    ]);
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var setIsLoading = useGlobalLoaderContext().setIsLoading;
    var contractID = useParams().contractID;
    var _useState = _sliced_to_array(useState([]), 2), supplierInfos = _useState[0], setSupplierInfos = _useState[1];
    var _useState1 = _sliced_to_array(useState(0), 2), partnerId = _useState1[0], setPartnerId = _useState1[1];
    var accessToken = localStorage.getItem("accessToken");
    var adminInfo = getInfoAdminSystem(accessToken);
    var _useState2 = _sliced_to_array(useState([]), 2), provinceId = _useState2[0], setProvinceId = _useState2[1];
    var _useState3 = _sliced_to_array(useState([]), 2), districtId = _useState3[0], setDistrictId = _useState3[1];
    var _useState4 = _sliced_to_array(useState([]), 2), subDistrictId = _useState4[0], setSubDistrictId = _useState4[1];
    var _useState5 = _sliced_to_array(useState(0), 2), countMonth = _useState5[0], setCountMonth = _useState5[1];
    var _useState6 = _sliced_to_array(useState(""), 2), dateStart = _useState6[0], setDateStart = _useState6[1];
    var _useState7 = _sliced_to_array(useState([]), 2), bankInfos = _useState7[0], setBankInfos = _useState7[1];
    var _useState8 = _sliced_to_array(useState(false), 2), reBankInfo = _useState8[0], setReBankInfo = _useState8[1];
    var _useState9 = _sliced_to_array(useState([]), 2), optionsMstBank = _useState9[0], setOptionsMstBank = _useState9[1];
    var _useState10 = _sliced_to_array(useState([]), 2), optionsMstBrand = _useState10[0], setOptionsMstBrand = _useState10[1];
    var _useState11 = _sliced_to_array(useState([]), 2), selectedBanks = _useState11[0], setSelectedBanks = _useState11[1];
    var _useState12 = _sliced_to_array(useState({
        companyName: "",
        companyBranch: "",
        companyTaxId: "",
        companyAddress: "",
        companyProvince: "",
        companyDistrict: "",
        companySubDistrict: "",
        companyZipCode: "",
        contractName: "",
        contactPhone: "",
        contactEmail: "",
        contactPosition: ""
    }), 2), partnerInfo = _useState12[0], setPartnerInfo = _useState12[1];
    var _useState13 = _sliced_to_array(useState({
        bankAccName: "",
        bankAccNo: "",
        bankBranch: "",
        bankName: ""
    }), 2), bankData = _useState13[0], setBankData = _useState13[1];
    var schema = props.schema ? props.schema : yup.object().shape({});
    var statusCt = props.statusCt ? props.statusCt : 0;
    var statusQuot = props.statusQuot ? props.statusQuot : 0;
    var quoteId = props.quoteId ? props.quoteId : 0;
    var quoteCode = props.quoteCode ? props.quoteCode : "";
    var _useState14 = _sliced_to_array(useState(null), 2), bankChkNum = _useState14[0], setBankChkNum = _useState14[1];
    var _useState15 = _sliced_to_array(useState(null), 2), businessIdLo = _useState15[0], setBusinessIdLo = _useState15[1];
    var _useState16 = _sliced_to_array(useState(0), 2), bussLoad = _useState16[0], setBussLoad = _useState16[1];
    var formatResult = function(item) {
        return /*#__PURE__*/ _jsxs("div", {
            className: "fs-12",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    children: item.bus_business_company
                }),
                /*#__PURE__*/ _jsx("div", {
                    style: {
                        color: "#f26f3a"
                    },
                    children: item.bus_business_taxid
                })
            ]
        }, item.bus_business_id);
    };
    var _useState17 = _sliced_to_array(useState(false), 2), cancelShow = _useState17[0], setCancelShow = _useState17[1];
    var handleCancelShow = function() {
        return setCancelShow(true);
    };
    var handleCancelClose = function() {
        return setCancelShow(false);
    };
    var _useState18 = _sliced_to_array(useState({
        visible: false,
        textsuccess: "",
        direction: ""
    }), 2), modalsuccess = _useState18[0], setModalsuccess = _useState18[1];
    var loadAllMsts = function() {
        dispatch(getAllMstBusiness());
        dispatch(getAllProvince());
        dispatch(getAllMstBank());
        dispatch(getAllMstBrand());
    };
    var getAllMstBusinessReducer = useAppSelector(function(state) {
        return state.getAllMstBusinessReducer;
    });
    var getAllProvinceReducer = useAppSelector(function(state) {
        return state.getAllProvinceReducer;
    });
    var getAllDistrictReducer = useAppSelector(function(state) {
        return state.getAllDistrictReducer;
    });
    var getAllSubDistrictReducer = useAppSelector(function(state) {
        return state.getAllSubDistrictReducer;
    });
    var getContractBankByIdReducer = useAppSelector(function(state) {
        return state.getContractBankByIdReducer;
    });
    var getAllMstBankReducer = useAppSelector(function(state) {
        return state.getAllMstBankReducer;
    });
    var getAllMstBrandReducer = useAppSelector(function(state) {
        return state.getAllMstBrandReducer;
    });
    useEffect(function() {
        setIsLoading(getAllMstBusinessReducer.isFetching || getAllProvinceReducer.isFetching || getAllDistrictReducer.isFetching || getAllSubDistrictReducer.isFetching || getAllMstBankReducer.isFetching || getContractBankByIdReducer.isFetching || getAllMstBrandReducer.isFetching);
        if (getAllProvinceReducer.data) {
            var options = mapProvinceThToOptions(getAllProvinceReducer.data.data);
            setProvinceId(_to_consumable_array(options));
        }
        if (getAllDistrictReducer.data) {
            var options1 = mapDistrictThToOptions(getAllDistrictReducer.data.data);
            setDistrictId(_to_consumable_array(options1));
        }
        if (getAllSubDistrictReducer.data) {
            var options2 = mapSubDistrictThToOptions(getAllSubDistrictReducer.data.data);
            setSubDistrictId(_to_consumable_array(options2));
        }
        if (getAllMstBankReducer.data) {
            var options3 = mapMstToOptions(getAllMstBankReducer.data.data);
            setOptionsMstBank(_to_consumable_array(options3));
        }
        if (getContractBankByIdReducer.data && !getContractBankByIdReducer.isError) {
            var dataBank = getContractBankByIdReducer.data.data;
            setBankInfos(dataBank.map(function(item, index) {
                return _object_spread({}, item);
            }));
        }
        if (getAllMstBusinessReducer.data && !getAllMstBusinessReducer.isError) {
            var datas = getAllMstBusinessReducer.data.data.filter(function(item) {
                return item.bus_business_id !== null && item.bus_business_status == 3;
            });
            if (datas && datas.length > 0) {
                setSupplierInfos(datas.map(function(item, index) {
                    return _object_spread_props(_object_spread({}, item), {
                        bus_business_company: item.bus_business_businesstype === 2 ? filterTextAndNum(item.bus_business_comprefixname) + filterTextAndNum(item.bus_business_name) + filterTextAndNum(item.bus_business_suffixname) : item.bus_business_businesstype === 1 ? getPrefixName(item.bus_business_prefixid) + filterTextAndNum(item.bus_business_fname) + " " + filterTextAndNum(item.bus_business_lname) : "ไม่ระบุชื่อธุรกิจ " + (index + 1)
                    });
                }));
            }
        }
        if (getAllMstBrandReducer.data && !getAllMstBrandReducer.isError) {
            var dataBrandNew = [];
            getAllMstBrandReducer.data.data.map(function(ele) {
                return dataBrandNew.push({
                    label: ele.set_brand_name,
                    value: ele.set_brand_id
                });
            });
            setOptionsMstBrand(dataBrandNew);
        }
    }, [
        getAllMstBusinessReducer,
        getAllProvinceReducer,
        getAllDistrictReducer,
        getAllSubDistrictReducer,
        getContractBankByIdReducer,
        getAllMstBrandReducer
    ]);
    useEffect(function() {
        loadAllMsts();
    }, []);
    useEffect(function() {
        if (contractID && contractID > 0) {
            var infoCompany = supplierInfos.filter(function(item) {
                return item.bus_business_id !== null && item.bus_business_id == partnerData.ct_contract_businessid;
            });
            var infoBankAll = optionsMstBank.filter(function(item) {
                return item.value !== null && item.value == partnerData.ct_contract_bankid;
            });
            // console.log("supplierInfos",supplierInfos);
            // console.log("infoCompany",infoCompany);
            // console.log("infoBankAll",infoBankAll);
            setBusinessIdLo(partnerData.ct_contract_businessid);
            setPartnerInfo(_object_spread_props(_object_spread({}, partnerInfo), {
                companyName: partnerData.ct_contract_businesstype === 2 ? filterTextAndNum(partnerData.ct_contract_comprefixname) + filterTextAndNum(partnerData.ct_contract_name) + filterTextAndNum(partnerData.ct_contract_suffixname) : partnerData.ct_contract_businesstype === 1 ? getPrefixName(partnerData.ct_contract_prefixid) + filterTextAndNum(partnerData.ct_contract_fname) + " " + filterTextAndNum(partnerData.ct_contract_lname) : "ไม่ระบุชื่อธุรกิจ",
                companyBranch: partnerData.ct_contract_branchname && partnerData.ct_contract_branchname != "" && partnerData.ct_contract_branchname != null ? partnerData.ct_contract_branchname : "-",
                companyTaxId: partnerData.ct_contract_taxid && partnerData.ct_contract_taxid != "" && partnerData.ct_contract_taxid != null ? partnerData.ct_contract_taxid : "-",
                contractName: partnerData.ct_contract_mainfname && partnerData.ct_contract_mainfname != "" && partnerData.ct_contract_mainlname != null ? filterTextAndNum(partnerData.ct_contract_mainfname) + " " + filterTextAndNum(partnerData.ct_contract_mainlname) : "-",
                companyAddress: partnerData.ct_contract_address && partnerData.ct_contract_address != "" && partnerData.ct_contract_address != null ? filterTextAndNum("".concat(partnerData.ct_contract_address)) : "",
                companyZipCode: partnerData.ct_contract_zipcodeid && partnerData.ct_contract_zipcodeid != "" && partnerData.ct_contract_zipcodeid != null ? filterTextAndNum("".concat(partnerData.ct_contract_zipcodeid)) : "",
                contactPhone: partnerData.ct_contract_mainphone && partnerData.ct_contract_mainphone != "" && partnerData.ct_contract_mainphone != null ? filterTextAndNum("".concat(partnerData.ct_contract_mainphone)) : "-",
                contactEmail: partnerData.ct_contract_mainemail && partnerData.ct_contract_mainemail != "" && partnerData.ct_contract_mainemail != null ? filterTextAndNum("".concat(partnerData.ct_contract_mainemail)) : "-",
                companyProvince: partnerData.ct_contract_provinceid && partnerData.ct_contract_provinceid != "" && partnerData.ct_contract_provinceid != null ? infoCompany && infoCompany.length > 0 ? JSON.parse(infoCompany[0].Busprovinceid.province_name).th : "" : "",
                companyDistrict: partnerData.ct_contract_subprovinceid && partnerData.ct_contract_subprovinceid != "" && partnerData.ct_contract_subprovinceid != null ? infoCompany && infoCompany.length > 0 ? JSON.parse(infoCompany[0].Bussubprovinceid.district_name).th : "" : "",
                companySubDistrict: partnerData.ct_contract_districtid && partnerData.ct_contract_districtid != "" && partnerData.ct_contract_districtid != null ? infoCompany && infoCompany.length > 0 ? JSON.parse(infoCompany[0].Busdistrictid.subdistrict_name).th : "" : "",
                contactPosition: infoCompany && infoCompany.length > 0 && infoCompany[0].bus_business_mainposition != "" && infoCompany[0].bus_business_mainposition != null ? filterTextAndNum("".concat(infoCompany[0].bus_business_mainposition)) : "-"
            }));
            setBankData(_object_spread_props(_object_spread({}, bankData), {
                bankAccName: partnerData.ct_contract_accountname && partnerData.ct_contract_accountname != "" && partnerData.ct_contract_accountname != null ? filterTextAndNum("".concat(partnerData.ct_contract_accountname)) : "-",
                bankAccNo: partnerData.ct_contract_accountno && partnerData.ct_contract_accountno != "" && partnerData.ct_contract_accountno != null ? filterTextAndNum("".concat(partnerData.ct_contract_accountno)) : "-",
                bankBranch: partnerData.ct_contract_branchn && partnerData.ct_contract_branchn != "" && partnerData.ct_contract_branchn != null ? filterTextAndNum("".concat(partnerData.ct_contract_branchn)) : "-",
                bankName: partnerData.ct_contract_bankid && partnerData.ct_contract_bankid != "" && partnerData.ct_contract_bankid != null ? infoBankAll && infoBankAll.length > 0 ? filterTextAndNum("".concat(infoBankAll[0].label)) : "-" : "-"
            }));
            setPartnerData(_object_spread_props(_object_spread({}, partnerData), {
                userInfo: partnerInfo,
                bankData: bankData,
                mstBank: optionsMstBank
            }));
        }
        if (businessIdLo && businessIdLo > 0 && businessIdLo != bussLoad) {
            setBussLoad(businessIdLo);
            getInfoBusinessById(businessIdLo);
            if (partnerData && partnerData.ct_bank && partnerData.ct_bank.length > 0) {
                setSelectedBanks(partnerData.ct_bank.map(function(item, index) {
                    return {
                        bus_bank_id: item.ct_bank_busbankid,
                        bus_bank_accountno: item.ct_bank_accountno,
                        bus_bank_name: item.ct_bank_name,
                        bus_bank_branchn: item.ct_bank_branchn,
                        bus_bank_bankid: item.ct_bank_bankid,
                        bus_bank_bankname: null
                    };
                }));
            }
        }
    }, [
        partnerData,
        partnerInfo,
        bankData,
        optionsMstBank,
        contractID,
        businessIdLo,
        bussLoad
    ]);
    var getInfoBusinessById = function() {
        var businessId = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
        setBankInfos([]);
        if (businessId && businessId > 0) {
            dispatch(getContractBankById({
                busineesid: parseInt(businessId, 10)
            }, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
        }
    };
    useEffect(function() {
        if (selectedBanks && selectedBanks.length > 0) {
            setPartnerData(_object_spread_props(_object_spread({}, partnerData), {
                ct_bank: selectedBanks
            }));
        } else if ((!selectedBanks || selectedBanks.length <= 0) && selectedBanks.length != bankChkNum) {
            setPartnerData(_object_spread_props(_object_spread({}, partnerData), {
                ct_bank: []
            }));
            setBankChkNum(selectedBanks.length);
        }
    }, [
        selectedBanks,
        bankChkNum
    ]);
    var handleCheckboxChange = function(bank) {
        setSelectedBanks(function(prev) {
            var exists = prev.some(function(item) {
                return item.bus_bank_id === bank.bus_bank_id;
            });
            if (exists) {
                // ถ้ามีอยู่แล้ว → เอาออก
                return prev.filter(function(item) {
                    return item.bus_bank_id !== bank.bus_bank_id;
                });
            } else {
                // ถ้ายังไม่มี → เพิ่มเข้าไป
                return _to_consumable_array(prev).concat([
                    bank
                ]);
            }
        });
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Formik, {
                enableReinitialize: true,
                initialValues: partnerData,
                validationSchema: schema,
                onSubmit: function() {
                    var _ref = _async_to_generator(function(values) {
                        return _ts_generator(this, function(_state) {
                            return [
                                2
                            ];
                        });
                    //await sleep(500);
                    });
                    return function(values) {
                        return _ref.apply(this, arguments);
                    };
                }(),
                children: function(param) {
                    var handleSubmit = param.handleSubmit, handleChange = param.handleChange, touched = param.touched, errors = param.errors, values = param.values, setFieldValue = param.setFieldValue, setValues = param.setValues, isInvalid = param.isInvalid, isValid = param.isValid, resetForm = param.resetForm;
                    return /*#__PURE__*/ _jsx(Form, {
                        noValidate: true,
                        onSubmit: handleSubmit,
                        children: /*#__PURE__*/ _jsx("fieldset", {
                            children: /*#__PURE__*/ _jsx(Card, {
                                className: "card-st-1 mb-4",
                                children: /*#__PURE__*/ _jsxs(CardBody, {
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "fs-16 fw-bold mb-2 tc-5",
                                            children: "ข้อมูลทั่วไป"
                                        }),
                                        /*#__PURE__*/ _jsxs(Row, {
                                            className: "align-items-center",
                                            children: [
                                                /*#__PURE__*/ _jsx(Col, {
                                                    xs: 12,
                                                    md: 6,
                                                    lg: 3,
                                                    xl: 3,
                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                        className: "mb-2 form-st-3 pb-1",
                                                        children: [
                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                className: "mb-1",
                                                                style: {
                                                                    zIndex: 11
                                                                },
                                                                children: "ลูกค้า"
                                                            }),
                                                            statusCt && statusCt > 1 && props.editDisabled ? /*#__PURE__*/ _jsx(Form.Control, {
                                                                type: "text",
                                                                name: "ct_contract_name",
                                                                placeholder: "",
                                                                value: values.ct_contract_businesstype === 2 ? filterTextAndNum(values.ct_contract_comprefixname) + filterTextAndNum(values.ct_contract_name) + filterTextAndNum(values.ct_contract_suffixname) : values.ct_contract_businesstype === 1 ? getPrefixName(values.ct_contract_prefixid) + filterTextAndNum(values.ct_contract_fname) + " " + filterTextAndNum(values.ct_contract_lname) : "ไม่ระบุชื่อธุรกิจ",
                                                                onChange: function(e) {},
                                                                isValid: touched.ct_contract_name && !errors.ct_contract_name,
                                                                isInvalid: !!errors.ct_contract_name,
                                                                disabled: true,
                                                                readOnly: true
                                                            }) : /*#__PURE__*/ _jsx(ReactSearchAutocomplete, {
                                                                items: supplierInfos,
                                                                placeholder: "กรุณากรอกชื่อลูกค้า",
                                                                onSelect: function(item) {
                                                                    setValues(_object_spread_props(_object_spread({}, values), {
                                                                        ct_contract_memid: item.bus_business_memid ? item.bus_business_memid : values.ct_contract_memid,
                                                                        ct_contract_businessid: item.bus_business_id ? item.bus_business_id : values.ct_contract_businessid,
                                                                        ct_contract_businesstype: item.bus_business_businesstype ? item.bus_business_businesstype : values.ct_contract_businesstype,
                                                                        ct_contract_taxid: item.bus_business_taxid ? item.bus_business_taxid : values.ct_contract_taxid,
                                                                        ct_contract_categoryid: item.bus_business_categoryid ? item.bus_business_categoryid : values.ct_contract_categoryid,
                                                                        ct_contract_comprefixname: item.bus_business_comprefixname ? item.bus_business_comprefixname : values.ct_contract_comprefixname,
                                                                        ct_contract_name: item.bus_business_name ? item.bus_business_name : values.ct_contract_name,
                                                                        ct_contract_suffixname: item.bus_business_suffixname ? item.bus_business_suffixname : values.ct_contract_suffixname,
                                                                        ct_contract_vatcode: item.bus_business_vatcode ? item.bus_business_vatcode : values.ct_contract_vatcode,
                                                                        ct_contract_branchname: item.bus_business_branchname ? item.bus_business_branchname : values.ct_contract_branchname,
                                                                        ct_contract_prefixid: item.bus_business_prefixid ? item.bus_business_prefixid : values.ct_contract_prefixid,
                                                                        ct_contract_fname: item.bus_business_fname ? item.bus_business_fname : values.ct_contract_fname,
                                                                        ct_contract_lname: item.bus_business_lname ? item.bus_business_lname : values.ct_contract_lname,
                                                                        ct_contract_address: item.bus_business_address ? item.bus_business_address : values.ct_contract_address,
                                                                        ct_contract_provinceid: item.bus_business_provinceid ? item.bus_business_provinceid : values.ct_contract_provinceid,
                                                                        ct_contract_subprovinceid: item.bus_business_subprovinceid ? item.bus_business_subprovinceid : values.ct_contract_subprovinceid,
                                                                        ct_contract_districtid: item.bus_business_districtid ? item.bus_business_districtid : values.ct_contract_districtid,
                                                                        ct_contract_zipcodeid: item.bus_business_zipcodeid ? item.bus_business_zipcodeid : values.ct_contract_zipcodeid,
                                                                        ct_contract_mainfname: item.bus_business_mainfname ? item.bus_business_mainfname : values.ct_contract_mainfname,
                                                                        ct_contract_mainlname: item.bus_business_mainlname ? item.bus_business_mainlname : values.ct_contract_mainlname,
                                                                        ct_contract_mainphone: item.bus_business_mainphone ? item.bus_business_mainphone : values.ct_contract_mainphone,
                                                                        ct_contract_mainemail: item.bus_business_mainemail ? item.bus_business_mainemail : values.ct_contract_mainemail
                                                                    }));
                                                                    setPartnerId(item.bus_business_id);
                                                                    props.setBusinessId(item.bus_business_id);
                                                                    getInfoBusinessById(item.bus_business_id);
                                                                    setPartnerData(_object_spread_props(_object_spread({}, partnerData), {
                                                                        ct_contract_memid: item.bus_business_memid ? item.bus_business_memid : values.ct_contract_memid,
                                                                        ct_contract_businessid: item.bus_business_id ? item.bus_business_id : values.ct_contract_businessid,
                                                                        ct_contract_businesstype: item.bus_business_businesstype ? item.bus_business_businesstype : values.ct_contract_businesstype,
                                                                        ct_contract_taxid: item.bus_business_taxid ? item.bus_business_taxid : values.ct_contract_taxid,
                                                                        ct_contract_comprefixid: item.bus_business_comprefixid ? item.bus_business_comprefixid : values.ct_contract_comprefixid,
                                                                        ct_contract_categoryid: item.bus_business_categoryid ? item.bus_business_categoryid : values.ct_contract_categoryid,
                                                                        ct_contract_comprefixname: item.bus_business_comprefixname ? item.bus_business_comprefixname : values.ct_contract_comprefixname,
                                                                        ct_contract_name: item.bus_business_name ? item.bus_business_name : values.ct_contract_name,
                                                                        //ct_contract_name: item.bus_business_company ? item.bus_business_company : values.ct_contract_name,
                                                                        ct_contract_suffixname: item.bus_business_suffixname ? item.bus_business_suffixname : values.ct_contract_suffixname,
                                                                        ct_contract_vatcode: item.bus_business_vatcode ? item.bus_business_vatcode : values.ct_contract_vatcode,
                                                                        ct_contract_branchname: item.bus_business_branchname ? item.bus_business_branchname : values.ct_contract_branchname,
                                                                        ct_contract_prefixid: item.bus_business_prefixid ? item.bus_business_prefixid : values.ct_contract_prefixid,
                                                                        ct_contract_fname: item.bus_business_fname ? item.bus_business_fname : values.ct_contract_fname,
                                                                        ct_contract_lname: item.bus_business_lname ? item.bus_business_lname : values.ct_contract_lname,
                                                                        ct_contract_address: item.bus_business_address ? item.bus_business_address : values.ct_contract_address,
                                                                        ct_contract_provinceid: item.bus_business_provinceid ? item.bus_business_provinceid : values.ct_contract_provinceid,
                                                                        ct_contract_subprovinceid: item.bus_business_subprovinceid ? item.bus_business_subprovinceid : values.ct_contract_subprovinceid,
                                                                        ct_contract_districtid: item.bus_business_districtid ? item.bus_business_districtid : values.ct_contract_districtid,
                                                                        ct_contract_zipcodeid: item.bus_business_zipcodeid ? item.bus_business_zipcodeid : values.ct_contract_zipcodeid,
                                                                        ct_contract_mainfname: item.bus_business_mainfname ? item.bus_business_mainfname : values.ct_contract_mainfname,
                                                                        ct_contract_mainlname: item.bus_business_mainlname ? item.bus_business_mainlname : values.ct_contract_mainlname,
                                                                        ct_contract_mainphone: item.bus_business_mainphone ? item.bus_business_mainphone : values.ct_contract_mainphone,
                                                                        ct_contract_mainemail: item.bus_business_mainemail ? item.bus_business_mainemail : values.ct_contract_mainemail
                                                                    }));
                                                                    props.setResetProduct(true);
                                                                    // getAddressThai(
                                                                    //   item.bus_business_provinceid, 
                                                                    //   item.bus_business_subprovinceid, 
                                                                    //   item.bus_business_districtid
                                                                    // );
                                                                    // setProvinceIdS(item.bus_business_provinceid);
                                                                    // setDistrictIdS(item.bus_business_subprovinceid);
                                                                    // setSubDistrictIdS(item.bus_business_districtid);
                                                                    setPartnerInfo(_object_spread_props(_object_spread({}, partnerInfo), {
                                                                        companyName: item.bus_business_company,
                                                                        companyBranch: item.bus_business_branchname && item.bus_business_branchname != "" && item.bus_business_branchname != null ? item.bus_business_branchname : "-",
                                                                        companyTaxId: item.bus_business_taxid && item.bus_business_taxid != "" && item.bus_business_taxid != null ? item.bus_business_taxid : "-",
                                                                        contractName: item.bus_business_mainfname && item.bus_business_mainfname != "" && item.bus_business_mainlname != null ? filterTextAndNum(item.bus_business_mainfname) + " " + filterTextAndNum(item.bus_business_mainlname) : "-",
                                                                        companyAddress: item.bus_business_address && item.bus_business_address != "" && item.bus_business_address != null ? filterTextAndNum("".concat(item.bus_business_address)) : "",
                                                                        companyProvince: item.bus_business_provinceid && item.bus_business_provinceid != "" && item.bus_business_provinceid != null ? JSON.parse(item.Busprovinceid.province_name).th : "",
                                                                        companyDistrict: item.bus_business_subprovinceid && item.bus_business_subprovinceid != "" && item.bus_business_subprovinceid != null ? JSON.parse(item.Bussubprovinceid.district_name).th : "",
                                                                        companySubDistrict: item.bus_business_districtid && item.bus_business_districtid != "" && item.bus_business_districtid != null ? JSON.parse(item.Busdistrictid.subdistrict_name).th : "",
                                                                        companyZipCode: item.bus_business_zipcodeid && item.bus_business_zipcodeid != "" && item.bus_business_zipcodeid != null ? filterTextAndNum("".concat(item.bus_business_zipcodeid)) : "",
                                                                        contactPhone: item.bus_business_mainphone && item.bus_business_mainphone != "" && item.bus_business_mainphone != null ? filterTextAndNum("".concat(item.bus_business_mainphone)) : "-",
                                                                        contactEmail: item.bus_business_mainemail && item.bus_business_mainemail != "" && item.bus_business_mainemail != null ? filterTextAndNum("".concat(item.bus_business_mainemail)) : "-",
                                                                        contactPosition: item.bus_business_mainposition && item.bus_business_mainposition != "" && item.bus_business_mainposition != null ? filterTextAndNum("".concat(item.bus_business_mainposition)) : "-"
                                                                    }));
                                                                },
                                                                onClear: function() {
                                                                    setFieldValue("ct_contract_businessid", "");
                                                                    setPartnerInfo(_object_spread_props(_object_spread({}, partnerInfo), {
                                                                        companyName: "",
                                                                        companyBranch: "-",
                                                                        companyTaxId: "-",
                                                                        companyAddress: "",
                                                                        companyProvince: "",
                                                                        companyDistrict: "",
                                                                        companySubDistrict: "",
                                                                        companyZipCode: "",
                                                                        contractName: "",
                                                                        contactPhone: "-",
                                                                        contactEmail: "-",
                                                                        contactPosition: "-"
                                                                    }));
                                                                    setPartnerData(_object_spread_props(_object_spread({}, partnerData), {
                                                                        ct_contract_memid: "",
                                                                        ct_contract_businessid: "",
                                                                        ct_contract_businesstype: "",
                                                                        ct_contract_taxid: "",
                                                                        ct_contract_comprefixid: "",
                                                                        ct_contract_categoryid: "",
                                                                        ct_contract_comprefixname: "",
                                                                        ct_contract_name: "",
                                                                        ct_contract_suffixname: "",
                                                                        ct_contract_vatcode: "",
                                                                        ct_contract_branchname: "",
                                                                        ct_contract_prefixid: "",
                                                                        ct_contract_fname: "",
                                                                        ct_contract_lname: "",
                                                                        ct_contract_address: "",
                                                                        ct_contract_provinceid: "",
                                                                        ct_contract_subprovinceid: "",
                                                                        ct_contract_districtid: "",
                                                                        ct_contract_zipcodeid: "",
                                                                        ct_contract_mainfname: "",
                                                                        ct_contract_mainlname: "",
                                                                        ct_contract_mainphone: "",
                                                                        ct_contract_mainemail: ""
                                                                    }));
                                                                    props.setBusinessId(null);
                                                                    props.setResetProduct(true);
                                                                },
                                                                autoFocus: true,
                                                                formatResult: formatResult,
                                                                fuseOptions: {
                                                                    keys: [
                                                                        "bus_business_company",
                                                                        "bus_business_taxid"
                                                                    ]
                                                                },
                                                                resultStringKeyName: "bus_business_company",
                                                                styling: {
                                                                    height: "50px",
                                                                    borderRadius: "10px",
                                                                    boxShadow: "none",
                                                                    zIndex: 10,
                                                                    border: !values.ct_contract_id ? "1px solid #dc3545" : "1px solid rgb(223, 225, 229)"
                                                                },
                                                                showIcon: false,
                                                                className: "scrollSearchAutocomplete"
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ _jsx(Col, {
                                                    xs: 12,
                                                    md: 6,
                                                    lg: 3,
                                                    xl: 3,
                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                        className: "mb-2 form-st-3 pb-1",
                                                        children: [
                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                className: "mb-1",
                                                                children: "แบรนด์"
                                                            }),
                                                            /*#__PURE__*/ _jsx(Select, {
                                                                options: optionsMstBrand,
                                                                onChange: function(selected) {
                                                                    setValues(_object_spread_props(_object_spread({}, values), {
                                                                        ct_contract_brandid: selected ? selected.value : ""
                                                                    }));
                                                                    setPartnerData(_object_spread_props(_object_spread({}, partnerData), {
                                                                        ct_contract_brandid: selected ? selected.value : ""
                                                                    }));
                                                                },
                                                                value: optionsMstBrand.find(function(option) {
                                                                    return option.value === values.ct_contract_brandid;
                                                                }) || null,
                                                                isClearable: true,
                                                                placeholder: "กรุณาเลือกแบรนด์",
                                                                className: "w-100 select-st-1",
                                                                styles: {
                                                                    control: function(base) {
                                                                        return _object_spread_props(_object_spread({}, base), {
                                                                            border: !values.ct_contract_brandid ? "1px solid #dc3545" : "1px solid rgb(223, 225, 229)"
                                                                        });
                                                                    }
                                                                },
                                                                isDisabled: statusCt && statusCt > 1 && props.editDisabled ? true : false
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ _jsx(Col, {
                                                    xs: 12,
                                                    md: 6,
                                                    lg: 3,
                                                    xl: 3,
                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                        className: "mb-2 form-st-3 pb-1",
                                                        children: [
                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                className: "mb-1",
                                                                children: "เลขที่สัญญา"
                                                            }),
                                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                                type: "text",
                                                                name: "ct_contract_code",
                                                                placeholder: "กรุณากรอกเลขที่สัญญา",
                                                                value: values.ct_contract_code && values.ct_contract_code != "" && values.ct_contract_code != null ? values.ct_contract_code : "-",
                                                                onChange: function(e) {
                                                                    setFieldValue("ct_contract_code", e.target.value);
                                                                    setPartnerData(_object_spread_props(_object_spread({}, partnerData), {
                                                                        ct_contract_code: e.target.value
                                                                    }));
                                                                },
                                                                isValid: touched.ct_contract_code && !errors.ct_contract_code,
                                                                isInvalid: !!errors.ct_contract_code,
                                                                disabled: true,
                                                                readOnly: true
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ _jsx(Col, {
                                                    xs: 12,
                                                    md: 6,
                                                    lg: 3,
                                                    xl: 3,
                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                        className: "mb-2 form-st-3 pb-1",
                                                        children: [
                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                className: "mb-1",
                                                                children: "ผู้จัดทำเอกสาร"
                                                            }),
                                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                                type: "text",
                                                                name: "ct_contract_crebyid",
                                                                placeholder: "กรุณากรอกชื่อผู้จัดทำเอกสาร",
                                                                value: values.ct_contract_crebyid && values.ct_contract_crebyid != "" && values.ct_contract_crebyid != null ? values.sys_user_fullname : adminInfo && adminInfo.userId && adminInfo.userId != "" && adminInfo.userId != null ? adminInfo.userFullName : "-",
                                                                onChange: handleChange,
                                                                isValid: touched.ct_contract_crebyid && !errors.ct_contract_crebyid,
                                                                isInvalid: !!errors.ct_contract_crebyid,
                                                                disabled: true,
                                                                readOnly: true
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "fs-16 fw-bold my-3 tc-5",
                                            children: "ข้อมูลลูกค้า"
                                        }),
                                        /*#__PURE__*/ _jsxs(Row, {
                                            className: "",
                                            children: [
                                                /*#__PURE__*/ _jsxs(Col, {
                                                    xs: 12,
                                                    md: 6,
                                                    lg: 4,
                                                    xl: 3,
                                                    children: [
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "fs-18 fw-bold mb-3 tc-1",
                                                            children: "ชื่อลูกค้า"
                                                        }),
                                                        partnerInfo.companyName && partnerInfo.companyName != "" ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ _jsx("p", {
                                                                    className: "fs-18 mb-2",
                                                                    children: partnerInfo.companyName
                                                                }),
                                                                /*#__PURE__*/ _jsxs("p", {
                                                                    className: "fs-18 mb-2",
                                                                    children: [
                                                                        "สาขา : ",
                                                                        partnerInfo.companyBranch
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ _jsxs("p", {
                                                                    className: "fs-18 mb-2",
                                                                    children: [
                                                                        "ทะเบียนนิติบุคคล : ",
                                                                        /*#__PURE__*/ _jsx("span", {
                                                                            className: "tc-5",
                                                                            children: partnerInfo.companyTaxId
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }) : /*#__PURE__*/ _jsx("div", {
                                                            className: "fs-18 mb-2",
                                                            children: "-"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsxs(Col, {
                                                    xs: 12,
                                                    md: 6,
                                                    lg: 4,
                                                    xl: 3,
                                                    children: [
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "fs-18 fw-bold mb-3 tc-1",
                                                            children: "ที่อยู่"
                                                        }),
                                                        partnerInfo.companyAddress && partnerInfo.companyAddress != "" ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ _jsx("p", {
                                                                    className: "fs-18 mb-2",
                                                                    children: partnerInfo.companyAddress
                                                                }),
                                                                /*#__PURE__*/ _jsx("p", {
                                                                    className: "fs-18 mb-2",
                                                                    children: partnerInfo.companySubDistrict + " " + partnerInfo.companyDistrict
                                                                }),
                                                                /*#__PURE__*/ _jsx("p", {
                                                                    className: "fs-18 mb-2",
                                                                    children: partnerInfo.companyProvince + " " + partnerInfo.companyZipCode
                                                                })
                                                            ]
                                                        }) : /*#__PURE__*/ _jsx("div", {
                                                            className: "fs-18 mb-2",
                                                            children: "-"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsxs(Col, {
                                                    xs: 12,
                                                    md: 6,
                                                    lg: 4,
                                                    xl: 3,
                                                    children: [
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "fs-18 fw-bold mb-3 tc-1",
                                                            children: "ข้อมูลผู้ติดต่อ"
                                                        }),
                                                        partnerInfo.contractName && partnerInfo.contractName != "" ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ _jsxs("p", {
                                                                    className: "fs-18 mb-2",
                                                                    children: [
                                                                        "ชื่อ : ",
                                                                        partnerInfo.contractName
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ _jsxs("p", {
                                                                    className: "fs-18 mb-2",
                                                                    children: [
                                                                        "เบอร์โทรศัพท์ : ",
                                                                        partnerInfo.contactPhone
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ _jsxs("p", {
                                                                    className: "fs-18 mb-2",
                                                                    children: [
                                                                        "อีเมล : ",
                                                                        partnerInfo.contactEmail
                                                                    ]
                                                                })
                                                            ]
                                                        }) : /*#__PURE__*/ _jsx("div", {
                                                            className: "fs-18 mb-2",
                                                            children: "-"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "fs-16 fw-bold mb-2 tc-5",
                                            children: "ข้อมูลบัญชี"
                                        }),
                                        /*#__PURE__*/ _jsx(Row, {
                                            children: bankInfos && bankInfos.length > 0 ? bankInfos.map(function(info, index) {
                                                return /*#__PURE__*/ _jsx(Col, {
                                                    xs: 12,
                                                    md: 6,
                                                    lg: 4,
                                                    xl: 3,
                                                    className: "mb-2",
                                                    children: /*#__PURE__*/ _jsxs(Form.Check, {
                                                        type: "checkbox",
                                                        id: "bankInfo-id-".concat(info.bus_bank_id),
                                                        disabled: statusCt && statusCt > 1 && props.editDisabled,
                                                        children: [
                                                            /*#__PURE__*/ _jsx(Form.Check.Input, {
                                                                type: "checkbox",
                                                                checked: selectedBanks.some(function(item) {
                                                                    return item.bus_bank_id === info.bus_bank_id;
                                                                }),
                                                                onChange: function() {
                                                                    return handleCheckboxChange(info);
                                                                },
                                                                disabled: statusCt && statusCt > 1 && props.editDisabled
                                                            }),
                                                            /*#__PURE__*/ _jsx(Form.Check.Label, {
                                                                children: "ชื่อบัญชี : ".concat(info.bus_bank_name)
                                                            }),
                                                            /*#__PURE__*/ _jsx("br", {}),
                                                            /*#__PURE__*/ _jsx(Form.Check.Label, {
                                                                children: "เลขที่บัญชี : ".concat(info.bus_bank_accountno)
                                                            }),
                                                            /*#__PURE__*/ _jsx("br", {}),
                                                            /*#__PURE__*/ _jsx(Form.Check.Label, {
                                                                children: "ธนาคาร : ".concat(info.bus_bank_bankname)
                                                            }),
                                                            /*#__PURE__*/ _jsx("br", {}),
                                                            /*#__PURE__*/ _jsx(Form.Check.Label, {
                                                                children: "สาขาธนาคาร : ".concat(info.bus_bank_branchn)
                                                            })
                                                        ]
                                                    })
                                                }, "bankInfo-".concat(index));
                                            }) : /*#__PURE__*/ _jsx(Col, {
                                                xs: 12,
                                                children: /*#__PURE__*/ _jsx("div", {
                                                    className: "fs-18 mb-2",
                                                    children: "-"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "fs-16 fw-bold my-3 tc-5",
                                            children: "ข้อมูลสัญญา"
                                        }),
                                        /*#__PURE__*/ _jsxs(Row, {
                                            className: "align-items-center",
                                            children: [
                                                /*#__PURE__*/ _jsx(Col, {
                                                    xs: 12,
                                                    md: 6,
                                                    lg: 4,
                                                    xl: 2,
                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                        className: "mb-2 form-st-3 pb-1",
                                                        children: [
                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                className: "mb-1",
                                                                children: "อายุสัญญา (เดือน)"
                                                            }),
                                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                                type: "number",
                                                                name: "ct_contract_duration",
                                                                placeholder: "กรุณากรอกอายุสัญญา",
                                                                value: values.ct_contract_duration,
                                                                onChange: function(e) {
                                                                    setCountMonth(e.target.value);
                                                                    setFieldValue("ct_contract_duration", e.target.value);
                                                                    setPartnerData(_object_spread_props(_object_spread({}, partnerData), {
                                                                        ct_contract_duration: e.target.value
                                                                    }));
                                                                },
                                                                isValid: touched.ct_contract_duration && !errors.ct_contract_duration,
                                                                isInvalid: !!errors.ct_contract_duration,
                                                                disabled: statusCt && statusCt > 1 && props.editDisabled ? true : false,
                                                                readOnly: statusCt && statusCt > 1 && props.editDisabled ? true : false
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ _jsx(Col, {
                                                    xs: 12,
                                                    md: 6,
                                                    lg: 4,
                                                    xl: 3,
                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                        className: "mb-2 form-st-3 pb-1",
                                                        children: [
                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                className: "mb-1",
                                                                children: "วันที่เริ่มสัญญา"
                                                            }),
                                                            /*#__PURE__*/ _jsx(DatePicker, {
                                                                inputFormat: "DD/MM/YYYY",
                                                                selected: values.ct_contract_startdate ? moment(values.ct_contract_startdate).toDate() : "",
                                                                onChange: function(date) {
                                                                    if (moment(date).isValid()) {
                                                                        // console.log(moment(date).format("YYYY-MM-DD 00:00:00"));
                                                                        setFieldValue("ct_contract_startdate", moment(date).format("YYYY-MM-DD 00:00:00"));
                                                                        setDateStart(moment(date).format("YYYY-MM-DD 00:00:00"));
                                                                        setPartnerData(_object_spread_props(_object_spread({}, partnerData), {
                                                                            ct_contract_startdate: moment(date).format("YYYY-MM-DD 00:00:00")
                                                                        }));
                                                                    } else {
                                                                        setFieldValue("ct_contract_startdate", "");
                                                                        setDateStart("");
                                                                        setPartnerData(_object_spread_props(_object_spread({}, partnerData), {
                                                                            ct_contract_startdate: ""
                                                                        }));
                                                                    }
                                                                },
                                                                placeholder: "DD/MM/YYYY",
                                                                className: "w-100 datepicker2 ".concat(values.ct_contract_startdate ? "" : !!errors.ct_contract_startdate ? "is-invalid" : ""),
                                                                value: values.ct_contract_startdate ? moment(values.ct_contract_startdate).format("DD/MM/YYYY") : "",
                                                                disabled: statusCt && statusCt > 1 && props.editDisabled ? true : false,
                                                                readOnly: statusCt && statusCt > 1 && props.editDisabled ? true : false
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ _jsx(Col, {
                                                    xs: 12,
                                                    md: 6,
                                                    lg: 4,
                                                    xl: 3,
                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                        className: "mb-2 form-st-3 pb-1",
                                                        children: [
                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                className: "mb-1",
                                                                children: "วันที่หมดอายุสัญญา"
                                                            }),
                                                            /*#__PURE__*/ _jsx(DatePicker, {
                                                                inputFormat: "DD/MM/YYYY",
                                                                selected: values.ct_contract_enddate ? moment(values.ct_contract_enddate).toDate() : countMonth && countMonth > 0 && dateStart && dateStart != "" && dateStart != null ? moment(dateStart).add({
                                                                    months: countMonth
                                                                }).toDate() : "",
                                                                onChange: function(date) {
                                                                    if (moment(date).isValid()) {
                                                                        // console.log(moment(date).format("YYYY-MM-DD 00:00:00"));
                                                                        setFieldValue("ct_contract_enddate", moment(date).format("YYYY-MM-DD 00:00:00"));
                                                                        setPartnerData(_object_spread_props(_object_spread({}, partnerData), {
                                                                            ct_contract_enddate: moment(date).format("YYYY-MM-DD 00:00:00")
                                                                        }));
                                                                    } else {
                                                                        setFieldValue("ct_contract_enddate", "");
                                                                        setPartnerData(_object_spread_props(_object_spread({}, partnerData), {
                                                                            ct_contract_enddate: ""
                                                                        }));
                                                                    }
                                                                },
                                                                placeholder: "DD/MM/YYYY",
                                                                className: "w-100 datepicker2 ".concat(values.ct_contract_enddate ? "" : !!errors.ct_contract_enddate ? "is-invalid" : ""),
                                                                value: values.ct_contract_enddate ? moment(values.ct_contract_enddate).format("DD/MM/YYYY") : countMonth && countMonth > 0 && dateStart && dateStart != "" && dateStart != null ? moment(dateStart).add({
                                                                    months: countMonth
                                                                }).format("DD/MM/YYYY") : "",
                                                                disabled: true,
                                                                readOnly: true
                                                            })
                                                        ]
                                                    })
                                                }),
                                                statusCt && statusCt >= 3 ? /*#__PURE__*/ _jsx(Col, {
                                                    xs: 6,
                                                    md: 6,
                                                    lg: 4,
                                                    xl: 2,
                                                    children: statusQuot && statusQuot == 2 ? /*#__PURE__*/ _jsx(Button, {
                                                        className: "mb-xs-2 mb-lg-0",
                                                        href: "/quotation/contract_create/" + contractID,
                                                        variant: "primary",
                                                        children: "สร้างใบเสนอราคา"
                                                    }) : /*#__PURE__*/ _jsxs(_Fragment, {
                                                        children: [
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "fs-16 fw-bold mb-1 tc-5",
                                                                children: "เลขที่ใบเสนอราคา"
                                                            }),
                                                            /*#__PURE__*/ _jsx(Button, {
                                                                variant: "link",
                                                                href: "/quotation/edit/" + quoteId,
                                                                children: quoteCode
                                                            })
                                                        ]
                                                    })
                                                }) : /*#__PURE__*/ _jsx(_Fragment, {}),
                                                statusCt && statusCt >= 6 ? /*#__PURE__*/ _jsx(Col, {
                                                    xs: 6,
                                                    md: 6,
                                                    lg: 4,
                                                    xl: 2,
                                                    className: "text-end",
                                                    children: /*#__PURE__*/ _jsx(Button, {
                                                        className: "mb-xs-2 mb-lg-0",
                                                        onClick: function() {
                                                            handleCancelShow();
                                                        },
                                                        variant: "danger",
                                                        children: "ยกเลิกสัญญา"
                                                    })
                                                }) : /*#__PURE__*/ _jsx(_Fragment, {})
                                            ]
                                        })
                                    ]
                                })
                            })
                        })
                    });
                }
            }),
            /*#__PURE__*/ _jsx(CancelModal, {
                show: cancelShow,
                onHide: handleCancelClose,
                setDataFrom: setPartnerData,
                dataFrom: partnerData,
                modalsuccess: modalsuccess,
                setModalsuccess: setModalsuccess
            }),
            /*#__PURE__*/ _jsx(ModalSuccessCustom, {
                show: modalsuccess.visible,
                onHide: function() {
                    return setModalsuccess(function(prev) {
                        return _object_spread_props(_object_spread({}, prev), {
                            visible: false
                        });
                    });
                },
                textsuccess: modalsuccess.textsuccess,
                navigate: navigate,
                direction: modalsuccess.direction
            })
        ]
    });
};
var DetailContractNew = function(_param) {
    var contractData = _param.contractData, setContractData = _param.setContractData, props = _object_without_properties(_param, [
        "contractData",
        "setContractData"
    ]);
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var setIsLoading = useGlobalLoaderContext().setIsLoading;
    var contractID = useParams().contractID;
    var accessToken = localStorage.getItem("accessToken");
    var adminInfo = getInfoAdminSystem(accessToken);
    var _useState = _sliced_to_array(useState([]), 2), productData = _useState[0], setProductData = _useState[1];
    var _useState1 = _sliced_to_array(useState(false), 2), modalShow = _useState1[0], setModalShow = _useState1[1];
    var _useState2 = _sliced_to_array(useState({
        productAmount: 0,
        sumInitalCost: 0,
        sumDiscount: 0,
        sumTax: 0,
        sumPreTax: 0,
        sumVat: 0,
        sumNet: 0
    }), 2), productSum = _useState2[0], setProductSum = _useState2[1];
    var _useState3 = _sliced_to_array(useState([]), 2), branchSaleData = _useState3[0], setBranchSaleData = _useState3[1];
    var _useState4 = _sliced_to_array(useState(false), 2), modalSaleShow = _useState4[0], setModalSaleShow = _useState4[1];
    var _useState5 = _sliced_to_array(useState({
        sumMonth: 0,
        sumInitalCost: 0,
        sumDiscount: 0,
        sumTax: 0,
        sumPreTax: 0,
        sumVat: 0,
        sumNet: 0
    }), 2), branchSum = _useState5[0], setBranchSum = _useState5[1];
    var _useState6 = _sliced_to_array(useState([]), 2), branchAdsData = _useState6[0], setBranchAdsData = _useState6[1];
    var _useState7 = _sliced_to_array(useState(false), 2), modalAdsShow = _useState7[0], setModalAdsShow = _useState7[1];
    var _useState8 = _sliced_to_array(useState({
        sumMonth: 0,
        sumInitalCost: 0,
        sumDiscount: 0,
        sumTax: 0,
        sumPreTax: 0,
        sumVat: 0,
        sumNet: 0
    }), 2), adsSum = _useState8[0], setAdsSum = _useState8[1];
    var _useState9 = _sliced_to_array(useState([
        {
            value: 1,
            label: "จ่ายทั้งหมด (ระยะเวลาตลอดอายุสัญญา)"
        },
        {
            value: 2,
            label: "รายเดือน"
        },
        {
            value: 3,
            label: "ราย 3 เดือน"
        },
        {
            value: 4,
            label: "ราย 6 เดือน"
        },
        {
            value: 5,
            label: "รายปี"
        }
    ]), 2), optionsTypePrice = _useState9[0], setOptionsTypePrice = _useState9[1];
    var _useState10 = _sliced_to_array(useState([
        {
            value: 0,
            label: "ไม่มี"
        },
        {
            value: 3,
            label: "3%"
        },
        {
            value: 7,
            label: "7%"
        },
        {
            value: 10,
            label: "10%"
        }
    ]), 2), optionsMstVat = _useState10[0], setOptionsMstVat = _useState10[1];
    var _useState11 = _sliced_to_array(useState([
        {
            value: 0,
            label: "ไม่มี"
        },
        {
            value: 1,
            label: "1%"
        },
        {
            value: 2,
            label: "2%"
        },
        {
            value: 3,
            label: "3%"
        },
        {
            value: 5,
            label: "5%"
        }
    ]), 2), optionsMstTax = _useState11[0], setOptionsMstTax = _useState11[1];
    var _useState12 = _sliced_to_array(useState([]), 2), optionsPdList = _useState12[0], setOptionsPdList = _useState12[1];
    var schema = props.schema ? props.schema : yup.object().shape({});
    var dataPrintNew = props.dataPrintNew ? props.dataPrintNew : {};
    var bankInfoSl = props.bankInfoSl && props.bankInfoSl.length > 0 ? props.bankInfoSl : [];
    var businessId = props.businessId ? props.businessId : 0;
    var statusCt = props.statusCt ? props.statusCt : 0;
    var _useState13 = _sliced_to_array(useState(0), 2), entryFee = _useState13[0], setEntryFee = _useState13[1];
    var _useState14 = _sliced_to_array(useState(0), 2), entryFeeSku = _useState14[0], setEntryFeeSku = _useState14[1];
    var _useState15 = _sliced_to_array(useState(0), 2), positionFee = _useState15[0], setPositionFee = _useState15[1];
    var _useState16 = _sliced_to_array(useState(0), 2), positionFeeSku = _useState16[0], setPositionFeeSku = _useState16[1];
    var _useState17 = _sliced_to_array(useState(0), 2), adsFee = _useState17[0], setAdsFee = _useState17[1];
    var _useState18 = _sliced_to_array(useState(0), 2), adsFeeSku = _useState18[0], setAdsFeeSku = _useState18[1];
    var _useState19 = _sliced_to_array(useState(), 2), dataFrom = _useState19[0], setDataFrom = _useState19[1];
    var _useState20 = _sliced_to_array(useState(0), 2), statusSubmit = _useState20[0], setStatusSubmit = _useState20[1];
    var _useState21 = _sliced_to_array(useState(false), 2), loadDataPd = _useState21[0], setLoadDataPd = _useState21[1];
    var _useState22 = _sliced_to_array(useState(false), 2), loadDataPlace = _useState22[0], setLoadDataPlace = _useState22[1];
    var _useState23 = _sliced_to_array(useState(false), 2), loadDataAds = _useState23[0], setLoadDataAds = _useState23[1];
    var _useState24 = _sliced_to_array(useState([]), 2), msgText = _useState24[0], setMsgText = _useState24[1];
    var _useState25 = _sliced_to_array(useState({
        open: false,
        x: 10,
        y: 0,
        width: 460,
        height: 320,
        pin: false,
        mode: "normal",
        modalname: "apsuccess2"
    }), 2), modalAlert = _useState25[0], setModalAlert = _useState25[1];
    var _useState26 = _sliced_to_array(useState(""), 2), fileUpLoad = _useState26[0], setFileUpLoad = _useState26[1];
    var getContractProductByIdReducer = useAppSelector(function(state) {
        return state.getContractProductByIdReducer;
    });
    var getContractPlacementByIdReducer = useAppSelector(function(state) {
        return state.getContractPlacementByIdReducer;
    });
    var getContractAdsByIdReducer = useAppSelector(function(state) {
        return state.getContractAdsByIdReducer;
    });
    var getContractFileByIdReducer = useAppSelector(function(state) {
        return state.getContractFileByIdReducer;
    });
    var getContractProductInfoReducer = useAppSelector(function(state) {
        return state.getContractProductInfoReducer;
    });
    var getData = function() {
        if (contractID && contractID > 0) {
            dispatch(getContractProductById({
                contractid: parseInt(contractID, 10)
            }, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
            dispatch(getContractPlacementById({
                contractid: parseInt(contractID, 10)
            }, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
            dispatch(getContractAdsById({
                contractid: parseInt(contractID, 10)
            }, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
            dispatch(getContractFileById({
                contractid: parseInt(contractID, 10)
            }, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
        }
    };
    var _useState27 = _sliced_to_array(useState(false), 2), draftShow = _useState27[0], setDraftShow = _useState27[1];
    var handleDraftShow = function() {
        return setDraftShow(true);
    };
    var handleDraftClose = function() {
        return setDraftShow(false);
    };
    var _useState28 = _sliced_to_array(useState(false), 2), sendApproveShow = _useState28[0], setSendApproveShow = _useState28[1];
    var handleSendApproveShow = function() {
        return setSendApproveShow(true);
    };
    var handleSendApproveClose = function() {
        return setSendApproveShow(false);
    };
    var _useState29 = _sliced_to_array(useState(false), 2), approveShow = _useState29[0], setApproveShow = _useState29[1];
    var handleApproveShow = function() {
        return setApproveShow(true);
    };
    var handleApproveClose = function() {
        return setApproveShow(false);
    };
    var _useState30 = _sliced_to_array(useState(false), 2), noApproveShow = _useState30[0], setNoApproveShow = _useState30[1];
    var handleNoApproveShow = function() {
        return setNoApproveShow(true);
    };
    var handleNoApproveClose = function() {
        return setNoApproveShow(false);
    };
    var _useState31 = _sliced_to_array(useState(false), 2), confirmShow = _useState31[0], setConfirmShow = _useState31[1];
    var handleConfirmShow = function() {
        return setConfirmShow(true);
    };
    var handleConfirmClose = function() {
        return setConfirmShow(false);
    };
    var _useState32 = _sliced_to_array(useState(false), 2), saveDataShow = _useState32[0], setSaveDataShow = _useState32[1];
    var handleSaveDataShow = function() {
        return setSaveDataShow(true);
    };
    var handleSaveDataClose = function() {
        return setSaveDataShow(false);
    };
    var _useState33 = _sliced_to_array(useState([]), 2), fileDelOld = _useState33[0], setFileDelOld = _useState33[1];
    var _useState34 = _sliced_to_array(useState(false), 2), saveEditShow = _useState34[0], setSaveEditShow = _useState34[1];
    var handleSaveEditShow = function() {
        return setSaveEditShow(true);
    };
    var handleEditClose = function() {
        return setSaveEditShow(false);
    };
    var _useState35 = _sliced_to_array(useState(false), 2), notifyBoxShow = _useState35[0], setNotifyBoxShow = _useState35[1];
    var handleNotifyBoxShow = function() {
        return setNotifyBoxShow(true);
    };
    var handleNotifyClose = function() {
        return setNotifyBoxShow(false);
    };
    var _useState36 = _sliced_to_array(useState(false), 2), reloadCalMain = _useState36[0], setReloadCalMain = _useState36[1];
    var _useState37 = _sliced_to_array(useState({
        visible: false,
        textsuccess: "",
        direction: ""
    }), 2), modalsuccess = _useState37[0], setModalsuccess = _useState37[1];
    var chackFillSave = function() {
        var statusData = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, dataSave = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
        try {
            var errMsg = "";
            if (statusData && statusData > 0 && statusData <= 2) {
                if (dataSave) {
                    //console.log("ct_contract_businessid : ",dataSave.ct_contract_businessid);
                    if (!dataSave.ct_contract_businessid || dataSave.ct_contract_businessid <= 0) {
                        errMsg += "กรุณากรอกหรือเลือกชื่อลูกค้าที่จะทำสัญญา<br><br>";
                    }
                    //  if(!dataSave.ct_contract_busbankid || dataSave.ct_contract_busbankid <= 0){
                    //   errMsg += "กรุณากรอกหรือเลือกบัญชีธนาคารที่จะทำสัญญา<br><br>";
                    //  }
                    if (!dataSave.ct_contract_brandid || dataSave.ct_contract_brandid <= 0) {
                        errMsg += "กรุณากรอกหรือเลือกชื่อแบรนด์ที่จะทำสัญญา<br><br>";
                    }
                    if (!dataSave.ct_contract_duration || dataSave.ct_contract_duration <= 0) {
                        errMsg += "กรุณากรอกอายุสัญญา<br><br>";
                    }
                    if (!dataSave.ct_contract_startdate || dataSave.ct_contract_startdate <= 0) {
                        errMsg += "กรุณากรอกวันที่เริ่มสัญญา<br><br>";
                    }
                    if (!dataSave.ct_contract_paytype || dataSave.ct_contract_paytype <= 0) {
                        errMsg += "กรุณาเลือกการชำระเงิน<br><br>";
                    }
                    if (!dataSave.ct_contract_salescomm || dataSave.ct_contract_salescomm <= 0) {
                        errMsg += "กรุณากรอกค่าคอมมิชชั่นการขาย<br><br>";
                    }
                    if (!dataSave.ct_contract_wholesalescomm || dataSave.ct_contract_wholesalescomm <= 0) {
                        errMsg += "กรุณากรอกค่าคอมมิชชั่นกรณีค้าส่ง<br><br>";
                    }
                    if (!dataSave.ct_bank || dataSave.ct_bank.length <= 0) {
                        errMsg += "กรุณาเลือกข้อมูลบัญชีธนาคารที่จะทำสัญญา อย่างน้อย 1 รายการ<br><br>";
                    }
                    if ((!dataSave.ct_products || dataSave.ct_products.length <= 0) && (!dataSave.ct_placements || dataSave.ct_placements.length <= 0) && (!dataSave.ct_adverts || dataSave.ct_adverts.length <= 0)) {
                        errMsg += "กรุณาเพิ่มรายการสินค้า หรือ เพิ่มสาขาการขาย หรือ เพิ่มสาขาโฆษณา อย่างน้อย 1 รายการ<br><br>";
                    } else {
                        if (dataSave.ct_products && dataSave.ct_products.length > 0) {
                            // if(!dataSave.ct_contract_initialcoststatus || dataSave.ct_contract_initialcoststatus <= 0){
                            //   errMsg += "กรุณาเลือก ข้อ 2.1 ค่าแรกเข้าสินค้า ต้องการจะเปิดใช้งานเก็บค่าแรกเข้าหรือไม่<br><br>";
                            // }
                            if (!dataSave.ct_contract_initialcosttype || dataSave.ct_contract_initialcosttype <= 0) {
                                errMsg += "กรุณาเลือก ข้อ 2.1 ค่าแรกเข้าสินค้า ต้องการยกเว้นค่าแรกเข้าสินค้าหรือไม่<br><br>";
                            }
                            if (dataSave.ct_contract_initialcosttype && dataSave.ct_contract_initialcosttype == 2 && (!dataSave.ct_contract_initialcostsku || dataSave.ct_contract_initialcostsku <= 0)) {
                                errMsg += "กรุณากรอกค่าแรกเข้าต่อ SKU ในข้อ 2.1 ค่าแรกเข้าสินค้า<br><br>";
                            }
                        }
                        if (dataSave.ct_placements && dataSave.ct_placements.length > 0) {
                            // if(!dataSave.ct_contract_placementstatus || dataSave.ct_contract_placementstatus <= 0){
                            //   errMsg += "กรุณาเลือก ข้อ 2.2 ค่าวางสินค้า ต้องการจะเปิดใช้งานเก็บค่าแรกเข้าหรือไม่<br><br>";
                            // }
                            if (!dataSave.ct_contract_placementtype || dataSave.ct_contract_placementtype <= 0) {
                                errMsg += "กรุณาเลือก ข้อ 2.2 ค่าวางสินค้า ต้องการยกเว้นค่าวางสินค้าหรือไม่<br><br>";
                            }
                            if (dataSave.ct_contract_placementtype && dataSave.ct_contract_placementtype == 2 && (!dataSave.ct_contract_placementsku || dataSave.ct_contract_placementsku <= 0)) {
                                errMsg += "กรุณากรอกค่าแรกเข้าต่อ SKU ในข้อ 2.2 ค่าวางสินค้า<br><br>";
                            }
                        }
                        if (dataSave.ct_adverts && dataSave.ct_adverts.length > 0) {
                            // if(!dataSave.ct_contract_advertstatus || dataSave.ct_contract_advertstatus <= 0){
                            //   errMsg += "กรุณาเลือก ข้อ 2.3 ค่าโฆษณา ต้องการจะเปิดใช้งานเก็บค่าแรกเข้าหรือไม่<br><br>";
                            // }
                            if (!dataSave.ct_contract_adverttype || dataSave.ct_contract_adverttype <= 0) {
                                errMsg += "กรุณาเลือก ข้อ 2.3 ค่าโฆษณา ต้องการยกเว้นค่าโฆษณาหรือไม่<br><br>";
                            }
                            if (dataSave.ct_contract_adverttype && dataSave.ct_contract_adverttype == 2 && (!dataSave.ct_contract_advertsku || dataSave.ct_contract_advertsku <= 0)) {
                                errMsg += "กรุณากรอกค่าแรกเข้าต่อ SKU ในข้อ 2.3 ค่าโฆษณา<br><br>";
                            }
                        }
                    }
                } else {
                    errMsg = "กรุณากรอกหรือเลือกชื่อลูกค้าที่จะทำสัญญา<br><br>" + "กรุณากรอกหรือเลือกบัญชีธนาคารที่จะทำสัญญา<br><br>" + "กรุณากรอกอายุสัญญา<br><br>" + "กรุณากรอกวันที่เริ่มสัญญา<br><br>" + "กรุณาเลือกการชำระเงิน<br><br>" + "กรุณากรอกค่าคอมมิชชั่นการขาย<br><br>" + "กรุณากรอกค่าคอมมิชชั่นกรณีค้าส่ง<br><br>" + "กรุณาเลือกข้อมูลบัญชีธนาคารที่จะทำสัญญา อย่างน้อย 1 รายการ";
                }
                if (errMsg && errMsg != "" && errMsg != null) {
                    setMsgText(errMsg);
                    handleNotifyBoxShow();
                // setModalAlert((prev) => (
                // { 
                //   ...prev, 
                //   open: true
                // }));
                } else {
                    if (statusData == 1) {
                        handleDraftShow();
                    } else if (statusData == 2) {
                        handleSendApproveShow();
                    }
                }
            }
        } catch (error) {
            console.error("Error : ", error);
        }
    };
    if (!window.Buffer) window.Buffer = Buffer;
    useEffect(function() {
        getData();
    }, []);
    useEffect(function() {
        var userId = adminInfo && adminInfo.userId && adminInfo.userId != "" && adminInfo.userId != null ? parseInt(adminInfo.userId, 10) : 1;
        if (contractData) {
            var typePdCost = contractData.ct_contract_initialcosttype && contractData.ct_contract_initialcosttype != null ? filterTextAndNum(contractData.ct_contract_initialcosttype, 1) : 0;
            var typePdCostSku = contractData.ct_contract_initialcostsku && contractData.ct_contract_initialcostsku != null ? filterTextAndNum(contractData.ct_contract_initialcostsku, 2) : 0;
            var typePlaceCost = contractData.ct_contract_placementtype && contractData.ct_contract_placementtype != null ? filterTextAndNum(contractData.ct_contract_placementtype, 1) : 0;
            var typePlaceCostSku = contractData.ct_contract_placementsku && contractData.ct_contract_placementsku != null ? filterTextAndNum(contractData.ct_contract_placementsku, 2) : 0;
            var typeAdsCost = contractData.ct_contract_adverttype && contractData.ct_contract_adverttype != null ? filterTextAndNum(contractData.ct_contract_adverttype, 1) : 0;
            var typeAdsCostSku = contractData.ct_contract_advertsku && contractData.ct_contract_advertsku != null ? filterTextAndNum(contractData.ct_contract_advertsku, 2) : 0;
            setEntryFee(typePdCost);
            setEntryFeeSku(typePdCostSku);
            setPositionFee(typePlaceCost);
            setPositionFeeSku(typePlaceCostSku);
            setAdsFee(typeAdsCost);
            setAdsFeeSku(typeAdsCostSku);
            var ctBankInfo = [];
            if (contractData.ct_bank && contractData.ct_bank.length > 0) {
                ctBankInfo = contractData.ct_bank.map(function(item) {
                    var hasValidBankId = item.ct_bank_id && parseFloat(item.ct_bank_id) > 0;
                    return _object_spread_props(_object_spread({}, hasValidBankId && {
                        ct_bank_id: parseFloat(item.ct_bank_id)
                    }), {
                        ct_bank_busbankid: item.bus_bank_id && item.bus_bank_id > 0 ? parseInt(item.bus_bank_id, 10) : null,
                        ct_bank_accountno: item.bus_bank_accountno && item.bus_bank_accountno != "" && item.bus_bank_accountno != null ? item.bus_bank_accountno : null,
                        ct_bank_name: item.bus_bank_name && item.bus_bank_name != "" && item.bus_bank_name != null ? item.bus_bank_name : null,
                        ct_bank_bankid: item.bus_bank_bankid && item.bus_bank_bankid > 0 ? parseInt(item.bus_bank_bankid, 10) : null,
                        ct_bank_type: 2,
                        ct_bank_branchn: item.bus_bank_branchn && item.bus_bank_branchn != "" && item.bus_bank_branchn != null ? item.bus_bank_branchn : null,
                        ct_bank_status: 1
                    });
                });
            }
            var chkDuration = contractData.ct_contract_duration && contractData.ct_contract_duration > 0 ? parseInt(contractData.ct_contract_duration, 10) : 0;
            var chkStartDate = contractData.ct_contract_startdate && contractData.ct_contract_startdate != "" && contractData.ct_contract_startdate != null ? contractData.ct_contract_startdate : "";
            var endDateSet = "";
            if (chkDuration && chkDuration > 0 && chkStartDate && chkStartDate != "") {
                endDateSet = moment(chkStartDate).add({
                    months: chkDuration
                }).format("YYYY-MM-DD 00:00:00");
            }
            setDataFrom(function(dataFrom) {
                var _obj;
                return _object_spread_props(_object_spread({}, dataFrom, contractData), (_obj = {
                    ct_contract_prefixid: contractData.ct_contract_prefixid && contractData.ct_contract_prefixid > 0 ? parseInt(contractData.ct_contract_prefixid, 10) : 0,
                    ct_contract_businessid: contractData.ct_contract_businessid && contractData.ct_contract_businessid > 0 ? parseInt(contractData.ct_contract_businessid, 10) : 0,
                    ct_contract_busbankid: contractData.ct_contract_busbankid && contractData.ct_contract_busbankid > 0 ? parseInt(contractData.ct_contract_busbankid, 10) : 0,
                    ct_contract_businesstype: contractData.ct_contract_businesstype && contractData.ct_contract_businesstype > 0 ? parseInt(contractData.ct_contract_businesstype, 10) : 0,
                    ct_contract_categoryid: contractData.ct_contract_categoryid && contractData.ct_contract_categoryid > 0 ? parseInt(contractData.ct_contract_categoryid, 10) : 0,
                    ct_contract_comprefixid: contractData.ct_contract_comprefixid && contractData.ct_contract_comprefixid > 0 ? parseInt(contractData.ct_contract_comprefixid, 10) : 0
                }, _define_property(_obj, "ct_contract_prefixid", contractData.ct_contract_prefixid && contractData.ct_contract_prefixid > 0 ? parseInt(contractData.ct_contract_prefixid, 10) : 0), _define_property(_obj, "ct_contract_duration", chkDuration), _define_property(_obj, "ct_contract_initialcostsku", contractData.ct_contract_initialcostsku && contractData.ct_contract_initialcostsku > 0 ? parseFloat(contractData.ct_contract_initialcostsku) : 0), _define_property(_obj, "ct_contract_placementsku", contractData.ct_contract_placementsku && contractData.ct_contract_placementsku > 0 ? parseFloat(contractData.ct_contract_placementsku) : 0), _define_property(_obj, "ct_contract_advertsku", contractData.ct_contract_advertsku && contractData.ct_contract_advertsku > 0 ? parseFloat(contractData.ct_contract_advertsku) : 0), _define_property(_obj, "ct_contract_salescomm", contractData.ct_contract_salescomm && contractData.ct_contract_salescomm > 0 ? parseFloat(contractData.ct_contract_salescomm) : 0), _define_property(_obj, "ct_contract_wholesalescomm", contractData.ct_contract_wholesalescomm && contractData.ct_contract_wholesalescomm > 0 ? parseFloat(contractData.ct_contract_wholesalescomm) : 0), _define_property(_obj, "ct_contract_initialcoststatus", 1), _define_property(_obj, "ct_contract_placementstatus", 1), _define_property(_obj, "ct_contract_advertstatus", 1), //ct_contract_approvedate: moment(dateAt).utc().format(),
                _define_property(_obj, "ct_contract_crebyid", contractID && contractID > 0 ? parseInt(contractData.ct_contract_wholesalescomm, 10) : userId), //ct_contract_credate: moment(dateAt).utc().format(),
                _define_property(_obj, "ct_contract_updatebyid", userId), //ct_contract_updatedate: moment(dateAt).utc().format(),
                _define_property(_obj, "ct_contract_startdate", chkStartDate && chkStartDate != "" ? moment(chkStartDate).format("YYYY-MM-DD") + "T00:00:00.000Z" : ""), _define_property(_obj, "ct_contract_enddate", endDateSet && endDateSet != "" ? moment(endDateSet).format("YYYY-MM-DD") + "T00:00:00.000Z" : ""), _define_property(_obj, "ct_bank", ctBankInfo), _define_property(_obj, "ct_products_delete", []), _define_property(_obj, "ct_placements_delete", []), _define_property(_obj, "ct_adverts_delete", []), _define_property(_obj, "ct_bank_delete", []), _obj));
            });
        }
        if (productData && productData.length > 0) {
            var ctProductItem = productData.map(function(item) {
                var hasValidId = item.ct_product_id && parseFloat(item.ct_product_id) > 0;
                return _object_spread_props(_object_spread({}, hasValidId && {
                    ct_product_id: parseFloat(item.ct_product_id)
                }), {
                    ct_product_productid: parseFloat(item.ct_product_productid),
                    ct_product_name: item.ct_product_name,
                    ct_product_initalcost: parseFloat(item.ct_product_initalcost),
                    ct_product_discount: parseFloat(item.ct_product_discount),
                    ct_product_tax: parseFloat(item.ct_product_tax),
                    ct_product_pretax: parseFloat(item.ct_product_pretax),
                    ct_product_vat: parseFloat(item.ct_product_vat),
                    ct_product_net: parseFloat(item.ct_product_net),
                    ct_product_remark: item.ct_product_remark,
                    ct_product_crebyid: contractID && contractID > 0 ? parseInt(item.ct_product_crebyid, 10) : userId,
                    ct_product_updatebyid: userId
                });
            });
            setDataFrom(function(dataFrom) {
                return _object_spread_props(_object_spread({}, dataFrom), {
                    ct_products: ctProductItem
                });
            });
        } else {
            setDataFrom(function(dataFrom) {
                return _object_spread_props(_object_spread({}, dataFrom), {
                    ct_products: []
                });
            });
        }
        if (branchSaleData && branchSaleData.length > 0) {
            var ctPlaceItem = branchSaleData.map(function(item) {
                var hasValidId2 = item.ct_placement_id && parseFloat(item.ct_placement_id) > 0;
                return _object_spread_props(_object_spread({}, hasValidId2 && {
                    ct_placement_id: parseFloat(item.ct_placement_id)
                }), {
                    ct_placement_branchid: parseFloat(item.ct_placement_branchid),
                    ct_placement_positionid: item.ct_placement_positionid ? parseFloat(item.ct_placement_positionid) : null,
                    ct_placement_pdid: item.ct_placement_pdid ? parseFloat(item.ct_placement_pdid) : null,
                    ct_placement_pdnameth: item.ct_placement_pdnameth ? item.ct_placement_pdnameth : null,
                    ct_placement_month: parseFloat(item.ct_placement_month),
                    ct_placement_cost: parseFloat(item.ct_placement_cost),
                    ct_placement_discount: parseFloat(item.ct_placement_discount),
                    ct_placement_tax: parseFloat(item.ct_placement_tax),
                    ct_placement_pretax: parseFloat(item.ct_placement_pretax),
                    ct_placement_vat: parseFloat(item.ct_placement_vat),
                    ct_placement_net: parseFloat(item.ct_placement_net),
                    ct_placement_remark: item.ct_placement_remark,
                    ct_placement_crebyid: contractID && contractID > 0 ? parseInt(item.ct_placement_crebyid, 10) : userId,
                    ct_placement_updatebyid: userId
                });
            });
            setDataFrom(function(dataFrom) {
                return _object_spread_props(_object_spread({}, dataFrom), {
                    ct_placements: ctPlaceItem
                });
            });
        } else {
            setDataFrom(function(dataFrom) {
                return _object_spread_props(_object_spread({}, dataFrom), {
                    ct_placements: []
                });
            });
        }
        if (branchAdsData && branchAdsData.length > 0) {
            var ctAdvertsItem = branchAdsData.map(function(item) {
                var hasValidId3 = item.ct_advert_id && parseFloat(item.ct_advert_id) > 0;
                return _object_spread_props(_object_spread({}, hasValidId3 && {
                    ct_advert_id: parseFloat(item.ct_advert_id)
                }), {
                    ct_advert_branchid: parseInt(item.ct_advert_branchid, 10),
                    ct_advert_adpointid: parseInt(item.ct_advert_adpointid, 10),
                    ct_advert_month: parseInt(item.ct_advert_month, 10),
                    ct_advert_cost: parseFloat(item.ct_advert_cost),
                    ct_advert_discount: parseFloat(item.ct_advert_discount),
                    ct_advert_tax: parseFloat(item.ct_advert_tax),
                    ct_advert_pretax: parseFloat(item.ct_advert_pretax),
                    ct_advert_vat: parseFloat(item.ct_advert_vat),
                    ct_advert_net: parseFloat(item.ct_advert_net),
                    ct_advert_remark: item.ct_advert_remark,
                    ct_advert_crebyid: contractID && contractID > 0 ? parseInt(item.ct_advert_crebyid, 10) : userId,
                    ct_advert_updatebyid: userId
                });
            });
            setDataFrom(function(dataFrom) {
                return _object_spread_props(_object_spread({}, dataFrom), {
                    ct_adverts: ctAdvertsItem
                });
            });
        } else {
            setDataFrom(function(dataFrom) {
                return _object_spread_props(_object_spread({}, dataFrom), {
                    ct_adverts: []
                });
            });
        }
    }, [
        contractData,
        productData,
        branchSaleData,
        branchAdsData
    ]);
    useEffect(function() {
        setIsLoading(getContractProductByIdReducer.isFetching || getContractPlacementByIdReducer.isFetching || getContractAdsByIdReducer.isFetching || getContractFileByIdReducer.isFetching || getContractProductInfoReducer.isFetching);
        if (getContractProductByIdReducer.data && !getContractProductByIdReducer.isError) {
            var dataNewSet = getContractProductByIdReducer.data.data;
            if (dataNewSet && dataNewSet.length > 0) {
                setProductData(dataNewSet.map(function(item, index) {
                    return _object_spread_props(_object_spread({}, item), {
                        rowID: nanoid(),
                        checkedProduct: 1
                    });
                }));
            // setOptionsPdList(
            //   dataNewSet.map((item2) => (
            //       {
            //         label: item2.ct_product_name,
            //         value: item2.ct_product_productid,
            //       }
            //     )
            //   )
            // );
            //setLoadDataPd(true);
            }
            props.setDataPrintNew(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    ctProducts: dataNewSet && dataNewSet.length > 0 ? dataNewSet : []
                });
            });
        }
        if (getContractPlacementByIdReducer.data && !getContractPlacementByIdReducer.isError) {
            var dataNewSet2 = getContractPlacementByIdReducer.data.data;
            var placeDataNew = [];
            if (dataNewSet2 && dataNewSet2.length > 0) {
                dataNewSet2.map(function(item, index) {
                    var optionPosition = [];
                    if (item.setPosition && item.setPosition.length > 0) {
                        optionPosition = item.setPosition.map(function(item2) {
                            return {
                                label: item2.set_position_name,
                                value: item2.set_position_id
                            };
                        });
                    } else if (item.setPosition) {
                        optionPosition = [
                            {
                                label: item.setPosition.set_position_name,
                                value: item.setPosition.set_position_id
                            }
                        ];
                    }
                    placeDataNew = _to_consumable_array(placeDataNew).concat([
                        _object_spread_props(_object_spread({}, item), {
                            rowID: nanoid(),
                            ct_placement_branch_name: item.set_branch_name,
                            ct_placement_option: optionPosition
                        })
                    ]);
                });
                setBranchSaleData(placeDataNew);
            //setLoadDataPlace(true);
            }
            props.setDataPrintNew(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    ctPlacements: dataNewSet2 && dataNewSet2.length > 0 ? dataNewSet2 : []
                });
            });
        }
        if (getContractAdsByIdReducer.data && !getContractAdsByIdReducer.isError) {
            var dataNewSet3 = getContractAdsByIdReducer.data.data;
            var adsDataNew = [];
            if (dataNewSet3 && dataNewSet3.length > 0) {
                dataNewSet3.map(function(item, index) {
                    var optionPosition = [];
                    if (item.setAdpoint && item.setAdpoint.length > 0) {
                        optionPosition = item.setAdpoint.map(function(item2) {
                            return {
                                label: item2.set_adpoint_name,
                                value: item2.set_adpoint_id
                            };
                        });
                    } else if (item.setAdpoint) {
                        optionPosition = [
                            {
                                label: item.setAdpoint.set_adpoint_name,
                                value: item.setAdpoint.set_adpoint_id
                            }
                        ];
                    }
                    adsDataNew = _to_consumable_array(adsDataNew).concat([
                        _object_spread_props(_object_spread({}, item), {
                            rowID: nanoid(),
                            ct_advert_branch_name: item.set_branch_name,
                            ct_advert_option: optionPosition
                        })
                    ]);
                });
                setBranchAdsData(adsDataNew);
            //setLoadDataAds(true);
            }
            props.setDataPrintNew(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    ctAdverts: dataNewSet3 && dataNewSet3.length > 0 ? dataNewSet3 : []
                });
            });
        }
        if (getContractFileByIdReducer.data && !getContractFileByIdReducer.isError) {
            var datas = getContractFileByIdReducer.data.data;
            if (datas && datas.length > 0) {
                setFileUpLoad(datas.map(function(item) {
                    return _object_spread_props(_object_spread({}, item), {
                        rowId: nanoid(),
                        isDelete: true,
                        ct_file_chk: "old_file"
                    });
                }));
            }
        }
        if (getContractProductInfoReducer.data && !getContractProductInfoReducer.isError) {
            var dataNewSetPd = getContractProductInfoReducer.data.data;
            if (dataNewSetPd && dataNewSetPd.length > 0) {
                setOptionsPdList(dataNewSetPd.map(function(item2) {
                    return {
                        label: item2.pd_product_nameth,
                        value: item2.pd_product_id
                    };
                }));
            }
        }
    }, [
        getContractProductByIdReducer,
        getContractPlacementByIdReducer,
        getContractAdsByIdReducer,
        getContractFileByIdReducer,
        getContractProductInfoReducer
    ]);
    var handleDownload = function() {
        var _ref = _async_to_generator(function() {
            var _dataPrintNew_formData, dataPrintNewTotal, blob, fileName, error;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        // สร้าง blob PDF
                        //console.log("reservationData",reservationData);
                        dataPrintNewTotal = {};
                        if (dataPrintNew) {
                            Object.assign(dataPrintNewTotal, dataPrintNew);
                        }
                        if (dataFrom && dataFrom.userInfo) {
                            Object.assign(dataPrintNewTotal, {
                                userInfo: dataFrom.userInfo
                            });
                        }
                        // if(dataFrom && dataFrom.mstBank && dataFrom.mstBank.length>0){
                        //   Object.assign(dataPrintNewTotal,{ mstBank: dataFrom.mstBank });
                        // }
                        if (dataPrintNewTotal && dataPrintNewTotal.ctBank && dataPrintNewTotal.ctBank.length > 0 && dataFrom && dataFrom.mstBank && dataFrom.mstBank.length > 0) {
                            dataPrintNewTotal.ctBank = dataPrintNewTotal.ctBank.map(function(item) {
                                var mstBankItem = dataFrom.mstBank.find(function(bank) {
                                    return bank.value === item.ct_bank_bankid;
                                });
                                return _object_spread_props(_object_spread({}, item), {
                                    ct_bank_bankid_text: mstBankItem ? mstBankItem.label : "-"
                                });
                            });
                        }
                        return [
                            4,
                            pdf(/*#__PURE__*/ _jsx(ContractDocument, {
                                data: dataPrintNewTotal
                            })).toBlob()
                        ];
                    case 1:
                        blob = _state.sent();
                        // ตั้งชื่อไฟล์
                        fileName = "ใบสัญญา_".concat((dataPrintNew === null || dataPrintNew === void 0 ? void 0 : (_dataPrintNew_formData = dataPrintNew.formData) === null || _dataPrintNew_formData === void 0 ? void 0 : _dataPrintNew_formData.ct_contract_code) || "ไม่มีเลขที่", "_").concat(moment().format("DDMMYYYYHHmmss"), ".pdf");
                        // ดาวน์โหลด
                        saveAs(blob, fileName);
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error = _state.sent();
                        console.error("เกิดข้อผิดพลาดในการสร้าง PDF:", error);
                        alert("ไม่สามารถสร้างไฟล์ PDF ได้");
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleDownload() {
            return _ref.apply(this, arguments);
        };
    }();
    // const handleOpenPrint = async () => {
    //   const dataPrintNewTotal = {};
    //   if(dataPrintNew){
    //     Object.assign(dataPrintNewTotal, dataPrintNew);
    //   }
    //   if(dataFrom && dataFrom.userInfo){
    //     Object.assign(dataPrintNewTotal,{ userInfo: dataFrom.userInfo });
    //   }
    //   // if(dataFrom && dataFrom.mstBank && dataFrom.mstBank.length>0){
    //   //   Object.assign(dataPrintNewTotal,{ mstBank: dataFrom.mstBank });
    //   // }
    //   if(dataPrintNewTotal && dataPrintNewTotal.ctBank 
    //     && dataPrintNewTotal.ctBank.length>0
    //     && dataFrom && dataFrom.mstBank && dataFrom.mstBank.length>0
    //   ){
    //     dataPrintNewTotal.ctBank = dataPrintNewTotal.ctBank.map((item) => {
    //       const mstBankItem = dataFrom.mstBank.find((bank) => bank.value === item.ct_bank_bankid);
    //       return {
    //         ...item,
    //         ct_bank_bankid_text: mstBankItem ? mstBankItem.label : '-',
    //       };
    //     });
    //   }
    //   // console.log("dataFrom :", dataPrintNew);
    //   // console.log("dataFromSubmit :", dataFrom);
    //   // console.log("dataPrintNewTotal :", dataPrintNewTotal);
    //   const blob = await pdf(<ContractDocument data={dataPrintNewTotal} />).toBlob();
    //   const url = URL.createObjectURL(blob);
    //   // เปิด PDF ในหน้าต่างใหม่
    //   const newWindow = window.open(url, "_blank");
    //   // เตรียมปุ่มดาวน์โหลด
    //   if (newWindow) {
    //     const fileName = `ใบสัญญา-${dataPrintNew?.formData?.ct_contract_code || "ไม่มีเลขที่"}.pdf`;
    //     // Inject ปุ่มดาวน์โหลดลงในแท็บใหม่
    //     newWindow.document.write(`
    //     <html>
    //       <head>
    //         <title>${fileName}</title>
    //       </head>
    //       <body style="margin:0;">
    //         <iframe src="${url}" width="100%" height="100%" style="border:none;"></iframe>
    //       </body>
    //     </html>
    //     `);
    //   } else {
    //     alert("ไม่สามารถเปิดหน้าต่างใหม่ได้ กรุณาอนุญาต pop-up");
    //   }
    // };
    useEffect(function() {
        if (productSum && productSum.productAmount && productSum.productAmount > 0) {
            //console.log("productSum : ",productSum);
            setDataFrom(function(dataFrom) {
                return _object_spread_props(_object_spread({}, dataFrom), {
                    ct_contract_totallist: parseFloat(productSum.productAmount),
                    ct_contract_pdinitalcost: parseFloat(productSum.sumInitalCost),
                    ct_contract_pddiscount: parseFloat(productSum.sumDiscount),
                    ct_contract_pdtax: parseFloat(productSum.sumTax),
                    ct_contract_pdpretax: parseFloat(productSum.sumPreTax),
                    ct_contract_pdnet: parseFloat(productSum.sumNet)
                });
            });
        }
        if (branchSum && branchSum.sumMonth && branchSum.sumMonth > 0) {
            //console.log("branchSum : ",branchSum);
            setDataFrom(function(dataFrom) {
                return _object_spread_props(_object_spread({}, dataFrom), {
                    ct_contract_plmmonth: parseFloat(branchSum.sumMonth),
                    ct_contract_plmcost: parseFloat(branchSum.sumInitalCost),
                    ct_contract_plmdiscount: parseFloat(branchSum.sumDiscount),
                    ct_contract_plmtax: parseFloat(branchSum.sumTax),
                    ct_contract_plmpretax: parseFloat(branchSum.sumPreTax),
                    ct_contract_plmnet: parseFloat(branchSum.sumNet)
                });
            });
        }
        if (adsSum && adsSum.sumMonth && adsSum.sumMonth > 0) {
            //console.log("adsSum : ",adsSum);
            setDataFrom(function(dataFrom) {
                return _object_spread_props(_object_spread({}, dataFrom), {
                    ct_contract_admonth: parseFloat(adsSum.sumMonth),
                    ct_contract_adost: parseFloat(adsSum.sumInitalCost),
                    ct_contract_addiscount: parseFloat(adsSum.sumDiscount),
                    ct_contract_adtax: parseFloat(adsSum.sumTax),
                    ct_contract_adpretax: parseFloat(adsSum.sumPreTax),
                    ct_contract_adnet: parseFloat(adsSum.sumNet)
                });
            });
        }
    }, [
        productSum,
        branchSum,
        adsSum
    ]);
    useEffect(function() {
        if (businessId && businessId > 0) {
            dispatch(getContractProductInfo({
                businessid: parseInt(businessId, 10)
            }, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
        }
    }, [
        businessId
    ]);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Formik, {
                enableReinitialize: true,
                initialValues: contractData,
                validationSchema: schema,
                onSubmit: function() {
                    var _ref = _async_to_generator(function(values) {
                        return _ts_generator(this, function(_state) {
                            return [
                                2
                            ];
                        });
                    //await sleep(500);
                    });
                    return function(values) {
                        return _ref.apply(this, arguments);
                    };
                }(),
                children: function(param) {
                    var handleSubmit = param.handleSubmit, handleChange = param.handleChange, touched = param.touched, errors = param.errors, values = param.values, setFieldValue = param.setFieldValue, setValues = param.setValues, isInvalid = param.isInvalid, isValid = param.isValid, resetForm = param.resetForm;
                    return /*#__PURE__*/ _jsx(Form, {
                        noValidate: true,
                        onSubmit: handleSubmit,
                        children: /*#__PURE__*/ _jsxs("fieldset", {
                            disabled: statusCt && statusCt > 1 && props.editDisabled ? true : false,
                            children: [
                                /*#__PURE__*/ _jsx(Card, {
                                    className: "card-st-1 mb-4",
                                    children: /*#__PURE__*/ _jsxs(CardBody, {
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "fs-16 fw-bold mb-2 tc-5",
                                                children: "2.1 ค่าแรกเข้าสินค้า"
                                            }),
                                            /*#__PURE__*/ _jsx(Row, {
                                                children: /*#__PURE__*/ _jsx(Col, {
                                                    xs: 12,
                                                    children: /*#__PURE__*/ _jsx("div", {
                                                        className: "mb-2",
                                                        children: /*#__PURE__*/ _jsxs(Row, {
                                                            className: "align-items-center",
                                                            children: [
                                                                /*#__PURE__*/ _jsx(Col, {
                                                                    xs: 12,
                                                                    md: "auto",
                                                                    children: /*#__PURE__*/ _jsx(Form.Check, {
                                                                        inline: true,
                                                                        type: "radio",
                                                                        id: "p2-radio-1",
                                                                        label: "ยกเว้นค่าแรกเข้าสินค้า",
                                                                        checked: values.ct_contract_initialcosttype === 1 || !values.ct_contract_initialcosttype ? true : false,
                                                                        className: "form-check-st-2 tc-7 mt-0",
                                                                        name: "ct_contract_initialcosttype",
                                                                        onChange: function() {
                                                                            setFieldValue("ct_contract_initialcosttype", 1);
                                                                            setEntryFee(1);
                                                                            setContractData(_object_spread_props(_object_spread({}, contractData), {
                                                                                ct_contract_initialcosttype: 1
                                                                            }));
                                                                        }
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx(Col, {
                                                                    xs: 12,
                                                                    md: "auto",
                                                                    children: /*#__PURE__*/ _jsxs(Stack, {
                                                                        direction: "horizontal",
                                                                        gap: 2,
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx("div", {
                                                                                children: /*#__PURE__*/ _jsx(Form.Check, {
                                                                                    inline: true,
                                                                                    type: "radio",
                                                                                    id: "p2-radio-2",
                                                                                    label: "ค่าแรกเข้าคงที่",
                                                                                    checked: values.ct_contract_initialcosttype === 2 ? true : false,
                                                                                    className: "form-check-st-2 tc-7 mt-0",
                                                                                    name: "ct_contract_initialcosttype",
                                                                                    onChange: function() {
                                                                                        setFieldValue("ct_contract_initialcosttype", 2);
                                                                                        setEntryFee(2);
                                                                                        setContractData(_object_spread_props(_object_spread({}, contractData), {
                                                                                            ct_contract_initialcosttype: 2
                                                                                        }));
                                                                                    }
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("div", {
                                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                                    className: "mb-2 form-st-3 pb-1",
                                                                                    children: [
                                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                                            className: "mb-1",
                                                                                            children: "ค่าแรกเข้าต่อ SKU"
                                                                                        }),
                                                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                                                            type: "number",
                                                                                            name: "ct_contract_initialcostsku",
                                                                                            placeholder: "กรอกค่าแรกเข้าคงที่",
                                                                                            value: values.ct_contract_initialcostsku && values.ct_contract_initialcostsku != "" && values.ct_contract_initialcostsku != null ? values.ct_contract_initialcostsku : "",
                                                                                            onChange: function(e) {
                                                                                                setEntryFeeSku(e.target.value);
                                                                                                setFieldValue("ct_contract_initialcostsku", e.target.value);
                                                                                                setContractData(_object_spread_props(_object_spread({}, contractData), {
                                                                                                    ct_contract_initialcostsku: e.target.value
                                                                                                }));
                                                                                            },
                                                                                            isValid: touched.ct_contract_initialcostsku && !errors.ct_contract_initialcostsku,
                                                                                            isInvalid: !!errors.ct_contract_initialcostsku
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx(Col, {
                                                                    xs: 12,
                                                                    md: "auto",
                                                                    children: /*#__PURE__*/ _jsx(Form.Check, {
                                                                        inline: true,
                                                                        type: "radio",
                                                                        id: "p2-radio-3",
                                                                        label: "กำหนดค่าเอง",
                                                                        checked: values.ct_contract_initialcosttype === 3 ? true : false,
                                                                        className: "form-check-st-2 tc-7 mt-0",
                                                                        name: "ct_contract_initialcosttype",
                                                                        onChange: function() {
                                                                            setFieldValue("ct_contract_initialcosttype", 3);
                                                                            setEntryFee(3);
                                                                            setContractData(_object_spread_props(_object_spread({}, contractData), {
                                                                                ct_contract_initialcosttype: 3
                                                                            }));
                                                                        }
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    }, "p2-radio")
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "my-4",
                                    children: /*#__PURE__*/ _jsx(ProductData, {
                                        productData: productData,
                                        setProductData: setProductData,
                                        entryFee: entryFee,
                                        entryFeeSku: entryFeeSku,
                                        optionsMstVat: optionsMstVat,
                                        optionsMstTax: optionsMstTax,
                                        productSum: productSum,
                                        setProductSum: setProductSum,
                                        editDisabled: props.editDisabled,
                                        reloadCalMain: reloadCalMain,
                                        setReloadCalMain: setReloadCalMain
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "my-4",
                                    children: /*#__PURE__*/ _jsx(Button, {
                                        type: "button",
                                        className: "btn-st-3 me-3",
                                        variant: "",
                                        onClick: function() {
                                            setLoadDataPd(true);
                                            setModalShow(true);
                                        },
                                        children: "เพิ่มรายการสินค้า"
                                    })
                                }),
                                optionsTypePrice && optionsTypePrice.length > 0 ? /*#__PURE__*/ _jsx(Card, {
                                    className: "card-st-1 mb-4",
                                    children: /*#__PURE__*/ _jsxs(CardBody, {
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "fs-16 fw-bold mb-2 tc-5",
                                                children: "การชำระเงิน"
                                            }),
                                            /*#__PURE__*/ _jsx(Row, {
                                                className: "align-items-center",
                                                children: /*#__PURE__*/ _jsx(Col, {
                                                    xs: 12,
                                                    children: /*#__PURE__*/ _jsx("div", {
                                                        className: "mb-2",
                                                        children: optionsTypePrice.map(function(item, index) {
                                                            return /*#__PURE__*/ _jsx(Form.Check, {
                                                                inline: true,
                                                                type: "radio",
                                                                id: "p3-radio-".concat(index + 1),
                                                                label: item.label,
                                                                checked: values.ct_contract_paytype === item.value || !values.ct_contract_paytype && index == 0 ? true : false,
                                                                className: "form-check-st-2 tc-7 mt-0",
                                                                name: "ct_contract_paytype",
                                                                isInvalid: !!errors.ct_contract_paytype,
                                                                onChange: function() {
                                                                    setFieldValue("ct_contract_paytype", item.value);
                                                                    setContractData(_object_spread_props(_object_spread({}, contractData), {
                                                                        ct_contract_paytype: item.value
                                                                    }));
                                                                }
                                                            });
                                                        })
                                                    }, "p3-radio")
                                                })
                                            })
                                        ]
                                    })
                                }) : /*#__PURE__*/ _jsx(_Fragment, {}),
                                /*#__PURE__*/ _jsx(Card, {
                                    className: "card-st-1 mb-4",
                                    children: /*#__PURE__*/ _jsxs(CardBody, {
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "fs-16 fw-bold mb-2 tc-5",
                                                children: "2.2 ค่าวางสินค้า"
                                            }),
                                            /*#__PURE__*/ _jsx(Row, {
                                                children: /*#__PURE__*/ _jsx(Col, {
                                                    xs: 12,
                                                    children: /*#__PURE__*/ _jsx("div", {
                                                        className: "mb-2",
                                                        children: /*#__PURE__*/ _jsxs(Row, {
                                                            className: "align-items-center",
                                                            children: [
                                                                /*#__PURE__*/ _jsx(Col, {
                                                                    xs: 12,
                                                                    md: "auto",
                                                                    children: /*#__PURE__*/ _jsx(Form.Check, {
                                                                        inline: true,
                                                                        type: "radio",
                                                                        id: "p5-radio-1",
                                                                        label: "ยกเว้นค่าวางสินค้า",
                                                                        checked: values.ct_contract_placementtype === 1 || !values.ct_contract_placementtype ? true : false,
                                                                        className: "form-check-st-2 tc-7 mt-0",
                                                                        name: "ct_contract_placementtype",
                                                                        isInvalid: !!errors.ct_contract_placementtype,
                                                                        onChange: function() {
                                                                            setFieldValue("ct_contract_placementtype", 1);
                                                                            setPositionFee(1);
                                                                            setContractData(_object_spread_props(_object_spread({}, contractData), {
                                                                                ct_contract_placementtype: 1
                                                                            }));
                                                                        }
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx(Col, {
                                                                    xs: 12,
                                                                    md: "auto",
                                                                    children: /*#__PURE__*/ _jsxs(Stack, {
                                                                        direction: "horizontal",
                                                                        gap: 2,
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx("div", {
                                                                                children: /*#__PURE__*/ _jsx(Form.Check, {
                                                                                    inline: true,
                                                                                    type: "radio",
                                                                                    id: "p5-radio-2",
                                                                                    label: "ค่าวางสินค้าคงที่",
                                                                                    checked: values.ct_contract_placementtype === 2,
                                                                                    className: "form-check-st-2 tc-7 mt-0",
                                                                                    name: "ct_contract_placementtype",
                                                                                    isInvalid: !!errors.ct_contract_placementtype,
                                                                                    onChange: function() {
                                                                                        setFieldValue("ct_contract_placementtype", 2);
                                                                                        setPositionFee(2);
                                                                                        setContractData(_object_spread_props(_object_spread({}, contractData), {
                                                                                            ct_contract_placementtype: 2
                                                                                        }));
                                                                                    }
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("div", {
                                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                                    className: "mb-2 form-st-3 pb-1",
                                                                                    children: [
                                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                                            className: "mb-1",
                                                                                            children: "ค่าแรกเข้าต่อ SKU"
                                                                                        }),
                                                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                                                            type: "number",
                                                                                            name: "ct_contract_placementsku",
                                                                                            placeholder: "กรอกค่าแรกเข้าคงที่",
                                                                                            value: values.ct_contract_placementsku && values.ct_contract_placementsku != "" && values.ct_contract_placementsku != null ? values.ct_contract_placementsku : "",
                                                                                            onChange: function(e) {
                                                                                                setPositionFeeSku(e.target.value);
                                                                                                setFieldValue("ct_contract_placementsku", e.target.value);
                                                                                                setContractData(_object_spread_props(_object_spread({}, contractData), {
                                                                                                    ct_contract_placementsku: e.target.value
                                                                                                }));
                                                                                            },
                                                                                            isValid: touched.ct_contract_placementsku && !errors.ct_contract_placementsku,
                                                                                            isInvalid: !!errors.ct_contract_placementsku
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx(Col, {
                                                                    xs: 12,
                                                                    md: "auto",
                                                                    children: /*#__PURE__*/ _jsx(Form.Check, {
                                                                        inline: true,
                                                                        type: "radio",
                                                                        id: "p5-radio-3",
                                                                        label: "กำหนดค่าเอง",
                                                                        checked: values.ct_contract_placementtype === 3,
                                                                        className: "form-check-st-2 tc-7 mt-0",
                                                                        name: "ct_contract_placementtype",
                                                                        isInvalid: !!errors.ct_contract_placementtype,
                                                                        onChange: function() {
                                                                            setFieldValue("ct_contract_placementtype", 3);
                                                                            setPositionFee(3);
                                                                            setContractData(_object_spread_props(_object_spread({}, contractData), {
                                                                                ct_contract_placementtype: 3
                                                                            }));
                                                                        }
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    }, "p5-radio")
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "my-4",
                                    children: /*#__PURE__*/ _jsx(BranchData, {
                                        branchData: branchSaleData,
                                        setBranchData: setBranchSaleData,
                                        entryFee: positionFee,
                                        entryFeeSku: positionFeeSku,
                                        optionsMstVat: optionsMstVat,
                                        optionsMstTax: optionsMstTax,
                                        branchSum: branchSum,
                                        setBranchSum: setBranchSum,
                                        editDisabled: props.editDisabled,
                                        optionsPdList: optionsPdList
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "my-4",
                                    children: /*#__PURE__*/ _jsx(Button, {
                                        type: "button",
                                        className: "btn-st-3 me-3",
                                        variant: "",
                                        onClick: function() {
                                            return setModalSaleShow(true);
                                        },
                                        children: "เพิ่มสาขาการขาย"
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Card, {
                                    className: "card-st-1 mb-4",
                                    children: /*#__PURE__*/ _jsxs(CardBody, {
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "fs-16 fw-bold mb-2 tc-5",
                                                children: "2.3 ค่าโฆษณา"
                                            }),
                                            /*#__PURE__*/ _jsx(Row, {
                                                children: /*#__PURE__*/ _jsx(Col, {
                                                    xs: 12,
                                                    children: /*#__PURE__*/ _jsx("div", {
                                                        className: "mb-2",
                                                        children: /*#__PURE__*/ _jsxs(Row, {
                                                            className: "align-items-center",
                                                            children: [
                                                                /*#__PURE__*/ _jsx(Col, {
                                                                    xs: 12,
                                                                    md: "auto",
                                                                    children: /*#__PURE__*/ _jsx(Form.Check, {
                                                                        inline: true,
                                                                        type: "radio",
                                                                        id: "p7-radio-1",
                                                                        label: "ยกเว้นค่าโฆษณา",
                                                                        checked: values.ct_contract_adverttype === 1 || !values.ct_contract_adverttype ? true : false,
                                                                        className: "form-check-st-2 tc-7 mt-0",
                                                                        name: "ct_contract_adverttype",
                                                                        isInvalid: !!errors.ct_contract_adverttype,
                                                                        onChange: function() {
                                                                            setFieldValue("ct_contract_adverttype", 1);
                                                                            setAdsFee(1);
                                                                            setContractData(_object_spread_props(_object_spread({}, contractData), {
                                                                                ct_contract_adverttype: 1
                                                                            }));
                                                                        }
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx(Col, {
                                                                    xs: 12,
                                                                    md: "auto",
                                                                    children: /*#__PURE__*/ _jsxs(Stack, {
                                                                        direction: "horizontal",
                                                                        gap: 2,
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx("div", {
                                                                                children: /*#__PURE__*/ _jsx(Form.Check, {
                                                                                    inline: true,
                                                                                    type: "radio",
                                                                                    id: "p7-radio-2",
                                                                                    label: "ค่าโฆษณาเข้าคงที่",
                                                                                    checked: values.ct_contract_adverttype === 2,
                                                                                    className: "form-check-st-2 tc-7 mt-0",
                                                                                    name: "ct_contract_adverttype",
                                                                                    isInvalid: !!errors.ct_contract_adverttype,
                                                                                    onChange: function() {
                                                                                        setFieldValue("ct_contract_adverttype", 2);
                                                                                        setAdsFee(2);
                                                                                        setContractData(_object_spread_props(_object_spread({}, contractData), {
                                                                                            ct_contract_adverttype: 2
                                                                                        }));
                                                                                    }
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("div", {
                                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                                    className: "mb-2 form-st-3 pb-1",
                                                                                    children: [
                                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                                            className: "mb-1",
                                                                                            children: "ค่าแรกเข้าต่อ SKU"
                                                                                        }),
                                                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                                                            type: "number",
                                                                                            name: "ct_contract_advertsku",
                                                                                            placeholder: "กรอกค่าแรกเข้าคงที่",
                                                                                            value: values.ct_contract_advertsku && values.ct_contract_advertsku != "" && values.ct_contract_advertsku != null ? values.ct_contract_advertsku : "",
                                                                                            onChange: function(e) {
                                                                                                setAdsFeeSku(e.target.value);
                                                                                                setFieldValue("ct_contract_advertsku", e.target.value);
                                                                                                setContractData(_object_spread_props(_object_spread({}, contractData), {
                                                                                                    ct_contract_advertsku: e.target.value
                                                                                                }));
                                                                                            },
                                                                                            isValid: touched.ct_contract_advertsku && !errors.ct_contract_advertsku,
                                                                                            isInvalid: !!errors.ct_contract_advertsku
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx(Col, {
                                                                    xs: 12,
                                                                    md: "auto",
                                                                    children: /*#__PURE__*/ _jsx(Form.Check, {
                                                                        inline: true,
                                                                        type: "radio",
                                                                        id: "p7-radio-3",
                                                                        label: "กำหนดค่าเอง",
                                                                        checked: values.ct_contract_adverttype === 3,
                                                                        className: "form-check-st-2 tc-7 mt-0",
                                                                        name: "ct_contract_adverttype",
                                                                        isInvalid: !!errors.ct_contract_adverttype,
                                                                        onChange: function() {
                                                                            setFieldValue("ct_contract_adverttype", 3);
                                                                            setAdsFee(3);
                                                                            setContractData(_object_spread_props(_object_spread({}, contractData), {
                                                                                ct_contract_adverttype: 3
                                                                            }));
                                                                        }
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    }, "p7-radio")
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "my-4",
                                    children: /*#__PURE__*/ _jsx(AdsData, {
                                        adsData: branchAdsData,
                                        setAdsData: setBranchAdsData,
                                        entryFee: adsFee,
                                        entryFeeSku: adsFeeSku,
                                        optionsMstVat: optionsMstVat,
                                        optionsMstTax: optionsMstTax,
                                        adsSum: adsSum,
                                        setAdsSum: setAdsSum,
                                        editDisabled: props.editDisabled
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "my-4",
                                    children: /*#__PURE__*/ _jsx(Button, {
                                        type: "button",
                                        className: "btn-st-3 me-3",
                                        variant: "",
                                        onClick: function() {
                                            return setModalAdsShow(true);
                                        },
                                        children: "เพิ่มสาขาโฆษณา"
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Card, {
                                    className: "card-st-1 mb-4",
                                    children: /*#__PURE__*/ _jsxs(CardBody, {
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "fs-16 fw-bold mb-2 tc-5",
                                                children: "3. ค่าคอมมิชชั่น จากการขายสินค้า (GP)"
                                            }),
                                            /*#__PURE__*/ _jsxs(Row, {
                                                className: "align-items-center",
                                                children: [
                                                    /*#__PURE__*/ _jsx(Col, {
                                                        xs: 6,
                                                        md: 4,
                                                        lg: 2,
                                                        children: /*#__PURE__*/ _jsxs(InputGroup, {
                                                            className: "mb-2 form-st-3 pb-1",
                                                            children: [
                                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                                    className: "mb-1",
                                                                    style: {
                                                                        zIndex: 11
                                                                    },
                                                                    children: "ค่าคอมมิชชั่นการขาย"
                                                                }),
                                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                                    type: "number",
                                                                    name: "ct_contract_salescomm",
                                                                    placeholder: "0",
                                                                    value: values.ct_contract_salescomm,
                                                                    onChange: function(e) {
                                                                        setFieldValue("ct_contract_salescomm", e.target.value);
                                                                        setContractData(_object_spread_props(_object_spread({}, contractData), {
                                                                            ct_contract_salescomm: e.target.value
                                                                        }));
                                                                    },
                                                                    isValid: touched.ct_contract_salescomm && !errors.ct_contract_salescomm,
                                                                    isInvalid: !!errors.ct_contract_salescomm,
                                                                    "aria-describedby": "salescomm"
                                                                }),
                                                                /*#__PURE__*/ _jsx(InputGroup.Text, {
                                                                    id: "salescomm",
                                                                    children: "%"
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx(Col, {
                                                        xs: 6,
                                                        md: 4,
                                                        lg: 2,
                                                        children: /*#__PURE__*/ _jsxs(InputGroup, {
                                                            className: "mb-2 form-st-3 pb-1",
                                                            children: [
                                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                                    className: "mb-1",
                                                                    style: {
                                                                        zIndex: 11
                                                                    },
                                                                    children: "ค่าคอมมิชชั่นกรณีค้าส่ง"
                                                                }),
                                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                                    type: "number",
                                                                    name: "ct_contract_wholesalescomm",
                                                                    placeholder: "0",
                                                                    value: values.ct_contract_wholesalescomm,
                                                                    onChange: function(e) {
                                                                        setFieldValue("ct_contract_wholesalescomm", e.target.value);
                                                                        setContractData(_object_spread_props(_object_spread({}, contractData), {
                                                                            ct_contract_wholesalescomm: e.target.value
                                                                        }));
                                                                    },
                                                                    isValid: touched.ct_contract_wholesalescomm && !errors.ct_contract_wholesalescomm,
                                                                    isInvalid: !!errors.ct_contract_wholesalescomm,
                                                                    "aria-describedby": "wholesalescomm"
                                                                }),
                                                                /*#__PURE__*/ _jsx(InputGroup.Text, {
                                                                    id: "wholesalescomm",
                                                                    children: "%"
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Card, {
                                    className: "card-st-1 mb-4",
                                    children: /*#__PURE__*/ _jsxs(CardBody, {
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "fs-16 fw-bold mb-2 tc-5",
                                                children: "10. เงื่อนไขเพิ่ม"
                                            }),
                                            /*#__PURE__*/ _jsx(Row, {
                                                className: "align-items-center",
                                                children: /*#__PURE__*/ _jsx(Col, {
                                                    xs: 12,
                                                    children: /*#__PURE__*/ _jsx(Form.Group, {
                                                        className: "mb-2 form-st-3 pb-1",
                                                        children: /*#__PURE__*/ _jsx(Form.Control, {
                                                            as: "textarea",
                                                            rows: 4,
                                                            id: "ct_contract_additional",
                                                            name: "ct_contract_additional",
                                                            placeholder: "ใส่เงื่อนไขเพิ่มเติม",
                                                            style: {
                                                                resize: "none"
                                                            },
                                                            value: values.ct_contract_additional,
                                                            onChange: function(e) {
                                                                setFieldValue("ct_contract_additional", e.target.value);
                                                                setContractData(_object_spread_props(_object_spread({}, contractData), {
                                                                    ct_contract_additional: e.target.value
                                                                }));
                                                            },
                                                            isValid: touched.ct_contract_additional && !errors.ct_contract_additional,
                                                            isInvalid: !!errors.ct_contract_additional
                                                        })
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    });
                }
            }),
            props.activeButton && props.activeButton >= 3 ? /*#__PURE__*/ _jsx(Card, {
                className: "card-st-1 mb-4",
                children: /*#__PURE__*/ _jsxs(CardBody, {
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "fs-16 fw-bold mb-2 tc-5",
                            children: "ข้อมูลสัญญา"
                        }),
                        /*#__PURE__*/ _jsxs(Row, {
                            className: "align-items-center",
                            children: [
                                /*#__PURE__*/ _jsx(Col, {
                                    xs: 12,
                                    md: 6,
                                    lg: 4,
                                    xl: 3,
                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                        className: "mb-2 form-st-3 pb-1",
                                        children: [
                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                className: "mb-1",
                                                children: "อายุสัญญา (เดือน)"
                                            }),
                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                type: "number",
                                                name: "ct_contract_duration_show",
                                                placeholder: "กรุณากรอกอายุสัญญา",
                                                value: contractData.ct_contract_duration,
                                                onChange: function(e) {},
                                                disabled: true,
                                                readOnly: true
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Col, {
                                    xs: 12,
                                    md: 6,
                                    lg: 4,
                                    xl: 3,
                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                        className: "mb-2 form-st-3 pb-1",
                                        children: [
                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                className: "mb-1",
                                                children: "วันที่เริ่มสัญญา"
                                            }),
                                            /*#__PURE__*/ _jsx(DatePicker, {
                                                inputFormat: "DD/MM/YYYY",
                                                selected: contractData.ct_contract_startdate ? moment(contractData.ct_contract_startdate).toDate() : "",
                                                onChange: function(date) {},
                                                placeholder: "DD/MM/YYYY",
                                                className: "w-100 datepicker2",
                                                value: contractData.ct_contract_startdate ? moment(contractData.ct_contract_startdate).format("DD/MM/YYYY") : "",
                                                disabled: true,
                                                readOnly: true
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Col, {
                                    xs: 12,
                                    md: 6,
                                    lg: 4,
                                    xl: 3,
                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                        className: "mb-2 form-st-3 pb-1",
                                        children: [
                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                className: "mb-1",
                                                children: "วันที่หมดอายุสัญญา"
                                            }),
                                            /*#__PURE__*/ _jsx(DatePicker, {
                                                inputFormat: "DD/MM/YYYY",
                                                selected: contractData.ct_contract_enddate ? moment(contractData.ct_contract_enddate).toDate() : "",
                                                onChange: function(date) {},
                                                placeholder: "DD/MM/YYYY",
                                                className: "w-100 datepicker2",
                                                value: contractData.ct_contract_enddate ? moment(contractData.ct_contract_enddate).format("DD/MM/YYYY") : "",
                                                disabled: true,
                                                readOnly: true
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "fs-16 fw-bold my-2 tc-5",
                            children: "อัฟโหลดเอกสาร"
                        }),
                        /*#__PURE__*/ _jsx(Row, {
                            className: "align-items-center justify-content-between",
                            children: /*#__PURE__*/ _jsx(Col, {
                                xs: 12,
                                children: /*#__PURE__*/ _jsx(FileUploader, {
                                    fileUpLoad: fileUpLoad,
                                    setFileUpLoad: setFileUpLoad,
                                    fileDelOld: fileDelOld,
                                    setFileDelOld: setFileDelOld
                                })
                            })
                        })
                    ]
                })
            }) : /*#__PURE__*/ _jsx(_Fragment, {}),
            /*#__PURE__*/ _jsx(Card, {
                className: "card-st-1 mb-4",
                children: /*#__PURE__*/ _jsx(CardBody, {
                    children: /*#__PURE__*/ _jsxs(Row, {
                        className: "align-items-center justify-content-between",
                        children: [
                            props.activeButton && props.activeButton >= 3 ? /*#__PURE__*/ _jsx(Col, {
                                xs: 12,
                                sm: "auto",
                                className: "mb-3",
                                children: /*#__PURE__*/ _jsx("div", {
                                    className: "d-flex gap-2",
                                    children: /*#__PURE__*/ _jsxs(Button, {
                                        variant: "",
                                        className: "btn-print-info mb-xs-2 mb-lg-0",
                                        onClick: handleDownload,
                                        children: [
                                            /*#__PURE__*/ _jsx(PrintIcon, {
                                                className: "mr-1"
                                            }),
                                            "พิมพ์สัญญา"
                                        ]
                                    })
                                })
                            }) : /*#__PURE__*/ _jsx(Col, {
                                xs: 12,
                                sm: 6
                            }),
                            /*#__PURE__*/ _jsx(Col, {
                                xs: 12,
                                sm: "auto",
                                className: "mb-3",
                                children: /*#__PURE__*/ _jsxs("div", {
                                    className: "d-flex gap-2",
                                    children: [
                                        /*#__PURE__*/ _jsx(Button, {
                                            variant: "outline-secondary",
                                            href: "/manage_contract/new",
                                            className: "mb-xs-2 mb-lg-0",
                                            children: "ยกเลิก"
                                        }),
                                        props.activeButton && (props.activeButton == 4 || props.activeButton == 5) ? /*#__PURE__*/ _jsx(_Fragment, {
                                            children: /*#__PURE__*/ _jsx(Button, {
                                                className: "mb-xs-2 mb-lg-0",
                                                onClick: function() {
                                                    handleSaveDataShow();
                                                },
                                                variant: "success",
                                                children: "บันทึก"
                                            })
                                        }) : props.activeButton == 3 && props.editDisabled ? /*#__PURE__*/ _jsxs(_Fragment, {
                                            children: [
                                                /*#__PURE__*/ _jsx(Button, {
                                                    className: "mb-xs-2 mb-lg-0",
                                                    onClick: function() {
                                                        setStatusSubmit(6);
                                                        handleConfirmShow();
                                                    },
                                                    variant: "success",
                                                    children: "ยืนยันสัญญา"
                                                }),
                                                /*#__PURE__*/ _jsx(Button, {
                                                    className: "btn-st-7 px-2 mb-xs-2 mb-lg-0",
                                                    onClick: function() {
                                                        props.setEditDisabled(false);
                                                    },
                                                    variant: "",
                                                    children: "แก้ไข"
                                                })
                                            ]
                                        }) : props.activeButton == 3 && !props.editDisabled ? /*#__PURE__*/ _jsx(_Fragment, {
                                            children: /*#__PURE__*/ _jsx(Button, {
                                                className: "btn-st-7 px-2 mb-xs-2 mb-lg-0",
                                                onClick: function() {
                                                    handleSaveEditShow();
                                                },
                                                variant: "success",
                                                children: "บันทึก"
                                            })
                                        }) : props.activeButton == 2 ? /*#__PURE__*/ _jsxs(_Fragment, {
                                            children: [
                                                /*#__PURE__*/ _jsx(Button, {
                                                    className: "mb-xs-2 mb-lg-0",
                                                    onClick: function() {
                                                        setStatusSubmit(3);
                                                        handleApproveShow();
                                                    },
                                                    variant: "success",
                                                    children: "อนุมัติ"
                                                }),
                                                /*#__PURE__*/ _jsx(Button, {
                                                    className: "btn-st-7 px-2 mb-xs-2 mb-lg-0",
                                                    onClick: function() {
                                                        setStatusSubmit(4);
                                                        handleNoApproveShow();
                                                    },
                                                    variant: "",
                                                    children: "ไม่อนุมัติ"
                                                })
                                            ]
                                        }) : /*#__PURE__*/ _jsxs(_Fragment, {
                                            children: [
                                                /*#__PURE__*/ _jsx(Button, {
                                                    className: "btn-st-7 px-2 mb-xs-2 mb-lg-0",
                                                    onClick: function() {
                                                        setStatusSubmit(1);
                                                        chackFillSave(1, dataFrom);
                                                    //handleDraftShow();
                                                    },
                                                    variant: "",
                                                    children: "บันทึกร่าง"
                                                }),
                                                /*#__PURE__*/ _jsx(Button, {
                                                    className: "mb-xs-2 mb-lg-0",
                                                    onClick: function() {
                                                        setStatusSubmit(2);
                                                        chackFillSave(2, dataFrom);
                                                    //handleSendApproveShow();
                                                    },
                                                    variant: "primary",
                                                    children: "ส่งอนุมัติ"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ _jsx(ProductModal, {
                show: modalShow,
                onHide: function() {
                    setLoadDataPd(false);
                    setModalShow(false);
                },
                setProductData: setProductData,
                productData: productData,
                businessId: businessId,
                entryFee: entryFee,
                entryFeeSku: entryFeeSku,
                // optionsPdList={optionsPdList}
                // setOptionsPdList={setOptionsPdList}
                reloadCalMain: reloadCalMain,
                setReloadCalMain: setReloadCalMain,
                resetProduct: props.resetProduct,
                setResetProduct: props.setResetProduct,
                loadDataPd: loadDataPd,
                setLoadDataPd: setLoadDataPd
            }),
            /*#__PURE__*/ _jsx(BranchSaleModal, {
                show: modalSaleShow,
                onHide: function() {
                    return setModalSaleShow(false);
                },
                setBranchSaleData: setBranchSaleData,
                branchSaleData: branchSaleData,
                businessId: businessId,
                entryFee: positionFee,
                entryFeeSku: positionFeeSku
            }),
            /*#__PURE__*/ _jsx(BranchAdsModal, {
                show: modalAdsShow,
                onHide: function() {
                    return setModalAdsShow(false);
                },
                setBranchAdsData: setBranchAdsData,
                branchAdsData: branchAdsData,
                businessId: businessId,
                entryFee: adsFee,
                entryFeeSku: adsFeeSku
            }),
            /*#__PURE__*/ _jsx(DraftModal, {
                show: draftShow,
                onHide: handleDraftClose,
                setDataFrom: setDataFrom,
                dataFrom: dataFrom,
                modalsuccess: modalsuccess,
                setModalsuccess: setModalsuccess,
                bankInfoSl: bankInfoSl
            }),
            /*#__PURE__*/ _jsx(SendApproveModal, {
                show: sendApproveShow,
                onHide: handleSendApproveClose,
                setDataFrom: setDataFrom,
                dataFrom: dataFrom,
                modalsuccess: modalsuccess,
                setModalsuccess: setModalsuccess,
                bankInfoSl: bankInfoSl
            }),
            /*#__PURE__*/ _jsx(ApproveModal, {
                show: approveShow,
                onHide: handleApproveClose,
                setDataFrom: setDataFrom,
                dataFrom: dataFrom,
                modalsuccess: modalsuccess,
                setModalsuccess: setModalsuccess,
                bankInfoSl: bankInfoSl
            }),
            /*#__PURE__*/ _jsx(NoApproveModal, {
                show: noApproveShow,
                onHide: handleNoApproveClose,
                setDataFrom: setDataFrom,
                dataFrom: dataFrom,
                modalsuccess: modalsuccess,
                setModalsuccess: setModalsuccess,
                bankInfoSl: bankInfoSl
            }),
            /*#__PURE__*/ _jsx(ConfirmModal, {
                show: confirmShow,
                onHide: handleConfirmClose,
                fileUpLoad: fileUpLoad,
                setFileUpLoad: setFileUpLoad,
                dataFrom: dataFrom,
                modalsuccess: modalsuccess,
                setModalsuccess: setModalsuccess,
                bankInfoSl: bankInfoSl
            }),
            /*#__PURE__*/ _jsx(SaveDataModal, {
                show: saveDataShow,
                onHide: handleSaveDataClose,
                fileUpLoad: fileUpLoad,
                setFileUpLoad: setFileUpLoad,
                fileDelOld: fileDelOld,
                setFileDelOld: setFileDelOld,
                dataFrom: dataFrom,
                modalsuccess: modalsuccess,
                setModalsuccess: setModalsuccess,
                bankInfoSl: bankInfoSl
            }),
            /*#__PURE__*/ _jsx(EditDataModal, {
                show: saveEditShow,
                onHide: handleEditClose,
                setDataFrom: setDataFrom,
                dataFrom: dataFrom,
                modalsuccess: modalsuccess,
                setModalsuccess: setModalsuccess,
                bankInfoSl: bankInfoSl
            }),
            /*#__PURE__*/ _jsx(ModalSuccessCustom, {
                show: modalsuccess.visible,
                onHide: function() {
                    return setModalsuccess(function(prev) {
                        return _object_spread_props(_object_spread({}, prev), {
                            visible: false
                        });
                    });
                },
                textsuccess: modalsuccess.textsuccess,
                navigate: navigate,
                direction: modalsuccess.direction
            }),
            /*#__PURE__*/ _jsx(NotifyModal, {
                show: notifyBoxShow,
                onHide: handleNotifyClose,
                hTitle: "แจ้งเตือน",
                msgText: msgText,
                heightM: 320
            }),
            /*#__PURE__*/ _jsxs(ModalAllder, {
                modal: modalAlert,
                setModal: setModalAlert,
                htitle: "แจ้งเตือน",
                hbtn: false,
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "pt-4 text-break",
                        style: {
                            fontSize: "22px",
                            color: "#2F4858"
                        },
                        dangerouslySetInnerHTML: {
                            __html: msgText && msgText != "" ? msgText : "ข้อความแจ้งเตือน"
                        }
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "d-flex align-items-center pb-4 pt-5 ",
                        children: /*#__PURE__*/ _jsx(Button, {
                            variant: "danger",
                            className: "fs-20 mx-auto",
                            onClick: function() {
                                return setModalAlert(function(prev) {
                                    return _object_spread_props(_object_spread({}, prev), {
                                        open: false
                                    });
                                });
                            },
                            children: "ยืนยัน"
                        })
                    })
                ]
            })
        ]
    });
};
function ProductData(_param) {
    var productData = _param.productData, setProductData = _param.setProductData, props = _object_without_properties(_param, [
        "productData",
        "setProductData"
    ]);
    var rest = _extends({}, _object_destructuring_empty(props));
    var entryFee = props.entryFee ? props.entryFee : 0;
    var entryFeeSku = props.entryFeeSku ? props.entryFeeSku : 0;
    var optionsMstVat = props.optionsMstVat && props.optionsMstVat.length > 0 ? props.optionsMstVat : [];
    var optionsMstTax = props.optionsMstTax && props.optionsMstTax.length > 0 ? props.optionsMstTax : [];
    var statusCt = props.statusCt ? props.statusCt : 0;
    var reloadCalMain = props.reloadCalMain ? props.reloadCalMain : false;
    var _useState = _sliced_to_array(useState(null), 2), pdAmount = _useState[0], setPdAmount = _useState[1];
    var _useState1 = _sliced_to_array(useState(null), 2), pdSumCost = _useState1[0], setPdSumCost = _useState1[1];
    var _useState2 = _sliced_to_array(useState(null), 2), pdSumDiscount = _useState2[0], setPdSumDiscount = _useState2[1];
    var _useState3 = _sliced_to_array(useState(null), 2), pdSumTax = _useState3[0], setPdSumTax = _useState3[1];
    var _useState4 = _sliced_to_array(useState(null), 2), pdSumPreTax = _useState4[0], setPdSumPreTax = _useState4[1];
    var _useState5 = _sliced_to_array(useState(null), 2), pdSumVat = _useState5[0], setPdSumVat = _useState5[1];
    var _useState6 = _sliced_to_array(useState(null), 2), pdSumNet = _useState6[0], setPdSumNet = _useState6[1];
    var _useState7 = _sliced_to_array(useState(false), 2), reloadCal = _useState7[0], setReloadCal = _useState7[1];
    var calSumTabel = function() {
        var productAmount = 0;
        var sumInitalCost = 0;
        var sumDiscount = 0;
        var sumTax = 0;
        var sumPreTax = 0;
        var sumVat = 0;
        var sumNet = 0;
        if (productData && productData.length > 0) {
            productAmount = productData.length;
            setProductData(productData.map(function(item, index) {
                var pretax = 0;
                var taxVale = 0;
                var vatVale = 0;
                var netVale = 0;
                if (item.ct_product_initalcost && item.ct_product_initalcost > 0) {
                    if (item.ct_product_discount && item.ct_product_discount > 0) {
                        pretax = parseFloat(item.ct_product_initalcost) - parseFloat(item.ct_product_discount);
                    } else {
                        pretax = parseFloat(item.ct_product_initalcost);
                    }
                    if (item.ct_product_tax && item.ct_product_tax > 0) {
                        taxVale = parseFloat(pretax) * parseFloat(item.ct_product_tax) / 100;
                    } else {
                        taxVale = 0;
                    }
                    if (item.ct_product_vat && item.ct_product_vat > 0) {
                        vatVale = parseFloat(pretax) * parseFloat(item.ct_product_vat) / 100;
                        netVale = parseFloat(pretax - vatVale + taxVale);
                    } else {
                        vatVale = 0;
                        netVale = parseFloat(pretax + taxVale);
                    }
                } else {
                    pretax = 0;
                    taxVale = 0;
                    vatVale = 0;
                    netVale = 0;
                }
                if (item.ct_product_initalcost && item.ct_product_initalcost > 0) {
                    sumInitalCost += parseFloat(item.ct_product_initalcost);
                }
                if (item.ct_product_discount && item.ct_product_discount > 0) {
                    sumDiscount += parseFloat(item.ct_product_discount);
                }
                if (taxVale && taxVale > 0) {
                    sumTax += parseFloat(taxVale);
                }
                if (pretax && pretax > 0) {
                    sumPreTax += parseFloat(pretax);
                }
                if (vatVale && vatVale > 0) {
                    sumVat += parseFloat(vatVale);
                }
                if (netVale && netVale > 0) {
                    sumNet += parseFloat(netVale);
                }
                return _object_spread_props(_object_spread({}, item), {
                    ct_product_pretax: parseFloat(pretax),
                    ct_product_tax_vale: parseFloat(taxVale),
                    ct_product_vat_value: parseFloat(vatVale),
                    ct_product_net: parseFloat(netVale)
                });
            }));
        }
        props.setProductSum({
            productAmount: parseInt(productAmount),
            sumInitalCost: parseFloat(sumInitalCost),
            sumDiscount: parseFloat(sumDiscount),
            sumTax: parseFloat(sumTax),
            sumPreTax: parseFloat(sumPreTax),
            sumVat: parseFloat(sumVat),
            sumNet: parseFloat(sumNet)
        });
        setPdAmount(parseInt(productAmount));
        setPdSumCost(parseFloat(sumInitalCost));
        setPdSumDiscount(parseFloat(sumDiscount));
        setPdSumTax(parseFloat(sumTax));
        setPdSumPreTax(parseFloat(sumPreTax));
        setPdSumVat(parseFloat(sumVat));
        setPdSumNet(parseFloat(sumNet));
        setReloadCal(false);
        props.setReloadCalMain(false);
    };
    var handleDeleteRow = function(rowId) {
        if (rowId && rowId != "" && rowId != null) {
            setProductData(function(productData) {
                return productData.filter(function(item) {
                    return item.rowID !== rowId;
                });
            });
            setReloadCal(true);
        }
    };
    useEffect(function() {
        if (entryFee && entryFee > 0) {
            setProductData(productData.map(function(item, index) {
                return _object_spread_props(_object_spread({}, item), {
                    rowID: nanoid(),
                    ct_product_initalcost: entryFee == 2 ? NumberFormatFloat(entryFeeSku, 2) : entryFee == 1 ? NumberFormatFloat(0, 2) : NumberFormatFloat(item.ct_product_initalcost, 2)
                });
            }));
            setReloadCal(true);
        }
    }, [
        entryFee,
        entryFeeSku
    ]);
    useEffect(function() {
        if ((reloadCal || reloadCalMain) && productData && productData.length > 0) {
            //console.log("productData",productData);
            calSumTabel();
        } else if (productData && productData.length > 0 && (!pdSumCost || pdSumCost == 0)) {
            calSumTabel();
        }
    }, [
        productData,
        reloadCal
    ]);
    return /*#__PURE__*/ _jsxs(Table, {
        striped: true,
        bordered: true,
        responsive: true,
        children: [
            /*#__PURE__*/ _jsx("thead", {
                children: /*#__PURE__*/ _jsxs("tr", {
                    children: [
                        /*#__PURE__*/ _jsx("th", {
                            className: "text-center",
                            children: "#"
                        }),
                        /*#__PURE__*/ _jsx("th", {
                            children: "รายการสินค้า"
                        }),
                        /*#__PURE__*/ _jsxs("th", {
                            className: "text-center bg-th-primary",
                            children: [
                                "ค่าแรกเข้า",
                                /*#__PURE__*/ _jsx("br", {}),
                                "(Ex.vat)"
                            ]
                        }),
                        /*#__PURE__*/ _jsx("th", {
                            className: "text-center bg-th-danger",
                            children: "ส่วนลด"
                        }),
                        /*#__PURE__*/ _jsx("th", {
                            className: "text-center bg-th-secondary",
                            children: "ภาษี"
                        }),
                        /*#__PURE__*/ _jsx("th", {
                            className: "text-center",
                            children: "มูลค่าก่อนภาษี"
                        }),
                        /*#__PURE__*/ _jsx("th", {
                            className: "text-center",
                            children: "หัก ณ ที่จ่าย"
                        }),
                        /*#__PURE__*/ _jsx("th", {
                            className: "text-center",
                            children: "มูลค่าสุทธิ"
                        }),
                        /*#__PURE__*/ _jsx("th", {
                            className: "text-center",
                            children: "หมายเหตุ"
                        }),
                        productData && productData.length > 0 ? /*#__PURE__*/ _jsx("th", {}) : /*#__PURE__*/ _jsx(_Fragment, {})
                    ]
                })
            }),
            /*#__PURE__*/ _jsxs("tbody", {
                children: [
                    productData && productData.length > 0 ? productData.map(function(item, index) {
                        return /*#__PURE__*/ _jsxs("tr", {
                            children: [
                                /*#__PURE__*/ _jsx("td", {
                                    className: "align-middle text-center",
                                    style: {
                                        minWidth: 80
                                    },
                                    children: index + 1
                                }),
                                /*#__PURE__*/ _jsx("td", {
                                    class: "align-middle",
                                    style: {
                                        minWidth: 200
                                    },
                                    children: item.ct_product_name
                                }),
                                /*#__PURE__*/ _jsx("td", {
                                    className: "align-middle text-center bg-td-primary",
                                    style: {
                                        minWidth: 200
                                    },
                                    children: entryFee && entryFee == 3 ? /*#__PURE__*/ _jsx(Form.Control, {
                                        type: "number",
                                        placeholder: "ค่าแรกเข้า",
                                        style: {
                                            width: "150px"
                                        },
                                        onChange: function(e) {
                                            setProductData(function(prev) {
                                                return prev.map(function(el) {
                                                    if (el.rowID === item.rowID) {
                                                        return _object_spread_props(_object_spread({}, el), {
                                                            ct_product_initalcost: e.target.value
                                                        });
                                                    }
                                                    return el;
                                                });
                                            });
                                            setReloadCal(true);
                                        },
                                        value: item.ct_product_initalcost != null && item.ct_product_initalcost != "" && item.ct_product_initalcost != "null" ? NumberFormatFloat(item.ct_product_initalcost, 2) : ""
                                    }) : /*#__PURE__*/ _jsx(NumericFormat, {
                                        value: item.ct_product_initalcost,
                                        thousandSeparator: ",",
                                        decimalScale: 2,
                                        fixedDecimalScale: true,
                                        displayType: "text"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("td", {
                                    className: "align-middle text-center bg-td-danger",
                                    style: {
                                        minWidth: 150
                                    },
                                    children: /*#__PURE__*/ _jsx(Form.Control, {
                                        type: "number",
                                        placeholder: "ส่วนลด",
                                        style: {
                                            width: "150px"
                                        },
                                        onChange: function(e) {
                                            setProductData(function(prev) {
                                                return prev.map(function(el) {
                                                    if (el.rowID === item.rowID) {
                                                        return _object_spread_props(_object_spread({}, el), {
                                                            ct_product_discount: e.target.value
                                                        });
                                                    }
                                                    return el;
                                                });
                                            });
                                            setReloadCal(true);
                                        },
                                        value: item.ct_product_discount != null && item.ct_product_discount != "" && item.ct_product_discount != "null" ? NumberFormatFloat(item.ct_product_discount, 2) : ""
                                    })
                                }),
                                /*#__PURE__*/ _jsx("td", {
                                    className: "align-middle text-center",
                                    style: {
                                        minWidth: 150
                                    },
                                    children: /*#__PURE__*/ _jsx(Select, {
                                        as: "select",
                                        name: "ct_product_tax_" + (index + 1),
                                        onChange: function(e) {
                                            setProductData(function(prev) {
                                                return prev.map(function(el) {
                                                    if (el.rowID === item.rowID) {
                                                        return _object_spread_props(_object_spread({}, el), {
                                                            ct_product_tax: e.value
                                                        });
                                                    }
                                                    return el;
                                                });
                                            });
                                            setReloadCal(true);
                                        },
                                        className: "w-100 select-st-1",
                                        options: optionsMstVat,
                                        placeholder: "เลือกภาษี",
                                        value: optionsMstVat.filter(function(item2) {
                                            return item2.value === item.ct_product_tax;
                                        }),
                                        isDisabled: statusCt && statusCt > 1 ? true : false
                                    })
                                }),
                                /*#__PURE__*/ _jsx("td", {
                                    className: "align-middle text-center",
                                    style: {
                                        minWidth: 200
                                    },
                                    children: /*#__PURE__*/ _jsx(NumericFormat, {
                                        value: item.ct_product_pretax,
                                        thousandSeparator: ",",
                                        decimalScale: 2,
                                        fixedDecimalScale: true,
                                        displayType: "text"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("td", {
                                    className: "align-middle text-center",
                                    style: {
                                        minWidth: 150
                                    },
                                    children: /*#__PURE__*/ _jsx(Select, {
                                        as: "select",
                                        name: "ct_product_vat_" + (index + 1),
                                        onChange: function(e) {
                                            setProductData(function(prev) {
                                                return prev.map(function(el) {
                                                    if (el.rowID === item.rowID) {
                                                        return _object_spread_props(_object_spread({}, el), {
                                                            ct_product_vat: e.value
                                                        });
                                                    }
                                                    return el;
                                                });
                                            });
                                            setReloadCal(true);
                                        },
                                        className: "w-100 select-st-1",
                                        options: optionsMstTax,
                                        placeholder: "เลือกหัก ณ ที่จ่าย",
                                        value: optionsMstTax.filter(function(item2) {
                                            return item2.value === item.ct_product_vat;
                                        }),
                                        isDisabled: statusCt && statusCt > 1 ? true : false
                                    })
                                }),
                                /*#__PURE__*/ _jsx("td", {
                                    className: "align-middle text-center",
                                    style: {
                                        minWidth: 200
                                    },
                                    children: /*#__PURE__*/ _jsx(NumericFormat, {
                                        value: item.ct_product_net,
                                        thousandSeparator: ",",
                                        decimalScale: 2,
                                        fixedDecimalScale: true,
                                        displayType: "text"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("td", {
                                    class: "align-middle",
                                    style: {
                                        minWidth: 200
                                    },
                                    children: /*#__PURE__*/ _jsx(Form.Control, {
                                        type: "text",
                                        placeholder: "หมายเหตุ",
                                        style: {
                                            width: "200px"
                                        },
                                        onChange: function(e) {
                                            setProductData(function(prev) {
                                                return prev.map(function(el) {
                                                    if (el.rowID === item.rowID) {
                                                        return _object_spread_props(_object_spread({}, el), {
                                                            ct_product_remark: e.target.value
                                                        });
                                                    }
                                                    return el;
                                                });
                                            });
                                        },
                                        value: item.ct_product_remark != null && item.ct_product_remark != "" && item.ct_product_remark != "null" ? item.ct_product_remark : ""
                                    })
                                }),
                                /*#__PURE__*/ _jsx("td", {
                                    className: "align-middle text-center",
                                    children: /*#__PURE__*/ _jsx(IconButton, {
                                        "aria-label": "delete",
                                        color: "error",
                                        onClick: function() {
                                            return handleDeleteRow(item.rowID);
                                        },
                                        children: /*#__PURE__*/ _jsx(Avatar, {
                                            sx: {
                                                color: "rgba(176,4,18,1)",
                                                bgcolor: "rgba(246,225,227,1)"
                                            },
                                            children: /*#__PURE__*/ _jsx(DeleteIcon, {
                                                fontSize: "inherit"
                                            })
                                        })
                                    })
                                })
                            ]
                        });
                    }) : /*#__PURE__*/ _jsx(_Fragment, {}),
                    /*#__PURE__*/ _jsxs("tr", {
                        children: [
                            /*#__PURE__*/ _jsx("td", {
                                style: {
                                    minWidth: 80
                                }
                            }),
                            /*#__PURE__*/ _jsx("td", {
                                style: {
                                    minWidth: 200
                                }
                            }),
                            /*#__PURE__*/ _jsx("td", {
                                style: {
                                    minWidth: 200
                                }
                            }),
                            /*#__PURE__*/ _jsx("td", {
                                style: {
                                    minWidth: 150
                                }
                            }),
                            /*#__PURE__*/ _jsx("td", {
                                style: {
                                    minWidth: 150
                                }
                            }),
                            /*#__PURE__*/ _jsx("td", {
                                style: {
                                    minWidth: 200
                                }
                            }),
                            /*#__PURE__*/ _jsx("td", {
                                style: {
                                    minWidth: 150
                                }
                            }),
                            /*#__PURE__*/ _jsx("td", {
                                style: {
                                    minWidth: 200
                                }
                            }),
                            /*#__PURE__*/ _jsx("td", {
                                style: {
                                    minWidth: 200
                                }
                            }),
                            productData && productData.length > 0 ? /*#__PURE__*/ _jsx("td", {}) : /*#__PURE__*/ _jsx(_Fragment, {})
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("tr", {
                        children: [
                            /*#__PURE__*/ _jsx("td", {
                                colSpan: 2,
                                className: "text-end fw-bold",
                                children: "รวม"
                            }),
                            /*#__PURE__*/ _jsx("td", {
                                className: "text-end bg-td-primary fw-bold",
                                children: /*#__PURE__*/ _jsx(NumericFormat, {
                                    value: pdSumCost || 0,
                                    thousandSeparator: ",",
                                    decimalScale: 2,
                                    fixedDecimalScale: true,
                                    displayType: "text"
                                })
                            }),
                            /*#__PURE__*/ _jsx("td", {
                                className: "text-end bg-td-danger fw-bold",
                                children: /*#__PURE__*/ _jsx(NumericFormat, {
                                    value: pdSumDiscount || 0,
                                    thousandSeparator: ",",
                                    decimalScale: 2,
                                    fixedDecimalScale: true,
                                    displayType: "text"
                                })
                            }),
                            /*#__PURE__*/ _jsx("td", {
                                className: "text-end fw-bold"
                            }),
                            /*#__PURE__*/ _jsx("td", {
                                className: "text-end fw-bold",
                                children: /*#__PURE__*/ _jsx(NumericFormat, {
                                    value: pdSumPreTax || 0,
                                    thousandSeparator: ",",
                                    decimalScale: 2,
                                    fixedDecimalScale: true,
                                    displayType: "text"
                                })
                            }),
                            /*#__PURE__*/ _jsx("td", {
                                className: ""
                            }),
                            /*#__PURE__*/ _jsx("td", {
                                className: "text-end fw-bold",
                                children: /*#__PURE__*/ _jsx(NumericFormat, {
                                    value: pdSumNet || 0,
                                    thousandSeparator: ",",
                                    decimalScale: 2,
                                    fixedDecimalScale: true,
                                    displayType: "text"
                                })
                            }),
                            /*#__PURE__*/ _jsx("td", {
                                className: ""
                            }),
                            productData && productData.length > 0 ? /*#__PURE__*/ _jsx("td", {}) : /*#__PURE__*/ _jsx(_Fragment, {})
                        ]
                    })
                ]
            })
        ]
    });
}
function BranchData(_param) {
    var branchData = _param.branchData, setBranchData = _param.setBranchData, props = _object_without_properties(_param, [
        "branchData",
        "setBranchData"
    ]);
    var rest = _extends({}, _object_destructuring_empty(props));
    var entryFee = props.entryFee ? props.entryFee : 0;
    var entryFeeSku = props.entryFeeSku ? props.entryFeeSku : 0;
    var optionsMstVat = props.optionsMstVat && props.optionsMstVat.length > 0 ? props.optionsMstVat : [];
    var optionsMstTax = props.optionsMstTax && props.optionsMstTax.length > 0 ? props.optionsMstTax : [];
    var statusCt = props.statusCt ? props.statusCt : 0;
    var optionsPdList = props.optionsPdList && props.optionsPdList.length > 0 ? props.optionsPdList : [];
    var _useState = _sliced_to_array(useState(false), 2), reloadCal = _useState[0], setReloadCal = _useState[1];
    var calSumTabel = function() {
        var sumMonth = 0;
        var sumInitalCost = 0;
        var sumDiscount = 0;
        var sumTax = 0;
        var sumPreTax = 0;
        var sumVat = 0;
        var sumNet = 0;
        if (branchData && branchData.length > 0) {
            setBranchData(branchData.map(function(item, index) {
                var monthAmount = 0;
                var pretax = 0;
                var taxVale = 0;
                var vatVale = 0;
                var netVale = 0;
                if (item.ct_placement_month && item.ct_placement_month > 0) {
                    monthAmount = parseInt(item.ct_placement_month, 10);
                } else {
                    monthAmount = 0;
                }
                if (item.ct_placement_cost && item.ct_placement_cost > 0 && monthAmount > 0) {
                    if (item.ct_placement_discount && item.ct_placement_discount > 0) {
                        pretax = parseFloat(item.ct_placement_cost) * parseFloat(monthAmount) - parseFloat(item.ct_placement_discount);
                    } else {
                        pretax = parseFloat(item.ct_placement_cost) * parseFloat(monthAmount);
                    }
                    if (item.ct_placement_tax && item.ct_placement_tax > 0) {
                        taxVale = parseFloat(pretax) * parseFloat(item.ct_placement_tax) / 100;
                    } else {
                        taxVale = 0;
                    }
                    if (item.ct_placement_vat && item.ct_placement_vat > 0) {
                        vatVale = parseFloat(pretax) * parseFloat(item.ct_placement_vat) / 100;
                        netVale = parseFloat(pretax - vatVale + taxVale);
                    } else {
                        vatVale = 0;
                        netVale = parseFloat(pretax + taxVale);
                    }
                } else {
                    pretax = 0;
                    taxVale = 0;
                    vatVale = 0;
                    netVale = 0;
                }
                if (monthAmount && monthAmount > 0) {
                    sumMonth += parseInt(monthAmount, 10);
                }
                if (item.ct_placement_cost && item.ct_placement_cost > 0) {
                    sumInitalCost += parseFloat(item.ct_placement_cost);
                }
                if (item.ct_placement_discount && item.ct_placement_discount > 0) {
                    sumDiscount += parseFloat(item.ct_placement_discount);
                }
                if (taxVale && taxVale > 0) {
                    sumTax += parseFloat(taxVale);
                }
                if (pretax && pretax > 0) {
                    sumPreTax += parseFloat(pretax);
                }
                if (vatVale && vatVale > 0) {
                    sumVat += parseFloat(vatVale);
                }
                if (netVale && netVale > 0) {
                    sumNet += parseFloat(netVale);
                }
                return _object_spread_props(_object_spread({}, item), {
                    ct_placement_pretax: parseFloat(pretax),
                    ct_placement_tax_vale: parseFloat(taxVale),
                    ct_placement_vat_value: parseFloat(vatVale),
                    ct_placement_net: parseFloat(netVale)
                });
            }));
        }
        props.setBranchSum({
            sumMonth: parseInt(sumMonth),
            sumInitalCost: parseFloat(sumInitalCost),
            sumDiscount: parseFloat(sumDiscount),
            sumTax: parseFloat(sumTax),
            sumPreTax: parseFloat(sumPreTax),
            sumVat: parseFloat(sumVat),
            sumNet: parseFloat(sumNet)
        });
    };
    var handleDeleteRow = function(rowId) {
        if (rowId && rowId != "" && rowId != null) {
            setBranchData(function(branchData) {
                return branchData.filter(function(item) {
                    return item.rowID !== rowId;
                });
            });
            setReloadCal(true);
        }
    };
    useEffect(function() {
        if (entryFee && entryFee > 0) {
            setBranchData(branchData.map(function(item, index) {
                return _object_spread_props(_object_spread({}, item), {
                    rowID: nanoid(),
                    ct_placement_cost: entryFee == 2 ? NumberFormatFloat(entryFeeSku, 2) : entryFee == 1 ? NumberFormatFloat(0, 2) : NumberFormatFloat(item.ct_placement_cost, 2)
                });
            }));
            setReloadCal(true);
        }
    }, [
        entryFee,
        entryFeeSku
    ]);
    useEffect(function() {
        if (reloadCal && branchData && branchData.length > 0) {
            calSumTabel();
            setReloadCal(false);
        } else if (reloadCal && (!branchData || branchData.length <= 0)) {
            props.setBranchSum({
                sumMonth: 0,
                sumInitalCost: 0,
                sumDiscount: 0,
                sumTax: 0,
                sumPreTax: 0,
                sumVat: 0,
                sumNet: 0
            });
            setReloadCal(false);
        } else if (branchData && branchData.length > 0 && (!props.branchSum.sumInitalCost || props.branchSum.sumInitalCost == 0)) {
            calSumTabel();
        }
    }, [
        branchData,
        reloadCal
    ]);
    return /*#__PURE__*/ _jsxs(Table, {
        striped: true,
        bordered: true,
        responsive: true,
        children: [
            /*#__PURE__*/ _jsx("thead", {
                children: /*#__PURE__*/ _jsxs("tr", {
                    children: [
                        /*#__PURE__*/ _jsx("th", {
                            className: "text-center",
                            children: "#"
                        }),
                        /*#__PURE__*/ _jsx("th", {
                            children: "ช่องทางสาขาการขาย"
                        }),
                        /*#__PURE__*/ _jsx("th", {
                            className: "text-center",
                            children: "ตำแหน่งที่วาง"
                        }),
                        /*#__PURE__*/ _jsx("th", {
                            className: "text-center",
                            children: "สินค้า"
                        }),
                        /*#__PURE__*/ _jsx("th", {
                            className: "text-center",
                            children: "จำนวนเดือน"
                        }),
                        /*#__PURE__*/ _jsxs("th", {
                            className: "text-center",
                            children: [
                                "ค่าวางสินค้า / เดือน",
                                /*#__PURE__*/ _jsx("br", {}),
                                "( Ex.VAT )"
                            ]
                        }),
                        /*#__PURE__*/ _jsx("th", {
                            className: "text-center bg-th-danger",
                            children: "ส่วนลด"
                        }),
                        /*#__PURE__*/ _jsx("th", {
                            className: "text-center bg-th-secondary",
                            children: "ภาษี"
                        }),
                        /*#__PURE__*/ _jsx("th", {
                            className: "text-center",
                            children: "มูลค่าก่อนภาษี"
                        }),
                        /*#__PURE__*/ _jsx("th", {
                            className: "text-center",
                            children: "หัก ณ ที่จ่าย"
                        }),
                        /*#__PURE__*/ _jsx("th", {
                            className: "text-center",
                            children: "มูลค่าสุทธิ"
                        }),
                        /*#__PURE__*/ _jsx("th", {
                            className: "text-center",
                            children: "หมายเหตุ"
                        }),
                        branchData && branchData.length > 0 ? /*#__PURE__*/ _jsx("th", {
                            className: "text-center"
                        }) : /*#__PURE__*/ _jsx(_Fragment, {})
                    ]
                })
            }),
            /*#__PURE__*/ _jsxs("tbody", {
                children: [
                    branchData && branchData.length > 0 ? branchData.map(function(item, index) {
                        return /*#__PURE__*/ _jsxs("tr", {
                            children: [
                                /*#__PURE__*/ _jsx("td", {
                                    className: "align-middle text-center",
                                    style: {
                                        minWidth: 80
                                    },
                                    children: index + 1
                                }),
                                /*#__PURE__*/ _jsx("td", {
                                    className: "align-middle",
                                    style: {
                                        minWidth: 200
                                    },
                                    children: item.ct_placement_branch_name
                                }),
                                /*#__PURE__*/ _jsx("td", {
                                    className: "align-middle text-center",
                                    style: {
                                        minWidth: 125
                                    },
                                    children: /*#__PURE__*/ _jsx(Select, {
                                        as: "select",
                                        name: "ct_placement_positionid_" + (index + 1),
                                        onChange: function(e) {
                                            setBranchData(function(prev) {
                                                return prev.map(function(el) {
                                                    if (el.rowID === item.rowID) {
                                                        return _object_spread_props(_object_spread({}, el), {
                                                            ct_placement_positionid: e.value
                                                        });
                                                    }
                                                    return el;
                                                });
                                            });
                                        },
                                        className: "w-100 select-st-1",
                                        options: item.ct_placement_option,
                                        placeholder: "เลือกตำแหน่ง",
                                        value: item.ct_placement_option.filter(function(item2) {
                                            return item2.value === item.ct_placement_positionid;
                                        }),
                                        isDisabled: statusCt && statusCt > 1 ? true : false
                                    })
                                }),
                                /*#__PURE__*/ _jsx("td", {
                                    className: "align-middle text-center",
                                    style: {
                                        minWidth: 200
                                    },
                                    children: /*#__PURE__*/ _jsx(Select, {
                                        as: "select",
                                        name: "ct_placement_pdid_" + (index + 1),
                                        onChange: function(e) {
                                            setBranchData(function(prev) {
                                                return prev.map(function(el) {
                                                    if (el.rowID === item.rowID) {
                                                        return _object_spread_props(_object_spread({}, el), {
                                                            ct_placement_pdid: e.value,
                                                            ct_placement_pdnameth: e.label
                                                        });
                                                    }
                                                    return el;
                                                });
                                            });
                                        },
                                        className: "w-100 select-st-1",
                                        options: optionsPdList,
                                        placeholder: "เลือกสินค้า",
                                        value: optionsPdList.filter(function(item2) {
                                            return item2.value === item.ct_placement_pdid;
                                        }),
                                        isDisabled: statusCt && statusCt > 1 ? true : false
                                    })
                                }),
                                /*#__PURE__*/ _jsx("td", {
                                    className: "align-middle text-center",
                                    style: {
                                        minWidth: 100
                                    },
                                    children: /*#__PURE__*/ _jsx(Form.Control, {
                                        type: "number",
                                        placeholder: "จำนวนเดือน",
                                        style: {
                                            width: "100px"
                                        },
                                        onChange: function(e) {
                                            setBranchData(function(prev) {
                                                return prev.map(function(el) {
                                                    if (el.rowID === item.rowID) {
                                                        return _object_spread_props(_object_spread({}, el), {
                                                            ct_placement_month: e.target.value
                                                        });
                                                    }
                                                    return el;
                                                });
                                            });
                                            setReloadCal(true);
                                        },
                                        value: item.ct_placement_month != null && item.ct_placement_month != "" && item.ct_placement_month != "null" ? parseInt(item.ct_placement_month, 10) : ""
                                    })
                                }),
                                /*#__PURE__*/ _jsx("td", {
                                    className: "align-middle text-center",
                                    style: {
                                        minWidth: 150
                                    },
                                    children: entryFee && entryFee == 3 ? /*#__PURE__*/ _jsx(Form.Control, {
                                        type: "number",
                                        placeholder: "ค่าวางสินค้า / เดือน",
                                        style: {
                                            width: "150px"
                                        },
                                        onChange: function(e) {
                                            setBranchData(function(prev) {
                                                return prev.map(function(el) {
                                                    if (el.rowID === item.rowID) {
                                                        return _object_spread_props(_object_spread({}, el), {
                                                            ct_placement_cost: e.target.value
                                                        });
                                                    }
                                                    return el;
                                                });
                                            });
                                            setReloadCal(true);
                                        },
                                        value: item.ct_placement_cost != null && item.ct_placement_cost != "" && item.ct_placement_cost != "null" ? NumberFormatFloat(item.ct_placement_cost, 2) : ""
                                    }) : /*#__PURE__*/ _jsx(NumericFormat, {
                                        value: item.ct_placement_cost,
                                        thousandSeparator: ",",
                                        decimalScale: 2,
                                        fixedDecimalScale: true,
                                        displayType: "text"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("td", {
                                    className: "align-middle text-center bg-td-danger",
                                    style: {
                                        minWidth: 150
                                    },
                                    children: /*#__PURE__*/ _jsx(Form.Control, {
                                        type: "number",
                                        placeholder: "ส่วนลด",
                                        style: {
                                            width: "150px"
                                        },
                                        onChange: function(e) {
                                            setBranchData(function(prev) {
                                                return prev.map(function(el) {
                                                    if (el.rowID === item.rowID) {
                                                        return _object_spread_props(_object_spread({}, el), {
                                                            ct_placement_discount: e.target.value
                                                        });
                                                    }
                                                    return el;
                                                });
                                            });
                                            setReloadCal(true);
                                        },
                                        value: item.ct_placement_discount != null && item.ct_placement_discount != "" && item.ct_placement_discount != "null" ? NumberFormatFloat(item.ct_placement_discount, 2) : ""
                                    })
                                }),
                                /*#__PURE__*/ _jsx("td", {
                                    className: "align-middle text-center",
                                    style: {
                                        minWidth: 110
                                    },
                                    children: /*#__PURE__*/ _jsx(Select, {
                                        as: "select",
                                        name: "ct_placement_tax_" + (index + 1),
                                        onChange: function(e) {
                                            setBranchData(function(prev) {
                                                return prev.map(function(el) {
                                                    if (el.rowID === item.rowID) {
                                                        return _object_spread_props(_object_spread({}, el), {
                                                            ct_placement_tax: e.value
                                                        });
                                                    }
                                                    return el;
                                                });
                                            });
                                            setReloadCal(true);
                                        },
                                        className: "w-100 select-st-1",
                                        options: optionsMstVat,
                                        placeholder: "เลือกภาษี",
                                        value: optionsMstVat.filter(function(item2) {
                                            return item2.value === item.ct_placement_tax;
                                        }),
                                        isDisabled: statusCt && statusCt > 1 ? true : false
                                    })
                                }),
                                /*#__PURE__*/ _jsx("td", {
                                    className: "align-middle text-center",
                                    style: {
                                        minWidth: 100
                                    },
                                    children: /*#__PURE__*/ _jsx(NumericFormat, {
                                        value: item.ct_placement_pretax,
                                        thousandSeparator: ",",
                                        decimalScale: 2,
                                        fixedDecimalScale: true,
                                        displayType: "text"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("td", {
                                    className: "align-middle text-center",
                                    style: {
                                        minWidth: 125
                                    },
                                    children: /*#__PURE__*/ _jsx(Select, {
                                        as: "select",
                                        name: "ct_placement_vat_" + (index + 1),
                                        onChange: function(e) {
                                            setBranchData(function(prev) {
                                                return prev.map(function(el) {
                                                    if (el.rowID === item.rowID) {
                                                        return _object_spread_props(_object_spread({}, el), {
                                                            ct_placement_vat: e.value
                                                        });
                                                    }
                                                    return el;
                                                });
                                            });
                                            setReloadCal(true);
                                        },
                                        className: "w-100 select-st-1",
                                        options: optionsMstTax,
                                        placeholder: "เลือกหัก ณ ที่จ่าย",
                                        value: optionsMstTax.filter(function(item2) {
                                            return item2.value === item.ct_placement_vat;
                                        }),
                                        isDisabled: statusCt && statusCt > 1 ? true : false
                                    })
                                }),
                                /*#__PURE__*/ _jsx("td", {
                                    className: "align-middle text-center",
                                    style: {
                                        minWidth: 100
                                    },
                                    children: /*#__PURE__*/ _jsx(NumericFormat, {
                                        value: item.ct_placement_net,
                                        thousandSeparator: ",",
                                        decimalScale: 2,
                                        fixedDecimalScale: true,
                                        displayType: "text"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("td", {
                                    className: "align-middle",
                                    style: {
                                        minWidth: 200
                                    },
                                    children: /*#__PURE__*/ _jsx(Form.Control, {
                                        type: "text",
                                        placeholder: "หมายเหตุ",
                                        style: {
                                            width: "200px"
                                        },
                                        onChange: function(e) {
                                            setBranchData(function(prev) {
                                                return prev.map(function(el) {
                                                    if (el.rowID === item.rowID) {
                                                        return _object_spread_props(_object_spread({}, el), {
                                                            ct_placement_remark: e.target.value
                                                        });
                                                    }
                                                    return el;
                                                });
                                            });
                                        },
                                        value: item.ct_placement_remark != null && item.ct_placement_remark != "" && item.ct_placement_remark != "null" ? item.ct_placement_remark : ""
                                    })
                                }),
                                /*#__PURE__*/ _jsx("td", {
                                    className: "align-middle text-center",
                                    children: /*#__PURE__*/ _jsx(IconButton, {
                                        "aria-label": "delete",
                                        color: "error",
                                        onClick: function() {
                                            return handleDeleteRow(item.rowID);
                                        },
                                        children: /*#__PURE__*/ _jsx(Avatar, {
                                            sx: {
                                                color: "rgba(176,4,18,1)",
                                                bgcolor: "rgba(246,225,227,1)"
                                            },
                                            children: /*#__PURE__*/ _jsx(DeleteIcon, {
                                                fontSize: "inherit"
                                            })
                                        })
                                    })
                                })
                            ]
                        });
                    }) : /*#__PURE__*/ _jsx(_Fragment, {}),
                    /*#__PURE__*/ _jsxs("tr", {
                        children: [
                            /*#__PURE__*/ _jsx("td", {
                                style: {
                                    minWidth: 80
                                }
                            }),
                            /*#__PURE__*/ _jsx("td", {
                                style: {
                                    minWidth: 200
                                }
                            }),
                            /*#__PURE__*/ _jsx("td", {
                                style: {
                                    minWidth: 125
                                }
                            }),
                            /*#__PURE__*/ _jsx("td", {
                                style: {
                                    minWidth: 200
                                }
                            }),
                            /*#__PURE__*/ _jsx("td", {
                                style: {
                                    minWidth: 100
                                }
                            }),
                            /*#__PURE__*/ _jsx("td", {
                                style: {
                                    minWidth: 150
                                }
                            }),
                            /*#__PURE__*/ _jsx("td", {
                                style: {
                                    minWidth: 150
                                }
                            }),
                            /*#__PURE__*/ _jsx("td", {
                                style: {
                                    minWidth: 110
                                }
                            }),
                            /*#__PURE__*/ _jsx("td", {
                                style: {
                                    minWidth: 100
                                }
                            }),
                            /*#__PURE__*/ _jsx("td", {
                                style: {
                                    minWidth: 125
                                }
                            }),
                            /*#__PURE__*/ _jsx("td", {
                                style: {
                                    minWidth: 100
                                }
                            }),
                            /*#__PURE__*/ _jsx("td", {
                                style: {
                                    minWidth: 200
                                }
                            }),
                            branchData && branchData.length > 0 ? /*#__PURE__*/ _jsx("td", {}) : /*#__PURE__*/ _jsx(_Fragment, {})
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("tr", {
                        children: [
                            /*#__PURE__*/ _jsx("td", {
                                colSpan: 4,
                                className: "text-end fw-bold",
                                children: "รวม"
                            }),
                            /*#__PURE__*/ _jsx("td", {
                                className: "text-center fw-bold"
                            }),
                            /*#__PURE__*/ _jsx("td", {
                                className: "text-end fw-bold",
                                children: /*#__PURE__*/ _jsx(NumericFormat, {
                                    value: props.branchSum.sumInitalCost,
                                    thousandSeparator: ",",
                                    decimalScale: 2,
                                    fixedDecimalScale: true,
                                    displayType: "text"
                                })
                            }),
                            /*#__PURE__*/ _jsx("td", {
                                className: "text-end bg-td-danger fw-bold",
                                children: /*#__PURE__*/ _jsx(NumericFormat, {
                                    value: props.branchSum.sumDiscount,
                                    thousandSeparator: ",",
                                    decimalScale: 2,
                                    fixedDecimalScale: true,
                                    displayType: "text"
                                })
                            }),
                            /*#__PURE__*/ _jsx("td", {
                                className: "text-end fw-bold"
                            }),
                            /*#__PURE__*/ _jsx("td", {
                                className: "text-end fw-bold",
                                children: /*#__PURE__*/ _jsx(NumericFormat, {
                                    value: props.branchSum.sumPreTax,
                                    thousandSeparator: ",",
                                    decimalScale: 2,
                                    fixedDecimalScale: true,
                                    displayType: "text"
                                })
                            }),
                            /*#__PURE__*/ _jsx("td", {
                                className: ""
                            }),
                            /*#__PURE__*/ _jsx("td", {
                                className: "text-end fw-bold",
                                children: /*#__PURE__*/ _jsx(NumericFormat, {
                                    value: props.branchSum.sumNet,
                                    thousandSeparator: ",",
                                    decimalScale: 2,
                                    fixedDecimalScale: true,
                                    displayType: "text"
                                })
                            }),
                            /*#__PURE__*/ _jsx("td", {
                                className: ""
                            }),
                            branchData && branchData.length > 0 ? /*#__PURE__*/ _jsx("td", {}) : /*#__PURE__*/ _jsx(_Fragment, {})
                        ]
                    })
                ]
            })
        ]
    });
}
function AdsData(_param) {
    var adsData = _param.adsData, setAdsData = _param.setAdsData, props = _object_without_properties(_param, [
        "adsData",
        "setAdsData"
    ]);
    var rest = _extends({}, _object_destructuring_empty(props));
    var entryFee = props.entryFee ? props.entryFee : 0;
    var entryFeeSku = props.entryFeeSku ? props.entryFeeSku : 0;
    var optionsMstVat = props.optionsMstVat && props.optionsMstVat.length > 0 ? props.optionsMstVat : [];
    var optionsMstTax = props.optionsMstTax && props.optionsMstTax.length > 0 ? props.optionsMstTax : [];
    var statusCt = props.statusCt ? props.statusCt : 0;
    var _useState = _sliced_to_array(useState(false), 2), reloadCal = _useState[0], setReloadCal = _useState[1];
    var calSumTabel = function() {
        var sumMonth = 0;
        var sumInitalCost = 0;
        var sumDiscount = 0;
        var sumTax = 0;
        var sumPreTax = 0;
        var sumVat = 0;
        var sumNet = 0;
        if (adsData && adsData.length > 0) {
            setAdsData(adsData.map(function(item, index) {
                var monthAmount = 0;
                var pretax = 0;
                var taxVale = 0;
                var vatVale = 0;
                var netVale = 0;
                if (item.ct_advert_month && item.ct_advert_month > 0) {
                    monthAmount = parseInt(item.ct_advert_month, 10);
                } else {
                    monthAmount = 0;
                }
                if (item.ct_advert_cost && item.ct_advert_cost > 0 && monthAmount > 0) {
                    if (item.ct_advert_discount && item.ct_advert_discount > 0) {
                        pretax = parseFloat(item.ct_advert_cost) * parseFloat(monthAmount) - parseFloat(item.ct_advert_discount);
                    } else {
                        pretax = parseFloat(item.ct_advert_cost) * parseFloat(monthAmount);
                    }
                    if (item.ct_advert_tax && item.ct_advert_tax > 0) {
                        taxVale = parseFloat(pretax) * parseFloat(item.ct_advert_tax) / 100;
                    } else {
                        taxVale = 0;
                    }
                    if (item.ct_advert_vat && item.ct_advert_vat > 0) {
                        vatVale = parseFloat(pretax) * parseFloat(item.ct_advert_vat) / 100;
                        netVale = parseFloat(pretax - vatVale + taxVale);
                    } else {
                        vatVale = 0;
                        netVale = parseFloat(pretax + taxVale);
                    }
                } else {
                    pretax = 0;
                    taxVale = 0;
                    vatVale = 0;
                    netVale = 0;
                }
                if (monthAmount && monthAmount > 0) {
                    sumMonth += parseInt(monthAmount, 10);
                }
                if (item.ct_advert_cost && item.ct_advert_cost > 0) {
                    sumInitalCost += parseFloat(item.ct_advert_cost);
                }
                if (item.ct_advert_discount && item.ct_advert_discount > 0) {
                    sumDiscount += parseFloat(item.ct_advert_discount);
                }
                if (taxVale && taxVale > 0) {
                    sumTax += parseFloat(taxVale);
                }
                if (pretax && pretax > 0) {
                    sumPreTax += parseFloat(pretax);
                }
                if (vatVale && vatVale > 0) {
                    sumVat += parseFloat(vatVale);
                }
                if (netVale && netVale > 0) {
                    sumNet += parseFloat(netVale);
                }
                return _object_spread_props(_object_spread({}, item), {
                    ct_advert_pretax: parseFloat(pretax),
                    ct_advert_tax_vale: parseFloat(taxVale),
                    ct_advert_vat_value: parseFloat(vatVale),
                    ct_advert_net: parseFloat(netVale)
                });
            }));
        }
        props.setAdsSum({
            sumMonth: parseInt(sumMonth),
            sumInitalCost: parseFloat(sumInitalCost),
            sumDiscount: parseFloat(sumDiscount),
            sumTax: parseFloat(sumTax),
            sumPreTax: parseFloat(sumPreTax),
            sumVat: parseFloat(sumVat),
            sumNet: parseFloat(sumNet)
        });
    };
    var handleDeleteRow = function(rowId) {
        if (rowId && rowId != "" && rowId != null) {
            setAdsData(function(adsData) {
                return adsData.filter(function(item) {
                    return item.rowID !== rowId;
                });
            });
            setReloadCal(true);
        }
    };
    useEffect(function() {
        if (entryFee && entryFee > 0) {
            setAdsData(adsData.map(function(item, index) {
                return _object_spread_props(_object_spread({}, item), {
                    rowID: nanoid(),
                    ct_advert_cost: entryFee == 2 ? NumberFormatFloat(entryFeeSku, 2) : entryFee == 1 ? NumberFormatFloat(0, 2) : NumberFormatFloat(item.ct_advert_cost, 2)
                });
            }));
            setReloadCal(true);
        }
    }, [
        entryFee,
        entryFeeSku
    ]);
    useEffect(function() {
        if (reloadCal && adsData && adsData.length > 0) {
            calSumTabel();
            setReloadCal(false);
        } else if (reloadCal && (!adsData || adsData.length <= 0)) {
            props.setAdsSum({
                sumMonth: 0,
                sumInitalCost: 0,
                sumDiscount: 0,
                sumTax: 0,
                sumPreTax: 0,
                sumVat: 0,
                sumNet: 0
            });
            setReloadCal(false);
        } else if (adsData && adsData.length > 0 && (!props.adsSum.sumInitalCost || props.adsSum.sumInitalCost == 0)) {
            calSumTabel();
        }
    }, [
        adsData,
        reloadCal
    ]);
    return /*#__PURE__*/ _jsxs(Table, {
        striped: true,
        bordered: true,
        responsive: true,
        children: [
            /*#__PURE__*/ _jsx("thead", {
                children: /*#__PURE__*/ _jsxs("tr", {
                    children: [
                        /*#__PURE__*/ _jsx("th", {
                            className: "text-center",
                            children: "#"
                        }),
                        /*#__PURE__*/ _jsx("th", {
                            children: "ช่องทางสาขาโฆษณา"
                        }),
                        /*#__PURE__*/ _jsx("th", {
                            className: "text-center",
                            children: "ตำแหน่งที่วาง"
                        }),
                        /*#__PURE__*/ _jsx("th", {
                            className: "text-center",
                            children: "จำนวนเดือน"
                        }),
                        /*#__PURE__*/ _jsxs("th", {
                            className: "text-center",
                            children: [
                                "ค่าวางสินค้า / เดือน",
                                /*#__PURE__*/ _jsx("br", {}),
                                "( Ex.VAT )"
                            ]
                        }),
                        /*#__PURE__*/ _jsx("th", {
                            className: "text-center bg-th-danger",
                            children: "ส่วนลด"
                        }),
                        /*#__PURE__*/ _jsx("th", {
                            className: "text-center bg-th-secondary",
                            children: "ภาษี"
                        }),
                        /*#__PURE__*/ _jsx("th", {
                            className: "text-center",
                            children: "มูลค่าก่อนภาษี"
                        }),
                        /*#__PURE__*/ _jsx("th", {
                            className: "text-center",
                            children: "หัก ณ ที่จ่าย"
                        }),
                        /*#__PURE__*/ _jsx("th", {
                            className: "text-center",
                            children: "มูลค่าสุทธิ"
                        }),
                        /*#__PURE__*/ _jsx("th", {
                            className: "text-center",
                            children: "หมายเหตุ"
                        }),
                        adsData && adsData.length > 0 ? /*#__PURE__*/ _jsx("th", {
                            className: "text-center"
                        }) : /*#__PURE__*/ _jsx(_Fragment, {})
                    ]
                })
            }),
            /*#__PURE__*/ _jsxs("tbody", {
                children: [
                    adsData && adsData.length > 0 ? adsData.map(function(item, index) {
                        return /*#__PURE__*/ _jsxs("tr", {
                            children: [
                                /*#__PURE__*/ _jsx("td", {
                                    className: "align-middle text-center",
                                    style: {
                                        minWidth: 80
                                    },
                                    children: index + 1
                                }),
                                /*#__PURE__*/ _jsx("td", {
                                    className: "align-middle",
                                    style: {
                                        minWidth: 200
                                    },
                                    children: item.ct_advert_branch_name
                                }),
                                /*#__PURE__*/ _jsx("td", {
                                    className: "align-middle text-center",
                                    style: {
                                        minWidth: 200
                                    },
                                    children: /*#__PURE__*/ _jsx(Select, {
                                        as: "select",
                                        name: "ct_advert_adpointid_" + (index + 1),
                                        onChange: function(e) {
                                            setAdsData(function(prev) {
                                                return prev.map(function(el) {
                                                    if (el.rowID === item.rowID) {
                                                        return _object_spread_props(_object_spread({}, el), {
                                                            ct_advert_adpointid: e.value
                                                        });
                                                    }
                                                    return el;
                                                });
                                            });
                                        },
                                        className: "w-100 select-st-1",
                                        options: item.ct_advert_option,
                                        placeholder: "เลือกตำแหน่ง",
                                        value: item.ct_advert_option.filter(function(item2) {
                                            return item2.value === item.ct_advert_adpointid;
                                        }),
                                        isDisabled: statusCt && statusCt > 1 ? true : false
                                    })
                                }),
                                /*#__PURE__*/ _jsx("td", {
                                    className: "align-middle text-center",
                                    style: {
                                        minWidth: 100
                                    },
                                    children: /*#__PURE__*/ _jsx(Form.Control, {
                                        type: "number",
                                        placeholder: "จำนวนเดือน",
                                        style: {
                                            width: "100px"
                                        },
                                        onChange: function(e) {
                                            setAdsData(function(prev) {
                                                return prev.map(function(el) {
                                                    if (el.rowID === item.rowID) {
                                                        return _object_spread_props(_object_spread({}, el), {
                                                            ct_advert_month: e.target.value
                                                        });
                                                    }
                                                    return el;
                                                });
                                            });
                                            setReloadCal(true);
                                        },
                                        value: item.ct_advert_month != null && item.ct_advert_month != "" && item.ct_advert_month != "null" ? parseInt(item.ct_advert_month, 10) : ""
                                    })
                                }),
                                /*#__PURE__*/ _jsx("td", {
                                    className: "align-middle text-center",
                                    style: {
                                        minWidth: 150
                                    },
                                    children: entryFee && entryFee == 3 ? /*#__PURE__*/ _jsx(Form.Control, {
                                        type: "number",
                                        placeholder: "ค่าวางสินค้า / เดือน",
                                        style: {
                                            width: "150px"
                                        },
                                        onChange: function(e) {
                                            setAdsData(function(prev) {
                                                return prev.map(function(el) {
                                                    if (el.rowID === item.rowID) {
                                                        return _object_spread_props(_object_spread({}, el), {
                                                            ct_advert_cost: e.target.value
                                                        });
                                                    }
                                                    return el;
                                                });
                                            });
                                            setReloadCal(true);
                                        },
                                        value: item.ct_advert_cost != null && item.ct_advert_cost != "" && item.ct_advert_cost != "null" ? NumberFormatFloat(item.ct_advert_cost, 2) : ""
                                    }) : /*#__PURE__*/ _jsx(NumericFormat, {
                                        value: item.ct_advert_cost,
                                        thousandSeparator: ",",
                                        decimalScale: 2,
                                        fixedDecimalScale: true,
                                        displayType: "text"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("td", {
                                    className: "align-middle text-center bg-td-danger",
                                    style: {
                                        minWidth: 150
                                    },
                                    children: /*#__PURE__*/ _jsx(Form.Control, {
                                        type: "number",
                                        placeholder: "ส่วนลด",
                                        style: {
                                            width: "150px"
                                        },
                                        onChange: function(e) {
                                            setAdsData(function(prev) {
                                                return prev.map(function(el) {
                                                    if (el.rowID === item.rowID) {
                                                        return _object_spread_props(_object_spread({}, el), {
                                                            ct_advert_discount: e.target.value
                                                        });
                                                    }
                                                    return el;
                                                });
                                            });
                                            setReloadCal(true);
                                        },
                                        value: item.ct_advert_discount != null && item.ct_advert_discount != "" && item.ct_advert_discount != "null" ? NumberFormatFloat(item.ct_advert_discount, 2) : ""
                                    })
                                }),
                                /*#__PURE__*/ _jsx("td", {
                                    className: "align-middle text-center",
                                    style: {
                                        minWidth: 110
                                    },
                                    children: /*#__PURE__*/ _jsx(Select, {
                                        as: "select",
                                        name: "ct_advert_tax_" + (index + 1),
                                        onChange: function(e) {
                                            setAdsData(function(prev) {
                                                return prev.map(function(el) {
                                                    if (el.rowID === item.rowID) {
                                                        return _object_spread_props(_object_spread({}, el), {
                                                            ct_advert_tax: e.value
                                                        });
                                                    }
                                                    return el;
                                                });
                                            });
                                            setReloadCal(true);
                                        },
                                        className: "w-100 select-st-1",
                                        options: optionsMstVat,
                                        placeholder: "เลือกภาษี",
                                        value: optionsMstVat.filter(function(item2) {
                                            return item2.value === item.ct_advert_tax;
                                        }),
                                        isDisabled: statusCt && statusCt > 1 ? true : false
                                    })
                                }),
                                /*#__PURE__*/ _jsx("td", {
                                    className: "align-middle text-center",
                                    style: {
                                        minWidth: 125
                                    },
                                    children: /*#__PURE__*/ _jsx(NumericFormat, {
                                        value: item.ct_advert_pretax,
                                        thousandSeparator: ",",
                                        decimalScale: 2,
                                        fixedDecimalScale: true,
                                        displayType: "text"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("td", {
                                    className: "align-middle text-center",
                                    style: {
                                        minWidth: 150
                                    },
                                    children: /*#__PURE__*/ _jsx(Select, {
                                        as: "select",
                                        name: "ct_advert_vat_" + (index + 1),
                                        onChange: function(e) {
                                            setAdsData(function(prev) {
                                                return prev.map(function(el) {
                                                    if (el.rowID === item.rowID) {
                                                        return _object_spread_props(_object_spread({}, el), {
                                                            ct_advert_vat: e.value
                                                        });
                                                    }
                                                    return el;
                                                });
                                            });
                                            setReloadCal(true);
                                        },
                                        className: "w-100 select-st-1",
                                        options: optionsMstTax,
                                        placeholder: "เลือกหัก ณ ที่จ่าย",
                                        value: optionsMstTax.filter(function(item2) {
                                            return item2.value === item.ct_advert_vat;
                                        }),
                                        isDisabled: statusCt && statusCt > 1 ? true : false
                                    })
                                }),
                                /*#__PURE__*/ _jsx("td", {
                                    className: "align-middle text-center",
                                    style: {
                                        minWidth: 150
                                    },
                                    children: /*#__PURE__*/ _jsx(NumericFormat, {
                                        value: item.ct_advert_net,
                                        thousandSeparator: ",",
                                        decimalScale: 2,
                                        fixedDecimalScale: true,
                                        displayType: "text"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("td", {
                                    className: "align-middle",
                                    style: {
                                        minWidth: 200
                                    },
                                    children: /*#__PURE__*/ _jsx(Form.Control, {
                                        type: "text",
                                        placeholder: "หมายเหตุ",
                                        style: {
                                            width: "200px"
                                        },
                                        onChange: function(e) {
                                            setAdsData(function(prev) {
                                                return prev.map(function(el) {
                                                    if (el.rowID === item.rowID) {
                                                        return _object_spread_props(_object_spread({}, el), {
                                                            ct_advert_remark: e.target.value
                                                        });
                                                    }
                                                    return el;
                                                });
                                            });
                                        },
                                        value: item.ct_advert_remark != null && item.ct_advert_remark != "" && item.ct_advert_remark != "null" ? item.ct_advert_remark : ""
                                    })
                                }),
                                /*#__PURE__*/ _jsx("td", {
                                    className: "align-middle text-center",
                                    children: /*#__PURE__*/ _jsx(IconButton, {
                                        "aria-label": "delete",
                                        color: "error",
                                        onClick: function() {
                                            return handleDeleteRow(item.rowID);
                                        },
                                        children: /*#__PURE__*/ _jsx(Avatar, {
                                            sx: {
                                                color: "rgba(176,4,18,1)",
                                                bgcolor: "rgba(246,225,227,1)"
                                            },
                                            children: /*#__PURE__*/ _jsx(DeleteIcon, {
                                                fontSize: "inherit"
                                            })
                                        })
                                    })
                                })
                            ]
                        });
                    }) : /*#__PURE__*/ _jsx(_Fragment, {}),
                    /*#__PURE__*/ _jsxs("tr", {
                        children: [
                            /*#__PURE__*/ _jsx("td", {
                                style: {
                                    minWidth: 80
                                }
                            }),
                            /*#__PURE__*/ _jsx("td", {
                                style: {
                                    minWidth: 200
                                }
                            }),
                            /*#__PURE__*/ _jsx("td", {
                                style: {
                                    minWidth: 200
                                }
                            }),
                            /*#__PURE__*/ _jsx("td", {
                                style: {
                                    minWidth: 100
                                }
                            }),
                            /*#__PURE__*/ _jsx("td", {
                                style: {
                                    minWidth: 150
                                }
                            }),
                            /*#__PURE__*/ _jsx("td", {
                                style: {
                                    minWidth: 150
                                }
                            }),
                            /*#__PURE__*/ _jsx("td", {
                                style: {
                                    minWidth: 110
                                }
                            }),
                            /*#__PURE__*/ _jsx("td", {
                                style: {
                                    minWidth: 125
                                }
                            }),
                            /*#__PURE__*/ _jsx("td", {
                                style: {
                                    minWidth: 150
                                }
                            }),
                            /*#__PURE__*/ _jsx("td", {
                                style: {
                                    minWidth: 150
                                }
                            }),
                            /*#__PURE__*/ _jsx("td", {
                                style: {
                                    minWidth: 200
                                }
                            }),
                            adsData && adsData.length > 0 ? /*#__PURE__*/ _jsx("td", {}) : /*#__PURE__*/ _jsx(_Fragment, {})
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("tr", {
                        children: [
                            /*#__PURE__*/ _jsx("td", {
                                colSpan: 3,
                                className: "text-end fw-bold",
                                children: "รวม"
                            }),
                            /*#__PURE__*/ _jsx("td", {
                                className: "text-center fw-bold"
                            }),
                            /*#__PURE__*/ _jsx("td", {
                                className: "text-end fw-bold",
                                children: /*#__PURE__*/ _jsx(NumericFormat, {
                                    value: props.adsSum.sumInitalCost,
                                    thousandSeparator: ",",
                                    decimalScale: 2,
                                    fixedDecimalScale: true,
                                    displayType: "text"
                                })
                            }),
                            /*#__PURE__*/ _jsx("td", {
                                className: "text-end bg-td-danger fw-bold",
                                children: /*#__PURE__*/ _jsx(NumericFormat, {
                                    value: props.adsSum.sumDiscount,
                                    thousandSeparator: ",",
                                    decimalScale: 2,
                                    fixedDecimalScale: true,
                                    displayType: "text"
                                })
                            }),
                            /*#__PURE__*/ _jsx("td", {
                                className: "text-end fw-bold"
                            }),
                            /*#__PURE__*/ _jsx("td", {
                                className: "text-end fw-bold",
                                children: /*#__PURE__*/ _jsx(NumericFormat, {
                                    value: props.adsSum.sumPreTax,
                                    thousandSeparator: ",",
                                    decimalScale: 2,
                                    fixedDecimalScale: true,
                                    displayType: "text"
                                })
                            }),
                            /*#__PURE__*/ _jsx("td", {
                                className: ""
                            }),
                            /*#__PURE__*/ _jsx("td", {
                                className: "text-end fw-bold",
                                children: /*#__PURE__*/ _jsx(NumericFormat, {
                                    value: props.adsSum.sumNet,
                                    thousandSeparator: ",",
                                    decimalScale: 2,
                                    fixedDecimalScale: true,
                                    displayType: "text"
                                })
                            }),
                            /*#__PURE__*/ _jsx("td", {
                                className: ""
                            }),
                            adsData && adsData.length > 0 ? /*#__PURE__*/ _jsx("td", {}) : /*#__PURE__*/ _jsx(_Fragment, {})
                        ]
                    })
                ]
            })
        ]
    });
}
var rowSelectProduct = function(row) {
    return row.checkedProduct == true;
};
function ProductModal(_param) {
    var productData = _param.productData, setProductData = _param.setProductData, props = _object_without_properties(_param, [
        "productData",
        "setProductData"
    ]);
    var rest = _extends({}, _object_destructuring_empty(props));
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var _useState = _sliced_to_array(useState(""), 2), filterText = _useState[0], setFilterText = _useState[1];
    var _useState1 = _sliced_to_array(useState([]), 2), filteredItems = _useState1[0], setFilteredItems = _useState1[1];
    var _useState2 = _sliced_to_array(useState([]), 2), tabledata = _useState2[0], setTabledata = _useState2[1];
    var _useState3 = _sliced_to_array(useState([]), 2), optionsCategoryProduct = _useState3[0], setOptionsCategoryProduct = _useState3[1];
    var _useState4 = _sliced_to_array(useState([]), 2), optionsTypeProduct = _useState4[0], setOptionsTypeProduct = _useState4[1];
    var _useState5 = _sliced_to_array(useState(""), 2), textBrand = _useState5[0], setTextBrand = _useState5[1];
    var _useState6 = _sliced_to_array(useState(""), 2), cateId = _useState6[0], setCateId = _useState6[1];
    var _useState7 = _sliced_to_array(useState(""), 2), typePdId = _useState7[0], setTypePdId = _useState7[1];
    var _useState8 = _sliced_to_array(useState([]), 2), dataSelected = _useState8[0], setDataSelected = _useState8[1];
    var businessId = props.businessId && props.businessId > 0 ? props.businessId : 0;
    var _useState9 = _sliced_to_array(useState([]), 2), dataPdOld = _useState9[0], setDataPdOld = _useState9[1];
    var _useState10 = _sliced_to_array(useState(true), 2), loadDataOld = _useState10[0], setLoadDataOld = _useState10[1];
    var entryFee = props.entryFee ? props.entryFee : 0;
    var entryFeeSku = props.entryFeeSku ? props.entryFeeSku : 0;
    var getContractProductInfoReducer = useAppSelector(function(state) {
        return state.getContractProductInfoReducer;
    });
    var getData = function() {
        if (businessId && businessId > 0) {
            dispatch(getContractProductInfo({
                businessid: parseInt(businessId, 10)
            }, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
        }
    };
    var handleChange = function(param) {
        var selectedRows = param.selectedRows;
        // You can set state or dispatch with something like Redux so we can use the retrieved data
        //console.log('Selected Rows: ', selectedRows);
        setDataSelected(selectedRows);
    };
    var handleClose = function() {
        return props.onHide();
    };
    var handleClick = function() {
        if (dataSelected && dataSelected.length > 0) {
            //setProductData([]); // Clear existing product data
            //props.setOptionsPdList([]);
            dataSelected.map(function(item, index) {
                if (item.pd_product_id && item.pd_product_id != "" && item.pd_product_id > 0) {
                    var chkPd = dataPdOld.filter(function(item2) {
                        return item2.ct_product_productid == item.pd_product_id;
                    });
                    var entryFeeCost = 0;
                    // console.log("dataPdOld : ",dataPdOld);
                    //  console.log("chkPd : ",chkPd);
                    if (entryFee && entryFee == 3) {
                        entryFeeCost = chkPd && chkPd.length > 0 && chkPd[0].ct_product_initalcost && chkPd[0].ct_product_initalcost > 0 ? chkPd[0].ct_product_initalcost : 0;
                    } else if (entryFee && entryFee == 2) {
                        entryFeeCost = entryFeeSku;
                    } else if (entryFee && entryFee == 1) {
                        entryFeeCost = 0;
                    }
                    setProductData(function(productData) {
                        return _to_consumable_array(productData).concat([
                            {
                                rowID: nanoid(),
                                ct_product_id: chkPd && chkPd.length > 0 && chkPd[0].ct_product_id && chkPd[0].ct_product_id > 0 ? chkPd[0].ct_product_id : 0,
                                ct_product_productid: item.pd_product_id,
                                ct_product_code: item.pd_product_code,
                                ct_product_barcode: item.pd_product_barcode,
                                ct_product_name: item.pd_product_nameth,
                                ct_product_brand: item.pd_product_brand,
                                ct_product_categoryid: item.pd_product_categoryid,
                                ct_product_categoryname: item.set_productcategory_name,
                                ct_product_recommentprice: item.pd_product_recommentprice,
                                ct_product_unitid: item.pd_product_unitid,
                                ct_product_unitname: item.set_unit_name,
                                ct_product_continer: item.pd_pdetail_continer,
                                ct_product_initalcost: parseFloat(entryFeeCost),
                                ct_product_discount: chkPd && chkPd.length > 0 && chkPd[0].ct_product_discount && chkPd[0].ct_product_discount > 0 ? parseFloat(chkPd[0].ct_product_discount) : 0,
                                ct_product_tax: chkPd && chkPd.length > 0 && chkPd[0].ct_product_tax && chkPd[0].ct_product_tax > 0 ? parseFloat(chkPd[0].ct_product_tax) : 0,
                                ct_product_tax_vale: chkPd && chkPd.length > 0 && chkPd[0].ct_product_tax_vale && chkPd[0].ct_product_tax_vale > 0 ? parseFloat(chkPd[0].ct_product_tax_vale) : 0,
                                ct_product_pretax: chkPd && chkPd.length > 0 && chkPd[0].ct_product_pretax && chkPd[0].ct_product_pretax > 0 ? parseFloat(chkPd[0].ct_product_pretax) : 0,
                                ct_product_vat: chkPd && chkPd.length > 0 && chkPd[0].ct_product_vat && chkPd[0].ct_product_vat > 0 ? parseInt(chkPd[0].ct_product_vat) : 0,
                                ct_product_vat_value: chkPd && chkPd.length > 0 && chkPd[0].ct_product_vat_value && chkPd[0].ct_product_vat_value > 0 ? parseInt(chkPd[0].ct_product_vat_value) : 0,
                                ct_product_net: chkPd && chkPd.length > 0 && chkPd[0].ct_product_net && chkPd[0].ct_product_net > 0 ? parseFloat(chkPd[0].ct_product_net) : 0,
                                ct_product_remark: chkPd && chkPd.length > 0 && chkPd[0].ct_product_remark && chkPd[0].ct_product_remark != "" && chkPd[0].ct_product_remark != null ? chkPd[0].ct_product_net : "",
                                checkedProduct: true
                            }
                        ]);
                    });
                // props.setOptionsPdList(optionsPdList => [
                //   ...optionsPdList,
                //   {
                //     label: item.pd_product_nameth,
                //     value: item.pd_product_id,
                //   }
                // ]);
                }
            });
        } else {
            // If no products are selected, clear the product data
            setProductData([]);
        //props.setOptionsPdList([]);
        }
        props.setReloadCalMain(true);
        props.onHide();
    };
    useEffect(function() {
        setIsLoading(getContractProductInfoReducer.isFetching);
        if (getContractProductInfoReducer.data && !getContractProductInfoReducer.isError) {
            var dataNewSet = getContractProductInfoReducer.data.data;
            if (dataNewSet && dataNewSet.length > 0) {
                setTabledata(dataNewSet.map(function(item, index) {
                    return _object_spread({}, item);
                }));
                var uniqueCategory = Array.from(new Map(dataNewSet.map(function(item) {
                    return [
                        item.pd_product_categoryid,
                        {
                            label: item.set_productcategory_name,
                            value: item.pd_product_categoryid
                        }
                    ];
                })).values());
                setOptionsCategoryProduct(uniqueCategory);
            }
        }
    }, [
        getContractProductInfoReducer
    ]);
    var columns = [
        {
            name: "รหัสสินค้า",
            selector: function(row) {
                return row.pd_product_code;
            },
            center: true,
            width: "150px"
        },
        {
            name: "ชื่อสินค้า",
            selector: function(row) {
                return row.pd_product_nameth;
            },
            cell: function(row) {
                return /*#__PURE__*/ _jsxs("div", {
                    children: [
                        row.pd_product_nameth,
                        /*#__PURE__*/ _jsx("br", {}),
                        /*#__PURE__*/ _jsx("span", {
                            className: "figure-caption span-orang-gb",
                            children: row.pd_product_barcode
                        })
                    ]
                });
            }
        },
        {
            name: "แบรนด์สินค้า",
            selector: function(row) {
                return row.pd_product_brand;
            },
            width: "100px",
            center: true,
            cell: function(row) {
                return row.pd_product_brand && row.pd_product_brand != "" ? row.pd_product_brand : "-";
            }
        },
        {
            name: "หมวดหมู่",
            selector: function(row) {
                return row.set_productcategory_name;
            },
            center: true,
            width: "150px",
            cell: function(row) {
                return row.set_productcategory_name && row.set_productcategory_name != "" ? row.set_productcategory_name : "-";
            }
        },
        {
            name: "ราคาขาย",
            selector: function(row) {
                return row.pd_product_recommentprice;
            },
            center: true,
            cell: function(row) {
                return /*#__PURE__*/ _jsx(_Fragment, {
                    children: row.pd_product_recommentprice && row.pd_product_recommentprice >= 0 ? NumberFormatFloat(row.pd_product_recommentprice, 2) : "-"
                });
            },
            width: "150px"
        },
        {
            name: "หน่วย",
            selector: function(row) {
                return row.set_unit_name;
            },
            center: true,
            cell: function(row) {
                return /*#__PURE__*/ _jsx(_Fragment, {
                    children: row.set_unit_name && row.set_unit_name != "" ? row.set_unit_name : "-"
                });
            },
            width: "100px"
        },
        {
            name: "อัตตราส่วน / จำนวน",
            selector: function(row) {
                return row.pd_pdetail_continer;
            },
            center: true,
            cell: function(row) {
                return /*#__PURE__*/ _jsx(_Fragment, {
                    children: row.pd_pdetail_continer && row.pd_pdetail_continer != "" ? row.pd_pdetail_continer : "-"
                });
            },
            width: "150px"
        }
    ];
    useEffect(function() {
        if (props.loadDataPd && productData && productData.length > 0 && tabledata && tabledata.length > 0) {
            props.setLoadDataPd(false);
            // console.log("productData : ",productData);
            // console.log("tabledata : ",tabledata);
            setFilteredItems(tabledata.filter(function(item) {
                var selectedItem = productData.find(function(row) {
                    return row.ct_product_productid === item.pd_product_id;
                });
                return !selectedItem;
            }));
        }
        if (loadDataOld && productData && productData.length > 0) {
            setDataPdOld(productData.map(function(item) {
                return _object_spread({}, item);
            }));
            setLoadDataOld(false);
        }
    }, [
        productData,
        props.loadDataPd,
        loadDataOld
    ]);
    useEffect(function() {
        if (!props.resetProduct && businessId && businessId > 0) {
            getData();
        } else if (props.resetProduct) {
            setTabledata([]);
            setOptionsCategoryProduct([]);
            setProductData([]);
            setDataSelected([]);
            props.setResetProduct(false);
        }
    }, [
        businessId,
        props.resetProduct
    ]);
    useEffect(function() {
        var text = (filterText || "").toUpperCase();
        var brand = (textBrand || "").toUpperCase();
        var category = cateId || "";
        var result = tabledata.filter(function(item) {
            if (!item.pd_product_id || item.pd_product_id <= 0) return false;
            var pass = true;
            if (text) {
                pass = (item.pd_product_code || "").toUpperCase().includes(text) || (item.pd_product_nameth || "").includes(text) || (item.pd_product_nameen || "").toUpperCase().includes(text) || (item.pd_product_barcode || "").toUpperCase().includes(text);
            }
            if (pass && brand) {
                pass = (item.pd_product_brand || "").toUpperCase().includes(brand);
            }
            if (pass && category) {
                pass = item.pd_product_categoryid == category;
            }
            return pass;
        });
        setFilteredItems(result);
    }, [
        tabledata,
        cateId,
        textBrand,
        filterText
    ]);
    return /*#__PURE__*/ _jsxs(Modal, _object_spread_props(_object_spread({}, rest), {
        size: "xl",
        centered: true,
        children: [
            /*#__PURE__*/ _jsx(Modal.Header, {
                closeButton: true,
                className: "modal-header-danger",
                children: /*#__PURE__*/ _jsx(Modal.Title, {
                    children: "เพิ่มสินค้าหลายรายการ"
                })
            }),
            /*#__PURE__*/ _jsxs(Modal.Body, {
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "align-items-center",
                        children: /*#__PURE__*/ _jsxs(Stack, {
                            direction: "horizontal",
                            gap: 3,
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                        className: "mb-2 form-st-3 pb-1",
                                        children: [
                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                className: "mb-1",
                                                children: "หมวดหมู่"
                                            }),
                                            /*#__PURE__*/ _jsx(Select, {
                                                as: "select",
                                                name: "select_search_category",
                                                onChange: function(e) {
                                                    setCateId(e.value);
                                                },
                                                className: "w-100 select-st-1",
                                                options: optionsCategoryProduct,
                                                placeholder: "เลือกหมวดหมู่",
                                                value: optionsCategoryProduct.filter(function(item) {
                                                    return item.value === cateId;
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                        className: "mb-2 form-st-3 pb-1",
                                        children: [
                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                className: "mb-1",
                                                children: "แบรนด์สินค้า"
                                            }),
                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                type: "text",
                                                name: "input_search_brand",
                                                className: "form-control",
                                                placeholder: "กรอกชื่อ",
                                                onChange: function(e) {
                                                    return setTextBrand(e.target.value);
                                                },
                                                value: textBrand != null && textBrand != "" && textBrand != "null" ? textBrand : ""
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "ms-auto",
                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                        className: "mb-2 form-st-3 pb-1",
                                        children: [
                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                className: "mb-1",
                                                children: "ค้นหา"
                                            }),
                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                type: "text",
                                                className: "me-3",
                                                name: "input_search_product",
                                                placeholder: "ค้นหารหัสสินค้า / ชื่อสินค้า / บาร์โค้ด",
                                                onChange: function(e) {
                                                    return setFilterText(e.target.value);
                                                },
                                                value: filterText != null && filterText != "" && filterText != "null" ? filterText : ""
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    children: /*#__PURE__*/ _jsx(Button, {
                                        variant: "outline-primary",
                                        onClick: function(e) {
                                            setFilterText("");
                                            setCateId(null);
                                            setTextBrand("");
                                        },
                                        children: "ล้างค่าการค้นหา"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "my-3",
                        children: /*#__PURE__*/ _jsx(DataTableLayout, {
                            item: filteredItems,
                            columns: columns,
                            isSelectRows: true,
                            PerPage: 5,
                            handleRowSelected: handleChange,
                            dataRowSelected: rowSelectProduct
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(Modal.Footer, {
                children: [
                    /*#__PURE__*/ _jsx(Button, {
                        variant: "outline-secondary",
                        onClick: handleClose,
                        children: "ยกเลิก"
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        variant: "danger",
                        onClick: handleClick,
                        children: "ยืนยัน"
                    })
                ]
            })
        ]
    }));
}
function BranchSaleModal(_param) {
    var branchSaleData = _param.branchSaleData, setBranchSaleData = _param.setBranchSaleData, entryFee = _param.entryFee, entryFeeSku = _param.entryFeeSku, props = _object_without_properties(_param, [
        "branchSaleData",
        "setBranchSaleData",
        "entryFee",
        "entryFeeSku"
    ]);
    var rest = _extends({}, _object_destructuring_empty(props));
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var _useState = _sliced_to_array(useState(""), 2), filterText = _useState[0], setFilterText = _useState[1];
    var _useState1 = _sliced_to_array(useState([]), 2), tabledata = _useState1[0], setTabledata = _useState1[1];
    var _useState2 = _sliced_to_array(useState([]), 2), filteredItems = _useState2[0], setFilteredItems = _useState2[1];
    var _useState3 = _sliced_to_array(useState([]), 2), dataSelected = _useState3[0], setDataSelected = _useState3[1];
    var _useState4 = _sliced_to_array(useState(0), 2), entryFeeCost = _useState4[0], setEntryFeeCost = _useState4[1];
    var getAllBranchByPositionReducer = useAppSelector(function(state) {
        return state.getAllBranchByPositionReducer;
    });
    var getData = function() {
        dispatch(getAllBranchByPosition());
    };
    var handleClick = function(branchId) {
        if (branchId && branchId > 0) {
            var chkBranch = tabledata.filter(function(item2) {
                return item2.set_branch_id == branchId;
            });
            //let entryFeeCost = 0;
            var optionPosition = [];
            // if(entryFee && entryFee == 2){
            //   setEntryFeeCost(entryFeeSku);
            // }
            // else if(entryFee && entryFee == 1){
            //   setEntryFeeCost(0);
            // }
            if (chkBranch && chkBranch.length > 0 && chkBranch[0].setPosition && chkBranch[0].setPosition.length > 0) {
                optionPosition = chkBranch[0].setPosition.map(function(item, index) {
                    return {
                        label: item.set_position_name,
                        value: item.set_position_id
                    };
                });
            }
            setBranchSaleData(function(branchSaleData) {
                return _to_consumable_array(branchSaleData).concat([
                    {
                        rowID: nanoid(),
                        ct_placement_contid: 0,
                        ct_placement_branchid: chkBranch && chkBranch.length > 0 && chkBranch[0].set_branch_id && chkBranch[0].set_branch_id > 0 ? chkBranch[0].set_branch_id : 0,
                        ct_placement_branch_name: chkBranch && chkBranch.length > 0 && chkBranch[0].set_branch_name && chkBranch[0].set_branch_name != "" && chkBranch[0].set_branch_name != null ? chkBranch[0].set_branch_name : "",
                        ct_placement_positionid: 0,
                        ct_placement_month: 0,
                        ct_placement_cost: parseFloat(entryFeeCost),
                        ct_placement_discount: 0,
                        ct_placement_tax: 0,
                        ct_placement_pretax: 0,
                        ct_placement_vat: 0,
                        ct_placement_net: 0,
                        ct_placement_remark: "",
                        ct_placement_option: optionPosition,
                        ct_placement_pdid: 0,
                        ct_placement_pdnameth: "",
                        ct_placement_pdnameen: ""
                    }
                ]);
            });
        }
        props.onHide();
    };
    useEffect(function() {
        setIsLoading(getAllBranchByPositionReducer.isFetching);
        if (getAllBranchByPositionReducer.data && !getAllBranchByPositionReducer.isError) {
            var dataNewSet = getAllBranchByPositionReducer.data.data;
            if (dataNewSet && dataNewSet.length > 0) {
                setTabledata(dataNewSet.map(function(item, index) {
                    return _object_spread_props(_object_spread({}, item), {
                        set_branch_balance_product: 0,
                        set_branch_amount_product: 0,
                        set_branch_price: 0,
                        set_branch_code: item.set_branch_id.toString().padStart(10, "0")
                    });
                }));
            }
        }
    }, [
        getAllBranchByPositionReducer
    ]);
    useEffect(function() {
        if (tabledata && tabledata.length > 0) {
            if (filterText && filterText != "" && filterText != null) {
                setFilteredItems(tabledata.filter(function(item) {
                    return item.set_branch_id !== null && item.setPosition && item.setPosition.length > 0 && item.set_branch_name.toLowerCase().includes(filterText.toLowerCase());
                }));
            } else {
                setFilteredItems(tabledata.filter(function(item) {
                    return item.set_branch_id !== null && item.setPosition && item.setPosition.length > 0;
                }));
            }
        }
    }, [
        tabledata,
        filterText
    ]);
    var columns = [
        // {
        //   name: "รหัสสถานที่",
        //   selector: (row) => row.set_branch_code,
        //   width: "170px",
        //   cell: (row) => (
        //     <>
        //       {(row.set_branch_code && row.set_branch_code != '' && row.set_branch_code != null) ? 
        //         row.set_branch_code.trim() 
        //       : "-" }
        //     </>
        //   ),
        // },
        {
            name: "ชื่อสถานที่",
            selector: function(row) {
                return row.set_branch_name;
            },
            cell: function(row) {
                return /*#__PURE__*/ _jsx(_Fragment, {
                    children: row.set_branch_name && row.set_branch_name != "" && row.set_branch_name != null ? row.set_branch_name.trim() : "-"
                });
            }
        },
        // {
        //   name: "ราคามาตราฐาน",
        //   selector: (row) => row.set_branch_price,
        //   width: "170px",
        //   cell: (row) => (
        //    <>
        //       {(row.set_branch_price && row.set_branch_price>=0) ? 
        //         NumberFormatFloat(row.set_branch_price,2) 
        //       : "-" }
        //     </>
        //   ),
        // },
        // {
        //   name: "รายการสินค้าที่วาง",
        //   selector: (row) => row.set_branch_amount_product,
        //   cell: (row) =>  (
        //     <>
        //       {(row.set_branch_amount_product && row.set_branch_amount_product>=0) ? 
        //         NumberFormat(row.set_branch_amount_product,0) 
        //       : "-" }
        //     </>
        //   ),
        //   width: "150px",
        // },
        // {
        //   name: "จำนวนคงเหลือพื้นที่วางสินค้า",
        //   selector: (row) => row.set_branch_balance_product,
        //   cell: (row) =>  (
        //     <>
        //       {(row.set_branch_balance_product && row.set_branch_balance_product>=0) ? 
        //         NumberFormat(row.set_branch_balance_product,0) 
        //       : "-" }
        //     </>
        //   ),
        //   width: "100px",
        // },
        {
            name: "ตัวเลือก",
            selector: function(row) {
                return row.set_branch_id;
            },
            center: true,
            width: "120px",
            cell: function(row) {
                return /*#__PURE__*/ _jsx(Button, {
                    type: "button",
                    className: " btn-st-3",
                    onClick: function() {
                        handleClick(row.set_branch_id);
                    },
                    children: "เลือก"
                });
            }
        }
    ];
    useEffect(function() {
        getData();
    }, []);
    useEffect(function() {
        if (entryFee || entryFeeSku) {
            if (entryFee && entryFee == 2) {
                setEntryFeeCost(entryFeeSku && entryFeeSku > 0 ? parseFloat(entryFeeSku) : 0);
            } else if (entryFee && entryFee == 1) {
                setEntryFeeCost(0);
            }
        }
    }, [
        entryFee,
        entryFeeSku
    ]);
    return /*#__PURE__*/ _jsxs(Modal, _object_spread_props(_object_spread({}, rest), {
        size: "xl",
        centered: true,
        children: [
            /*#__PURE__*/ _jsx(Modal.Header, {
                closeButton: true,
                className: "modal-header-danger",
                children: /*#__PURE__*/ _jsx(Modal.Title, {
                    children: "เพิ่มสาขาการขายหลายรายการ"
                })
            }),
            /*#__PURE__*/ _jsxs(Modal.Body, {
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "align-items-center",
                        children: /*#__PURE__*/ _jsxs(Stack, {
                            direction: "horizontal",
                            gap: 3,
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "ms-auto",
                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                        className: "mb-2 form-st-3 pb-1",
                                        children: [
                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                className: "mb-1",
                                                children: "ค้นหา"
                                            }),
                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                type: "text",
                                                className: "me-3",
                                                name: "input_search_product",
                                                placeholder: "ค้นหาชื่อสถานที่",
                                                onChange: function(e) {
                                                    return setFilterText(e.target.value);
                                                },
                                                value: filterText != null && filterText != "" && filterText != "null" ? filterText : ""
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    children: /*#__PURE__*/ _jsx(Button, {
                                        variant: "outline-primary",
                                        onClick: function(e) {
                                            return setFilterText(null);
                                        },
                                        children: "ล้างค่าการค้นหา"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "px-3",
                        children: /*#__PURE__*/ _jsx(DataTableLayout, {
                            item: filteredItems,
                            columns: columns,
                            isSelectRows: false,
                            PerPage: 10
                        })
                    })
                ]
            })
        ]
    }));
}
function BranchAdsModal(_param) {
    var branchAdsData = _param.branchAdsData, setBranchAdsData = _param.setBranchAdsData, props = _object_without_properties(_param, [
        "branchAdsData",
        "setBranchAdsData"
    ]);
    var rest = _extends({}, _object_destructuring_empty(props));
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var _useState = _sliced_to_array(useState(""), 2), filterText = _useState[0], setFilterText = _useState[1];
    var _useState1 = _sliced_to_array(useState([]), 2), tabledata = _useState1[0], setTabledata = _useState1[1];
    var _useState2 = _sliced_to_array(useState([]), 2), filteredItems = _useState2[0], setFilteredItems = _useState2[1];
    var entryFee = props.entryFee ? props.entryFee : 0;
    var entryFeeSku = props.entryFeeSku ? props.entryFeeSku : 0;
    var getAllBranchByAdPointReducer = useAppSelector(function(state) {
        return state.getAllBranchByAdPointReducer;
    });
    var getData = function() {
        dispatch(getAllBranchByAdPoint());
    };
    var handleClick = function(branchId) {
        if (branchId && branchId > 0) {
            var chkBranch = tabledata.filter(function(item2) {
                return item2.set_branch_id == branchId;
            });
            var entryFeeCost = 0;
            var optionPosition = [];
            if (entryFee && entryFee == 2) {
                entryFeeCost = entryFeeSku;
            } else if (entryFee && entryFee == 1) {
                entryFeeCost = 0;
            }
            if (chkBranch && chkBranch.length > 0 && chkBranch[0].setAdpoint && chkBranch[0].setAdpoint.length > 0) {
                optionPosition = chkBranch[0].setAdpoint.map(function(item, index) {
                    return {
                        label: item.set_adpoint_name,
                        value: item.set_adpoint_id
                    };
                });
            }
            setBranchAdsData(function(branchAdsData) {
                return _to_consumable_array(branchAdsData).concat([
                    {
                        rowID: nanoid(),
                        ct_advert_id: 0,
                        ct_advert_contid: 0,
                        ct_advert_branchid: chkBranch && chkBranch.length > 0 && chkBranch[0].set_branch_id && chkBranch[0].set_branch_id > 0 ? chkBranch[0].set_branch_id : 0,
                        ct_advert_branch_name: chkBranch && chkBranch.length > 0 && chkBranch[0].set_branch_name && chkBranch[0].set_branch_name != "" && chkBranch[0].set_branch_name != null ? chkBranch[0].set_branch_name : "",
                        ct_advert_adpointid: 0,
                        ct_advert_month: 0,
                        ct_advert_cost: parseFloat(entryFeeCost),
                        ct_advert_discount: 0,
                        ct_advert_tax: 0,
                        ct_advert_pretax: 0,
                        ct_advert_vat: 0,
                        ct_advert_net: 0,
                        ct_advert_remark: "",
                        ct_advert_option: optionPosition
                    }
                ]);
            });
        }
        props.onHide();
    };
    useEffect(function() {
        setIsLoading(getAllBranchByAdPointReducer.isFetching);
        if (getAllBranchByAdPointReducer.data && !getAllBranchByAdPointReducer.isError) {
            var dataNewSet = getAllBranchByAdPointReducer.data.data;
            if (dataNewSet && dataNewSet.length > 0) {
                setTabledata(dataNewSet.map(function(item, index) {
                    return _object_spread_props(_object_spread({}, item), {
                        set_branch_balance_product: 0,
                        set_branch_amount_product: 0,
                        set_branch_price: 0,
                        set_branch_code: item.set_branch_id.toString().padStart(10, "0")
                    });
                }));
            }
        }
    }, [
        getAllBranchByAdPointReducer
    ]);
    var columns = [
        // {
        //   name: "รหัสสถานที่",
        //   selector: (row) => row.set_branch_code,
        //   width: "170px",
        //   cell: (row) => (
        //     <>
        //       {(row.set_branch_code && row.set_branch_code != '' && row.set_branch_code != null) ? 
        //         row.set_branch_code.trim() 
        //       : "-" }
        //     </>
        //   ),
        // },
        {
            name: "ชื่อสถานที่",
            selector: function(row) {
                return row.set_branch_name;
            },
            //width: "200px",
            cell: function(row) {
                return /*#__PURE__*/ _jsx(_Fragment, {
                    children: row.set_branch_name && row.set_branch_name != "" && row.set_branch_name != null ? row.set_branch_name.trim() : "-"
                });
            }
        },
        // {
        //   name: "ราคามาตราฐาน",
        //   selector: (row) => row.set_branch_price,
        //   width: "170px",
        //   cell: (row) => (
        //    <>
        //       {(row.set_branch_price && row.set_branch_price>=0) ? 
        //         NumberFormatFloat(row.set_branch_price,2) 
        //       : "-" }
        //     </>
        //   ),
        // },
        // {
        //   name: "รายการสินค้าที่วาง",
        //   selector: (row) => row.set_branch_amount_product,
        //   cell: (row) =>  (
        //     <>
        //       {(row.set_branch_amount_product && row.set_branch_amount_product>=0) ? 
        //         NumberFormat(row.set_branch_amount_product,0) 
        //       : "-" }
        //     </>
        //   ),
        //   width: "150px",
        // },
        // {
        //   name: "จำนวนคงเหลือพื้นที่วางสินค้า",
        //   selector: (row) => row.set_branch_balance_product,
        //   cell: (row) =>  (
        //     <>
        //       {(row.set_branch_balance_product && row.set_branch_balance_product>=0) ? 
        //         NumberFormat(row.set_branch_balance_product,0) 
        //       : "-" }
        //     </>
        //   ),
        //   width: "100px",
        // },
        {
            name: "ตัวเลือก",
            selector: function(row) {
                return row.set_branch_id;
            },
            center: true,
            width: "120px",
            cell: function(row) {
                return /*#__PURE__*/ _jsx(Button, {
                    type: "button",
                    className: " btn-st-3",
                    onClick: function() {
                        return handleClick(row.set_branch_id);
                    },
                    children: "เลือก"
                });
            }
        }
    ];
    useEffect(function() {
        getData();
    }, []);
    useEffect(function() {
        if (tabledata && tabledata.length > 0) {
            if (filterText && filterText != "" && filterText != null) {
                setFilteredItems(tabledata.filter(function(item) {
                    return item.set_branch_id !== null && item.setAdpoint && item.setAdpoint.length > 0 && item.set_branch_name.toLowerCase().includes(filterText.toLowerCase());
                }));
            } else {
                setFilteredItems(tabledata.filter(function(item) {
                    return item.set_branch_id !== null && item.setAdpoint && item.setAdpoint.length > 0;
                }));
            }
        }
    }, [
        tabledata,
        filterText
    ]);
    return /*#__PURE__*/ _jsxs(Modal, _object_spread_props(_object_spread({}, rest), {
        size: "xl",
        centered: true,
        children: [
            /*#__PURE__*/ _jsx(Modal.Header, {
                closeButton: true,
                className: "modal-header-danger",
                children: /*#__PURE__*/ _jsx(Modal.Title, {
                    children: "เพิ่มสาขาการขายหลายรายการ"
                })
            }),
            /*#__PURE__*/ _jsxs(Modal.Body, {
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "align-items-center",
                        children: /*#__PURE__*/ _jsxs(Stack, {
                            direction: "horizontal",
                            gap: 3,
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "ms-auto",
                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                        className: "mb-2 form-st-3 pb-1",
                                        children: [
                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                className: "mb-1",
                                                children: "ค้นหา"
                                            }),
                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                type: "text",
                                                className: "me-3",
                                                name: "input_search_product",
                                                placeholder: "ค้นหาชื่อสถานที่",
                                                onChange: function(e) {
                                                    return setFilterText(e.target.value);
                                                },
                                                value: filterText != null && filterText != "" && filterText != "null" ? filterText : ""
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    children: /*#__PURE__*/ _jsx(Button, {
                                        variant: "outline-primary",
                                        onClick: function(e) {
                                            return setFilterText(null);
                                        },
                                        children: "ล้างค่าการค้นหา"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "px-3",
                        children: /*#__PURE__*/ _jsx(DataTableLayout, {
                            item: filteredItems,
                            columns: columns,
                            isSelectRows: false,
                            PerPage: 10
                        })
                    })
                ]
            })
        ]
    }));
}
var DetailInvoice = function(_param) {
    var invoiceData = _param.invoiceData, setInvoiceData = _param.setInvoiceData, props = _object_without_properties(_param, [
        "invoiceData",
        "setInvoiceData"
    ]);
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var setIsLoading = useGlobalLoaderContext().setIsLoading;
    var contractID = useParams().contractID;
    var _useState = _sliced_to_array(useState([]), 2), tabledata = _useState[0], setTabledata = _useState[1];
    var _useState1 = _sliced_to_array(useState(0), 2), countBill = _useState1[0], setCountBill = _useState1[1];
    var _useState2 = _sliced_to_array(useState(0), 2), totalPay = _useState2[0], setTotalPay = _useState2[1];
    var _useState3 = _sliced_to_array(useState(0), 2), totalBalance = _useState3[0], setTotalBalance = _useState3[1];
    var _useState4 = _sliced_to_array(useState(null), 2), pdfData = _useState4[0], setPdfData = _useState4[1];
    var _useState5 = _sliced_to_array(useState(false), 2), loadingPdf = _useState5[0], setLoadingPdf = _useState5[1];
    var getContractBillingInfoReducer = useAppSelector(function(state) {
        return state.getContractBillingInfoReducer;
    });
    var getBillingByIDReducer = useAppSelector(function(state) {
        return state.getBillingByIDReducer;
    });
    var getInvoiceByIDReducer = useAppSelector(function(state) {
        return state.getInvoiceByIDReducer;
    });
    // กดปุ่ม
    var handleGenerateBillingPdf = function() {
        var _ref = _async_to_generator(function(id) {
            var error;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        setLoadingPdf(true);
                        return [
                            4,
                            dispatch(getBillingByID(parseInt(id, 10), {
                                modalObj: modalObj,
                                setModalObj: setModalObj
                            }))
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error = _state.sent();
                        setLoadingPdf(false);
                        console.error(error);
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleGenerateBillingPdf(id) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleGenerateInvoicePdf = function() {
        var _ref = _async_to_generator(function(id) {
            var error;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        setLoadingPdf(true);
                        return [
                            4,
                            dispatch(getInvoiceByID(parseInt(id, 10), {
                                modalObj: modalObj,
                                setModalObj: setModalObj
                            }))
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error = _state.sent();
                        setLoadingPdf(false);
                        console.error(error);
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleGenerateInvoicePdf(id) {
            return _ref.apply(this, arguments);
        };
    }();
    var downloadPDF = function() {
        var _ref = _async_to_generator(function(param) {
            var dataBilling, fileName, blob, url, link, error;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        dataBilling = param.dataBilling, fileName = param.fileName;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        return [
                            4,
                            pdf(dataBilling).toBlob()
                        ];
                    case 2:
                        blob = _state.sent();
                        url = URL.createObjectURL(blob);
                        link = document.createElement("a");
                        link.href = url;
                        link.download = fileName;
                        link.click();
                        URL.revokeObjectURL(url);
                        return [
                            3,
                            5
                        ];
                    case 3:
                        error = _state.sent();
                        console.error(error);
                        return [
                            3,
                            5
                        ];
                    case 4:
                        setLoadingPdf(false);
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function downloadPDF(_) {
            return _ref.apply(this, arguments);
        };
    }();
    var getData = function() {
        if (contractID && contractID > 0) {
            dispatch(getContractBillingInfo({
                contractid: parseInt(contractID, 10)
            }, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
        }
    };
    var columns = [
        {
            name: "เลขที่ใบแจ้งหนี้",
            selector: function(row) {
                return row.bl_billing_code;
            },
            width: "200px",
            center: "true",
            cell: function(row) {
                return /*#__PURE__*/ _jsx("div", {
                    style: {
                        color: "#565DFF",
                        fontWeight: 500
                    },
                    children: /*#__PURE__*/ _jsx(Link, {
                        className: " me-2",
                        to: "billing/edit/" + row.bl_billing_id,
                        children: row.bl_billing_code && row.bl_billing_code != "" && row.bl_billing_code != null ? row.bl_billing_code : "ไม่มีรหัส"
                    })
                });
            }
        },
        {
            name: "วันที่ออกเอกสาร",
            selector: function(row) {
                return row.bl_billing_issuedate;
            },
            width: "200px",
            cell: function(row) {
                return row.bl_billing_issuedate && row.bl_billing_issuedate != null && row.bl_billing_issuedate != "" ? moment(row.bl_billing_issuedate).format("DD/MM/YYYY") : "-";
            },
            center: true
        },
        {
            name: "วันที่ครบกำหนด",
            selector: function(row) {
                return row.bl_billing_expiredate;
            },
            width: "200px",
            cell: function(row) {
                return row.bl_billing_expiredate && row.bl_billing_expiredate != null && row.bl_billing_expiredate != "" ? moment(row.bl_billing_expiredate).format("DD/MM/YYYY") : "-";
            },
            center: true
        },
        {
            name: "วันที่รับชำระ",
            selector: function(row) {
                return row.bl_billing_approvedate;
            },
            cell: function(row) {
                return row.bl_billing_approvedate && row.bl_billing_approvedate != null && row.bl_billing_approvedate != "" ? moment(row.bl_billing_approvedate).format("DD/MM/YYYY") : "-";
            },
            center: true,
            width: "150px"
        },
        {
            name: "มูลค่าสุทธิ",
            selector: function(row) {
                return row.bl_billing_totalpay;
            },
            cell: function(row) {
                return /*#__PURE__*/ _jsx(_Fragment, {
                    children: row.bl_billing_totalpay && row.bl_billing_totalpay >= 0 ? formatNumber(row.bl_billing_totalpay, 2) : "-"
                });
            },
            width: "100px"
        },
        {
            name: "สถานะ",
            selector: function(row) {
                return row.bl_billing_status;
            },
            cell: function(row) {
                return row.bl_billing_status == 6 ? /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "rgb(247 9 236)",
                        backgroundColor: "rgb(248 229 251)",
                        borderRadius: "20px",
                        width: "150px"
                    },
                    children: "ชำระเงินแล้ว"
                }) : row.bl_billing_status == 5 ? /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "#F95057",
                        backgroundColor: "#FFE3E3",
                        borderRadius: "20px",
                        width: "150px"
                    },
                    children: "ยกเลิก"
                }) : row.bl_billing_status == 4 ? /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "#10B02A",
                        backgroundColor: "rgba(238, 251, 229, 1)",
                        borderRadius: "20px",
                        width: "150px"
                    },
                    children: "ไม่อนุมัติ"
                }) : row.bl_billing_status == 3 ? /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "#10B02A",
                        backgroundColor: "rgba(238, 251, 229, 1)",
                        borderRadius: "20px",
                        width: "150px"
                    },
                    children: "อนุมัติแล้ว"
                }) : row.bl_billing_status == 2 ? /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "#FDB428",
                        backgroundColor: "#FFF6E5",
                        borderRadius: "20px",
                        width: "150px"
                    },
                    children: "รออนุมัติ"
                }) : /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "rgba(116, 116, 116, 1)",
                        backgroundColor: "rgba(244, 244, 244, 1)",
                        borderRadius: "20px",
                        width: "150px"
                    },
                    children: "รอออกใบแจ้งหนี้"
                });
            },
            width: "180px",
            center: true
        },
        {
            name: "ใบแจ้งหนี้",
            selector: function(row) {
                return row.bl_billing_id;
            },
            center: true,
            width: "100px",
            cell: function(row) {
                return /*#__PURE__*/ _jsx(Stack, {
                    direction: "horizontal",
                    gap: 2,
                    children: row.bl_billing_id && row.bl_billing_id != null && row.bl_billing_id != "" ? /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx(IconButton, {
                                "aria-label": "edit",
                                href: "/billing/edit/" + row.bl_billing_id,
                                children: /*#__PURE__*/ _jsx(EditIcon, {})
                            }),
                            /*#__PURE__*/ _jsx(IconButton, {
                                "aria-label": "print_bill",
                                onClick: function() {
                                    return handleGenerateBillingPdf(row.bl_billing_id);
                                },
                                children: /*#__PURE__*/ _jsx(Avatar, {
                                    sx: {
                                        bgcolor: "#FF5733"
                                    },
                                    variant: "rounded",
                                    children: /*#__PURE__*/ _jsx(PrintIcon, {})
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ _jsx(IconButton, {
                        "aria-label": "print",
                        children: /*#__PURE__*/ _jsx(Avatar, {
                            sx: {
                                bgcolor: "#6c757d"
                            },
                            variant: "rounded",
                            children: /*#__PURE__*/ _jsx(PrintIcon, {})
                        })
                    })
                });
            }
        },
        {
            name: "ใบเสร็จ",
            selector: function(row) {
                return row.bl_billing_approveid;
            },
            center: true,
            cell: function(row) {
                return /*#__PURE__*/ _jsx(Stack, {
                    direction: "horizontal",
                    gap: 2,
                    children: row.bl_billing_status && row.bl_billing_status != null && row.bl_billing_status == 6 ? /*#__PURE__*/ _jsx(IconButton, {
                        "aria-label": "print_invoice",
                        onClick: function() {
                            return handleGenerateInvoicePdf(row.bl_billing_approveid);
                        },
                        children: /*#__PURE__*/ _jsx(Avatar, {
                            sx: {
                                bgcolor: "#FF5733"
                            },
                            variant: "rounded",
                            children: /*#__PURE__*/ _jsx(PrintIcon, {})
                        })
                    }) : /*#__PURE__*/ _jsx(IconButton, {
                        "aria-label": "print",
                        children: /*#__PURE__*/ _jsx(Avatar, {
                            sx: {
                                bgcolor: "#6c757d"
                            },
                            variant: "rounded",
                            children: /*#__PURE__*/ _jsx(PrintIcon, {})
                        })
                    })
                });
            }
        }
    ];
    useEffect(function() {
        setIsLoading(getContractBillingInfoReducer.isFetching || getBillingByIDReducer.isFetching || getInvoiceByIDReducer.isFetching);
        if (getContractBillingInfoReducer.data && !getContractBillingInfoReducer.isError) {
            var dataNewSet = getContractBillingInfoReducer.data.data;
            if (dataNewSet && dataNewSet.length > 0) {
                setTabledata(dataNewSet.map(function(item, index) {
                    return _object_spread({}, item);
                }));
                setCountBill(dataNewSet.length || 0);
                var totalPayTemp = 0;
                var totalBalanceTemp = 0;
                dataNewSet.forEach(function(item2) {
                    totalPayTemp += item2.bl_billing_totalpay && item2.bl_billing_totalpay > 0 ? parseFloat(item2.bl_billing_totalpay) : 0;
                    totalBalanceTemp += item2.bl_billing_totalbalance && item2.bl_billing_totalbalance > 0 ? parseFloat(item2.bl_billing_totalbalance) : 0;
                });
                setTotalPay(totalPayTemp);
                setTotalBalance(totalBalanceTemp);
            }
        }
        if (getBillingByIDReducer.data && !getBillingByIDReducer.isError) {
            var dataNewSet1 = getBillingByIDReducer.data.data;
            if (dataNewSet1) {
                downloadPDF({
                    dataBilling: /*#__PURE__*/ _jsx(BillingPdf, {
                        data: dataNewSet1
                    }),
                    fileName: "Billing_" + moment().format("YYYYMMDDHHmmss") + ".pdf"
                });
            }
        }
        if (getInvoiceByIDReducer.data && !getInvoiceByIDReducer.isError) {
            var dataNewSet2 = getInvoiceByIDReducer.data.data;
            if (dataNewSet2) {
                downloadPDF({
                    dataBilling: /*#__PURE__*/ _jsx(InvoicePdf, {
                        data: dataNewSet2
                    }),
                    fileName: "Invoice_" + moment().format("YYYYMMDDHHmmss") + ".pdf"
                });
            }
        }
    }, [
        getContractBillingInfoReducer,
        getBillingByIDReducer,
        getInvoiceByIDReducer
    ]);
    useEffect(function() {
        getData();
    }, []);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "card card-st-1",
                children: /*#__PURE__*/ _jsx(Container, {
                    children: /*#__PURE__*/ _jsxs(Row, {
                        xs: 1,
                        md: 6,
                        lg: 3,
                        children: [
                            /*#__PURE__*/ _jsx(Col, {
                                children: /*#__PURE__*/ _jsxs("p", {
                                    className: "fs-18 my-4 text-center",
                                    children: [
                                        "จำนวนใบแจ้งหนี้ ",
                                        /*#__PURE__*/ _jsx("span", {
                                            className: "span-danger-gb",
                                            children: parseInt(countBill, 10)
                                        }),
                                        " ใบ"
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx(Col, {
                                children: /*#__PURE__*/ _jsxs("p", {
                                    className: "fs-18 my-4 text-center",
                                    children: [
                                        "มูลค่าสุทธิใบแจ้งหนี้ ",
                                        /*#__PURE__*/ _jsx("span", {
                                            className: "span-danger-gb",
                                            children: formatNumber(totalPay, 2)
                                        }),
                                        " บาท"
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx(Col, {
                                children: /*#__PURE__*/ _jsxs("p", {
                                    className: "fs-18 my-4 text-center",
                                    children: [
                                        "มูลค่าสุทธิที่ชำระ ",
                                        /*#__PURE__*/ _jsx("span", {
                                            className: "span-success-gb",
                                            children: formatNumber(totalBalance, 2)
                                        }),
                                        " บาท"
                                    ]
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "my-4",
                children: /*#__PURE__*/ _jsx(DataTableLayout, {
                    item: tabledata,
                    columns: columns,
                    isSelectRows: false,
                    PerPage: 10
                })
            })
        ]
    });
};
var DetailHistory = function(_param) {
    var historyData = _param.historyData, setHistoryData = _param.setHistoryData, props = _object_without_properties(_param, [
        "historyData",
        "setHistoryData"
    ]);
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var setIsLoading = useGlobalLoaderContext().setIsLoading;
    var contractID = useParams().contractID;
    var _useState = _sliced_to_array(useState(contractHistoryData), 2), tabledata = _useState[0], setTabledata = _useState[1];
    var _useState1 = _sliced_to_array(useState([]), 2), excelData = _useState1[0], setExcelData = _useState1[1];
    var _useState2 = _sliced_to_array(useState([
        {
            value: "1",
            label: "สร้าง"
        },
        {
            value: "2",
            label: "แก้ไข"
        }
    ]), 2), optionsTypeHistory = _useState2[0], setOptionsTypeHistory = _useState2[1];
    var _useState3 = _sliced_to_array(useState(""), 2), typeIdHistory = _useState3[0], setTypeIdHistory = _useState3[1];
    var columns = [
        {
            name: "วัน-เวลา",
            selector: function(row) {
                return row.historyDate;
            },
            width: "220px",
            center: "true",
            cell: function(row) {
                return /*#__PURE__*/ _jsx("div", {
                    style: {
                        color: "#B00412",
                        fontWeight: 500
                    },
                    children: row.historyDate && row.historyDate != null && row.historyDate != "" ? moment(row.historyDate).format("DD/MM/YYYY HH:mm") + " น." : "-"
                });
            }
        },
        {
            name: "ประเภท",
            selector: function(row) {
                return row.historyTypeId;
            },
            width: "200px",
            cell: function(row) {
                return row.historyTypeId && row.historyTypeId != null && row.historyTypeId != "" ? row.historyTypeName : "-";
            },
            center: true
        },
        {
            name: "รายละเอียด",
            selector: function(row) {
                return row.historyDetail;
            },
            cell: function(row) {
                return row.historyDetail && row.historyDetail != null && row.historyDetail != "" ? row.historyDetail : "-";
            }
        },
        {
            name: "ผู้ดำเนินการ",
            selector: function(row) {
                return row.historyAdminId;
            },
            cell: function(row) {
                return row.historyAdminId && row.historyAdminId != null && row.historyAdminId != "" ? row.historyAdminName : "-";
            },
            center: true,
            width: "300px"
        }
    ];
    return /*#__PURE__*/ _jsx("div", {
        className: "card card-st-2",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "card-body px-0 pt-4 pb-0",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "d-flex align-items-center px-4 mb-3 flex-wrap",
                    children: /*#__PURE__*/ _jsxs(Stack, {
                        direction: "horizontal",
                        gap: 3,
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                children: /*#__PURE__*/ _jsx(DownloadExcel, {
                                    data: excelData,
                                    filename: "history_" + moment().format("YYYYMMDDHHmmss")
                                })
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                children: /*#__PURE__*/ _jsx(Select, {
                                    as: "select",
                                    name: "select_history_typeId",
                                    onChange: function(e) {
                                        setTypeIdHistory(e.value);
                                    },
                                    className: "w-100 select-st-1",
                                    options: optionsTypeHistory,
                                    placeholder: "เลือกดูตามประเภท",
                                    value: optionsTypeHistory.filter(function(item) {
                                        return item.value === typeIdHistory;
                                    })
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx(DataTableLayout, {
                    item: tabledata,
                    columns: columns,
                    isSelectRows: false,
                    PerPage: 10
                })
            ]
        })
    });
};
function SendApproveModal(_param) {
    var dataFrom = _param.dataFrom, setDataFrom = _param.setDataFrom, props = _object_without_properties(_param, [
        "dataFrom",
        "setDataFrom"
    ]);
    var rest = _extends({}, _object_destructuring_empty(props));
    var contractID = useParams().contractID;
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var _useState = _sliced_to_array(useState(false), 2), isBoxAlert = _useState[0], setIsBoxAlert = _useState[1];
    var bankInfoSl = props.bankInfoSl && props.bankInfoSl.length > 0 ? props.bankInfoSl : [];
    var createContractNewReducer = useAppSelector(function(state) {
        return state.createContractNewReducer;
    });
    var updateContractReducer = useAppSelector(function(state) {
        return state.updateContractReducer;
    });
    var handleChange = function(e) {};
    var handleClick = function(val) {
        var dataFromNewSet = ReDataSaveNew(dataFrom, bankInfoSl);
        if (dataFrom && dataFrom != "" && dataFrom != null) {
            setIsLoading(true);
            var payload = {};
            if (contractID && contractID != "" && contractID != null) {
                payload = _object_spread_props(_object_spread({}, dataFromNewSet), {
                    ct_contract_status: 2,
                    ct_contract_id: parseInt(contractID, 10)
                });
                var payloadNew = SetDataFromNew(payload, "updated");
                dispatch(updateContract(payloadNew, {
                    modalObj: modalObj,
                    setModalObj: setModalObj
                }));
            } else {
                payload = _object_spread_props(_object_spread({}, dataFrom), {
                    ct_contract_status: 2
                });
                var payloadNew1 = SetDataFromNew(payload, "create");
                dispatch(createContractNew(payloadNew1, {
                    modalObj: modalObj,
                    setModalObj: setModalObj
                }));
            }
            setIsBoxAlert(true);
            props.onHide();
        }
    };
    var handleClose = function() {
        return props.onHide();
    };
    useEffect(function() {
        setIsLoading(createContractNewReducer.isFetching || updateContractReducer.isFetching);
        if (contractID && contractID != "" && contractID != null) {
            if (updateContractReducer.data && !updateContractReducer.isError) {
                var updatedData = updateContractReducer.data.data;
                dispatch(clearUpdateContract());
            } else {
                setIsBoxAlert(false);
            }
        } else {
            if (createContractNewReducer.data && !createContractNewReducer.isError) {
                var createData = createContractNewReducer.data.data;
                dispatch(clearCreateContractNew());
            } else {
                setIsBoxAlert(false);
            }
        }
        if (isBoxAlert) {
            props.setModalsuccess(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    visible: true,
                    textsuccess: "ส่งอนุมัติเรียบร้อย",
                    direction: "/manage_contract/new"
                });
            });
            setIsBoxAlert(false);
        }
    }, [
        createContractNewReducer,
        updateContractReducer
    ]);
    return /*#__PURE__*/ _jsxs(Modal, _object_spread_props(_object_spread({}, rest), {
        backdrop: "static",
        keyboard: false,
        "aria-labelledby": "contained-modal-title-vcenter",
        centered: true,
        children: [
            /*#__PURE__*/ _jsx(Modal.Header, {
                closeButton: true,
                className: "modal-header-danger",
                children: /*#__PURE__*/ _jsx(Modal.Title, {
                    children: "ส่งอนุมัติ"
                })
            }),
            /*#__PURE__*/ _jsx(Modal.Body, {
                children: /*#__PURE__*/ _jsx(Row, {
                    children: /*#__PURE__*/ _jsx(Col, {
                        xs: 12,
                        children: /*#__PURE__*/ _jsxs(Badge, {
                            bg: "danger-light",
                            text: "dark",
                            style: {
                                fontSize: "16px !important",
                                whiteSpace: "unset !important"
                            },
                            children: [
                                /*#__PURE__*/ _jsx(InfoIcon, {
                                    sx: {
                                        color: "#B00412"
                                    },
                                    className: "mr-2"
                                }),
                                "คุณต้องการที่จะส่งอนุมัติสัญญานี้หรือไม่"
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ _jsxs(Modal.Footer, {
                children: [
                    /*#__PURE__*/ _jsx(Button, {
                        variant: "outline-secondary",
                        onClick: handleClose,
                        children: "ยกเลิก"
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        variant: "danger",
                        onClick: handleClick,
                        children: "ยืนยัน"
                    })
                ]
            })
        ]
    }));
}
function DraftModal(_param) {
    var dataFrom = _param.dataFrom, setDataFrom = _param.setDataFrom, props = _object_without_properties(_param, [
        "dataFrom",
        "setDataFrom"
    ]);
    var rest = _extends({}, _object_destructuring_empty(props));
    var contractID = useParams().contractID;
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var _useState = _sliced_to_array(useState(false), 2), isBoxAlert = _useState[0], setIsBoxAlert = _useState[1];
    var bankInfoSl = props.bankInfoSl && props.bankInfoSl.length > 0 ? props.bankInfoSl : [];
    var createContractNewReducer = useAppSelector(function(state) {
        return state.createContractNewReducer;
    });
    var updateContractReducer = useAppSelector(function(state) {
        return state.updateContractReducer;
    });
    var handleChange = function(e) {};
    var handleClick = function(val) {
        var dataFromNewSet = ReDataSaveNew(dataFrom, bankInfoSl);
        if (dataFrom && dataFrom != "" && dataFrom != null) {
            setIsLoading(true);
            var payload = {};
            if (contractID && contractID != "" && contractID != null) {
                payload = _object_spread_props(_object_spread({}, dataFromNewSet), {
                    ct_contract_status: 1,
                    ct_contract_id: parseInt(contractID, 10)
                });
                var payloadNew = SetDataFromNew(payload, "updated");
                //console.log("payload",payloadNew);
                dispatch(updateContract(payloadNew, {
                    modalObj: modalObj,
                    setModalObj: setModalObj
                }));
            } else {
                payload = _object_spread_props(_object_spread({}, dataFrom), {
                    ct_contract_status: 1
                });
                //console.log("payload",payload);
                var payloadNew1 = SetDataFromNew(payload, "create");
                dispatch(createContractNew(payloadNew1, {
                    modalObj: modalObj,
                    setModalObj: setModalObj
                }));
            }
            setIsBoxAlert(true);
            props.onHide();
        }
    };
    var handleClose = function() {
        return props.onHide();
    };
    useEffect(function() {
        setIsLoading(createContractNewReducer.isFetching || updateContractReducer.isFetching);
        if (contractID && contractID != "" && contractID != null) {
            if (updateContractReducer.data && !updateContractReducer.isError) {
                var updatedData = updateContractReducer.data.data;
                dispatch(clearUpdateContract());
                if (isBoxAlert) {
                    props.setModalsuccess(function(prev) {
                        return _object_spread_props(_object_spread({}, prev), {
                            visible: true,
                            textsuccess: "บันทึกร่างเรียบร้อย",
                            direction: "/manage_contract/new"
                        });
                    });
                    setIsBoxAlert(false);
                }
            }
        } else {
            if (createContractNewReducer.data && !createContractNewReducer.isError) {
                var createData = createContractNewReducer.data.data;
                dispatch(clearCreateContractNew());
                if (isBoxAlert) {
                    props.setModalsuccess(function(prev) {
                        return _object_spread_props(_object_spread({}, prev), {
                            visible: true,
                            textsuccess: "บันทึกร่างเรียบร้อย",
                            direction: "/manage_contract/new"
                        });
                    });
                    setIsBoxAlert(false);
                }
            }
        }
    }, [
        createContractNewReducer,
        updateContractReducer
    ]);
    return /*#__PURE__*/ _jsxs(Modal, _object_spread_props(_object_spread({}, rest), {
        backdrop: "static",
        keyboard: false,
        "aria-labelledby": "contained-modal-title-vcenter",
        centered: true,
        children: [
            /*#__PURE__*/ _jsx(Modal.Header, {
                closeButton: true,
                className: "modal-header-danger",
                children: /*#__PURE__*/ _jsx(Modal.Title, {
                    children: "บันทึกร่าง"
                })
            }),
            /*#__PURE__*/ _jsx(Modal.Body, {
                children: /*#__PURE__*/ _jsx(Row, {
                    children: /*#__PURE__*/ _jsx(Col, {
                        xs: 12,
                        children: /*#__PURE__*/ _jsxs(Badge, {
                            bg: "danger-light",
                            text: "dark",
                            style: {
                                fontSize: "16px !important",
                                whiteSpace: "unset !important"
                            },
                            children: [
                                /*#__PURE__*/ _jsx(InfoIcon, {
                                    sx: {
                                        color: "#B00412"
                                    },
                                    className: "mr-2"
                                }),
                                "คุณต้องการที่จะบันทึกร่างสัญญานี้หรือไม่"
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ _jsxs(Modal.Footer, {
                children: [
                    /*#__PURE__*/ _jsx(Button, {
                        variant: "outline-secondary",
                        onClick: handleClose,
                        children: "ยกเลิก"
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        variant: "danger",
                        onClick: handleClick,
                        children: "ยืนยัน"
                    })
                ]
            })
        ]
    }));
}
function ApproveModal(_param) {
    var dataFrom = _param.dataFrom, setDataFrom = _param.setDataFrom, props = _object_without_properties(_param, [
        "dataFrom",
        "setDataFrom"
    ]);
    var rest = _extends({}, _object_destructuring_empty(props));
    var contractID = useParams().contractID;
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var _useState = _sliced_to_array(useState(false), 2), isBoxAlert = _useState[0], setIsBoxAlert = _useState[1];
    var _useState1 = _sliced_to_array(useState(""), 2), ctCode = _useState1[0], setCtCode = _useState1[1];
    var updateContractStatusReducer = useAppSelector(function(state) {
        return state.updateContractStatusReducer;
    });
    var handleChange = function(e) {};
    var handleClick = function(val) {
        if (dataFrom && dataFrom != "" && dataFrom != null) {
            setIsLoading(true);
            var payload = {};
            if (contractID && contractID != "" && contractID != null) {
                payload = {
                    contractid: parseInt(contractID, 10),
                    contractstatus: 3,
                    contractcomment: "อนุมัติเลขที่สัญญา " + ctCode
                };
                dispatch(updateContractStatus(payload, {
                    modalObj: modalObj,
                    setModalObj: setModalObj
                }));
            }
            setIsBoxAlert(true);
            props.onHide();
        }
    };
    var handleClose = function() {
        return props.onHide();
    };
    useEffect(function() {
        setIsLoading(updateContractStatusReducer.isFetching);
        if (contractID && contractID != "" && contractID != null) {
            if (updateContractStatusReducer.data && !updateContractStatusReducer.isError) {
                var updatedData = updateContractStatusReducer.data.data;
                dispatch(clearUpdateContractStatus());
            } else {
                setIsBoxAlert(false);
            }
        }
        if (isBoxAlert) {
            props.setModalsuccess(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    visible: true,
                    textsuccess: "อนุมัติเลขที่สัญญา " + ctCode + " เรียบร้อย",
                    direction: "/manage_contract/new"
                });
            });
            setIsBoxAlert(false);
        }
    }, [
        updateContractStatusReducer
    ]);
    useEffect(function() {
        if (dataFrom && dataFrom.ct_contract_code && dataFrom.ct_contract_code != "" && dataFrom.ct_contract_code != null) {
            setCtCode(dataFrom.ct_contract_code);
        }
    }, [
        dataFrom
    ]);
    return /*#__PURE__*/ _jsxs(Modal, _object_spread_props(_object_spread({}, rest), {
        backdrop: "static",
        keyboard: false,
        "aria-labelledby": "contained-modal-title-vcenter",
        centered: true,
        children: [
            /*#__PURE__*/ _jsx(Modal.Header, {
                closeButton: true,
                className: "modal-header-danger",
                children: /*#__PURE__*/ _jsx(Modal.Title, {
                    children: "อนุมัติสัญญา"
                })
            }),
            /*#__PURE__*/ _jsx(Modal.Body, {
                children: /*#__PURE__*/ _jsx(Row, {
                    children: /*#__PURE__*/ _jsx(Col, {
                        xs: 12,
                        children: /*#__PURE__*/ _jsxs(Badge, {
                            bg: "danger-light",
                            text: "dark",
                            style: {
                                fontSize: "16px !important",
                                whiteSpace: "unset !important"
                            },
                            children: [
                                /*#__PURE__*/ _jsx(InfoIcon, {
                                    sx: {
                                        color: "#B00412"
                                    },
                                    className: "mr-2"
                                }),
                                "คุณต้องการที่จะอนุมัติเลขที่สัญญา ",
                                ctCode,
                                " หรือไม่"
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ _jsxs(Modal.Footer, {
                children: [
                    /*#__PURE__*/ _jsx(Button, {
                        variant: "outline-secondary",
                        onClick: handleClose,
                        children: "ยกเลิก"
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        variant: "danger",
                        onClick: handleClick,
                        children: "ยืนยัน"
                    })
                ]
            })
        ]
    }));
}
function NoApproveModal(_param) {
    var dataFrom = _param.dataFrom, setDataFrom = _param.setDataFrom, props = _object_without_properties(_param, [
        "dataFrom",
        "setDataFrom"
    ]);
    var rest = _extends({}, _object_destructuring_empty(props));
    var contractID = useParams().contractID;
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var _useState = _sliced_to_array(useState(false), 2), isBoxAlert = _useState[0], setIsBoxAlert = _useState[1];
    var _useState1 = _sliced_to_array(useState(""), 2), ctCode = _useState1[0], setCtCode = _useState1[1];
    var _useState2 = _sliced_to_array(useState(""), 2), remark = _useState2[0], setRemark = _useState2[1];
    var _useState3 = _sliced_to_array(useState(0), 2), chgStatus = _useState3[0], setChgStatus = _useState3[1];
    var updateContractStatusReducer = useAppSelector(function(state) {
        return state.updateContractStatusReducer;
    });
    var handleChange = function(e) {
        setRemark(e.target.value);
    };
    var handleClick = function(val) {
        if (remark && remark.trim() !== "") {
            setIsLoading(true);
            var payload = {};
            if (contractID && contractID != "" && contractID != null) {
                payload = {
                    contractid: parseInt(contractID, 10),
                    contractstatus: chgStatus && chgStatus > 0 ? parseInt(chgStatus, 10) : 2,
                    contractcomment: remark.trim()
                };
                dispatch(updateContractStatus(payload, {
                    modalObj: modalObj,
                    setModalObj: setModalObj
                }));
            }
            setIsBoxAlert(true);
            props.onHide();
        } else {
            setModalObj(_object_spread_props(_object_spread({}, modalObj), {
                visible: true,
                subTitle: "รหัส 201",
                navigateDirection: undefined,
                title: "กรุณากรอกเหตุผลการไม่อนุมัติ"
            }));
            props.onHide();
        }
    };
    var handleClose = function() {
        return props.onHide();
    };
    useEffect(function() {
        setIsLoading(updateContractStatusReducer.isFetching);
        if (contractID && contractID != "" && contractID != null) {
            if (updateContractStatusReducer.data && !updateContractStatusReducer.isError) {
                var updatedData = updateContractStatusReducer.data.data;
                dispatch(clearUpdateContractStatus());
            } else {
                setIsBoxAlert(false);
            }
        }
        if (isBoxAlert) {
            props.setModalsuccess(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    visible: true,
                    textsuccess: "ไม่อนุมัติเลขที่สัญญา " + ctCode + " เรียบร้อย",
                    direction: "/manage_contract/new"
                });
            });
            setIsBoxAlert(false);
        }
    }, [
        updateContractStatusReducer
    ]);
    useEffect(function() {
        if (dataFrom && dataFrom.ct_contract_code && dataFrom.ct_contract_code != "" && dataFrom.ct_contract_code != null) {
            setCtCode(dataFrom.ct_contract_code);
        }
    }, [
        dataFrom
    ]);
    return /*#__PURE__*/ _jsxs(Modal, _object_spread_props(_object_spread({}, rest), {
        backdrop: "static",
        keyboard: false,
        "aria-labelledby": "contained-modal-title-vcenter",
        centered: true,
        children: [
            /*#__PURE__*/ _jsx(Modal.Header, {
                closeButton: true,
                className: "modal-header-danger",
                children: /*#__PURE__*/ _jsx(Modal.Title, {
                    children: "ยืนยันการไม่อนุมัติ"
                })
            }),
            /*#__PURE__*/ _jsx(Modal.Body, {
                children: /*#__PURE__*/ _jsxs(Row, {
                    className: "align-items-center mt-3",
                    children: [
                        /*#__PURE__*/ _jsx(Col, {
                            xs: 12,
                            children: /*#__PURE__*/ _jsxs(Form.Group, {
                                className: "mb-2 form-st-3 pb-1",
                                children: [
                                    /*#__PURE__*/ _jsxs(Form.Label, {
                                        className: "mb-1",
                                        children: [
                                            "เหตุผลการไม่อนุมัติ ",
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "span-red-gb",
                                                children: "*"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx(Form.Control, {
                                        as: "textarea",
                                        rows: 3,
                                        name: "remark_noapprove",
                                        placeholder: "กรอกคำอธิบาย",
                                        style: {
                                            resize: "none"
                                        },
                                        onChange: handleChange
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ _jsx(Col, {
                            xs: 12,
                            children: /*#__PURE__*/ _jsx("div", {
                                className: "fs-16 fw-bold my-2",
                                children: "การดำเนินการ"
                            })
                        }),
                        /*#__PURE__*/ _jsx(Col, {
                            xs: 12,
                            children: /*#__PURE__*/ _jsxs("div", {
                                className: "mb-2",
                                children: [
                                    /*#__PURE__*/ _jsx(Form.Check, {
                                        inline: true,
                                        type: "radio",
                                        id: "p99-radio-1",
                                        label: "เปลี่ยนเป็นบันทึกร่าง",
                                        className: "form-check-st-2 tc-7 mt-0",
                                        name: "chg_contract_status",
                                        checked: chgStatus === 1,
                                        onChange: function() {
                                            return setChgStatus(1);
                                        }
                                    }),
                                    /*#__PURE__*/ _jsx(Form.Check // prettier-ignore
                                    , {
                                        inline: true,
                                        type: "radio",
                                        id: "p99-radio-2",
                                        label: "ยกเลิกเอกสาร",
                                        className: "form-check-st-2 tc-7 mt-0",
                                        name: "chg_contract_status",
                                        checked: chgStatus === 5,
                                        onChange: function() {
                                            return setChgStatus(5);
                                        }
                                    })
                                ]
                            }, "p99-radio")
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsxs(Modal.Footer, {
                children: [
                    /*#__PURE__*/ _jsx(Button, {
                        variant: "outline-secondary",
                        onClick: handleClose,
                        children: "ยกเลิก"
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        variant: "danger",
                        onClick: handleClick,
                        children: "บันทึก"
                    })
                ]
            })
        ]
    }));
}
function ConfirmModal(_param) {
    var fileUpLoad = _param.fileUpLoad, setFileUpLoad = _param.setFileUpLoad, dataFrom = _param.dataFrom, props = _object_without_properties(_param, [
        "fileUpLoad",
        "setFileUpLoad",
        "dataFrom"
    ]);
    var rest = _extends({}, _object_destructuring_empty(props));
    var contractID = useParams().contractID;
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var _useState = _sliced_to_array(useState(false), 2), isBoxAlert = _useState[0], setIsBoxAlert = _useState[1];
    var _useState1 = _sliced_to_array(useState(""), 2), ctCode = _useState1[0], setCtCode = _useState1[1];
    var updateContractStatusReducer = useAppSelector(function(state) {
        return state.updateContractStatusReducer;
    });
    var updateApproveFileReducer = useAppSelector(function(state) {
        return state.updateApproveFileReducer;
    });
    var handleChange = function(e) {};
    var updateStatusConfirm = function() {
        if (contractID && contractID != "" && contractID != null) {
            setIsLoading(true);
            var payload = {
                contractid: parseInt(contractID, 10),
                contractstatus: 6,
                contractcomment: "ยืนยันเลขที่สัญญา " + ctCode
            };
            dispatch(updateContractStatus(payload, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
        }
        setIsBoxAlert(true);
        props.onHide();
    };
    var handleClick = function(val) {
        if (fileUpLoad && fileUpLoad.length > 0) {
            setIsLoading(true);
            var ctFileSet = fileUpLoad.map(function(item2) {
                return {
                    ct_file_crebyid: item2.ct_file_crebyid,
                    ct_file_url: item2.ct_file_url,
                    ct_file_name: item2.ct_file_name
                };
            });
            if (contractID && contractID != "" && contractID != null) {
                var payload = {
                    ct_contract_id: parseInt(contractID, 10),
                    ct_file: ctFileSet
                };
                dispatch(updateApproveFile(payload, {
                    modalObj: modalObj,
                    setModalObj: setModalObj
                }));
            }
        } else {
            setModalObj(_object_spread_props(_object_spread({}, modalObj), {
                visible: true,
                subTitle: "รหัส 201",
                navigateDirection: undefined,
                title: "กรุณาอัพโหลดไฟล์เอกสารที่สำคัญของสัญญานี้"
            }));
            props.onHide();
        }
    };
    var handleClose = function() {
        return props.onHide();
    };
    useEffect(function() {
        setIsLoading(updateContractStatusReducer.isFetching || updateApproveFileReducer.isFetching);
        if (contractID && contractID != "" && contractID != null) {
            if (updateContractStatusReducer.data && !updateContractStatusReducer.isError) {
                var updatedData = updateContractStatusReducer.data.data;
                dispatch(clearUpdateContractStatus());
            }
            if (updateApproveFileReducer.data && !updateApproveFileReducer.isError) {
                var updatedData2 = updateApproveFileReducer.data.data;
                dispatch(clearUpdateApproveFile());
                updateStatusConfirm();
            }
        }
        if (isBoxAlert) {
            props.setModalsuccess(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    visible: true,
                    textsuccess: "ยืนยันสัญญาเลขที่ " + ctCode + " เรียบร้อย",
                    direction: "/manage_contract/new"
                });
            });
            setIsBoxAlert(false);
        }
    }, [
        updateContractStatusReducer,
        updateApproveFileReducer
    ]);
    useEffect(function() {
        if (dataFrom && dataFrom.ct_contract_code && dataFrom.ct_contract_code != "" && dataFrom.ct_contract_code != null) {
            setCtCode(dataFrom.ct_contract_code);
        }
    }, [
        dataFrom
    ]);
    return /*#__PURE__*/ _jsxs(Modal, _object_spread_props(_object_spread({}, rest), {
        backdrop: "static",
        keyboard: false,
        "aria-labelledby": "contained-modal-title-vcenter",
        centered: true,
        children: [
            /*#__PURE__*/ _jsx(Modal.Header, {
                closeButton: true,
                className: "modal-header-danger",
                children: /*#__PURE__*/ _jsx(Modal.Title, {
                    children: "ยืนยันสัญญา"
                })
            }),
            /*#__PURE__*/ _jsx(Modal.Body, {
                children: /*#__PURE__*/ _jsx(Row, {
                    children: /*#__PURE__*/ _jsx(Col, {
                        xs: 12,
                        children: /*#__PURE__*/ _jsxs(Badge, {
                            bg: "danger-light",
                            text: "dark",
                            style: {
                                fontSize: "16px !important",
                                whiteSpace: "unset !important"
                            },
                            children: [
                                /*#__PURE__*/ _jsx(InfoIcon, {
                                    sx: {
                                        color: "#B00412"
                                    },
                                    className: "mr-2"
                                }),
                                "คุณต้องการที่จะยืนยันสัญญาเลขที่ ",
                                ctCode,
                                " หรือไม่"
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ _jsxs(Modal.Footer, {
                children: [
                    /*#__PURE__*/ _jsx(Button, {
                        variant: "outline-secondary",
                        onClick: handleClose,
                        children: "ยกเลิก"
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        variant: "danger",
                        onClick: handleClick,
                        children: "ยืนยัน"
                    })
                ]
            })
        ]
    }));
}
function CancelModal(_param) {
    var dataFrom = _param.dataFrom, setDataFrom = _param.setDataFrom, props = _object_without_properties(_param, [
        "dataFrom",
        "setDataFrom"
    ]);
    var rest = _extends({}, _object_destructuring_empty(props));
    var contractID = useParams().contractID;
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var _useState = _sliced_to_array(useState(false), 2), isBoxAlert = _useState[0], setIsBoxAlert = _useState[1];
    var _useState1 = _sliced_to_array(useState(""), 2), ctCode = _useState1[0], setCtCode = _useState1[1];
    var _useState2 = _sliced_to_array(useState(""), 2), remark = _useState2[0], setRemark = _useState2[1];
    var _useState3 = _sliced_to_array(useState(0), 2), chgStatus = _useState3[0], setChgStatus = _useState3[1];
    var updateContractStatusReducer = useAppSelector(function(state) {
        return state.updateContractStatusReducer;
    });
    var handleChange = function(e) {
        setRemark(e.target.value);
    };
    var handleClick = function(val) {
        if (remark && remark.trim() !== "") {
            setIsLoading(true);
            var payload = {};
            if (contractID && contractID != "" && contractID != null) {
                payload = {
                    contractid: parseInt(contractID, 10),
                    contractstatus: parseInt(5, 10),
                    contractcomment: remark.trim()
                };
                dispatch(updateContractStatus(payload, {
                    modalObj: modalObj,
                    setModalObj: setModalObj
                }));
            }
            setIsBoxAlert(true);
            props.onHide();
        } else {
            setModalObj(_object_spread_props(_object_spread({}, modalObj), {
                visible: true,
                subTitle: "รหัส 201",
                navigateDirection: undefined,
                title: "กรุณากรอกเหตุผลการยกเลิกสัญญา"
            }));
            props.onHide();
        }
    };
    var handleClose = function() {
        return props.onHide();
    };
    useEffect(function() {
        setIsLoading(updateContractStatusReducer.isFetching);
        if (contractID && contractID != "" && contractID != null) {
            if (updateContractStatusReducer.data && !updateContractStatusReducer.isError) {
                var updatedData = updateContractStatusReducer.data.data;
                dispatch(clearUpdateContractStatus());
            }
        }
        if (isBoxAlert) {
            props.setModalsuccess(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    visible: true,
                    textsuccess: "ยกเลิกเลขที่สัญญา " + ctCode + " เรียบร้อย",
                    direction: "/manage_contract/new"
                });
            });
            setIsBoxAlert(false);
        }
    }, [
        updateContractStatusReducer
    ]);
    useEffect(function() {
        if (dataFrom && dataFrom.ct_contract_code && dataFrom.ct_contract_code != "" && dataFrom.ct_contract_code != null) {
            setCtCode(dataFrom.ct_contract_code);
        }
    }, [
        dataFrom
    ]);
    return /*#__PURE__*/ _jsxs(Modal, _object_spread_props(_object_spread({}, rest), {
        backdrop: "static",
        keyboard: false,
        "aria-labelledby": "contained-modal-title-vcenter",
        centered: true,
        children: [
            /*#__PURE__*/ _jsx(Modal.Header, {
                closeButton: true,
                className: "modal-header-danger",
                children: /*#__PURE__*/ _jsx(Modal.Title, {
                    children: "ยกเลิกสัญญา"
                })
            }),
            /*#__PURE__*/ _jsx(Modal.Body, {
                children: /*#__PURE__*/ _jsx(Row, {
                    className: "align-items-center mt-3",
                    children: /*#__PURE__*/ _jsx(Col, {
                        xs: 12,
                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                            className: "mb-2 form-st-3 pb-1",
                            children: [
                                /*#__PURE__*/ _jsxs(Form.Label, {
                                    className: "mb-1",
                                    children: [
                                        "เหตุผลการยกเลิกสัญญา ",
                                        /*#__PURE__*/ _jsx("span", {
                                            className: "span-red-gb",
                                            children: "*"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx(Form.Control, {
                                    as: "textarea",
                                    rows: 3,
                                    name: "remark_noapprove",
                                    placeholder: "กรอกคำอธิบาย",
                                    style: {
                                        resize: "none"
                                    },
                                    onChange: handleChange
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ _jsxs(Modal.Footer, {
                children: [
                    /*#__PURE__*/ _jsx(Button, {
                        variant: "outline-secondary",
                        onClick: handleClose,
                        children: "ยกเลิก"
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        variant: "danger",
                        onClick: handleClick,
                        children: "ตกลง"
                    })
                ]
            })
        ]
    }));
}
function SaveDataModal(_param) {
    var fileUpLoad = _param.fileUpLoad, setFileUpLoad = _param.setFileUpLoad, dataFrom = _param.dataFrom, fileDelOld = _param.fileDelOld, setFileDelOld = _param.setFileDelOld, props = _object_without_properties(_param, [
        "fileUpLoad",
        "setFileUpLoad",
        "dataFrom",
        "fileDelOld",
        "setFileDelOld"
    ]);
    var rest = _extends({}, _object_destructuring_empty(props));
    var contractID = useParams().contractID;
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var _useState = _sliced_to_array(useState(false), 2), isBoxAlert = _useState[0], setIsBoxAlert = _useState[1];
    var _useState1 = _sliced_to_array(useState(false), 2), isSave = _useState1[0], setIsSave = _useState1[1];
    var _useState2 = _sliced_to_array(useState(""), 2), ctCode = _useState2[0], setCtCode = _useState2[1];
    var _useState3 = _sliced_to_array(useState([]), 2), arrDelFile = _useState3[0], setArrDelFile = _useState3[1];
    var updateContractFileReducer = useAppSelector(function(state) {
        return state.updateContractFileReducer;
    });
    var handleChange = function(e) {};
    var handleClick = function(val) {
        var modalSave = 0;
        if (fileUpLoad && fileUpLoad.length > 0) {
            var fileUpLoadNew = fileUpLoad.filter(function(item) {
                return item.ct_file_chk !== null && item.ct_file_chk == "new_file";
            });
            if (fileUpLoadNew && fileUpLoadNew.length > 0) {
                setIsLoading(true);
                var ctFileSet = fileUpLoadNew.map(function(item2) {
                    return {
                        ct_file_crebyid: item2.ct_file_crebyid,
                        ct_file_url: item2.ct_file_url,
                        ct_file_name: item2.ct_file_name
                    };
                });
                if (contractID && contractID != "" && contractID != null) {
                    var payload = {
                        ct_contract_id: parseInt(contractID, 10),
                        ct_file: ctFileSet,
                        ct_file_delete: arrDelFile
                    };
                    dispatch(updateContractFile(payload, {
                        modalObj: modalObj,
                        setModalObj: setModalObj
                    }));
                }
                setIsBoxAlert(true);
                props.onHide();
            } else if (arrDelFile && arrDelFile.length > 0) {
                setIsLoading(true);
                if (contractID && contractID != "" && contractID != null) {
                    var payload1 = {
                        ct_contract_id: parseInt(contractID, 10),
                        ct_file: [],
                        ct_file_delete: arrDelFile
                    };
                    dispatch(updateContractFile(payload1, {
                        modalObj: modalObj,
                        setModalObj: setModalObj
                    }));
                    setIsBoxAlert(true);
                    props.onHide();
                }
            } else {
                modalSave = 1;
            }
        } else if (arrDelFile && arrDelFile.length > 0) {
            setIsLoading(true);
            if (contractID && contractID != "" && contractID != null) {
                var payload2 = {
                    ct_contract_id: parseInt(contractID, 10),
                    ct_file: [],
                    ct_file_delete: arrDelFile
                };
                dispatch(updateContractFile(payload2, {
                    modalObj: modalObj,
                    setModalObj: setModalObj
                }));
                setIsBoxAlert(true);
                props.onHide();
            }
        } else {
            modalSave = 1;
        }
        if (modalSave && modalSave > 0) {
            props.setModalsuccess(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    visible: true,
                    textsuccess: "บันทึกสัญญาเลขที่ " + ctCode + " เรียบร้อย",
                    direction: "/manage_contract/new"
                });
            });
            props.onHide();
        }
    };
    var handleClose = function() {
        return props.onHide();
    };
    useEffect(function() {
        setIsLoading(updateContractFileReducer.isFetching);
        if (contractID && contractID != "" && contractID != null) {
            if (updateContractFileReducer.data && !updateContractFileReducer.isError) {
                var updatedData2 = updateContractFileReducer.data.data;
                dispatch(clearUpdateContractFile());
                setFileDelOld([]);
            }
        }
        if (isBoxAlert) {
            props.setModalsuccess(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    visible: true,
                    textsuccess: "บันทึกสัญญาเลขที่ " + ctCode + " เรียบร้อย",
                    direction: "/manage_contract/new"
                });
            });
            setIsBoxAlert(false);
            setFileDelOld([]);
        }
    }, [
        updateContractFileReducer
    ]);
    useEffect(function() {
        if (dataFrom && dataFrom.ct_contract_code && dataFrom.ct_contract_code != "" && dataFrom.ct_contract_code != null) {
            setCtCode(dataFrom.ct_contract_code);
        }
        if (fileDelOld && fileDelOld.length > 0) {
            //console.log('fileDelOld',fileDelOld);
            setArrDelFile(fileDelOld.map(function(item2) {
                return {
                    ct_file_id: item2.ct_file_id
                };
            }));
        }
    }, [
        dataFrom,
        fileDelOld
    ]);
    return /*#__PURE__*/ _jsxs(Modal, _object_spread_props(_object_spread({}, rest), {
        backdrop: "static",
        keyboard: false,
        "aria-labelledby": "contained-modal-title-vcenter",
        centered: true,
        children: [
            /*#__PURE__*/ _jsx(Modal.Header, {
                closeButton: true,
                className: "modal-header-danger",
                children: /*#__PURE__*/ _jsx(Modal.Title, {
                    children: "บันทึกข้อมูล"
                })
            }),
            /*#__PURE__*/ _jsx(Modal.Body, {
                children: /*#__PURE__*/ _jsx(Row, {
                    children: /*#__PURE__*/ _jsx(Col, {
                        xs: 12,
                        children: /*#__PURE__*/ _jsxs(Badge, {
                            bg: "danger-light",
                            text: "dark",
                            style: {
                                fontSize: "16px !important",
                                whiteSpace: "unset !important"
                            },
                            children: [
                                /*#__PURE__*/ _jsx(InfoIcon, {
                                    sx: {
                                        color: "#B00412"
                                    },
                                    className: "mr-2"
                                }),
                                "คุณต้องการที่จะบันทึกข้อมูลสัญญาเลขที่ ",
                                ctCode,
                                " หรือไม่"
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ _jsxs(Modal.Footer, {
                children: [
                    /*#__PURE__*/ _jsx(Button, {
                        variant: "outline-secondary",
                        onClick: handleClose,
                        children: "ยกเลิก"
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        variant: "danger",
                        onClick: handleClick,
                        children: "ยืนยัน"
                    })
                ]
            })
        ]
    }));
}
function EditDataModal(_param) {
    var dataFrom = _param.dataFrom, setDataFrom = _param.setDataFrom, props = _object_without_properties(_param, [
        "dataFrom",
        "setDataFrom"
    ]);
    var rest = _extends({}, _object_destructuring_empty(props));
    var contractID = useParams().contractID;
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var _useState = _sliced_to_array(useState(false), 2), isBoxAlert = _useState[0], setIsBoxAlert = _useState[1];
    var updateContractReducer = useAppSelector(function(state) {
        return state.updateContractReducer;
    });
    var handleChange = function(e) {};
    var handleClick = function(val) {
        if (dataFrom && dataFrom != "" && dataFrom != null) {
            setIsLoading(true);
            var payload = {};
            if (contractID && contractID != "" && contractID != null) {
                payload = _object_spread_props(_object_spread({}, dataFrom), {
                    ct_contract_status: dataFrom.ct_contract_status,
                    ct_contract_id: parseInt(contractID, 10)
                });
                var payloadNew = SetDataFromNew(payload, "updated");
                dispatch(updateContract(payloadNew, {
                    modalObj: modalObj,
                    setModalObj: setModalObj
                }));
            }
            setIsBoxAlert(true);
            props.onHide();
        }
    };
    var handleClose = function() {
        return props.onHide();
    };
    useEffect(function() {
        setIsLoading(updateContractReducer.isFetching);
        if (contractID && contractID != "" && contractID != null) {
            if (updateContractReducer.data && !updateContractReducer.isError) {
                var updatedData = updateContractReducer.data.data;
                dispatch(clearUpdateContract());
            } else {
                setIsBoxAlert(false);
            }
        }
        if (isBoxAlert) {
            props.setModalsuccess(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    visible: true,
                    textsuccess: "แก้ไขข้อมูลเรียบร้อย",
                    direction: "/manage_contract/new"
                });
            });
            setIsBoxAlert(false);
        }
    }, [
        updateContractReducer
    ]);
    return /*#__PURE__*/ _jsxs(Modal, _object_spread_props(_object_spread({}, rest), {
        backdrop: "static",
        keyboard: false,
        "aria-labelledby": "contained-modal-title-vcenter",
        centered: true,
        children: [
            /*#__PURE__*/ _jsx(Modal.Header, {
                closeButton: true,
                className: "modal-header-danger",
                children: /*#__PURE__*/ _jsx(Modal.Title, {
                    children: "แก้ไขข้อมูล"
                })
            }),
            /*#__PURE__*/ _jsx(Modal.Body, {
                children: /*#__PURE__*/ _jsx(Row, {
                    children: /*#__PURE__*/ _jsx(Col, {
                        xs: 12,
                        children: /*#__PURE__*/ _jsxs(Badge, {
                            bg: "danger-light",
                            text: "dark",
                            style: {
                                fontSize: "16px !important",
                                whiteSpace: "unset !important"
                            },
                            children: [
                                /*#__PURE__*/ _jsx(InfoIcon, {
                                    sx: {
                                        color: "#B00412"
                                    },
                                    className: "mr-2"
                                }),
                                "คุณต้องการที่จะบันทึกข้อมูลสัญญานี้หรือไม่"
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ _jsxs(Modal.Footer, {
                children: [
                    /*#__PURE__*/ _jsx(Button, {
                        variant: "outline-secondary",
                        onClick: handleClose,
                        children: "ยกเลิก"
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        variant: "danger",
                        onClick: handleClick,
                        children: "ยืนยัน"
                    })
                ]
            })
        ]
    }));
}
function DocTabs(_param) {
    var step = _param.step, role = _param.role, props = _object_without_properties(_param, [
        "step",
        "role"
    ]);
    var rest = _extends({}, _object_destructuring_empty(props));
    var contractID = useParams().contractID;
    // ตัวอย่างข้อมูล tab พร้อมเงื่อนไข
    var allTabs = [
        {
            eventKey: "detail_doc",
            title: "รายละเอียดสัญญา",
            visible: function() {
                return true;
            },
            content: /*#__PURE__*/ _jsx(DetailContractNew, {
                mode: props.mode,
                contractData: props.formdata,
                setContractData: props.setFormdata,
                schema: props.schema,
                editDisabled: props.editDisabled,
                setEditDisabled: props.setEditDisabled,
                activeButton: props.activeBt,
                businessId: props.businessId,
                statusCt: props.statusCt,
                dataPrintNew: props.dataPrintNew,
                setDataPrintNew: props.setDataPrintNew,
                bankInfoSl: props.bankInfoSl,
                resetProduct: props.resetProduct,
                setResetProduct: props.setResetProduct
            })
        },
        {
            eventKey: "detail_invoice",
            title: "ข้อมูลใบแจ้งหนี้",
            visible: function() {
                return step >= 2 ? true : false;
            },
            content: /*#__PURE__*/ _jsx(DetailInvoice, {
                mode: props.mode,
                invoiceData: props.formdata,
                setInvoiceData: props.setFormdata,
                editDisabled: props.editDisabled,
                setEditDisabled: props.setEditDisabled,
                activeButton: props.activeBt,
                statusCt: props.statusCt
            })
        }
    ];
    var visibleTabs = allTabs.filter(function(tab) {
        return tab.visible();
    });
    return /*#__PURE__*/ _jsx(Tabs, {
        defaultActiveKey: "detail_doc",
        id: "doc-tab-detail-com",
        className: "mb-3 pills-st-1",
        variant: "pills",
        children: visibleTabs.map(function(tab) {
            return /*#__PURE__*/ _jsx(Tab, {
                eventKey: tab.eventKey,
                title: tab.title,
                children: tab.content
            }, tab.eventKey);
        })
    });
}
function FileUploader(_param) {
    var fileUpLoad = _param.fileUpLoad, setFileUpLoad = _param.setFileUpLoad, props = _object_without_properties(_param, [
        "fileUpLoad",
        "setFileUpLoad"
    ]);
    var rest = _extends({}, _object_destructuring_empty(props));
    var contractID = useParams().contractID;
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var accessToken = localStorage.getItem("accessToken");
    var adminInfo = getInfoAdminSystem(accessToken);
    var uploadContractFileDocReducer = useAppSelector(function(state) {
        return state.uploadContractFileDocReducer;
    });
    var _useState = _sliced_to_array(useState([]), 2), uploads = _useState[0], setUploads = _useState[1];
    var onDrop = useCallback(function(acceptedFiles) {
        var newFiles = acceptedFiles.map(function(file) {
            return {
                file: file,
                status: "pending",
                progress: 0,
                error: null,
                id: null,
                url: null
            };
        });
        setUploads(function(prev) {
            return _to_consumable_array(prev).concat(_to_consumable_array(newFiles));
        });
        newFiles.forEach(function(fileObj, index) {
            uploadFile(fileObj, uploads.length + index);
        });
    }, [
        uploads
    ]);
    var uploadFile = function() {
        var _ref = _async_to_generator(function(fileObj, index) {
            var formData;
            return _ts_generator(this, function(_state) {
                formData = new FormData();
                formData.append("upload_contract", fileObj.file);
                setUploads(function(prev) {
                    return prev.map(function(item, i) {
                        return i === index ? _object_spread_props(_object_spread({}, item), {
                            status: "uploading",
                            progress: 0
                        }) : item;
                    });
                });
                try {
                    dispatch(uploadContractFileDoc(formData, {
                        modalObj: modalObj,
                        setModalObj: setModalObj
                    }));
                    setUploads(function(prev) {
                        return prev.map(function(item, i) {
                            return i === index ? _object_spread_props(_object_spread({}, item), {
                                status: "success"
                            }) : item;
                        });
                    });
                } catch (error) {
                    setUploads(function(prev) {
                        return prev.map(function(item, i) {
                            var _error_response_data, _error_response;
                            return i === index ? _object_spread_props(_object_spread({}, item), {
                                status: "error",
                                error: (error === null || error === void 0 ? void 0 : (_error_response = error.response) === null || _error_response === void 0 ? void 0 : (_error_response_data = _error_response.data) === null || _error_response_data === void 0 ? void 0 : _error_response_data.message) || (error === null || error === void 0 ? void 0 : error.message) || "อัปโหลดล้มเหลว"
                            }) : item;
                        });
                    });
                }
                return [
                    2
                ];
            });
        });
        return function uploadFile(fileObj, index) {
            return _ref.apply(this, arguments);
        };
    }();
    var _useDropzone = useDropzone({
        onDrop: onDrop,
        accept: {
            "application/pdf": [
                ".pdf"
            ],
            "image/*": [
                ".jpg",
                ".jpeg",
                ".png"
            ]
        },
        multiple: true
    }), getRootProps = _useDropzone.getRootProps, getInputProps = _useDropzone.getInputProps, isDragActive = _useDropzone.isDragActive;
    var removeFile = function(rowIdToRemove, idFile) {
        if (idFile && idFile > 0) {
            props.setFileDelOld(_to_consumable_array(props.fileDelOld).concat([
                {
                    ct_file_id: idFile
                }
            ]));
        }
        setFileUpLoad(function(prev) {
            return prev.filter(function(item, index) {
                return item.rowId !== rowIdToRemove;
            });
        });
    };
    useEffect(function() {
        setIsLoading(uploadContractFileDocReducer.isFetching);
        if (uploadContractFileDocReducer.data && !uploadContractFileDocReducer.isError) {
            var updatedData = uploadContractFileDocReducer.data.data;
            dispatch(clearUploadContractFileDoc());
            if (updatedData && updatedData.length > 0) {
                var ctFileUrl = "";
                var ctFileName = "";
                if (updatedData[0]) {
                    ctFileUrl = updatedData[0].imgFilePath;
                    ctFileName = updatedData[0].imgoriginalname;
                } else {
                    ctFileUrl = updatedData.imgFilePath;
                    ctFileName = updatedData.imgoriginalname;
                }
                setFileUpLoad(function(prev) {
                    return _to_consumable_array(prev).concat([
                        {
                            ct_file_id: 0,
                            ct_file_contid: contractID,
                            ct_file_crebyid: adminInfo && adminInfo.userId && adminInfo.userId != "" && adminInfo.userId != null ? parseInt(adminInfo.userId, 10) : 0,
                            ct_file_url: ctFileUrl,
                            ct_file_name: ctFileName,
                            rowId: nanoid(),
                            isDelete: true,
                            ct_file_chk: "new_file"
                        }
                    ]);
                });
            }
        }
    }, [
        uploadContractFileDocReducer
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        className: "p-4 border rounded-xl w-100",
        children: [
            /*#__PURE__*/ _jsxs("div", _object_spread_props(_object_spread({}, getRootProps()), {
                className: "border border-2 rounded p-5 text-center bg-light",
                style: {
                    cursor: "pointer"
                },
                children: [
                    /*#__PURE__*/ _jsx("input", _object_spread({}, getInputProps())),
                    isDragActive ? /*#__PURE__*/ _jsx("p", {
                        children: "ปล่อยไฟล์ที่นี่..."
                    }) : /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx("p", {
                                children: "ลากไฟล์ PDF / รูปมาวาง หรือคลิกเพื่อเลือกไฟล์"
                            }),
                            /*#__PURE__*/ _jsx("p", {
                                style: {
                                    color: "#A9ACB4"
                                },
                                children: " JPEG, JPG, PNG, PDF"
                            })
                        ]
                    })
                ]
            })),
            /*#__PURE__*/ _jsx("div", {
                className: "mt-4",
                children: fileUpLoad && fileUpLoad.length > 0 ? /*#__PURE__*/ _jsx(Stack, {
                    direction: "horizontal",
                    gap: 2,
                    sx: {
                        justifyContent: "flex-start",
                        alignItems: "center",
                        flexWrap: "wrap"
                    },
                    children: fileUpLoad.map(function(item, index) {
                        return /*#__PURE__*/ _jsxs("div", {
                            className: "mb-2",
                            style: {
                                alignContent: "center",
                                border: "1px dashed rgba(203, 208, 220, 1)",
                                borderRadius: 10,
                                height: 200,
                                width: 200
                            },
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "text-center",
                                    children: /*#__PURE__*/ _jsx(DownloadFile, {
                                        urlPath: item.ct_file_url,
                                        fileName: item.ct_file_name,
                                        showIconFile: true
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "text-center",
                                    children: /*#__PURE__*/ _jsx(DownloadFile, {
                                        urlPath: item.ct_file_url,
                                        fileName: item.ct_file_name,
                                        showText: true
                                    })
                                }),
                                item.isDelete ? /*#__PURE__*/ _jsx("div", {
                                    className: "text-center",
                                    children: /*#__PURE__*/ _jsx(ButtonMui, {
                                        size: "small",
                                        variant: "contained",
                                        color: "error",
                                        startIcon: /*#__PURE__*/ _jsx(DeleteIcon, {}),
                                        onClick: function() {
                                            return removeFile(item.rowId, item.ct_file_id);
                                        },
                                        children: "ลบ"
                                    })
                                }) : /*#__PURE__*/ _jsx(_Fragment, {})
                            ]
                        });
                    })
                }) : /*#__PURE__*/ _jsx(_Fragment, {})
            })
        ]
    });
}
// Styles
var styles = StyleSheet.create({
    page: {
        fontFamily: "THSarabun",
        fontSize: 16,
        padding: "40px 20px",
        lineHeight: 1
    },
    section: {
        marginBottom: 12
    },
    header: {
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "start"
    },
    logo: {
        width: 100,
        height: 61,
        marginBottom: 5
    },
    textHeaderCompany: {
        fontSize: 18,
        fontFamily: "THSarabun",
        fontWeight: "bold",
        marginBottom: 1
    },
    textDetailCompany: {
        fontSize: 16,
        fontFamily: "THSarabun"
    },
    centerHeaderText: {
        textAlign: "center",
        marginVertical: 12,
        fontSize: 18,
        fontFamily: "THSarabun",
        fontWeight: "bold"
    },
    rightDetailText: {
        fontFamily: "THSarabun",
        fontSize: 16,
        textAlign: "right"
    },
    paragraph: {
        fontSize: 16,
        lineHeight: 1.2,
        textAlign: "justify",
        fontFamily: "THSarabun",
        marginVertical: 15
    },
    bold: {
        fontFamily: "THSarabun",
        fontSize: 16,
        fontWeight: "bold"
    },
    footer: {
        position: "absolute",
        bottom: 30,
        left: 20,
        right: 20,
        textAlign: "right",
        fontFamily: "THSarabun",
        fontSize: 16,
        fontWeight: "bold"
    },
    sectionHeader: {
        fontFamily: "THSarabun",
        fontSize: 16,
        fontWeight: "bold"
    },
    paragraphSignature: {
        fontSize: 16,
        lineHeight: 1.2,
        textAlign: "justify",
        fontFamily: "THSarabun",
        marginVertical: 40
    },
    paragraphTextC: {
        fontSize: 16,
        lineHeight: 1.2,
        fontFamily: "THSarabun",
        marginBottom: 1
    },
    paddingLeftTextS1: {
        paddingLeft: 40
    },
    paddingLeftTextS2: {
        paddingLeft: 60
    },
    signatureRow: {
        flexDirection: "row",
        justifyContent: "space-between",
        paddingHorizontal: 20,
        marginVertical: 40
    },
    signatureRow2: {
        flexDirection: "row",
        justifyContent: "space-between",
        paddingHorizontal: 20
    },
    signatureBox: {
        minWidth: "45%",
        alignItems: "center"
    },
    signatureLine: {
        fontSize: 16,
        fontFamily: "THSarabun",
        marginBottom: 4,
        textAlign: "center",
        fontWeight: "bold"
    },
    signatureName: {
        fontSize: 16,
        fontFamily: "THSarabun",
        textAlign: "center",
        fontWeight: "bold"
    },
    paragraphPadding_40: {
        fontSize: 16,
        fontFamily: "THSarabun",
        marginVertical: 5,
        paddingLeft: 40
    },
    channelRow: {
        flexDirection: "row",
        justifyContent: "space-between",
        paddingLeft: 100,
        marginVertical: 10
    },
    channelBox: {
        minWidth: "45%",
        alignItems: "start"
    },
    channelLine: {
        fontSize: 16,
        fontFamily: "THSarabun",
        marginBottom: 4,
        textAlign: "left"
    },
    channelName: {
        fontSize: 16,
        fontFamily: "THSarabun",
        textAlign: "left"
    },
    table: {
        display: "flex",
        width: "auto",
        borderStyle: "solid",
        borderWidth: 1,
        borderColor: "#000",
        borderBottomWidth: 0
    },
    tableRow: {
        flexDirection: "row"
    },
    tableColHeader: {
        //width: '25%',
        borderStyle: "solid",
        borderWidth: 1,
        borderColor: "#000",
        borderLeftWidth: 0,
        borderTopWidth: 0,
        padding: 5
    },
    tableCol: {
        //width: '25%',
        borderStyle: "solid",
        borderWidth: 1,
        borderColor: "#000",
        borderLeftWidth: 0,
        borderTopWidth: 0,
        padding: 5
    },
    tableCellHeader: {
        fontSize: 14,
        fontWeight: "bold",
        textAlign: "center",
        fontFamily: "THSarabun"
    },
    tableCell: {
        fontSize: 12,
        fontFamily: "THSarabun",
        justifyContent: "center"
    },
    tableCol5P: {
        width: "5%"
    },
    tableCol10P: {
        width: "10%"
    },
    tableCol15P: {
        width: "15%"
    },
    tableCol20P: {
        width: "20%"
    },
    tableCol25P: {
        width: "25%"
    },
    tableCol30P: {
        width: "30%"
    },
    tableCol35P: {
        width: "35%"
    },
    tableCol40P: {
        width: "40%"
    },
    tableCol45P: {
        width: "45%"
    },
    tableCol50P: {
        width: "50%"
    },
    boxInfoPartner: {
        flexDirection: "row",
        justifyContent: "flex-start",
        marginLeft: 60
    }
});
// PDF Template Component
function ContractDocument(_param) {
    var data = _param.data, props = _object_without_properties(_param, [
        "data"
    ]);
    var _data_formData, _data_formData1, _data_formData2, _data_formData3, _data_formData4, _data_formData5, _data_formData6, _data_formData7, _data_formData8, _data_formData9, _data_formData10, _data_formData11;
    var rest = _extends({}, _object_destructuring_empty(props));
    var contractID = useParams().contractID;
    var _useState = _sliced_to_array(useState("จ่ายทั้งหมด" + "\xa0" + "(ระยะเวลาตลอดอายุสัญญา)"), 2), payType = _useState[0], setPayType = _useState[1];
    var _useState1 = _sliced_to_array(useState("3" + "\xa0" + "เดือน"), 2), payTypeSub = _useState1[0], setPayTypeSub = _useState1[1];
    var _useState2 = _sliced_to_array(useState(4), 2), payAmount = _useState2[0], setPayAmount = _useState2[1];
    var _useState3 = _sliced_to_array(useState("5,000"), 2), payPrice = _useState3[0], setPayPrice = _useState3[1];
    var _useState4 = _sliced_to_array(useState(0), 2), amountMonth = _useState4[0], setAmountMonth = _useState4[1];
    var _useState5 = _sliced_to_array(useState(""), 2), dateStart = _useState5[0], setDateStart = _useState5[1];
    var _useState6 = _sliced_to_array(useState(""), 2), dateEnd = _useState6[0], setDateEnd = _useState6[1];
    var _useState7 = _sliced_to_array(useState(""), 2), partnerName = _useState7[0], setPartnerName = _useState7[1];
    var _useState8 = _sliced_to_array(useState(""), 2), partnerAddr = _useState8[0], setPartnerAddr = _useState8[1];
    var _useState9 = _sliced_to_array(useState("-"), 2), partnerPosition = _useState9[0], setPartnerPosition = _useState9[1];
    var _useState10 = _sliced_to_array(useState("-"), 2), bankName = _useState10[0], setBankName = _useState10[1];
    var _useState11 = _sliced_to_array(useState("-"), 2), brandName = _useState11[0], setBrandName = _useState11[1];
    var _useState12 = _sliced_to_array(useState({}), 2), adsSum = _useState12[0], setAdsSum = _useState12[1];
    var _useState13 = _sliced_to_array(useState({}), 2), branchSum = _useState13[0], setBranchSum = _useState13[1];
    var _useState14 = _sliced_to_array(useState({}), 2), productSum = _useState14[0], setProductSum = _useState14[1];
    useEffect(function() {
        if (data) {
            if (data.userInfo) {
                if (data.userInfo && data.userInfo.companyName && data.userInfo.companyName != "" && data.userInfo.companyName != null) {
                    var infoCompanyName = data.userInfo.companyName.trim();
                    infoCompanyName = infoCompanyName.replace(" ", "\xa0");
                    setPartnerName(infoCompanyName);
                }
                if (data.userInfo && data.userInfo.companyAddress && data.userInfo.companyAddress != "" && data.userInfo.companyAddress != null) {
                    var infoCompanyAddress = data.userInfo.companyAddress.trim();
                    var companySubDistrict = "";
                    var companyDistrict = "";
                    var companyProvince = "";
                    var companyZipCode = "";
                    infoCompanyAddress = infoCompanyAddress.replace(" ", "\xa0");
                    if (data.userInfo.companyDistrict && data.userInfo.companyDistrict != "" && data.userInfo.companyDistrict != null) {
                        companyDistrict = data.userInfo.companyDistrict.trim();
                        if (data.ct_contract_provinceid && data.ct_contract_provinceid == 10) {
                            companyDistrict = "\xa0" + companyDistrict;
                        } else {
                            companyDistrict = "\xa0" + "อำเภอ\xa0" + companyDistrict;
                        }
                    }
                    if (data.userInfo.companySubDistrict && data.userInfo.companySubDistrict != "" && data.userInfo.companySubDistrict != null) {
                        companySubDistrict = data.userInfo.companySubDistrict.trim();
                        if (data.ct_contract_provinceid && data.ct_contract_provinceid == 10) {
                            companySubDistrict = "แขวง\xa0" + companySubDistrict;
                        } else {
                            companySubDistrict = "ตำบล\xa0" + companySubDistrict;
                        }
                        companySubDistrict = "\xa0" + companySubDistrict;
                    }
                    if (data.userInfo.companyProvince && data.userInfo.companyProvince != "" && data.userInfo.companyProvince != null) {
                        companyProvince = data.userInfo.companyProvince.trim();
                        companyProvince = "\xa0" + companyProvince;
                    }
                    if (data.userInfo.companyZipCode && data.userInfo.companyZipCode != "" && data.userInfo.companyZipCode != null) {
                        companyZipCode = data.userInfo.companyZipCode.trim();
                        companyZipCode = "\xa0" + companyZipCode;
                    }
                    infoCompanyAddress = infoCompanyAddress + companySubDistrict + companyDistrict + companyProvince + companyZipCode;
                    setPartnerAddr(infoCompanyAddress);
                }
                if (data.userInfo && data.userInfo.contactPosition && data.userInfo.contactPosition != "" && data.userInfo.contactPosition != null) {
                    setPartnerPosition(data.userInfo.contactPosition);
                }
            }
            if (data.formData) {
                var formData = data.formData;
                if (formData.ct_contract_startdate && formData.ct_contract_startdate != "" && formData.ct_contract_startdate != null) {
                    var dateStartNew = moment(formData.ct_contract_startdate).format("YYYY-MM-DD");
                    dateStartNew = formatThaiDate(dateStartNew).replace("  ", " ");
                    dateStartNew = dateStartNew.replace(" ", "\xa0");
                    setDateStart(dateStartNew);
                }
                if (formData.ct_contract_enddate && formData.ct_contract_enddate != "" && formData.ct_contract_enddate != null) {
                    var dateEndNew = moment(formData.ct_contract_enddate).format("YYYY-MM-DD");
                    dateEndNew = formatThaiDate(dateEndNew).replace("  ", " ");
                    dateEndNew = dateEndNew.replace(" ", "\xa0");
                    setDateEnd(dateEndNew);
                }
                if (formData.ct_contract_duration && formData.ct_contract_duration != "" && formData.ct_contract_duration != null && formData.ct_contract_duration > 0) {
                    setAmountMonth(formData.ct_contract_duration);
                }
                if (formData.ct_contract_brandid_text && formData.ct_contract_brandid_text != "" && formData.ct_contract_brandid_text != null) {
                    var infoBrandName = formData.ct_contract_brandid_text.trim();
                    infoBrandName = infoBrandName.replace(" ", "\xa0");
                    setBrandName(infoBrandName);
                }
                if (formData.ct_contract_paytype && formData.ct_contract_paytype != "" && formData.ct_contract_paytype != null) {
                    if (formData.ct_contract_paytype == 5) {
                        setPayType("รายปี");
                    } else if (formData.ct_contract_paytype == 4) {
                        setPayType("ราย" + "\xa0" + "6" + "\xa0" + "เดือน");
                    } else if (formData.ct_contract_paytype == 3) {
                        setPayType("ราย" + "\xa0" + "3" + "\xa0" + "เดือน");
                    } else if (formData.ct_contract_paytype == 2) {
                        setPayType("รายเดือน");
                    } else {
                        setPayType("จ่ายทั้งหมด" + "\xa0" + "(ระยะเวลาตลอดอายุสัญญา)");
                    }
                }
            }
            if (data.ctAdverts && data.ctAdverts.length > 0) {
                setAdsSum(SumCtAdvert(data.ctAdverts));
            }
            if (data.ctPlacements && data.ctPlacements.length > 0) {
                setBranchSum(SumCtPlacements(data.ctPlacements));
            }
            if (data.ctProducts && data.ctProducts.length > 0) {
                setProductSum(SumCtProducts(data.ctProducts));
            }
        }
    }, [
        data
    ]);
    var PDFHeader = function() {
        return /*#__PURE__*/ _jsxs(View, {
            style: styles.header,
            children: [
                /*#__PURE__*/ _jsx(Image, {
                    style: styles.logo,
                    src: "/images/logopardesco_new.png"
                }),
                /*#__PURE__*/ _jsxs(View, {
                    children: [
                        /*#__PURE__*/ _jsxs(Text, {
                            style: styles.textHeaderCompany,
                            children: [
                                "บริษัท",
                                "\xa0",
                                "พาร์เดสโก้",
                                "\xa0",
                                "กรุ๊ป",
                                "\xa0",
                                "จำกัด",
                                "\xa0",
                                "(สำนักงานใหญ่)"
                            ]
                        }),
                        /*#__PURE__*/ _jsx(Text, {
                            style: styles.textDetailCompany,
                            children: "เลขที่ 241/54 ซอยกาญจนาภิเษก 0015 แขวงศาลาธรรมสพน์"
                        }),
                        /*#__PURE__*/ _jsx(Text, {
                            style: styles.textDetailCompany,
                            children: "เขตทวีวัฒนา กรุงเทพมหานคร 10170"
                        })
                    ]
                })
            ]
        });
    };
    return /*#__PURE__*/ _jsxs(Document, {
        children: [
            /*#__PURE__*/ _jsxs(Page, {
                size: "A4",
                style: styles.page,
                children: [
                    /*#__PURE__*/ _jsx(PDFHeader, {}),
                    /*#__PURE__*/ _jsx(Text, {
                        style: styles.centerHeaderText,
                        children: "สัญญาฝากขายสินค้า"
                    }),
                    /*#__PURE__*/ _jsxs(View, {
                        style: {
                            flexDirection: "row",
                            justifyContent: "flex-end",
                            marginBottom: 10
                        },
                        children: [
                            /*#__PURE__*/ _jsx(Text, {
                                style: styles.rightDetailText,
                                children: "เลขที่สัญญา"
                            }),
                            /*#__PURE__*/ _jsx(Text, {
                                style: styles.bold,
                                children: " " + data.formData.ct_contract_code || ""
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(View, {
                        style: {
                            width: "100%",
                            marginVertical: 5
                        },
                        children: [
                            /*#__PURE__*/ _jsxs(Text, {
                                style: _object_spread_props(_object_spread({}, styles.paragraphTextC), {
                                    textAlign: "right"
                                }),
                                children: [
                                    "สัญญาฉบับนี้ทำขึ้นระหว่าง",
                                    "\xa0",
                                    /*#__PURE__*/ _jsxs(Text, {
                                        style: styles.bold,
                                        children: [
                                            "บริษัท",
                                            "\xa0",
                                            "พาร์เดสโก้",
                                            "\xa0",
                                            "กรุ๊ป",
                                            "\xa0",
                                            "จำกัด"
                                        ]
                                    }),
                                    "\xa0",
                                    "โดย",
                                    "\xa0",
                                    /*#__PURE__*/ _jsxs(Text, {
                                        style: styles.bold,
                                        children: [
                                            "นายสำเร็จ",
                                            "\xa0",
                                            "ติกกะวี"
                                        ]
                                    }),
                                    "\xa0",
                                    "และ",
                                    "\xa0",
                                    /*#__PURE__*/ _jsxs(Text, {
                                        style: styles.bold,
                                        children: [
                                            "นางสาวนันท์ณภัสร์",
                                            "\xa0",
                                            "เจียมกัลชาญ"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(Text, {
                                style: _object_spread({}, styles.paragraphTextC),
                                children: [
                                    "กรรมการผู้มีอำนาจ",
                                    "\xa0",
                                    "สำนักงานใหญ่",
                                    "\xa0",
                                    "ตั้งอยู่เลขที่",
                                    "\xa0",
                                    "241/54",
                                    "\xa0",
                                    "ซอยกาญจนาภิเษก",
                                    "\xa0",
                                    "0015",
                                    "\xa0",
                                    "แขวงศาลาธรรมสพน์",
                                    "\xa0",
                                    "เขตทวีวัฒนา",
                                    "\xa0",
                                    "กรุงเทพฯ"
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(Text, {
                                style: _object_spread({}, styles.paragraphTextC),
                                children: [
                                    "10170",
                                    "\xa0",
                                    "ซึ่งต่อไปเรียกว่า",
                                    "\xa0",
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: styles.bold,
                                        children: "“ผู้แทนขายสินค้า”"
                                    }),
                                    "\xa0",
                                    "ฝ่ายหนึ่ง",
                                    "\xa0",
                                    "กับ",
                                    "\xa0",
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: styles.bold,
                                        children: partnerName || ""
                                    }),
                                    "\xa0",
                                    "เลขประจำตัวผู้เสียภาษี",
                                    "\xa0",
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: styles.bold,
                                        children: data.formData.ct_contract_taxid || ""
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(Text, {
                                style: _object_spread({}, styles.paragraphTextC),
                                children: [
                                    "ที่อยู่",
                                    "\xa0",
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: styles.bold,
                                        children: partnerAddr
                                    }),
                                    "\xa0",
                                    "ซึ่งต่อไปในสัญญาจะเรียกว่า",
                                    "\xa0",
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: styles.bold,
                                        children: "“ผู้ฝากขายสินค้า”"
                                    }),
                                    "\xa0",
                                    "อีกฝ่ายหนึ่ง"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(View, {
                        style: {
                            width: "100%",
                            marginVertical: 5
                        },
                        children: /*#__PURE__*/ _jsx(Text, {
                            style: _object_spread({}, styles.paragraphTextC, styles.paddingLeftTextS1),
                            children: "คู่สัญญาทั้งสองตกลงทำสัญญากันโดยมีข้อความดังต่อไปนี้"
                        })
                    }),
                    /*#__PURE__*/ _jsxs(Text, {
                        style: _object_spread({}, styles.sectionHeader),
                        children: [
                            "1.",
                            "\xa0",
                            "รายละเอียด",
                            "\xa0",
                            "“ผู้ฝากขายสินค้า”"
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(View, {
                        style: {
                            width: "100%",
                            marginVertical: 2
                        },
                        children: [
                            /*#__PURE__*/ _jsxs(Text, {
                                style: _object_spread_props(_object_spread({}, styles.paragraphTextC, styles.paddingLeftTextS1), {
                                    marginVertical: 2
                                }),
                                children: [
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: styles.bold,
                                        children: "“ผู้ฝากขายสินค้า”"
                                    }),
                                    "\xa0",
                                    "เป็นผู้มีความพร้อม",
                                    "\xa0",
                                    "และ",
                                    "\xa0",
                                    "ต้องการฝากขายสินค้ากับ",
                                    "\xa0",
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: styles.bold,
                                        children: "“ผู้แทนขายสินค้า”"
                                    }),
                                    "\xa0",
                                    "ที่ร้าน",
                                    "\xa0",
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: styles.bold,
                                        children: "“PARDESCO”"
                                    }),
                                    "\xa0",
                                    "ดังนี้"
                                ]
                            }),
                            /*#__PURE__*/ _jsx(Text, {
                                style: _object_spread_props(_object_spread({}, styles.paragraphTextC, styles.paddingLeftTextS1), {
                                    marginVertical: 2
                                }),
                                children: "ข้อมูลผู้ฝากขาย"
                            }),
                            /*#__PURE__*/ _jsxs(Text, {
                                style: _object_spread_props(_object_spread({}, styles.paragraphTextC, styles.paddingLeftTextS2), {
                                    marginVertical: 2
                                }),
                                children: [
                                    "ชื่อแบรนด์",
                                    "\xa0",
                                    ":",
                                    "\xa0",
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: styles.bold,
                                        children: brandName || "-"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx(Text, {
                                style: _object_spread_props(_object_spread({}, styles.paragraphTextC, styles.paddingLeftTextS1), {
                                    marginVertical: 2
                                }),
                                children: "ข้อมูลผู้ติดต่อ"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(View, {
                        style: _object_spread({
                            marginVertical: 2
                        }, styles.boxInfoPartner),
                        children: [
                            /*#__PURE__*/ _jsxs(View, {
                                style: {
                                    minWidth: "30%",
                                    paddingRight: "5%"
                                },
                                children: [
                                    /*#__PURE__*/ _jsxs(Text, {
                                        style: _object_spread({}, styles.paragraphTextC),
                                        children: [
                                            "ชื่อ",
                                            "\xa0",
                                            ":",
                                            "\xa0",
                                            /*#__PURE__*/ _jsx(Text, {
                                                style: styles.bold,
                                                children: data.formData.ct_contract_mainfname || "-"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs(Text, {
                                        style: _object_spread({}, styles.paragraphTextC),
                                        children: [
                                            "เบอร์โทร",
                                            "\xa0",
                                            ":",
                                            "\xa0",
                                            /*#__PURE__*/ _jsx(Text, {
                                                style: styles.bold,
                                                children: data.formData.ct_contract_mainphone || "-"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs(Text, {
                                        style: _object_spread({}, styles.paragraphTextC),
                                        children: [
                                            "อีเมล",
                                            "\xa0",
                                            ":",
                                            "\xa0",
                                            /*#__PURE__*/ _jsx(Text, {
                                                style: styles.bold,
                                                children: data.formData.ct_contract_mainemail || "-"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx(View, {
                                style: {
                                    minWidth: "30%"
                                },
                                children: /*#__PURE__*/ _jsxs(Text, {
                                    style: _object_spread({}, styles.paragraphTextC),
                                    children: [
                                        "นามสกุล",
                                        "\xa0",
                                        ":",
                                        "\xa0",
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: styles.bold,
                                            children: data.formData.ct_contract_mainlname || "-"
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(Text, {
                        style: _object_spread_props(_object_spread({}, styles.paragraphTextC, styles.paddingLeftTextS1), {
                            marginVertical: 2
                        }),
                        children: "ข้อมูลธนาคาร"
                    }),
                    /*#__PURE__*/ _jsxs(View, {
                        style: _object_spread({
                            marginVertical: 2
                        }, styles.boxInfoPartner),
                        children: [
                            /*#__PURE__*/ _jsx(View, {
                                style: _object_spread({}, styles.tableCol5P),
                                children: /*#__PURE__*/ _jsx(Text, {
                                    style: _object_spread({}, styles.paragraphTextC)
                                })
                            }),
                            /*#__PURE__*/ _jsx(View, {
                                style: _object_spread({}, styles.tableCol20P),
                                children: /*#__PURE__*/ _jsx(Text, {
                                    style: _object_spread({}, styles.paragraphTextC),
                                    children: "ธนาคาร"
                                })
                            }),
                            /*#__PURE__*/ _jsx(View, {
                                style: _object_spread({}, styles.tableCol20P),
                                children: /*#__PURE__*/ _jsx(Text, {
                                    style: _object_spread({}, styles.paragraphTextC),
                                    children: "สาขา"
                                })
                            }),
                            /*#__PURE__*/ _jsx(View, {
                                style: _object_spread({}, styles.tableCol35P),
                                children: /*#__PURE__*/ _jsx(Text, {
                                    style: _object_spread({}, styles.paragraphTextC),
                                    children: "ชื่อบัญชี"
                                })
                            }),
                            /*#__PURE__*/ _jsx(View, {
                                style: _object_spread({}, styles.tableCol20P),
                                children: /*#__PURE__*/ _jsx(Text, {
                                    style: _object_spread({}, styles.paragraphTextC),
                                    children: "เลขที่บัญชี"
                                })
                            })
                        ]
                    }),
                    data.ctBank.map(function(item, index) {
                        return /*#__PURE__*/ _jsxs(View, {
                            style: _object_spread({
                                marginVertical: 2
                            }, styles.boxInfoPartner),
                            children: [
                                /*#__PURE__*/ _jsx(View, {
                                    style: _object_spread({}, styles.tableCol5P),
                                    children: /*#__PURE__*/ _jsxs(Text, {
                                        style: _object_spread_props(_object_spread({}, styles.paragraphTextC, styles.bold), {
                                            textAlign: "right",
                                            paddingRight: 5
                                        }),
                                        children: [
                                            index + 1,
                                            "."
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx(View, {
                                    style: _object_spread({}, styles.tableCol20P),
                                    children: /*#__PURE__*/ _jsx(Text, {
                                        style: _object_spread({}, styles.paragraphTextC, styles.bold),
                                        children: item.ct_bank_bankid && item.ct_bank_bankid > 0 ? filterTextAndNum(item.ct_bank_bankid_text, 3) : "-"
                                    })
                                }),
                                /*#__PURE__*/ _jsx(View, {
                                    style: _object_spread({}, styles.tableCol20P),
                                    children: /*#__PURE__*/ _jsx(Text, {
                                        style: _object_spread({}, styles.paragraphTextC, styles.bold),
                                        children: item.ct_bank_branchn || "-"
                                    })
                                }),
                                /*#__PURE__*/ _jsx(View, {
                                    style: _object_spread({}, styles.tableCol35P),
                                    children: /*#__PURE__*/ _jsx(Text, {
                                        style: _object_spread({}, styles.paragraphTextC, styles.bold),
                                        children: item.ct_bank_name || "-"
                                    })
                                }),
                                /*#__PURE__*/ _jsx(View, {
                                    style: _object_spread({}, styles.tableCol20P),
                                    children: /*#__PURE__*/ _jsx(Text, {
                                        style: _object_spread({}, styles.paragraphTextC, styles.bold),
                                        children: item.ct_bank_accountno || "-"
                                    })
                                })
                            ]
                        });
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(Page, {
                size: "A4",
                style: styles.page,
                children: [
                    /*#__PURE__*/ _jsx(PDFHeader, {}),
                    /*#__PURE__*/ _jsxs(Text, {
                        style: _object_spread_props(_object_spread({}, styles.sectionHeader), {
                            marginTop: 30
                        }),
                        children: [
                            "2.",
                            "\xa0",
                            "ค่าบริการและอายุสัญญา"
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(View, {
                        style: {
                            width: "100%",
                            marginVertical: 5
                        },
                        children: [
                            /*#__PURE__*/ _jsxs(Text, {
                                style: _object_spread({}, styles.paragraphTextC, styles.paddingLeftTextS1),
                                children: [
                                    "โดยทั้งสองฝ่ายตกลงทำสัญญากันตามรายละเอียดดังจะกล่าวต่อไปนี้",
                                    "\xa0",
                                    "หาก",
                                    "\xa0",
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: styles.bold,
                                        children: "“ผู้ฝากขายสินค้า”"
                                    }),
                                    "\xa0",
                                    "มีความประสงค์"
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(Text, {
                                style: _object_spread({}, styles.paragraphTextC),
                                children: [
                                    "ต่ออายุสัญญา",
                                    "\xa0",
                                    "จะต้องแจ้งให้",
                                    "\xa0",
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: styles.bold,
                                        children: "“ผู้แทนขายสินค้า”"
                                    }),
                                    "\xa0",
                                    "ทราบล่วงหน้าเป็นลายลักษณ์อักษรไม่น้อยกว่า",
                                    "\xa0",
                                    /*#__PURE__*/ _jsxs(Text, {
                                        style: styles.bold,
                                        children: [
                                            "30",
                                            "\xa0",
                                            "วัน"
                                        ]
                                    }),
                                    "\xa0",
                                    "ทั้งสองฝ่าย"
                                ]
                            }),
                            /*#__PURE__*/ _jsx(Text, {
                                style: _object_spread({}, styles.paragraphTextC),
                                children: "จะต้องทำสัญญาให้แล้วเสร็จก่อนหมดอายุสัญญานี้"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(View, {
                        style: {
                            width: "100%",
                            marginVertical: 10
                        },
                        children: [
                            /*#__PURE__*/ _jsxs(Text, {
                                style: _object_spread({}, styles.paragraphTextC, styles.paddingLeftTextS1),
                                children: [
                                    "ระยะเวลาสัญญา",
                                    "\xa0",
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: styles.bold,
                                        children: amountMonth || 0
                                    }),
                                    "\xa0",
                                    "เดือน"
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(Text, {
                                style: _object_spread({}, styles.paragraphTextC, styles.paddingLeftTextS1),
                                children: [
                                    "สัญญาเริ่มวันที่",
                                    "\xa0",
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: styles.bold,
                                        children: dateStart || ""
                                    }),
                                    "\xa0",
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: styles.bold,
                                        children: "-"
                                    }),
                                    "\xa0",
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: styles.bold,
                                        children: dateEnd || ""
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(View, {
                        style: {
                            width: "100%",
                            marginVertical: 5
                        },
                        children: [
                            /*#__PURE__*/ _jsxs(Text, {
                                style: _object_spread({}, styles.paragraphTextC, styles.paddingLeftTextS1),
                                children: [
                                    "2.1",
                                    "\xa0",
                                    "ค่าแรกเข้าสินค้า",
                                    "\xa0",
                                    "(Listing",
                                    "\xa0",
                                    "Fee)"
                                ]
                            }),
                            /*#__PURE__*/ _jsx(Text, {
                                style: _object_spread({}, styles.paragraphTextC, styles.paddingLeftTextS2, styles.bold),
                                children: "การชำระเงินครั้งแรกครั้งเดียว"
                            }),
                            (data === null || data === void 0 ? void 0 : (_data_formData = data.formData) === null || _data_formData === void 0 ? void 0 : _data_formData.ct_contract_initialcosttype) && (data === null || data === void 0 ? void 0 : (_data_formData1 = data.formData) === null || _data_formData1 === void 0 ? void 0 : _data_formData1.ct_contract_initialcosttype) > 1 && productSum && productSum.productAmount > 0 ? /*#__PURE__*/ _jsxs(Text, {
                                style: _object_spread({}, styles.paragraphTextC, styles.paddingLeftTextS2, styles.bold),
                                children: [
                                    "มีค่าธรรมเนียมแรกเข้า",
                                    "\xa0",
                                    "จำนวน",
                                    "\xa0",
                                    productSum.productAmount || 0,
                                    "\xa0",
                                    "SKU"
                                ]
                            }) : "",
                            /*#__PURE__*/ _jsx(Text, {
                                style: _object_spread({}, styles.paragraphTextC, styles.paddingLeftTextS2, styles.bold),
                                children: (data === null || data === void 0 ? void 0 : (_data_formData2 = data.formData) === null || _data_formData2 === void 0 ? void 0 : _data_formData2.ct_contract_initialcosttype) && (data === null || data === void 0 ? void 0 : (_data_formData3 = data.formData) === null || _data_formData3 === void 0 ? void 0 : _data_formData3.ct_contract_initialcosttype) > 1 ? "-" + "\xa0\xa0" + "รายละเอียดตามเอกสารแนบท้าย" + "\xa0" + "ข้อ" + "\xa0" + "2.1" : "-" + "\xa0\xa0" + "ยกเว้นค่าธรรมเนียมสินค้าแรกเข้า"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(View, {
                        style: {
                            width: "100%",
                            marginVertical: 5
                        },
                        children: [
                            /*#__PURE__*/ _jsxs(Text, {
                                style: _object_spread({}, styles.paragraphTextC, styles.paddingLeftTextS1, styles.bold),
                                children: [
                                    "2.2",
                                    "\xa0",
                                    "ค่าวางสินค้า",
                                    "\xa0",
                                    "(Facing",
                                    "\xa0",
                                    "Fee)"
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(Text, {
                                style: _object_spread({}, styles.paragraphTextC, styles.paddingLeftTextS2),
                                children: [
                                    "การชำระเงิน",
                                    "\xa0",
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: styles.bold,
                                        children: payType || "จ่ายทั้งหมด" + "\xa0" + "(ระยะเวลาตลอดอายุสัญญา)"
                                    })
                                ]
                            }),
                            (data === null || data === void 0 ? void 0 : (_data_formData4 = data.formData) === null || _data_formData4 === void 0 ? void 0 : _data_formData4.ct_contract_placementtype) && (data === null || data === void 0 ? void 0 : (_data_formData5 = data.formData) === null || _data_formData5 === void 0 ? void 0 : _data_formData5.ct_contract_placementtype) > 1 && data.ctPlacements && data.ctPlacements.length > 0 ? /*#__PURE__*/ _jsxs(Text, {
                                style: _object_spread({}, styles.paragraphTextC, styles.paddingLeftTextS2),
                                children: [
                                    "มีค่าวางสินค้า",
                                    "\xa0",
                                    "จำนวน",
                                    "\xa0",
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: styles.bold,
                                        children: data.ctPlacements.length || 0
                                    }),
                                    "\xa0",
                                    "SKU"
                                ]
                            }) : "",
                            /*#__PURE__*/ _jsx(Text, {
                                style: _object_spread({}, styles.paragraphTextC, styles.paddingLeftTextS2, styles.bold),
                                children: (data === null || data === void 0 ? void 0 : (_data_formData6 = data.formData) === null || _data_formData6 === void 0 ? void 0 : _data_formData6.ct_contract_placementtype) && (data === null || data === void 0 ? void 0 : (_data_formData7 = data.formData) === null || _data_formData7 === void 0 ? void 0 : _data_formData7.ct_contract_placementtype) > 1 ? "-" + "\xa0\xa0" + "รายละเอียดตามเอกสารแนบท้าย" + "\xa0" + "ข้อ" + "\xa0" + "2.2" : "-" + "\xa0\xa0" + "ยกเว้นค่าวางสินค้า"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(View, {
                        style: {
                            width: "100%",
                            marginVertical: 5
                        },
                        children: [
                            /*#__PURE__*/ _jsxs(Text, {
                                style: _object_spread({}, styles.paragraphTextC, styles.paddingLeftTextS1),
                                children: [
                                    "2.3",
                                    "\xa0",
                                    "ค่าโฆษณา",
                                    "\xa0",
                                    "(Media",
                                    "\xa0",
                                    "Fee)"
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(Text, {
                                style: _object_spread({}, styles.paragraphTextC, styles.paddingLeftTextS2),
                                children: [
                                    "การชำระเงิน",
                                    "\xa0",
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: styles.bold,
                                        children: payType || "จ่ายทั้งหมด" + "\xa0" + "(ระยะเวลาตลอดอายุสัญญา)"
                                    })
                                ]
                            }),
                            (data === null || data === void 0 ? void 0 : (_data_formData8 = data.formData) === null || _data_formData8 === void 0 ? void 0 : _data_formData8.ct_contract_adverttype) && (data === null || data === void 0 ? void 0 : (_data_formData9 = data.formData) === null || _data_formData9 === void 0 ? void 0 : _data_formData9.ct_contract_adverttype) > 1 && data.ctAdverts && data.ctAdverts.length > 0 ? /*#__PURE__*/ _jsxs(Text, {
                                style: _object_spread({}, styles.paragraphTextC, styles.paddingLeftTextS2),
                                children: [
                                    "มีค่าวางสินค้า",
                                    "\xa0",
                                    "จำนวน",
                                    "\xa0",
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: styles.bold,
                                        children: data.ctAdverts.length || 0
                                    }),
                                    "\xa0",
                                    "SKU"
                                ]
                            }) : "",
                            /*#__PURE__*/ _jsx(Text, {
                                style: _object_spread({}, styles.paragraphTextC, styles.paddingLeftTextS2, styles.bold),
                                children: (data === null || data === void 0 ? void 0 : (_data_formData10 = data.formData) === null || _data_formData10 === void 0 ? void 0 : _data_formData10.ct_contract_adverttype) && (data === null || data === void 0 ? void 0 : (_data_formData11 = data.formData) === null || _data_formData11 === void 0 ? void 0 : _data_formData11.ct_contract_adverttype) > 1 ? "-" + "\xa0\xa0" + "รายละเอียดตามเอกสารแนบท้าย" + "\xa0" + "ข้อ" + "\xa0" + "2.3" : "-" + "\xa0\xa0" + "ยกเว้นค่าโฆษณา"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(Text, {
                        style: _object_spread({}, styles.sectionHeader),
                        children: [
                            "3.",
                            "\xa0",
                            "ค่าคอมมิชชั่น",
                            "\xa0",
                            "จากการขายสินค้า",
                            "\xa0",
                            "(GP)"
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(View, {
                        style: {
                            width: "100%",
                            marginVertical: 5
                        },
                        children: [
                            /*#__PURE__*/ _jsxs(Text, {
                                style: _object_spread({}, styles.paragraphTextC, styles.paddingLeftTextS1),
                                children: [
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: styles.bold,
                                        children: "“ผู้ฝากขายสินค้า”"
                                    }),
                                    "\xa0",
                                    "ตกลงให้ค่าคอมมิชชั่นหรือส่วนแบ่งจากยอดขายที่เกิดขึ้น",
                                    "\xa0",
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: styles.bold,
                                        children: data.formData.ct_contract_salescomm && data.formData.ct_contract_salescomm >= 0 ? parseFloat(data.formData.ct_contract_salescomm) + "\xa0" + "%" : "0" + "\xa0" + "%"
                                    }),
                                    "\xa0",
                                    "แก่",
                                    "\xa0",
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: styles.bold,
                                        children: "“ผู้แทนขายสินค้า”"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(Text, {
                                style: _object_spread({}, styles.paragraphTextC, styles.paddingLeftTextS1),
                                children: [
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: styles.bold,
                                        children: "ข้อตกลงเพิ่มเติม"
                                    }),
                                    "\xa0",
                                    data.formData.ct_contract_wholesalescomm && data.formData.ct_contract_wholesalescomm > 0 ? /*#__PURE__*/ _jsxs(_Fragment, {
                                        children: [
                                            "กรณีนำเสนอขายค้าส่ง",
                                            "\xa0",
                                            "ให้ค่าคอมมิชชั่นหรือส่วนแบ่งจากยอดขายที่เกิดขึ้น",
                                            "\xa0",
                                            /*#__PURE__*/ _jsx(Text, {
                                                style: styles.bold,
                                                children: parseFloat(data.formData.ct_contract_wholesalescomm) + "\xa0" + "%"
                                            }),
                                            "\xa0",
                                            "แก่",
                                            "\xa0",
                                            /*#__PURE__*/ _jsx(Text, {
                                                style: styles.bold,
                                                children: "“ผู้แทนขายสินค้า”"
                                            })
                                        ]
                                    }) : /*#__PURE__*/ _jsx(Text, {
                                        style: styles.bold,
                                        children: "-"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(Text, {
                        style: _object_spread({}, styles.sectionHeader),
                        children: [
                            "4.",
                            "\xa0",
                            "รายงานยอดขาย",
                            "\xa0",
                            "และโอนเงินค้าสินค้าฝากขาย"
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(View, {
                        style: {
                            width: "100%",
                            marginVertical: 5
                        },
                        children: [
                            /*#__PURE__*/ _jsxs(Text, {
                                style: _object_spread({}, styles.paragraphTextC, styles.paddingLeftTextS1),
                                children: [
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: styles.bold,
                                        children: "“ผู้แทนขายสินค้า”"
                                    }),
                                    "\xa0",
                                    "จะสรุปรายงานยอดขายสินค้าทุกสิ้นเดือน",
                                    "\xa0",
                                    "และจัดส่งรายงานให้แก่",
                                    "\xa0",
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: styles.bold,
                                        children: "“ผู้ฝากขายสินค้า”"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(Text, {
                                style: _object_spread({}, styles.paragraphTextC),
                                children: [
                                    "ทุกวันที่",
                                    "\xa0",
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: styles.bold,
                                        children: "5"
                                    }),
                                    "\xa0",
                                    "และโอนเงินค่าสินค้าหลังหักส่วนแบ่งตามตกลง",
                                    "\xa0",
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: styles.bold
                                    }),
                                    "ข้อ",
                                    "\xa0",
                                    "3",
                                    "\xa0",
                                    "ในวันที่",
                                    "\xa0",
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: styles.bold,
                                        children: "10"
                                    }),
                                    "\xa0",
                                    "ของเดือนถัดไป"
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(Page, {
                size: "A4",
                style: styles.page,
                children: [
                    /*#__PURE__*/ _jsx(PDFHeader, {}),
                    /*#__PURE__*/ _jsxs(Text, {
                        style: _object_spread_props(_object_spread({}, styles.sectionHeader), {
                            marginTop: 30
                        }),
                        children: [
                            "5.",
                            "\xa0",
                            "ขั้นตอนการเตรียมข้อมูลสินค้า",
                            "\xa0",
                            "และการจัดส่งสินค้า"
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(View, {
                        style: {
                            width: "100%",
                            marginVertical: 5
                        },
                        children: [
                            /*#__PURE__*/ _jsxs(Text, {
                                style: _object_spread({}, styles.paragraphTextC, styles.paddingLeftTextS1),
                                children: [
                                    "ก่อนการจัดส่งสินค้า",
                                    "\xa0",
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: styles.bold,
                                        children: "“ผู้ฝากขายสินค้า”"
                                    }),
                                    "\xa0",
                                    "จะต้องดำเนินการตามขั้นตอนดังต่อไปนี้"
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(Text, {
                                style: _object_spread({}, styles.paragraphTextC, styles.paddingLeftTextS1),
                                children: [
                                    "5.1",
                                    "\xa0",
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: styles.bold,
                                        children: "“ผู้ฝากขายสินค้า”"
                                    }),
                                    "\xa0",
                                    "แจ้งข้อมูลสินค้าต่อ",
                                    "\xa0",
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: styles.bold,
                                        children: "“ผู้แทนขายสินค้า”"
                                    }),
                                    "\xa0",
                                    "ให้รับทราบ",
                                    "\xa0",
                                    "โดยกรอกข้อมูลในไฟล์นำเข้า",
                                    "\xa0",
                                    "สินค้า"
                                ]
                            }),
                            /*#__PURE__*/ _jsx(Text, {
                                style: _object_spread({}, styles.paragraphTextC),
                                children: "อย่างครบถ้วน"
                            }),
                            /*#__PURE__*/ _jsx(Text, {
                                style: _object_spread_props(_object_spread({}, styles.paragraphTextC, styles.paddingLeftTextS2), {
                                    marginTop: 3
                                }),
                                children: /*#__PURE__*/ _jsxs(Text, {
                                    style: styles.bold,
                                    children: [
                                        "***",
                                        "\xa0",
                                        "กรณี",
                                        "\xa0",
                                        "“ผู้ฝากขายสินค้า”",
                                        "\xa0",
                                        "แจ้งข้อมูลสินค้าไม่ถูกต้อง",
                                        "\xa0",
                                        "อาทิเช่น",
                                        "\xa0",
                                        "ชื่อสินค้า",
                                        "\xa0",
                                        "ราคาสินค้า",
                                        "\xa0",
                                        "หรือข้อมูลอื่นๆอันก่อให้"
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx(Text, {
                                style: _object_spread_props(_object_spread({}, styles.paragraphTextC), {
                                    marginBottom: 5
                                }),
                                children: /*#__PURE__*/ _jsxs(Text, {
                                    style: styles.bold,
                                    children: [
                                        "เกิดความเสียหายในระบบการขาย",
                                        "\xa0",
                                        "“ผู้ฝากขายสินค้า”",
                                        "\xa0",
                                        "จะต้องรับผิดชอบต่อความเสียหายที่เกิดขึ้นนั้นเอง",
                                        "\xa0",
                                        "แต่เพียงฝ่ายเดียว"
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsxs(Text, {
                                style: _object_spread_props(_object_spread({}, styles.paragraphTextC, styles.paddingLeftTextS1), {
                                    marginVertical: 5
                                }),
                                children: [
                                    "5.2",
                                    "\xa0",
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: styles.bold,
                                        children: "“ผู้ฝากขายสินค้า”"
                                    }),
                                    "\xa0",
                                    "จะต้องแนบ",
                                    "\xa0",
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: styles.bold,
                                        children: "“ใบส่งสินค้า”"
                                    }),
                                    "\xa0",
                                    "ไปพร้อมกับสินค้าที่จัดส่งเสมอ"
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(Text, {
                                style: _object_spread_props(_object_spread({}, styles.paragraphTextC, styles.paddingLeftTextS1), {
                                    marginVertical: 5
                                }),
                                children: [
                                    "5.3",
                                    "\xa0",
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: styles.bold,
                                        children: "“ผู้ฝากขายสินค้า”"
                                    }),
                                    "\xa0",
                                    "จะต้องระบุรายละเอียดสินค้าตามแบบฟอร์มของ",
                                    "\xa0",
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: styles.bold,
                                        children: "“ผู้แทนขายสินค้า”"
                                    }),
                                    "\xa0",
                                    "พร้อมระบุเลขที่สัญญา"
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(Text, {
                                style: _object_spread_props(_object_spread({}, styles.paragraphTextC, styles.paddingLeftTextS1), {
                                    marginTop: 5
                                }),
                                children: [
                                    "5.4",
                                    "\xa0",
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: styles.bold,
                                        children: "“ผู้ฝากขายสินค้า”"
                                    }),
                                    "\xa0",
                                    "จะต้องดำเนินการจัดส่งสินค้าและรับผิดชอบค่าใช้จ่ายในการจัดส่งสินค้าถึงหน้าร้าน",
                                    "\xa0",
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: styles.bold,
                                        children: "PARDESCO"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(Text, {
                                style: _object_spread_props(_object_spread({}, styles.paragraphTextC), {
                                    marginBottom: 5
                                }),
                                children: [
                                    "ณ",
                                    "\xa0",
                                    "นครหลวงเวียงจันทร์",
                                    "\xa0",
                                    "สาธารณรัฐประชาธิปไตยประชาชนลาว"
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(Text, {
                                style: _object_spread_props(_object_spread({}, styles.paragraphTextC, styles.paddingLeftTextS1), {
                                    marginTop: 5
                                }),
                                children: [
                                    "5.5",
                                    "\xa0",
                                    "กรณีที่สินค้าชำรุดเสียหาย",
                                    "\xa0",
                                    "มีตำหนิ",
                                    "\xa0",
                                    "ก่อนการรับสินค้าเข้าคลัง",
                                    "\xa0",
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: styles.bold,
                                        children: "“ผู้แทนขายสินค้า”"
                                    }),
                                    "\xa0",
                                    "จะแจ้งให้",
                                    "\xa0",
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: styles.bold,
                                        children: "“ผู้ฝากขายสินค้า”"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(Text, {
                                style: _object_spread({}, styles.paragraphTextC),
                                children: [
                                    "ทราบเพื่อบันทึกหักลบกับสินค้าที่ระบุไว้ใน",
                                    "\xa0",
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: styles.bold,
                                        children: "“ใบส่งสินค้า”"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(Text, {
                        style: _object_spread({}, styles.sectionHeader),
                        children: [
                            "6.",
                            "\xa0",
                            "ลิขสิทธิ์สินค้า"
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(View, {
                        style: {
                            width: "100%",
                            marginVertical: 5
                        },
                        children: [
                            /*#__PURE__*/ _jsxs(Text, {
                                style: _object_spread({}, styles.paragraphTextC, styles.paddingLeftTextS1),
                                children: [
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: styles.bold,
                                        children: "“ผู้ฝากขายสินค้า”"
                                    }),
                                    "\xa0",
                                    "ยืนยันว่าสินค้าที่นำมาขายนั้น",
                                    "\xa0",
                                    "เป็นสินค้าที่ไม่ละเมิดลิขสิทธิ์",
                                    "\xa0",
                                    "หาก",
                                    "\xa0",
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: styles.bold,
                                        children: "“ผู้แทนขายสินค้า”"
                                    }),
                                    "\xa0",
                                    "ตรวจพบภายหลัง"
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(Text, {
                                style: _object_spread({}, styles.paragraphTextC),
                                children: [
                                    "ว่าสินค้าที่นำมาขายนั้นเป็นสินค้าละเมิดลิขสิทธ์",
                                    "\xa0",
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: styles.bold,
                                        children: "“ผู้แทนขายสินค้า”"
                                    }),
                                    "\xa0",
                                    "สามารถยกเลิกสัญญาได้ทันที",
                                    "\xa0",
                                    "และไม่รับผิดชอบต่อความเสียหายที่เกิดขึ้นทุกกรณี"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(Text, {
                        style: _object_spread({}, styles.sectionHeader),
                        children: [
                            "7.",
                            "\xa0",
                            "การประชาสัมพันธ์",
                            "\xa0",
                            "และ",
                            "\xa0",
                            "การส่งเสริมการขาย"
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(View, {
                        style: {
                            width: "100%",
                            marginVertical: 5
                        },
                        children: [
                            /*#__PURE__*/ _jsxs(Text, {
                                style: _object_spread({}, styles.paragraphTextC, styles.paddingLeftTextS1),
                                children: [
                                    "7.1",
                                    "\xa0",
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: styles.bold,
                                        children: "“ผู้ฝากขายสินค้า”"
                                    }),
                                    "\xa0",
                                    "ยินดีทำการประชาสัมพันธ์ในสื่อต่างๆของตน",
                                    "\xa0",
                                    "รวมถึงการส่งเสริมการขายร่วมกับ",
                                    "\xa0",
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: styles.bold,
                                        children: "“ผู้แทนขายสินค้า”"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(Text, {
                                style: _object_spread({}, styles.paragraphTextC),
                                children: [
                                    "และยินดีให้",
                                    "\xa0",
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: styles.bold,
                                        children: "“ผู้แทนขายสินค้า”"
                                    }),
                                    "\xa0",
                                    "นำสินค้า",
                                    "\xa0",
                                    "ชื่อแบรนด์",
                                    "\xa0",
                                    "รูปภาพ",
                                    "\xa0",
                                    "คลิปวีดีโอ",
                                    "\xa0",
                                    "สื่อ",
                                    "\xa0",
                                    "ของ",
                                    "\xa0",
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: styles.bold,
                                        children: "“ผู้ฝากขายสินค้า”"
                                    }),
                                    "\xa0",
                                    "ไปใช้ในกิจกรรม"
                                ]
                            }),
                            /*#__PURE__*/ _jsx(Text, {
                                style: _object_spread_props(_object_spread({}, styles.paragraphTextC), {
                                    marginBottom: 5
                                }),
                                children: "ประชาสัมพันธ์ส่งเสริมการขายได้โดยไม่คิดมูลค่า"
                            }),
                            /*#__PURE__*/ _jsxs(Text, {
                                style: _object_spread({}, styles.paragraphTextC, styles.paddingLeftTextS1),
                                children: [
                                    "7.2",
                                    "\xa0",
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: styles.bold,
                                        children: "“ผู้ฝากขายสินค้า”"
                                    }),
                                    "\xa0",
                                    "ยินยอมที่จะให้เครดิต",
                                    "\xa0",
                                    "หรือ",
                                    "\xa0",
                                    "Tag",
                                    "\xa0",
                                    "ช่องทางประชาสัมพันธ์ของ",
                                    "\xa0",
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: styles.bold,
                                        children: "“ผู้แทนขายสินค้า”"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(Text, {
                                style: _object_spread({}, styles.paragraphTextC),
                                children: [
                                    "ทุกครั้งที่นำรูปและสื่อประชาสัมพันธ์ต่างๆของ",
                                    "\xa0",
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: styles.bold,
                                        children: "“ผู้แทนขายสินค้า”"
                                    }),
                                    "\xa0",
                                    "ไปใช้"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(Text, {
                        style: _object_spread({}, styles.sectionHeader),
                        children: [
                            "8.",
                            "\xa0",
                            "ความรับผิดชอบต่อสินค้าของ",
                            "\xa0",
                            "“ผู้แทนขายสินค้า”"
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(View, {
                        style: {
                            width: "100%",
                            marginVertical: 5
                        },
                        children: [
                            /*#__PURE__*/ _jsxs(Text, {
                                style: _object_spread({}, styles.paragraphTextC, styles.paddingLeftTextS1),
                                children: [
                                    "ความรับผิดชอบต่อสินค้าของ",
                                    "\xa0",
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: styles.bold,
                                        children: "“ผู้แทนขายสินค้า”"
                                    }),
                                    "\xa0",
                                    "เกิดตั้งแต่คลังสินค้าบันทึกรับสินค้าภายหลัง",
                                    "\xa0",
                                    "การตรวจนับจำนวน"
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(Text, {
                                style: _object_spread({}, styles.paragraphTextC),
                                children: [
                                    "และรับสินค้าที่มีสภาพสมบูรณ์โดย",
                                    "\xa0",
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: styles.bold,
                                        children: "“ผู้แทนขายสินค้า”"
                                    }),
                                    "\xa0",
                                    "มีหน้าที่ดูแลสินค้าของ",
                                    "\xa0",
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: styles.bold,
                                        children: "“ผู้ฝากขายสินค้า”"
                                    }),
                                    "\xa0",
                                    "ให้ดีที่สุดหากสินค้าเสียหาย"
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(Text, {
                                style: _object_spread({}, styles.paragraphTextC),
                                children: [
                                    "หรือสูญหายขณะอยุ่ในความรับผิดชอบของ",
                                    "\xa0",
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: styles.bold,
                                        children: "“ผู้แทนขายสินค้า”"
                                    }),
                                    "\xa0",
                                    "ยินดีที่จะรับผิดชอบต่อมูลค่าของสินค้านั้น"
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(Text, {
                                style: _object_spread({}, styles.paragraphTextC, styles.paddingLeftTextS1),
                                children: [
                                    "ทั้งนี้",
                                    "\xa0",
                                    "หากกรณี",
                                    "\xa0",
                                    "อัคคีภัย",
                                    "\xa0",
                                    "อุทกภัย",
                                    "\xa0",
                                    "ภัยธรรมชาติต่างๆ",
                                    "\xa0",
                                    "การจลาจล",
                                    "\xa0",
                                    "ภัยจากการก่อการร้าย",
                                    "\xa0",
                                    "โรคระบาด",
                                    "\xa0",
                                    "หรือเหตุการณ์"
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(Text, {
                                style: _object_spread({}, styles.paragraphTextC),
                                children: [
                                    "ที่นำมาซึ่งความเสียหายต่อสินค้านั้นเป็นเหตุการณ์สุดวิสัยทาง",
                                    "\xa0",
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: styles.bold,
                                        children: "“ผู้แทนขายสินค้า”"
                                    }),
                                    "\xa0",
                                    "ไม่ต้องรับผิดชอบต่อความเสียหายที่เกิดขึ้น"
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(Page, {
                size: "A4",
                style: styles.page,
                children: [
                    /*#__PURE__*/ _jsx(PDFHeader, {}),
                    /*#__PURE__*/ _jsxs(Text, {
                        style: _object_spread_props(_object_spread({}, styles.sectionHeader), {
                            marginTop: 30
                        }),
                        children: [
                            "9.",
                            "\xa0",
                            "ความรับผิดชอบต่อพื้นที่โฆษณาของ",
                            "\xa0",
                            "“ผู้แทนขายสินค้า”"
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(View, {
                        style: {
                            width: "100%",
                            marginVertical: 5
                        },
                        children: [
                            /*#__PURE__*/ _jsx(Text, {
                                style: _object_spread({}, styles.paragraphTextC, styles.paddingLeftTextS1),
                                children: "คำนิยาม"
                            }),
                            /*#__PURE__*/ _jsxs(Text, {
                                style: _object_spread({}, styles.paragraphTextC, styles.paddingLeftTextS2),
                                children: [
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: styles.bold,
                                        children: "“ผู้แทนขายสินค้า”"
                                    }),
                                    "\xa0",
                                    "หรือ",
                                    "\xa0",
                                    "ผู้ให้เช่า"
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(Text, {
                                style: _object_spread({}, styles.paragraphTextC, styles.paddingLeftTextS2),
                                children: [
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: styles.bold,
                                        children: "“ผู้ฝากขายสินค้า”"
                                    }),
                                    "\xa0",
                                    "หรือ",
                                    "\xa0",
                                    "ผู้เช่า"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(View, {
                        style: {
                            width: "100%",
                            marginVertical: 5
                        },
                        children: [
                            /*#__PURE__*/ _jsxs(Text, {
                                style: _object_spread({}, styles.paragraphTextC, styles.paddingLeftTextS1),
                                children: [
                                    "9.1",
                                    "\xa0",
                                    "การเผยแพร่โฆษณา"
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(Text, {
                                style: _object_spread({}, styles.paragraphTextC, styles.paddingLeftTextS2),
                                children: [
                                    "9.1.1",
                                    "\xa0",
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: styles.bold,
                                        children: "“ผู้แทนขายสินค้า”"
                                    }),
                                    "\xa0",
                                    "จะจัดสรรเวลาในการเผยแพร่โฆษณาตามที่ตกลง",
                                    "\xa0",
                                    "ไว้ล่วงหน้า",
                                    "\xa0",
                                    "โดยกำหนด"
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(Text, {
                                style: _object_spread({}, styles.paragraphTextC),
                                children: [
                                    "ช่วงเวลา",
                                    "\xa0",
                                    "/",
                                    "\xa0",
                                    "ความถี่",
                                    "\xa0",
                                    "/",
                                    "\xa0",
                                    "รอบการแสดงผลอย่างชัดเจนในใบเสนอราคา",
                                    "\xa0",
                                    "ซึ่งถือเป็นส่วนหนึ่งของสัญญาฉบับนี้"
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(Text, {
                                style: _object_spread({}, styles.paragraphTextC, styles.paddingLeftTextS2),
                                children: [
                                    "9.1.2",
                                    "\xa0",
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: styles.bold,
                                        children: "“ผู้ฝากขายสินค้า”"
                                    }),
                                    "\xa0",
                                    "จะไม่มีสิทธิเข้าไปควบคุม",
                                    "\xa0",
                                    "หรือปรับแก้การแสดงผล",
                                    "\xa0",
                                    "โฆษณาได้โดยพลการ"
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(Text, {
                                style: _object_spread({}, styles.paragraphTextC, styles.paddingLeftTextS2),
                                children: [
                                    "9.1.3",
                                    "\xa0",
                                    "หากเกิดเหตุสุดวิสัย",
                                    "\xa0",
                                    "เช่น",
                                    "\xa0",
                                    "ไฟฟ้าขัดข้อง",
                                    "\xa0",
                                    "ภัยธรรมชาติ",
                                    "\xa0",
                                    "เหตุการณ์ความไม่สงบ",
                                    "\xa0",
                                    "หรือเหตุอื่นใด",
                                    "\xa0",
                                    "ที่อยู่"
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(Text, {
                                style: _object_spread({}, styles.paragraphTextC),
                                children: [
                                    "นอกเหนือการควบคุมของ",
                                    "\xa0",
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: styles.bold,
                                        children: "“ผู้แทนขายสินค้า”"
                                    }),
                                    "\xa0",
                                    "ทำให้ไม่สามารถเผยแพร่โฆษณาได้ตามปกติ",
                                    "\xa0",
                                    "หรือ",
                                    "\xa0",
                                    "ความประมาทเลินเล่อของ"
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(Text, {
                                style: _object_spread({}, styles.paragraphTextC),
                                children: [
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: styles.bold,
                                        children: "“ผู้แทนขายสินค้า”"
                                    }),
                                    "\xa0",
                                    "เอง",
                                    "\xa0",
                                    "ในกรณีดังกล่าว",
                                    "\xa0",
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: styles.bold,
                                        children: "“ผู้แทนขายสินค้า”"
                                    }),
                                    "\xa0",
                                    "จะพิจารณาขยายเวลา",
                                    "\xa0",
                                    "การเผยแพร่ให้ตามสมควร",
                                    "\xa0",
                                    "โดยจะแจ้งให้"
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(Text, {
                                style: _object_spread({}, styles.paragraphTextC),
                                children: [
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: styles.bold,
                                        children: "“ผู้ฝากขายสินค้า”"
                                    }),
                                    "\xa0",
                                    "ทราบโดยเร็ว"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(View, {
                        style: {
                            width: "100%",
                            marginVertical: 5
                        },
                        children: [
                            /*#__PURE__*/ _jsxs(Text, {
                                style: _object_spread({}, styles.paragraphTextC, styles.paddingLeftTextS1),
                                children: [
                                    "9.2",
                                    "\xa0",
                                    "ความรับผิดชอบ"
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(Text, {
                                style: _object_spread({}, styles.paragraphTextC, styles.paddingLeftTextS2),
                                children: [
                                    "9.2.1",
                                    "\xa0",
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: styles.bold,
                                        children: "“ผู้ฝากขายสินค้า”"
                                    }),
                                    "\xa0",
                                    "ต้องรับผิดชอบต่อเนื้อหาโฆษณาที่นำมาเผยแพร่แต่เพียงผู้เดียว",
                                    "\xa0",
                                    "ทั้งในด้านความถูกต้อง"
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(Text, {
                                style: _object_spread({}, styles.paragraphTextC),
                                children: [
                                    "ความชอบด้วยกฎหมาย",
                                    "\xa0",
                                    "และการไม่ละเมิดลิขสิทธิ์หรือสิทธิของบุคคลอื่น",
                                    "\xa0",
                                    "หากมีความเสียหาย",
                                    "\xa0",
                                    "การฟ้องร้อง",
                                    "\xa0",
                                    "หรือการเรียกร้องค่าเสียหาย"
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(Text, {
                                style: _object_spread({}, styles.paragraphTextC),
                                children: [
                                    "จากบุคคลที่สามอันเนื่องมาจากเนื้อหาโฆษณา",
                                    "\xa0",
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: styles.bold,
                                        children: "“ผู้ฝากขายสินค้า”"
                                    }),
                                    "\xa0",
                                    "ต้องรับผิดชอบค่าเสียหาย",
                                    "\xa0",
                                    "ค่าใช้จ่าย",
                                    "\xa0",
                                    "และค่าธรรมเนียม"
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(Text, {
                                style: _object_spread({}, styles.paragraphTextC),
                                children: [
                                    "ทางกฎหมายทั้งหมดที่เกิดขึ้น",
                                    "\xa0",
                                    "แต่เพียงผู้เดียว"
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(Text, {
                                style: _object_spread({}, styles.paragraphTextC, styles.paddingLeftTextS2),
                                children: [
                                    "9.2.2",
                                    "\xa0",
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: styles.bold,
                                        children: "“ผู้แทนขายสินค้า”"
                                    }),
                                    "\xa0",
                                    "จะไม่รับผิดชอบต่อความเสียหายหรือการสูญเสียทางธุรกิจใดๆ",
                                    "\xa0",
                                    "ที่เกิดจากการเผยแพร่"
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(Text, {
                                style: _object_spread({}, styles.paragraphTextC),
                                children: [
                                    "หรือไม่สามารถเผยแพร่โฆษณาได้ตามที่ระบุในข้อ",
                                    "\xa0",
                                    "9.1.3",
                                    "\xa0",
                                    "เว้นแต่จะพิสูจน์ได้",
                                    "\xa0",
                                    "ว่าเกิดจากความผิดโดยตรงและความประมาทเลินเล่อของ"
                                ]
                            }),
                            /*#__PURE__*/ _jsx(Text, {
                                style: _object_spread({}, styles.paragraphTextC),
                                children: /*#__PURE__*/ _jsx(Text, {
                                    style: styles.bold,
                                    children: "“ผู้แทนขายสินค้า”"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(View, {
                        style: {
                            width: "100%",
                            marginVertical: 5
                        },
                        children: [
                            /*#__PURE__*/ _jsxs(Text, {
                                style: _object_spread({}, styles.paragraphTextC, styles.paddingLeftTextS1),
                                children: [
                                    "9.3",
                                    "\xa0",
                                    "การยกเลิกสัญญา"
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(Text, {
                                style: _object_spread({}, styles.paragraphTextC, styles.paddingLeftTextS2),
                                children: [
                                    "9.3.1",
                                    "\xa0",
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: styles.bold,
                                        children: "“ผู้ฝากขายสินค้า”"
                                    }),
                                    "\xa0",
                                    "สามารถบอกเลิกสัญญาก่อนครบกำหนดได้",
                                    "\xa0",
                                    "โดยแจ้งเป็นลายลักษณ์อักษรให้"
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(Text, {
                                style: _object_spread({}, styles.paragraphTextC),
                                children: [
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: styles.bold,
                                        children: "“ผู้แทนขายสินค้า”"
                                    }),
                                    "\xa0",
                                    "ทราบล่วงหน้าไม่น้อยกว่า",
                                    "\xa0",
                                    "30",
                                    "\xa0",
                                    "วัน",
                                    "\xa0",
                                    "และ",
                                    "\xa0",
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: styles.bold,
                                        children: "“ผู้ฝากขายสินค้า”"
                                    }),
                                    "\xa0",
                                    "จะไม่มีสิทธิได้รับเงินค่าเช่าที่ได้ชำระไปแล้วคืนไม่ว่ากรณีใดๆ"
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(Text, {
                                style: _object_spread({}, styles.paragraphTextC, styles.paddingLeftTextS2),
                                children: [
                                    "9.3.2",
                                    "\xa0",
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: styles.bold,
                                        children: "“ผู้แทนขายสินค้า”"
                                    }),
                                    "\xa0",
                                    "มีสิทธิบอกเลิกสัญญาได้ทันทีโดยไม่ต้องบอกกล่าวล่วงหน้า",
                                    "\xa0",
                                    "และไม่ต้องคืนค่าเช่า"
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(Text, {
                                style: _object_spread({}, styles.paragraphTextC),
                                children: [
                                    "ที่ได้ชำระไปแล้ว",
                                    "\xa0",
                                    "หาก",
                                    "\xa0",
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: styles.bold,
                                        children: "“ผู้ฝากขายสินค้า”"
                                    }),
                                    "\xa0",
                                    "ฝ่าฝืนข้อตกลงและเงื่อนไขสำคัญใดๆ",
                                    "\xa0",
                                    "ในสัญญานี้",
                                    "\xa0",
                                    "เช่น",
                                    "\xa0",
                                    "ไม่ชำระเงินตามกำหนดเวลา"
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(Text, {
                                style: _object_spread({}, styles.paragraphTextC),
                                children: [
                                    "มีการเผยแพร่เนื้อหาที่ผิดกฎหมาย",
                                    "\xa0",
                                    "ผิดศีลธรรม",
                                    "\xa0",
                                    "หรือผิดเงื่อนไขที่ระบุในสัญญา",
                                    "\xa0",
                                    "อย่างร้ายแรง",
                                    "\xa0",
                                    "หรือไม่ปฏิบัติตามคำเตือนของ"
                                ]
                            }),
                            /*#__PURE__*/ _jsx(Text, {
                                style: _object_spread({}, styles.paragraphTextC),
                                children: /*#__PURE__*/ _jsx(Text, {
                                    style: styles.bold,
                                    children: "“ผู้แทนขายสินค้า”"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(Page, {
                size: "A4",
                style: styles.page,
                children: [
                    /*#__PURE__*/ _jsx(PDFHeader, {}),
                    /*#__PURE__*/ _jsxs(View, {
                        style: {
                            width: "100%",
                            marginTop: 30,
                            marginBottom: 5
                        },
                        children: [
                            /*#__PURE__*/ _jsxs(Text, {
                                style: _object_spread({}, styles.paragraphTextC, styles.paddingLeftTextS1),
                                children: [
                                    "9.4",
                                    "\xa0",
                                    "การโอนสิทธิและหน้าที่"
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(Text, {
                                style: _object_spread({}, styles.paragraphTextC, styles.paddingLeftTextS2),
                                children: [
                                    "ห้าม",
                                    "\xa0",
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: styles.bold,
                                        children: "“ผู้ฝากขายสินค้า”"
                                    }),
                                    "\xa0",
                                    "โอนสิทธิ",
                                    "\xa0",
                                    "หน้าที่",
                                    "\xa0",
                                    "หรือให้สิทธิบุคคลอื่นเช่าต่อ",
                                    "\xa0",
                                    "หรือดำเนินการอื่นใด",
                                    "\xa0",
                                    "อันเป็นการเปลี่ยนแปลง"
                                ]
                            }),
                            /*#__PURE__*/ _jsx(Text, {
                                style: _object_spread({}, styles.paragraphTextC),
                                children: "สถานะของผู้เช่าตามสัญญาโดยเด็ดขาด"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(View, {
                        style: {
                            width: "100%",
                            marginVertical: 5
                        },
                        children: [
                            /*#__PURE__*/ _jsxs(Text, {
                                style: _object_spread({}, styles.paragraphTextC, styles.paddingLeftTextS1),
                                children: [
                                    "9.5",
                                    "\xa0",
                                    "การแก้ไขสัญญา"
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(Text, {
                                style: _object_spread({}, styles.paragraphTextC, styles.paddingLeftTextS2),
                                children: [
                                    "การแก้ไขหรือเพิ่มเติมข้อความใดในสัญญานี้ต้องได้รับความยินยอมจากทั้งสองฝ่าย",
                                    "\xa0",
                                    "เป็นลายลักษณ์อักษร"
                                ]
                            }),
                            /*#__PURE__*/ _jsx(Text, {
                                style: _object_spread({}, styles.paragraphTextC),
                                children: "และต้องลงนามโดยผู้มีอำนาจของทั้งสองฝ่าย"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(View, {
                        style: {
                            width: "100%",
                            marginVertical: 5
                        },
                        children: [
                            /*#__PURE__*/ _jsxs(Text, {
                                style: _object_spread({}, styles.paragraphTextC, styles.paddingLeftTextS1),
                                children: [
                                    "9.6",
                                    "\xa0",
                                    "ข้อพิพาทและกฎหมายที่ใช้บังคับ"
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(Text, {
                                style: _object_spread({}, styles.paragraphTextC, styles.paddingLeftTextS2),
                                children: [
                                    "9.6.1",
                                    "\xa0",
                                    "หากเกิดข้อพิพาทอันเนื่องมาจากหรือเกี่ยวข้องกับสัญญานี้",
                                    "\xa0",
                                    "ทั้งสองฝ่ายจะพยายาม",
                                    "\xa0",
                                    "เจรจาไกล่เกลี่ยกัน"
                                ]
                            }),
                            /*#__PURE__*/ _jsx(Text, {
                                style: _object_spread({}, styles.paragraphTextC),
                                children: "ด้วยความสุจริตใจและเป็นธรรม"
                            }),
                            /*#__PURE__*/ _jsxs(Text, {
                                style: _object_spread({}, styles.paragraphTextC, styles.paddingLeftTextS2),
                                children: [
                                    "9.6.2",
                                    "\xa0",
                                    "หากไม่สามารถตกลงกันได้",
                                    "\xa0",
                                    "ให้มีการฟ้องร้องต่อศาลไทย",
                                    "\xa0",
                                    "โดยใช้กฎหมายไทย",
                                    "\xa0",
                                    "เป็นหลักในการพิจารณาตัดสิน"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(Text, {
                        style: _object_spread({}, styles.sectionHeader),
                        children: [
                            "10.",
                            "\xa0",
                            "ข้อตกลงเพิ่มเติม"
                        ]
                    }),
                    /*#__PURE__*/ _jsx(View, {
                        style: {
                            width: "100%",
                            marginVertical: 5
                        },
                        children: /*#__PURE__*/ _jsx(Text, {
                            style: _object_spread({}, styles.paragraphTextC, styles.bold),
                            children: data.formData.ct_contract_additional && data.formData.ct_contract_additional.trim() != "" ? "\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0" + filterTextAndNum(data.formData.ct_contract_additional, 3) : ""
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(Page, {
                size: "A4",
                style: styles.page,
                children: [
                    /*#__PURE__*/ _jsx(PDFHeader, {}),
                    /*#__PURE__*/ _jsxs(View, {
                        style: {
                            width: "100%",
                            marginVertical: 40
                        },
                        children: [
                            /*#__PURE__*/ _jsxs(Text, {
                                style: styles.paragraphTextC,
                                children: [
                                    "\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0",
                                    "เอกสารสัญญาฉบับนี้",
                                    "\xa0",
                                    "ถูกทำขึ้น",
                                    "\xa0",
                                    "2",
                                    "\xa0",
                                    "ฉบับ",
                                    "\xa0",
                                    "มีเนื้อหาที่ถูกต้อง",
                                    "\xa0",
                                    "และตรงกัน",
                                    "\xa0",
                                    "โดยคู่สัญญาได้อ่าน",
                                    "\xa0",
                                    "และทำความเข้าใจเนื้อหาแห่งสัญญา"
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(Text, {
                                style: styles.paragraphTextC,
                                children: [
                                    "โดยละเอียดแล้ว",
                                    "\xa0",
                                    "เห็นว่าถูกต้องตรงตามเจตนาและยอมรับ",
                                    "\xa0",
                                    "เงื่อนไขร่วมกันทั้งหมดในสัญญานี้เป็นที่เรียบร้อยแล้ว",
                                    "\xa0",
                                    "จึงได้ลงลายมือชื่อ"
                                ]
                            }),
                            /*#__PURE__*/ _jsx(Text, {
                                style: styles.paragraphTextC,
                                children: "ไว้เป็นสำคัญต่อหน้าพยาน"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(Text, {
                        style: styles.sectionHeader,
                        children: "ผู้แทนขายสินค้า"
                    }),
                    /*#__PURE__*/ _jsxs(View, {
                        style: styles.signatureRow,
                        children: [
                            /*#__PURE__*/ _jsxs(View, {
                                style: _object_spread_props(_object_spread({}, styles.signatureBox), {
                                    paddingRight: "10%"
                                }),
                                children: [
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: styles.signatureLine,
                                        children: "ลงชื่อ ............................................................."
                                    }),
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: styles.signatureName,
                                        children: "( นายสำเร็จ ติกกะวี )"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(View, {
                                style: _object_spread_props(_object_spread({}, styles.signatureBox), {
                                    paddingLeft: "10%"
                                }),
                                children: [
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: styles.signatureLine,
                                        children: "ลงชื่อ ............................................................."
                                    }),
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: styles.signatureName,
                                        children: "( นางสาวนันท์ณภัสร์ เจียมกัลชาญ )"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(Text, {
                        style: styles.sectionHeader,
                        children: "ผู้ฝากขายสินค้า"
                    }),
                    /*#__PURE__*/ _jsxs(View, {
                        style: styles.signatureRow,
                        children: [
                            /*#__PURE__*/ _jsxs(View, {
                                style: _object_spread_props(_object_spread({}, styles.signatureBox), {
                                    paddingRight: "10%"
                                }),
                                children: [
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: styles.signatureLine,
                                        children: "ลงชื่อ ............................................................."
                                    }),
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: styles.signatureName,
                                        children: "(                                   )"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(View, {
                                style: _object_spread_props(_object_spread({}, styles.signatureBox), {
                                    paddingLeft: "10%"
                                }),
                                children: [
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: styles.signatureLine,
                                        children: "ลงชื่อ ............................................................."
                                    }),
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: styles.signatureName,
                                        children: "(                                   )"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(View, {
                        style: _object_spread_props(_object_spread({}, styles.signatureRow2), {
                            marginBottom: 40,
                            marginTop: 10
                        }),
                        children: [
                            /*#__PURE__*/ _jsxs(View, {
                                style: _object_spread_props(_object_spread({}, styles.signatureBox), {
                                    paddingRight: "10%"
                                }),
                                children: [
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: styles.signatureLine,
                                        children: "ลงชื่อ ............................................................."
                                    }),
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: styles.signatureName,
                                        children: "(                                   )"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(View, {
                                style: _object_spread_props(_object_spread({}, styles.signatureBox), {
                                    paddingLeft: "10%"
                                }),
                                children: [
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: styles.signatureLine,
                                        children: "ลงชื่อ ............................................................."
                                    }),
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: styles.signatureName,
                                        children: "(                                   )"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(Text, {
                        style: styles.sectionHeader,
                        children: "พยาน"
                    }),
                    /*#__PURE__*/ _jsxs(View, {
                        style: styles.signatureRow,
                        children: [
                            /*#__PURE__*/ _jsxs(View, {
                                style: _object_spread_props(_object_spread({}, styles.signatureBox), {
                                    paddingRight: "10%"
                                }),
                                children: [
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: styles.signatureLine,
                                        children: "ลงชื่อ ............................................................."
                                    }),
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: styles.signatureName,
                                        children: "(                                   )"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(View, {
                                style: _object_spread_props(_object_spread({}, styles.signatureBox), {
                                    paddingLeft: "10%"
                                }),
                                children: [
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: styles.signatureLine,
                                        children: "ลงชื่อ ............................................................."
                                    }),
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: styles.signatureName,
                                        children: "(                                   )"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(Text, {
                        render: function(param) {
                            var pageNumber = param.pageNumber, totalPages = param.totalPages;
                            return "".concat(pageNumber, " / ").concat(totalPages);
                        }
                    })
                ]
            }),
            data.ctProducts && data.ctProducts.length > 0 ? /*#__PURE__*/ _jsxs(Page, {
                size: "A4",
                style: styles.page,
                children: [
                    /*#__PURE__*/ _jsx(PDFHeader, {}),
                    /*#__PURE__*/ _jsxs(Text, {
                        style: styles.centerHeaderText,
                        children: [
                            "เอกสารแนบท้าย",
                            "\xa0",
                            "ข้อ",
                            "\xa0",
                            "2.1"
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(Text, {
                        style: styles.sectionHeader,
                        children: [
                            "2.1",
                            "\xa0",
                            "ค่าแรกเข้า"
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(View, {
                        style: _object_spread_props(_object_spread({}, styles.table), {
                            marginTop: 10,
                            marginBottom: 10
                        }),
                        children: [
                            /*#__PURE__*/ _jsxs(View, {
                                style: styles.tableRow,
                                children: [
                                    /*#__PURE__*/ _jsx(View, {
                                        style: _object_spread({}, styles.tableColHeader, styles.tableCol10P),
                                        children: /*#__PURE__*/ _jsx(Text, {
                                            style: styles.tableCellHeader,
                                            children: "ลำดับ"
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(View, {
                                        style: _object_spread({}, styles.tableColHeader, styles.tableCol35P),
                                        children: /*#__PURE__*/ _jsx(Text, {
                                            style: styles.tableCellHeader,
                                            children: "รายการ"
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(View, {
                                        style: _object_spread({}, styles.tableColHeader, styles.tableCol15P),
                                        children: /*#__PURE__*/ _jsxs(Text, {
                                            style: styles.tableCellHeader,
                                            children: [
                                                "ค่าแรกเข้า",
                                                " ",
                                                "(EX.VAT)"
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(View, {
                                        style: _object_spread({}, styles.tableColHeader, styles.tableCol15P),
                                        children: /*#__PURE__*/ _jsx(Text, {
                                            style: styles.tableCellHeader,
                                            children: "ส่วนลด"
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(View, {
                                        style: _object_spread({}, styles.tableColHeader, styles.tableCol25P),
                                        children: /*#__PURE__*/ _jsx(Text, {
                                            style: styles.tableCellHeader,
                                            children: "หมายเหตุ"
                                        })
                                    })
                                ]
                            }),
                            data.ctProducts.map(function(item, index) {
                                return /*#__PURE__*/ _jsxs(View, {
                                    style: styles.tableRow,
                                    children: [
                                        /*#__PURE__*/ _jsx(View, {
                                            style: _object_spread({}, styles.tableCol, styles.tableCol10P),
                                            children: /*#__PURE__*/ _jsx(Text, {
                                                style: _object_spread_props(_object_spread({}, styles.tableCell), {
                                                    textAlign: "center"
                                                }),
                                                children: index + 1
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(View, {
                                            style: _object_spread({}, styles.tableCol, styles.tableCol35P),
                                            children: /*#__PURE__*/ _jsx(Text, {
                                                style: styles.tableCell,
                                                children: filterTextAndNum(item.ct_product_name || "", 3)
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(View, {
                                            style: _object_spread({}, styles.tableCol, styles.tableCol15P),
                                            children: /*#__PURE__*/ _jsx(Text, {
                                                style: _object_spread_props(_object_spread({}, styles.tableCell), {
                                                    textAlign: "right"
                                                }),
                                                children: formatNumber(item.ct_product_initalcost, 2)
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(View, {
                                            style: _object_spread({}, styles.tableCol, styles.tableCol15P),
                                            children: /*#__PURE__*/ _jsx(Text, {
                                                style: _object_spread_props(_object_spread({}, styles.tableCell), {
                                                    textAlign: "right"
                                                }),
                                                children: formatNumber(item.ct_product_discount, 2)
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(View, {
                                            style: _object_spread({}, styles.tableCol, styles.tableCol25P),
                                            children: /*#__PURE__*/ _jsx(Text, {
                                                style: styles.tableCell,
                                                children: filterTextAndNum(item.ct_product_remark || "", 3)
                                            })
                                        })
                                    ]
                                });
                            }),
                            /*#__PURE__*/ _jsxs(View, {
                                style: styles.tableRow,
                                children: [
                                    /*#__PURE__*/ _jsx(View, {
                                        style: _object_spread({}, styles.tableCol, styles.tableCol10P),
                                        children: /*#__PURE__*/ _jsx(Text, {
                                            style: _object_spread_props(_object_spread({}, styles.tableCell), {
                                                textAlign: "center"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(View, {
                                        style: _object_spread({}, styles.tableCol, styles.tableCol35P),
                                        children: /*#__PURE__*/ _jsx(Text, {
                                            style: _object_spread_props(_object_spread({}, styles.tableCell), {
                                                textAlign: "center",
                                                fontWeight: "bold"
                                            }),
                                            children: "รวม"
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(View, {
                                        style: _object_spread({}, styles.tableCol, styles.tableCol15P),
                                        children: /*#__PURE__*/ _jsx(Text, {
                                            style: _object_spread_props(_object_spread({}, styles.tableCell), {
                                                textAlign: "right",
                                                fontWeight: "bold"
                                            }),
                                            children: productSum.sumCost ? formatNumber(productSum.sumCost, 2) : 0.00
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(View, {
                                        style: _object_spread({}, styles.tableCol, styles.tableCol15P),
                                        children: /*#__PURE__*/ _jsx(Text, {
                                            style: _object_spread_props(_object_spread({}, styles.tableCell), {
                                                textAlign: "right",
                                                fontWeight: "bold"
                                            }),
                                            children: productSum.sumDiscount ? formatNumber(productSum.sumDiscount, 2) : 0.00
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(View, {
                                        style: _object_spread({}, styles.tableCol, styles.tableCol25P),
                                        children: /*#__PURE__*/ _jsx(Text, {
                                            style: styles.tableCell
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(View, {
                        style: {
                            flexDirection: "row",
                            justifyContent: "flex-end",
                            marginBottom: 5
                        },
                        children: [
                            /*#__PURE__*/ _jsx(View, {
                                style: _object_spread({}, styles.tableCol20P),
                                children: /*#__PURE__*/ _jsx(Text, {
                                    style: _object_spread({}, styles.channelName, styles.bold),
                                    children: "มูลค่าก่อนหักส่วนลด"
                                })
                            }),
                            /*#__PURE__*/ _jsx(View, {
                                style: _object_spread({}, styles.tableCol20P),
                                children: /*#__PURE__*/ _jsx(Text, {
                                    style: _object_spread_props(_object_spread({}, styles.bold), {
                                        textAlign: "right"
                                    }),
                                    children: productSum.sumCost ? formatNumber(productSum.sumCost, 2) : 0.00
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(View, {
                        style: {
                            flexDirection: "row",
                            justifyContent: "flex-end",
                            marginBottom: 5
                        },
                        children: [
                            /*#__PURE__*/ _jsx(View, {
                                style: _object_spread({}, styles.tableCol20P),
                                children: /*#__PURE__*/ _jsx(Text, {
                                    style: styles.channelName,
                                    children: "ส่วนลด"
                                })
                            }),
                            /*#__PURE__*/ _jsx(View, {
                                style: _object_spread({}, styles.tableCol20P),
                                children: /*#__PURE__*/ _jsx(Text, {
                                    style: _object_spread_props(_object_spread({}, styles.bold), {
                                        textAlign: "right"
                                    }),
                                    children: productSum.sumDiscount ? formatNumber(productSum.sumDiscount, 2) : formatNumber(0, 2)
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(View, {
                        style: {
                            flexDirection: "row",
                            justifyContent: "flex-end",
                            marginBottom: 5
                        },
                        children: [
                            /*#__PURE__*/ _jsx(View, {
                                style: _object_spread({}, styles.tableCol20P),
                                children: /*#__PURE__*/ _jsx(Text, {
                                    style: _object_spread({}, styles.channelName, styles.bold),
                                    children: "มูลค่าหลังหักส่วนลด"
                                })
                            }),
                            /*#__PURE__*/ _jsx(View, {
                                style: _object_spread({}, styles.tableCol20P),
                                children: /*#__PURE__*/ _jsx(Text, {
                                    style: _object_spread_props(_object_spread({}, styles.bold), {
                                        textAlign: "right"
                                    }),
                                    children: productSum.sumPreTax ? formatNumber(productSum.sumPreTax, 2) : formatNumber(0, 2)
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(View, {
                        style: {
                            flexDirection: "row",
                            justifyContent: "flex-end",
                            marginBottom: 5
                        },
                        children: [
                            /*#__PURE__*/ _jsx(View, {
                                style: _object_spread({}, styles.tableCol20P),
                                children: /*#__PURE__*/ _jsx(Text, {
                                    style: styles.channelName,
                                    children: "ภาษีมูลค่าเพิ่ม"
                                })
                            }),
                            /*#__PURE__*/ _jsx(View, {
                                style: _object_spread({}, styles.tableCol20P),
                                children: /*#__PURE__*/ _jsx(Text, {
                                    style: _object_spread_props(_object_spread({}, styles.bold), {
                                        textAlign: "right"
                                    }),
                                    children: productSum.sumTax ? formatNumber(productSum.sumTax, 2) : formatNumber(0, 2)
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(View, {
                        style: {
                            flexDirection: "row",
                            justifyContent: "flex-end",
                            marginBottom: 5
                        },
                        children: [
                            /*#__PURE__*/ _jsx(View, {
                                style: _object_spread({}, styles.tableCol20P),
                                children: /*#__PURE__*/ _jsx(Text, {
                                    style: _object_spread({}, styles.channelName, styles.bold),
                                    children: "มูลค่ารวมภาษี"
                                })
                            }),
                            /*#__PURE__*/ _jsx(View, {
                                style: _object_spread({}, styles.tableCol20P),
                                children: /*#__PURE__*/ _jsx(Text, {
                                    style: _object_spread_props(_object_spread({}, styles.bold), {
                                        textAlign: "right"
                                    }),
                                    children: productSum.sumIsTax ? formatNumber(productSum.sumIsTax, 2) : formatNumber(0, 2)
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(View, {
                        style: {
                            flexDirection: "row",
                            justifyContent: "flex-end",
                            marginBottom: 5
                        },
                        children: [
                            /*#__PURE__*/ _jsx(View, {
                                style: _object_spread({}, styles.tableCol20P),
                                children: /*#__PURE__*/ _jsx(Text, {
                                    style: styles.channelName,
                                    children: "หัก ณ ที่จ่าย"
                                })
                            }),
                            /*#__PURE__*/ _jsx(View, {
                                style: _object_spread({}, styles.tableCol20P),
                                children: /*#__PURE__*/ _jsx(Text, {
                                    style: _object_spread_props(_object_spread({}, styles.bold), {
                                        textAlign: "right"
                                    }),
                                    children: productSum.sumVat ? formatNumber(productSum.sumVat, 2) : formatNumber(0, 2)
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(View, {
                        style: {
                            flexDirection: "row",
                            justifyContent: "flex-end",
                            marginBottom: 5
                        },
                        children: [
                            /*#__PURE__*/ _jsx(View, {
                                style: _object_spread({}, styles.tableCol20P),
                                children: /*#__PURE__*/ _jsx(Text, {
                                    style: _object_spread({}, styles.channelName, styles.bold),
                                    children: "มูลค่าสุทธิรวม"
                                })
                            }),
                            /*#__PURE__*/ _jsx(View, {
                                style: _object_spread({}, styles.tableCol20P),
                                children: /*#__PURE__*/ _jsx(Text, {
                                    style: _object_spread_props(_object_spread({}, styles.bold), {
                                        textAlign: "right"
                                    }),
                                    children: productSum.sumNet ? formatNumber(productSum.sumNet, 2) : formatNumber(0, 2)
                                })
                            })
                        ]
                    })
                ]
            }) : "",
            data.ctPlacements && data.ctPlacements.length > 0 ? /*#__PURE__*/ _jsxs(Page, {
                size: "A4",
                style: styles.page,
                children: [
                    /*#__PURE__*/ _jsx(PDFHeader, {}),
                    /*#__PURE__*/ _jsxs(Text, {
                        style: styles.centerHeaderText,
                        children: [
                            "เอกสารแนบท้าย",
                            "\xa0",
                            "ข้อ",
                            "\xa0",
                            "2.2"
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(Text, {
                        style: styles.sectionHeader,
                        children: [
                            "2.2",
                            "\xa0",
                            "ค่าวางสินค้า"
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(View, {
                        style: _object_spread_props(_object_spread({}, styles.table), {
                            marginTop: 10,
                            marginBottom: 10
                        }),
                        children: [
                            /*#__PURE__*/ _jsxs(View, {
                                style: styles.tableRow,
                                children: [
                                    /*#__PURE__*/ _jsx(View, {
                                        style: _object_spread({}, styles.tableColHeader, styles.tableCol10P),
                                        children: /*#__PURE__*/ _jsx(Text, {
                                            style: styles.tableCellHeader,
                                            children: "ลำดับ"
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(View, {
                                        style: _object_spread({}, styles.tableColHeader, styles.tableCol20P),
                                        children: /*#__PURE__*/ _jsx(Text, {
                                            style: styles.tableCellHeader,
                                            children: "ช่องทางการขาย"
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(View, {
                                        style: _object_spread({}, styles.tableColHeader, styles.tableCol15P),
                                        children: /*#__PURE__*/ _jsx(Text, {
                                            style: styles.tableCellHeader,
                                            children: "ตำแหน่งที่ว่าง"
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(View, {
                                        style: _object_spread({}, styles.tableColHeader, styles.tableCol10P),
                                        children: /*#__PURE__*/ _jsxs(Text, {
                                            style: styles.tableCellHeader,
                                            children: [
                                                "จำนวน",
                                                "\xa0",
                                                "(เดือน)"
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(View, {
                                        style: _object_spread({}, styles.tableColHeader, styles.tableCol15P),
                                        children: /*#__PURE__*/ _jsxs(Text, {
                                            style: styles.tableCellHeader,
                                            children: [
                                                "ค่าวางสินค้า",
                                                " ",
                                                "/",
                                                "\xa0",
                                                "เดือน"
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(View, {
                                        style: _object_spread({}, styles.tableColHeader, styles.tableCol15P),
                                        children: /*#__PURE__*/ _jsx(Text, {
                                            style: styles.tableCellHeader,
                                            children: "มูลค่ารวม"
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(View, {
                                        style: _object_spread({}, styles.tableColHeader, styles.tableCol15P),
                                        children: /*#__PURE__*/ _jsx(Text, {
                                            style: styles.tableCellHeader,
                                            children: "หมายเหตุ"
                                        })
                                    })
                                ]
                            }),
                            data.ctPlacements.map(function(item, index) {
                                return /*#__PURE__*/ _jsxs(View, {
                                    style: styles.tableRow,
                                    children: [
                                        /*#__PURE__*/ _jsx(View, {
                                            style: _object_spread({}, styles.tableCol, styles.tableCol10P),
                                            children: /*#__PURE__*/ _jsx(Text, {
                                                style: _object_spread_props(_object_spread({}, styles.tableCell), {
                                                    textAlign: "center"
                                                }),
                                                children: index + 1
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(View, {
                                            style: _object_spread({}, styles.tableCol, styles.tableCol20P),
                                            children: /*#__PURE__*/ _jsx(Text, {
                                                style: styles.tableCell,
                                                children: filterTextAndNum(item.set_branch_name || "", 3)
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(View, {
                                            style: _object_spread({}, styles.tableCol, styles.tableCol15P),
                                            children: /*#__PURE__*/ _jsx(Text, {
                                                style: styles.tableCell,
                                                children: filterTextAndNum(item.setPosition.set_position_name || "", 3)
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(View, {
                                            style: _object_spread({}, styles.tableCol, styles.tableCol10P),
                                            children: /*#__PURE__*/ _jsx(Text, {
                                                style: _object_spread_props(_object_spread({}, styles.tableCell), {
                                                    textAlign: "center"
                                                }),
                                                children: filterTextAndNum(item.ct_placement_month, 1)
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(View, {
                                            style: _object_spread({}, styles.tableCol, styles.tableCol15P),
                                            children: /*#__PURE__*/ _jsx(Text, {
                                                style: _object_spread_props(_object_spread({}, styles.tableCell), {
                                                    textAlign: "right"
                                                }),
                                                children: formatNumber(item.ct_placement_cost, 2)
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(View, {
                                            style: _object_spread({}, styles.tableCol, styles.tableCol15P),
                                            children: /*#__PURE__*/ _jsx(Text, {
                                                style: _object_spread_props(_object_spread({}, styles.tableCell), {
                                                    textAlign: "right"
                                                }),
                                                children: item.ct_placement_cost && item.ct_placement_cost > 0 && item.ct_placement_month && item.ct_placement_month > 0 ? formatNumber(item.ct_placement_cost * item.ct_placement_month, 2) : formatNumber(0, 2)
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(View, {
                                            style: _object_spread({}, styles.tableCol, styles.tableCol15P),
                                            children: /*#__PURE__*/ _jsx(Text, {
                                                style: styles.tableCell,
                                                children: filterTextAndNum(item.ct_placement_remark, 3)
                                            })
                                        })
                                    ]
                                });
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(View, {
                        style: {
                            flexDirection: "row",
                            justifyContent: "flex-end",
                            marginBottom: 5
                        },
                        children: [
                            /*#__PURE__*/ _jsx(View, {
                                style: _object_spread({}, styles.tableCol20P),
                                children: /*#__PURE__*/ _jsx(Text, {
                                    style: _object_spread({}, styles.channelName, styles.bold),
                                    children: "มูลค่าก่อนหักส่วนลด"
                                })
                            }),
                            /*#__PURE__*/ _jsx(View, {
                                style: _object_spread({}, styles.tableCol20P),
                                children: /*#__PURE__*/ _jsx(Text, {
                                    style: _object_spread_props(_object_spread({}, styles.bold), {
                                        textAlign: "right"
                                    }),
                                    children: branchSum.sumCost ? formatNumber(branchSum.sumCost, 2) : 0.00
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(View, {
                        style: {
                            flexDirection: "row",
                            justifyContent: "flex-end",
                            marginBottom: 5
                        },
                        children: [
                            /*#__PURE__*/ _jsx(View, {
                                style: _object_spread({}, styles.tableCol20P),
                                children: /*#__PURE__*/ _jsx(Text, {
                                    style: styles.channelName,
                                    children: "ส่วนลด"
                                })
                            }),
                            /*#__PURE__*/ _jsx(View, {
                                style: _object_spread({}, styles.tableCol20P),
                                children: /*#__PURE__*/ _jsx(Text, {
                                    style: _object_spread_props(_object_spread({}, styles.bold), {
                                        textAlign: "right"
                                    }),
                                    children: branchSum.sumDiscount ? formatNumber(branchSum.sumDiscount, 2) : 0.00
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(View, {
                        style: {
                            flexDirection: "row",
                            justifyContent: "flex-end",
                            marginBottom: 5
                        },
                        children: [
                            /*#__PURE__*/ _jsx(View, {
                                style: _object_spread({}, styles.tableCol20P),
                                children: /*#__PURE__*/ _jsx(Text, {
                                    style: _object_spread({}, styles.channelName, styles.bold),
                                    children: "มูลค่าหลังหักส่วนลด"
                                })
                            }),
                            /*#__PURE__*/ _jsx(View, {
                                style: _object_spread({}, styles.tableCol20P),
                                children: /*#__PURE__*/ _jsx(Text, {
                                    style: _object_spread_props(_object_spread({}, styles.bold), {
                                        textAlign: "right"
                                    }),
                                    children: branchSum.sumPreTax ? formatNumber(branchSum.sumPreTax, 2) : 0.00
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(View, {
                        style: {
                            flexDirection: "row",
                            justifyContent: "flex-end",
                            marginBottom: 5
                        },
                        children: [
                            /*#__PURE__*/ _jsx(View, {
                                style: _object_spread({}, styles.tableCol20P),
                                children: /*#__PURE__*/ _jsx(Text, {
                                    style: styles.channelName,
                                    children: "ภาษีมูลค่าเพิ่ม"
                                })
                            }),
                            /*#__PURE__*/ _jsx(View, {
                                style: _object_spread({}, styles.tableCol20P),
                                children: /*#__PURE__*/ _jsx(Text, {
                                    style: _object_spread_props(_object_spread({}, styles.bold), {
                                        textAlign: "right"
                                    }),
                                    children: branchSum.sumTax ? formatNumber(branchSum.sumTax, 2) : 0.00
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(View, {
                        style: {
                            flexDirection: "row",
                            justifyContent: "flex-end",
                            marginBottom: 5
                        },
                        children: [
                            /*#__PURE__*/ _jsx(View, {
                                style: _object_spread({}, styles.tableCol20P),
                                children: /*#__PURE__*/ _jsx(Text, {
                                    style: _object_spread({}, styles.channelName, styles.bold),
                                    children: "มูลค่ารวมภาษี"
                                })
                            }),
                            /*#__PURE__*/ _jsx(View, {
                                style: _object_spread({}, styles.tableCol20P),
                                children: /*#__PURE__*/ _jsx(Text, {
                                    style: _object_spread_props(_object_spread({}, styles.bold), {
                                        textAlign: "right"
                                    }),
                                    children: branchSum.sumIsTax ? formatNumber(branchSum.sumIsTax, 2) : 0.00
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(View, {
                        style: {
                            flexDirection: "row",
                            justifyContent: "flex-end",
                            marginBottom: 5
                        },
                        children: [
                            /*#__PURE__*/ _jsx(View, {
                                style: _object_spread({}, styles.tableCol20P),
                                children: /*#__PURE__*/ _jsx(Text, {
                                    style: styles.channelName,
                                    children: "หัก ณ ที่จ่าย"
                                })
                            }),
                            /*#__PURE__*/ _jsx(View, {
                                style: _object_spread({}, styles.tableCol20P),
                                children: /*#__PURE__*/ _jsx(Text, {
                                    style: _object_spread_props(_object_spread({}, styles.bold), {
                                        textAlign: "right"
                                    }),
                                    children: branchSum.sumVat ? formatNumber(branchSum.sumVat, 2) : 0.00
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(View, {
                        style: {
                            flexDirection: "row",
                            justifyContent: "flex-end",
                            marginBottom: 5
                        },
                        children: [
                            /*#__PURE__*/ _jsx(View, {
                                style: _object_spread({}, styles.tableCol20P),
                                children: /*#__PURE__*/ _jsx(Text, {
                                    style: _object_spread({}, styles.channelName, styles.bold),
                                    children: "มูลค่าสุทธิรวม"
                                })
                            }),
                            /*#__PURE__*/ _jsx(View, {
                                style: _object_spread({}, styles.tableCol20P),
                                children: /*#__PURE__*/ _jsx(Text, {
                                    style: _object_spread_props(_object_spread({}, styles.bold), {
                                        textAlign: "right"
                                    }),
                                    children: branchSum.sumNet ? formatNumber(branchSum.sumNet, 2) : 0.00
                                })
                            })
                        ]
                    })
                ]
            }) : "",
            data.ctAdverts && data.ctAdverts.length > 0 ? /*#__PURE__*/ _jsxs(Page, {
                size: "A4",
                style: styles.page,
                children: [
                    /*#__PURE__*/ _jsx(PDFHeader, {}),
                    /*#__PURE__*/ _jsxs(Text, {
                        style: styles.centerHeaderText,
                        children: [
                            "เอกสารแนบท้าย",
                            "\xa0",
                            "ข้อ",
                            "\xa0",
                            "2.3"
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(Text, {
                        style: styles.sectionHeader,
                        children: [
                            "2.3",
                            "\xa0",
                            "ค่าโฆษณา"
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(View, {
                        style: _object_spread_props(_object_spread({}, styles.table), {
                            marginTop: 10,
                            marginBottom: 10
                        }),
                        children: [
                            /*#__PURE__*/ _jsxs(View, {
                                style: styles.tableRow,
                                children: [
                                    /*#__PURE__*/ _jsx(View, {
                                        style: _object_spread({}, styles.tableColHeader, styles.tableCol10P),
                                        children: /*#__PURE__*/ _jsx(Text, {
                                            style: styles.tableCellHeader,
                                            children: "ลำดับ"
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(View, {
                                        style: _object_spread({}, styles.tableColHeader, styles.tableCol20P),
                                        children: /*#__PURE__*/ _jsx(Text, {
                                            style: styles.tableCellHeader,
                                            children: "ช่องทางการขาย"
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(View, {
                                        style: _object_spread({}, styles.tableColHeader, styles.tableCol15P),
                                        children: /*#__PURE__*/ _jsx(Text, {
                                            style: styles.tableCellHeader,
                                            children: "ตำแหน่งโฆษณา"
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(View, {
                                        style: _object_spread({}, styles.tableColHeader, styles.tableCol10P),
                                        children: /*#__PURE__*/ _jsxs(Text, {
                                            style: styles.tableCellHeader,
                                            children: [
                                                "จำนวน",
                                                " ",
                                                "(เดือน)"
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(View, {
                                        style: _object_spread({}, styles.tableColHeader, styles.tableCol15P),
                                        children: /*#__PURE__*/ _jsxs(Text, {
                                            style: styles.tableCellHeader,
                                            children: [
                                                "ค่าวางสินค้า",
                                                " ",
                                                "/",
                                                "\xa0",
                                                "เดือน"
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(View, {
                                        style: _object_spread({}, styles.tableColHeader, styles.tableCol15P),
                                        children: /*#__PURE__*/ _jsx(Text, {
                                            style: styles.tableCellHeader,
                                            children: "มูลค่ารวม"
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(View, {
                                        style: _object_spread({}, styles.tableColHeader, styles.tableCol15P),
                                        children: /*#__PURE__*/ _jsx(Text, {
                                            style: styles.tableCellHeader,
                                            children: "หมายเหตุ"
                                        })
                                    })
                                ]
                            }),
                            data.ctAdverts.map(function(item, index) {
                                return /*#__PURE__*/ _jsxs(View, {
                                    style: styles.tableRow,
                                    children: [
                                        /*#__PURE__*/ _jsx(View, {
                                            style: _object_spread({}, styles.tableCol, styles.tableCol10P),
                                            children: /*#__PURE__*/ _jsx(Text, {
                                                style: _object_spread_props(_object_spread({}, styles.tableCell), {
                                                    textAlign: "center"
                                                }),
                                                children: index + 1
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(View, {
                                            style: _object_spread({}, styles.tableCol, styles.tableCol20P),
                                            children: /*#__PURE__*/ _jsx(Text, {
                                                style: styles.tableCell,
                                                children: filterTextAndNum(item.set_branch_name || "", 3)
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(View, {
                                            style: _object_spread({}, styles.tableCol, styles.tableCol15P),
                                            children: /*#__PURE__*/ _jsx(Text, {
                                                style: styles.tableCell,
                                                children: filterTextAndNum(item.setAdpoint.set_adpoint_name || "", 3)
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(View, {
                                            style: _object_spread({}, styles.tableCol, styles.tableCol10P),
                                            children: /*#__PURE__*/ _jsx(Text, {
                                                style: _object_spread_props(_object_spread({}, styles.tableCell), {
                                                    textAlign: "center"
                                                }),
                                                children: filterTextAndNum(item.ct_advert_month, 1)
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(View, {
                                            style: _object_spread({}, styles.tableCol, styles.tableCol15P),
                                            children: /*#__PURE__*/ _jsx(Text, {
                                                style: _object_spread_props(_object_spread({}, styles.tableCell), {
                                                    textAlign: "right"
                                                }),
                                                children: formatNumber(item.ct_advert_cost, 2)
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(View, {
                                            style: _object_spread({}, styles.tableCol, styles.tableCol15P),
                                            children: /*#__PURE__*/ _jsx(Text, {
                                                style: _object_spread_props(_object_spread({}, styles.tableCell), {
                                                    textAlign: "right"
                                                }),
                                                children: item.ct_advert_cost && item.ct_advert_cost > 0 && item.ct_advert_month && item.ct_advert_month > 0 ? formatNumber(item.ct_advert_cost * item.ct_advert_month, 2) : formatNumber(0, 2)
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(View, {
                                            style: _object_spread({}, styles.tableCol, styles.tableCol15P),
                                            children: /*#__PURE__*/ _jsx(Text, {
                                                style: styles.tableCell,
                                                children: filterTextAndNum(item.ct_advert_remark || "", 3)
                                            })
                                        })
                                    ]
                                });
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(View, {
                        style: {
                            flexDirection: "row",
                            justifyContent: "flex-end",
                            marginBottom: 5
                        },
                        children: [
                            /*#__PURE__*/ _jsx(View, {
                                style: _object_spread({}, styles.tableCol20P),
                                children: /*#__PURE__*/ _jsx(Text, {
                                    style: _object_spread({}, styles.channelName, styles.bold),
                                    children: "มูลค่าก่อนหักส่วนลด"
                                })
                            }),
                            /*#__PURE__*/ _jsx(View, {
                                style: _object_spread({}, styles.tableCol20P),
                                children: /*#__PURE__*/ _jsx(Text, {
                                    style: _object_spread_props(_object_spread({}, styles.bold), {
                                        textAlign: "right"
                                    }),
                                    children: adsSum.sumCost ? formatNumber(adsSum.sumCost, 2) : 0.00
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(View, {
                        style: {
                            flexDirection: "row",
                            justifyContent: "flex-end",
                            marginBottom: 5
                        },
                        children: [
                            /*#__PURE__*/ _jsx(View, {
                                style: _object_spread({}, styles.tableCol20P),
                                children: /*#__PURE__*/ _jsx(Text, {
                                    style: styles.channelName,
                                    children: "ส่วนลด"
                                })
                            }),
                            /*#__PURE__*/ _jsx(View, {
                                style: _object_spread({}, styles.tableCol20P),
                                children: /*#__PURE__*/ _jsx(Text, {
                                    style: _object_spread_props(_object_spread({}, styles.bold), {
                                        textAlign: "right"
                                    }),
                                    children: adsSum.sumDiscount ? formatNumber(adsSum.sumDiscount, 2) : 0.00
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(View, {
                        style: {
                            flexDirection: "row",
                            justifyContent: "flex-end",
                            marginBottom: 5
                        },
                        children: [
                            /*#__PURE__*/ _jsx(View, {
                                style: _object_spread({}, styles.tableCol20P),
                                children: /*#__PURE__*/ _jsx(Text, {
                                    style: _object_spread({}, styles.channelName, styles.bold),
                                    children: "มูลค่าหลังหักส่วนลด"
                                })
                            }),
                            /*#__PURE__*/ _jsx(View, {
                                style: _object_spread({}, styles.tableCol20P),
                                children: /*#__PURE__*/ _jsx(Text, {
                                    style: _object_spread_props(_object_spread({}, styles.bold), {
                                        textAlign: "right"
                                    }),
                                    children: adsSum.sumPreTax ? formatNumber(adsSum.sumPreTax, 2) : 0.00
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(View, {
                        style: {
                            flexDirection: "row",
                            justifyContent: "flex-end",
                            marginBottom: 5
                        },
                        children: [
                            /*#__PURE__*/ _jsx(View, {
                                style: _object_spread({}, styles.tableCol20P),
                                children: /*#__PURE__*/ _jsx(Text, {
                                    style: styles.channelName,
                                    children: "ภาษีมูลค่าเพิ่ม"
                                })
                            }),
                            /*#__PURE__*/ _jsx(View, {
                                style: _object_spread({}, styles.tableCol20P),
                                children: /*#__PURE__*/ _jsx(Text, {
                                    style: _object_spread_props(_object_spread({}, styles.bold), {
                                        textAlign: "right"
                                    }),
                                    children: adsSum.sumTax ? formatNumber(adsSum.sumTax, 2) : 0.00
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(View, {
                        style: {
                            flexDirection: "row",
                            justifyContent: "flex-end",
                            marginBottom: 5
                        },
                        children: [
                            /*#__PURE__*/ _jsx(View, {
                                style: _object_spread({}, styles.tableCol20P),
                                children: /*#__PURE__*/ _jsx(Text, {
                                    style: _object_spread({}, styles.channelName, styles.bold),
                                    children: "มูลค่ารวมภาษี"
                                })
                            }),
                            /*#__PURE__*/ _jsx(View, {
                                style: _object_spread({}, styles.tableCol20P),
                                children: /*#__PURE__*/ _jsx(Text, {
                                    style: _object_spread_props(_object_spread({}, styles.bold), {
                                        textAlign: "right"
                                    }),
                                    children: adsSum.sumIsTax ? formatNumber(adsSum.sumIsTax, 2) : 0.00
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(View, {
                        style: {
                            flexDirection: "row",
                            justifyContent: "flex-end",
                            marginBottom: 5
                        },
                        children: [
                            /*#__PURE__*/ _jsx(View, {
                                style: _object_spread({}, styles.tableCol20P),
                                children: /*#__PURE__*/ _jsx(Text, {
                                    style: styles.channelName,
                                    children: "หัก ณ ที่จ่าย"
                                })
                            }),
                            /*#__PURE__*/ _jsx(View, {
                                style: _object_spread({}, styles.tableCol20P),
                                children: /*#__PURE__*/ _jsx(Text, {
                                    style: _object_spread_props(_object_spread({}, styles.bold), {
                                        textAlign: "right"
                                    }),
                                    children: adsSum.sumVat ? formatNumber(adsSum.sumVat, 2) : 0.00
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(View, {
                        style: {
                            flexDirection: "row",
                            justifyContent: "flex-end",
                            marginBottom: 5
                        },
                        children: [
                            /*#__PURE__*/ _jsx(View, {
                                style: _object_spread({}, styles.tableCol20P),
                                children: /*#__PURE__*/ _jsx(Text, {
                                    style: _object_spread({}, styles.channelName, styles.bold),
                                    children: "มูลค่าสุทธิรวม"
                                })
                            }),
                            /*#__PURE__*/ _jsx(View, {
                                style: _object_spread({}, styles.tableCol20P),
                                children: /*#__PURE__*/ _jsx(Text, {
                                    style: _object_spread_props(_object_spread({}, styles.bold), {
                                        textAlign: "right"
                                    }),
                                    children: adsSum.sumNet ? formatNumber(adsSum.sumNet, 2) : 0.00
                                })
                            })
                        ]
                    })
                ]
            }) : ""
        ]
    });
}
;
function SetDataFromNew() {
    var dataFrom = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, modType = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "create";
    var dataFromNew = {};
    if (dataFrom) {
        dataFromNew = {
            ct_contract_memid: dataFrom.ct_contract_memid && dataFrom.ct_contract_memid > 0 ? parseInt(dataFrom.ct_contract_memid, 10) : null,
            ct_contract_businessid: dataFrom.ct_contract_businessid && dataFrom.ct_contract_businessid > 0 ? parseInt(dataFrom.ct_contract_businessid, 10) : null,
            ct_contract_busbankid: dataFrom.ct_contract_busbankid && dataFrom.ct_contract_busbankid > 0 ? parseInt(dataFrom.ct_contract_busbankid, 10) : null,
            ct_contract_code: dataFrom.ct_contract_code && dataFrom.ct_contract_code != "" && dataFrom.ct_contract_code != null ? dataFrom.ct_contract_code.trim() : null,
            ct_contract_businesstype: dataFrom.ct_contract_businesstype && dataFrom.ct_contract_businesstype > 0 ? parseInt(dataFrom.ct_contract_businesstype, 10) : null,
            ct_contract_taxid: dataFrom.ct_contract_taxid && dataFrom.ct_contract_taxid != "" && dataFrom.ct_contract_taxid != null ? dataFrom.ct_contract_taxid.trim() : null,
            ct_contract_categoryid: dataFrom.ct_contract_categoryid && dataFrom.ct_contract_categoryid > 0 ? parseInt(dataFrom.ct_contract_categoryid, 10) : null,
            ct_contract_comprefixid: dataFrom.ct_contract_comprefixid && dataFrom.ct_contract_comprefixid > 0 ? parseInt(dataFrom.ct_contract_comprefixid, 10) : null,
            ct_contract_comprefixname: dataFrom.ct_contract_comprefixname && dataFrom.ct_contract_comprefixname != "" && dataFrom.ct_contract_comprefixname != null ? dataFrom.ct_contract_comprefixname.trim() : null,
            ct_contract_name: dataFrom.ct_contract_name && dataFrom.ct_contract_name != "" && dataFrom.ct_contract_name != null ? dataFrom.ct_contract_name.trim() : null,
            ct_contract_suffixname: dataFrom.ct_contract_suffixname && dataFrom.ct_contract_suffixname != "" && dataFrom.ct_contract_suffixname != null ? dataFrom.ct_contract_suffixname.trim() : null,
            ct_contract_vatcode: dataFrom.ct_contract_vatcode && dataFrom.ct_contract_vatcode != "" && dataFrom.ct_contract_vatcode != null ? dataFrom.ct_contract_vatcode.trim() : null,
            ct_contract_branchname: dataFrom.ct_contract_branchname && dataFrom.ct_contract_branchname != "" && dataFrom.ct_contract_branchname != null ? dataFrom.ct_contract_branchname.trim() : null,
            ct_contract_prefixid: dataFrom.ct_contract_prefixid && dataFrom.ct_contract_prefixid > 0 ? parseInt(dataFrom.ct_contract_prefixid, 10) : null,
            ct_contract_fname: dataFrom.ct_contract_fname && dataFrom.ct_contract_fname != "" && dataFrom.ct_contract_fname != null ? dataFrom.ct_contract_fname.trim() : null,
            ct_contract_lname: dataFrom.ct_contract_lname && dataFrom.ct_contract_lname != "" && dataFrom.ct_contract_lname != null ? dataFrom.ct_contract_lname.trim() : null,
            ct_contract_address: dataFrom.ct_contract_address && dataFrom.ct_contract_address != "" && dataFrom.ct_contract_address != null ? dataFrom.ct_contract_address.trim() : null,
            ct_contract_provinceid: dataFrom.ct_contract_provinceid && dataFrom.ct_contract_provinceid > 0 ? parseInt(dataFrom.ct_contract_provinceid, 10) : null,
            ct_contract_subprovinceid: dataFrom.ct_contract_subprovinceid && dataFrom.ct_contract_subprovinceid > 0 ? parseInt(dataFrom.ct_contract_subprovinceid, 10) : null,
            ct_contract_districtid: dataFrom.ct_contract_districtid && dataFrom.ct_contract_districtid > 0 ? parseInt(dataFrom.ct_contract_districtid, 10) : null,
            ct_contract_zipcodeid: dataFrom.ct_contract_zipcodeid && dataFrom.ct_contract_zipcodeid != "" && dataFrom.ct_contract_zipcodeid != null ? dataFrom.ct_contract_zipcodeid.trim() : null,
            ct_contract_mainfname: dataFrom.ct_contract_mainfname && dataFrom.ct_contract_mainfname != "" && dataFrom.ct_contract_mainfname != null ? dataFrom.ct_contract_mainfname.trim() : null,
            ct_contract_mainlname: dataFrom.ct_contract_mainlname && dataFrom.ct_contract_mainlname != "" && dataFrom.ct_contract_mainlname != null ? dataFrom.ct_contract_mainlname.trim() : null,
            ct_contract_mainphone: dataFrom.ct_contract_mainphone && dataFrom.ct_contract_mainphone != "" && dataFrom.ct_contract_mainphone != null ? dataFrom.ct_contract_mainphone.trim() : null,
            ct_contract_mainemail: dataFrom.ct_contract_mainemail && dataFrom.ct_contract_mainemail != "" && dataFrom.ct_contract_mainemail != null ? dataFrom.ct_contract_mainemail.trim() : null,
            ct_contract_bankid: dataFrom.ct_contract_bankid && dataFrom.ct_contract_bankid > 0 ? parseInt(dataFrom.ct_contract_bankid, 10) : null,
            ct_contract_branchn: dataFrom.ct_contract_branchn && dataFrom.ct_contract_branchn != "" && dataFrom.ct_contract_branchn != null ? dataFrom.ct_contract_branchn.trim() : null,
            ct_contract_accountname: dataFrom.ct_contract_accountname && dataFrom.ct_contract_accountname != "" && dataFrom.ct_contract_accountname != null ? dataFrom.ct_contract_accountname.trim() : null,
            ct_contract_accountno: dataFrom.ct_contract_accountno && dataFrom.ct_contract_accountno != "" && dataFrom.ct_contract_accountno != null ? dataFrom.ct_contract_accountno.trim() : null,
            ct_contract_duration: dataFrom.ct_contract_duration && dataFrom.ct_contract_duration > 0 ? parseInt(dataFrom.ct_contract_duration, 10) : null,
            ct_contract_startdate: dataFrom.ct_contract_startdate && dataFrom.ct_contract_startdate != "" && dataFrom.ct_contract_startdate != null ? dataFrom.ct_contract_startdate.trim() : null,
            ct_contract_enddate: dataFrom.ct_contract_enddate && dataFrom.ct_contract_enddate != "" && dataFrom.ct_contract_enddate != null ? dataFrom.ct_contract_enddate.trim() : null,
            ct_contract_initialcoststatus: dataFrom.ct_contract_initialcoststatus && dataFrom.ct_contract_initialcoststatus > 0 ? parseInt(dataFrom.ct_contract_initialcoststatus, 10) : null,
            ct_contract_initialcosttype: dataFrom.ct_contract_initialcosttype && dataFrom.ct_contract_initialcosttype > 0 ? parseInt(dataFrom.ct_contract_initialcosttype, 10) : null,
            ct_contract_initialcostsku: dataFrom.ct_contract_initialcostsku && dataFrom.ct_contract_initialcostsku > 0 ? parseFloat(dataFrom.ct_contract_initialcostsku) : 0,
            ct_contract_pdinitalcost: dataFrom.ct_contract_pdinitalcost && dataFrom.ct_contract_pdinitalcost > 0 ? parseFloat(dataFrom.ct_contract_pdinitalcost) : parseFloat(0),
            ct_contract_pddiscount: dataFrom.ct_contract_pddiscount && dataFrom.ct_contract_pddiscount > 0 ? parseFloat(dataFrom.ct_contract_pddiscount) : parseFloat(0),
            ct_contract_pdtax: dataFrom.ct_contract_pdtax && dataFrom.ct_contract_pdtax > 0 ? parseFloat(dataFrom.ct_contract_pdtax) : parseFloat(0),
            ct_contract_pdpretax: dataFrom.ct_contract_pdpretax && dataFrom.ct_contract_pdpretax > 0 ? parseFloat(dataFrom.ct_contract_pdpretax) : parseFloat(0),
            ct_contract_pdnet: dataFrom.ct_contract_pdnet && dataFrom.ct_contract_pdnet > 0 ? parseFloat(dataFrom.ct_contract_pdnet) : parseFloat(0),
            ct_contract_paytype: dataFrom.ct_contract_paytype && dataFrom.ct_contract_paytype > 0 ? parseInt(dataFrom.ct_contract_paytype, 10) : null,
            ct_contract_placementstatus: dataFrom.ct_contract_placementstatus && dataFrom.ct_contract_placementstatus > 0 ? parseInt(dataFrom.ct_contract_placementstatus, 10) : null,
            ct_contract_placementtype: dataFrom.ct_contract_placementtype && dataFrom.ct_contract_placementtype > 0 ? parseInt(dataFrom.ct_contract_placementtype, 10) : null,
            ct_contract_placementsku: dataFrom.ct_contract_placementsku && dataFrom.ct_contract_placementsku > 0 ? parseFloat(dataFrom.ct_contract_placementsku) : parseFloat(0),
            ct_contract_plmmonth: dataFrom.ct_contract_plmmonth && dataFrom.ct_contract_plmmonth > 0 ? parseInt(dataFrom.ct_contract_plmmonth, 10) : null,
            ct_contract_plmcost: dataFrom.ct_contract_plmcost && dataFrom.ct_contract_plmcost > 0 ? parseFloat(dataFrom.ct_contract_plmcost) : parseFloat(0),
            ct_contract_plmdiscount: dataFrom.ct_contract_plmdiscount && dataFrom.ct_contract_plmdiscount > 0 ? parseFloat(dataFrom.ct_contract_plmdiscount) : parseFloat(0),
            ct_contract_plmtax: dataFrom.ct_contract_plmtax && dataFrom.ct_contract_plmtax > 0 ? parseFloat(dataFrom.ct_contract_plmtax) : parseFloat(0),
            ct_contract_plmpretax: dataFrom.ct_contract_plmpretax && dataFrom.ct_contract_plmpretax > 0 ? parseFloat(dataFrom.ct_contract_plmpretax) : parseFloat(0),
            ct_contract_plmnet: dataFrom.ct_contract_plmnet && dataFrom.ct_contract_plmnet > 0 ? parseFloat(dataFrom.ct_contract_plmnet) : parseFloat(0),
            ct_contract_advertstatus: dataFrom.ct_contract_advertstatus && dataFrom.ct_contract_advertstatus > 0 ? parseInt(dataFrom.ct_contract_advertstatus, 10) : null,
            ct_contract_adverttype: dataFrom.ct_contract_adverttype && dataFrom.ct_contract_adverttype > 0 ? parseInt(dataFrom.ct_contract_adverttype, 10) : null,
            ct_contract_advertsku: dataFrom.ct_contract_advertsku && dataFrom.ct_contract_advertsku > 0 ? parseFloat(dataFrom.ct_contract_advertsku) : parseFloat(0),
            ct_contract_admonth: dataFrom.ct_contract_admonth && dataFrom.ct_contract_admonth > 0 ? parseInt(dataFrom.ct_contract_admonth, 10) : 0,
            ct_contract_adost: dataFrom.ct_contract_adost && dataFrom.ct_contract_adost > 0 ? parseFloat(dataFrom.ct_contract_adost) : parseFloat(0),
            ct_contract_addiscount: dataFrom.ct_contract_addiscount && dataFrom.ct_contract_addiscount > 0 ? parseFloat(dataFrom.ct_contract_addiscount) : parseFloat(0),
            ct_contract_adtax: dataFrom.ct_contract_adtax && dataFrom.ct_contract_adtax > 0 ? parseFloat(dataFrom.ct_contract_adtax) : parseFloat(0),
            ct_contract_adpretax: dataFrom.ct_contract_adpretax && dataFrom.ct_contract_adpretax > 0 ? parseFloat(dataFrom.ct_contract_adpretax) : parseFloat(0),
            ct_contract_adnet: dataFrom.ct_contract_adnet && dataFrom.ct_contract_adnet > 0 ? parseFloat(dataFrom.ct_contract_adnet) : parseFloat(0),
            ct_contract_salescomm: dataFrom.ct_contract_salescomm && dataFrom.ct_contract_salescomm > 0 ? parseFloat(dataFrom.ct_contract_salescomm) : parseFloat(0),
            ct_contract_wholesalescomm: dataFrom.ct_contract_wholesalescomm && dataFrom.ct_contract_wholesalescomm > 0 ? parseFloat(dataFrom.ct_contract_wholesalescomm) : parseFloat(0),
            ct_contract_additional: dataFrom.ct_contract_additional && dataFrom.ct_contract_additional != "" && dataFrom.ct_contract_additional != null ? dataFrom.ct_contract_additional.trim() : null,
            ct_contract_status: dataFrom.ct_contract_status && dataFrom.ct_contract_status > 0 ? parseInt(dataFrom.ct_contract_status, 10) : null,
            ct_contract_approveid: dataFrom.ct_contract_approveid && dataFrom.ct_contract_approveid > 0 ? parseInt(dataFrom.ct_contract_approveid, 10) : null,
            ct_contract_approvedate: dataFrom.ct_contract_approvedate && dataFrom.ct_contract_approvedate != "" && dataFrom.ct_contract_approvedate != null ? dataFrom.ct_contract_approvedate.trim() : null,
            ct_contract_crebyid: dataFrom.ct_contract_crebyid && dataFrom.ct_contract_crebyid > 0 ? parseInt(dataFrom.ct_contract_crebyid, 10) : null,
            ct_contract_credate: dataFrom.ct_contract_credate && dataFrom.ct_contract_credate != "" && dataFrom.ct_contract_credate != null ? dataFrom.ct_contract_credate.trim() : null,
            ct_contract_updatebyid: dataFrom.ct_contract_updatebyid && dataFrom.ct_contract_updatebyid > 0 ? parseInt(dataFrom.ct_contract_updatebyid, 10) : null,
            ct_contract_updatedate: dataFrom.ct_contract_updatedate && dataFrom.ct_contract_updatedate != "" && dataFrom.ct_contract_updatedate != null ? dataFrom.ct_contract_updatedate.trim() : null,
            ct_contract_totallist: dataFrom.ct_contract_totallist && dataFrom.ct_contract_totallist > 0 ? parseInt(dataFrom.ct_contract_totallist, 10) : null,
            ct_contract_brandid: dataFrom.ct_contract_brandid && dataFrom.ct_contract_brandid > 0 ? parseInt(dataFrom.ct_contract_brandid, 10) : null,
            ct_products: dataFrom.ct_products && dataFrom.ct_products.length > 0 ? dataFrom.ct_products : [],
            ct_placements: dataFrom.ct_placements && dataFrom.ct_placements.length > 0 ? dataFrom.ct_placements : [],
            ct_adverts: dataFrom.ct_adverts && dataFrom.ct_adverts.length > 0 ? dataFrom.ct_adverts : [],
            ct_bank: dataFrom.ct_bank && dataFrom.ct_bank.length > 0 ? dataFrom.ct_bank : []
        };
        if (modType && modType === "updated") {
            dataFromNew = _object_spread_props(_object_spread({}, dataFromNew), {
                ct_contract_id: dataFrom.ct_contract_id && dataFrom.ct_contract_id > 0 ? parseInt(dataFrom.ct_contract_id, 10) : null,
                qr_quotation_id: dataFrom.qr_quotation_id && dataFrom.qr_quotation_id > 0 ? parseInt(dataFrom.qr_quotation_id, 10) : null,
                qr_quotation_code: dataFrom.qr_quotation_code && dataFrom.qr_quotation_code != "" && dataFrom.qr_quotation_code != null ? dataFrom.qr_quotation_code.trim() : null,
                ct_products_delete: dataFrom.ct_products_delete && dataFrom.ct_products_delete.length > 0 ? dataFrom.ct_products_delete : [],
                ct_placements_delete: dataFrom.ct_placements_delete && dataFrom.ct_placements_delete.length > 0 ? dataFrom.ct_placements_delete : [],
                ct_adverts_delete: dataFrom.ct_adverts_delete && dataFrom.ct_adverts_delete.length > 0 ? dataFrom.ct_adverts_delete : [],
                ct_bank_delete: dataFrom.ct_bank_delete && dataFrom.ct_bank_delete.length > 0 ? dataFrom.ct_bank_delete : []
            });
        }
    }
    return dataFromNew;
}
function SumCtAdvert() {
    var ctAdverts = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    var sumMonth = 0;
    var sumCost = 0;
    var sumInitalCost = 0;
    var sumDiscount = 0;
    var sumTax = 0;
    var sumPreTax = 0;
    var sumIsTax = 0;
    var sumVat = 0;
    var sumNet = 0;
    if (ctAdverts && ctAdverts.length > 0) {
        ctAdverts.map(function(item, index) {
            var monthAmount = 0;
            var costVale = 0;
            var pretax = 0;
            var taxVale = 0;
            var vatVale = 0;
            var netVale = 0;
            var isTaxVale = 0;
            if (item.ct_advert_month && item.ct_advert_month > 0) {
                monthAmount = parseInt(item.ct_advert_month, 10);
            } else {
                monthAmount = 0;
            }
            if (item.ct_advert_cost && item.ct_advert_cost > 0 && monthAmount > 0) {
                costVale = parseFloat(item.ct_advert_cost) * parseFloat(monthAmount);
                if (item.ct_advert_discount && item.ct_advert_discount > 0) {
                    pretax = parseFloat(item.ct_advert_cost) * parseFloat(monthAmount) - parseFloat(item.ct_advert_discount);
                } else {
                    pretax = parseFloat(item.ct_advert_cost) * parseFloat(monthAmount);
                }
                if (item.ct_advert_tax && item.ct_advert_tax > 0) {
                    taxVale = parseFloat(pretax) * parseFloat(item.ct_advert_tax) / 100;
                } else {
                    taxVale = 0;
                }
                if (item.ct_advert_vat && item.ct_advert_vat > 0) {
                    vatVale = parseFloat(pretax) * parseFloat(item.ct_advert_vat) / 100;
                    netVale = parseFloat(pretax - vatVale + taxVale);
                } else {
                    vatVale = 0;
                    netVale = parseFloat(pretax + taxVale);
                }
                isTaxVale = parseFloat(pretax + taxVale);
            } else {
                costVale = 0;
                pretax = 0;
                taxVale = 0;
                vatVale = 0;
                netVale = 0;
                isTaxVale = 0;
            }
            if (monthAmount && monthAmount > 0) {
                sumMonth += parseInt(monthAmount, 10);
            }
            if (costVale && costVale > 0) {
                sumCost += parseFloat(costVale);
            }
            if (isTaxVale && isTaxVale > 0) {
                sumIsTax += parseFloat(isTaxVale);
            }
            if (item.ct_advert_cost && item.ct_advert_cost > 0) {
                sumInitalCost += parseFloat(item.ct_advert_cost);
            }
            if (item.ct_advert_discount && item.ct_advert_discount > 0) {
                sumDiscount += parseFloat(item.ct_advert_discount);
            }
            if (taxVale && taxVale > 0) {
                sumTax += parseFloat(taxVale);
            }
            if (pretax && pretax > 0) {
                sumPreTax += parseFloat(pretax);
            }
            if (vatVale && vatVale > 0) {
                sumVat += parseFloat(vatVale);
            }
            if (netVale && netVale > 0) {
                sumNet += parseFloat(netVale);
            }
        });
    }
    return {
        sumMonth: parseInt(sumMonth),
        sumCost: parseFloat(sumCost),
        sumInitalCost: parseFloat(sumInitalCost),
        sumDiscount: parseFloat(sumDiscount),
        sumTax: parseFloat(sumTax),
        sumPreTax: parseFloat(sumPreTax),
        sumIsTax: parseFloat(sumIsTax),
        sumVat: parseFloat(sumVat),
        sumNet: parseFloat(sumNet)
    };
}
function SumCtPlacements() {
    var ctPlacements = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    var sumMonth = 0;
    var sumCost = 0;
    var sumInitalCost = 0;
    var sumDiscount = 0;
    var sumTax = 0;
    var sumPreTax = 0;
    var sumIsTax = 0;
    var sumVat = 0;
    var sumNet = 0;
    if (ctPlacements && ctPlacements.length > 0) {
        ctPlacements.map(function(item, index) {
            var monthAmount = 0;
            var costVale = 0;
            var pretax = 0;
            var taxVale = 0;
            var vatVale = 0;
            var netVale = 0;
            var isTaxVale = 0;
            if (item.ct_placement_month && item.ct_placement_month > 0) {
                monthAmount = parseInt(item.ct_placement_month, 10);
            } else {
                monthAmount = 0;
            }
            if (item.ct_placement_cost && item.ct_placement_cost > 0 && monthAmount > 0) {
                costVale = parseFloat(item.ct_placement_cost) * parseFloat(monthAmount);
                if (item.ct_placement_discount && item.ct_placement_discount > 0) {
                    pretax = parseFloat(item.ct_placement_cost) * parseFloat(monthAmount) - parseFloat(item.ct_placement_discount);
                } else {
                    pretax = parseFloat(item.ct_placement_cost) * parseFloat(monthAmount);
                }
                if (item.ct_placement_tax && item.ct_placement_tax > 0) {
                    taxVale = parseFloat(pretax) * parseFloat(item.ct_placement_tax) / 100;
                } else {
                    taxVale = 0;
                }
                if (item.ct_placement_vat && item.ct_placement_vat > 0) {
                    vatVale = parseFloat(pretax) * parseFloat(item.ct_placement_vat) / 100;
                    netVale = parseFloat(pretax - vatVale + taxVale);
                } else {
                    vatVale = 0;
                    netVale = parseFloat(pretax + taxVale);
                }
                isTaxVale = parseFloat(pretax + taxVale);
            } else {
                costVale = 0;
                pretax = 0;
                taxVale = 0;
                vatVale = 0;
                netVale = 0;
                isTaxVale = 0;
            }
            if (monthAmount && monthAmount > 0) {
                sumMonth += parseInt(monthAmount, 10);
            }
            if (costVale && costVale > 0) {
                sumCost += parseFloat(costVale);
            }
            if (isTaxVale && isTaxVale > 0) {
                sumIsTax += parseFloat(isTaxVale);
            }
            if (item.ct_placement_cost && item.ct_placement_cost > 0) {
                sumInitalCost += parseFloat(item.ct_placement_cost);
            }
            if (item.ct_placement_discount && item.ct_placement_discount > 0) {
                sumDiscount += parseFloat(item.ct_placement_discount);
            }
            if (taxVale && taxVale > 0) {
                sumTax += parseFloat(taxVale);
            }
            if (pretax && pretax > 0) {
                sumPreTax += parseFloat(pretax);
            }
            if (vatVale && vatVale > 0) {
                sumVat += parseFloat(vatVale);
            }
            if (netVale && netVale > 0) {
                sumNet += parseFloat(netVale);
            }
        });
    }
    return {
        sumMonth: parseInt(sumMonth),
        sumCost: parseFloat(sumCost),
        sumInitalCost: parseFloat(sumInitalCost),
        sumDiscount: parseFloat(sumDiscount),
        sumTax: parseFloat(sumTax),
        sumPreTax: parseFloat(sumPreTax),
        sumIsTax: parseFloat(sumIsTax),
        sumVat: parseFloat(sumVat),
        sumNet: parseFloat(sumNet)
    };
}
function SumCtProducts() {
    var ctProducts = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    var productAmount = 0;
    var sumCost = 0;
    var sumInitalCost = 0;
    var sumDiscount = 0;
    var sumTax = 0;
    var sumPreTax = 0;
    var sumIsTax = 0;
    var sumVat = 0;
    var sumNet = 0;
    if (ctProducts && ctProducts.length > 0) {
        productAmount = ctProducts.length;
        ctProducts.map(function(item, index) {
            var costVale = 0;
            var pretax = 0;
            var taxVale = 0;
            var vatVale = 0;
            var netVale = 0;
            var isTaxVale = 0;
            if (item.ct_product_initalcost && item.ct_product_initalcost > 0) {
                costVale = parseFloat(item.ct_product_initalcost);
                if (item.ct_product_discount && item.ct_product_discount > 0) {
                    pretax = parseFloat(item.ct_product_initalcost) - parseFloat(item.ct_product_discount);
                } else {
                    pretax = parseFloat(item.ct_product_initalcost);
                }
                if (item.ct_product_tax && item.ct_product_tax > 0) {
                    taxVale = parseFloat(pretax) * parseFloat(item.ct_product_tax) / 100;
                } else {
                    taxVale = 0;
                }
                if (item.ct_product_vat && item.ct_product_vat > 0) {
                    vatVale = parseFloat(pretax) * parseFloat(item.ct_product_vat) / 100;
                    netVale = parseFloat(pretax - vatVale + taxVale);
                } else {
                    vatVale = 0;
                    netVale = parseFloat(pretax + taxVale);
                }
                isTaxVale = parseFloat(pretax + taxVale);
            } else {
                costVale = 0;
                pretax = 0;
                taxVale = 0;
                vatVale = 0;
                netVale = 0;
                isTaxVale = 0;
            }
            if (costVale && costVale > 0) {
                sumCost += parseFloat(costVale);
            }
            if (isTaxVale && isTaxVale > 0) {
                sumIsTax += parseFloat(isTaxVale);
            }
            if (item.ct_product_initalcost && item.ct_product_initalcost > 0) {
                sumInitalCost += parseFloat(item.ct_product_initalcost);
            }
            if (item.ct_product_discount && item.ct_product_discount > 0) {
                sumDiscount += parseFloat(item.ct_product_discount);
            }
            if (taxVale && taxVale > 0) {
                sumTax += parseFloat(taxVale);
            }
            if (pretax && pretax > 0) {
                sumPreTax += parseFloat(pretax);
            }
            if (vatVale && vatVale > 0) {
                sumVat += parseFloat(vatVale);
            }
            if (netVale && netVale > 0) {
                sumNet += parseFloat(netVale);
            }
        });
    }
    return {
        productAmount: parseInt(productAmount),
        sumCost: parseFloat(sumCost),
        sumInitalCost: parseFloat(sumInitalCost),
        sumDiscount: parseFloat(sumDiscount),
        sumTax: parseFloat(sumTax),
        sumPreTax: parseFloat(sumPreTax),
        sumIsTax: parseFloat(sumIsTax),
        sumVat: parseFloat(sumVat),
        sumNet: parseFloat(sumNet)
    };
}
function ReDataSaveNew() {
    var dataSave = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null, bankInfoSl = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    var dataFromNew = {};
    var selectBankTrue = [];
    var selectBankDel = [];
    if (dataSave) {
        if (dataSave.ct_bank && dataSave.ct_bank.length > 0) {
            dataSave.ct_bank.map(function(item) {
                var findBank = bankInfoSl.find(function(bank) {
                    return bank.ct_bank_busbankid == item.ct_bank_busbankid;
                });
                if (findBank) {
                    selectBankTrue.push(_object_spread_props(_object_spread({}, item), {
                        ct_bank_id: findBank.ct_bank_id
                    }));
                } else {
                    selectBankTrue.push(_object_spread({}, item));
                }
            });
        }
        if (bankInfoSl && bankInfoSl.length > 0) {
            bankInfoSl.map(function(item) {
                if (item.ct_bank_id && item.ct_bank_id > 0) {
                    var findBank = dataSave.ct_bank.find(function(bank) {
                        return bank.ct_bank_busbankid == item.ct_bank_busbankid;
                    });
                    if (!findBank) {
                        selectBankDel.push({
                            ct_bank_id: item.ct_bank_id
                        });
                    }
                }
            });
        }
        dataFromNew = _object_spread_props(_object_spread({}, dataSave), {
            ct_bank: selectBankTrue && selectBankTrue.length > 0 ? selectBankTrue : dataSave.ct_bank,
            ct_bank_delete: selectBankDel
        });
    }
    return dataFromNew;
}
function NotifyModal(_param) {
    var hTitle = _param.hTitle, msgText = _param.msgText, props = _object_without_properties(_param, [
        "hTitle",
        "msgText"
    ]);
    var rest = _extends({}, _object_destructuring_empty(props));
    var contractID = useParams().contractID;
    var heightM = rest.heightM || 0;
    var handleChange = function(e) {};
    var handleClick = function() {};
    var handleClose = function() {
        return props.onHide();
    };
    return /*#__PURE__*/ _jsxs(Modal, _object_spread_props(_object_spread({}, rest), {
        backdrop: "static",
        keyboard: false,
        "aria-labelledby": "contained-modal-title-vcenter",
        centered: true,
        children: [
            /*#__PURE__*/ _jsx(Modal.Header, {
                closeButton: true,
                className: "modal-header-danger",
                children: /*#__PURE__*/ _jsx(Modal.Title, {
                    children: hTitle && hTitle != "" ? hTitle : "หัวข้อความแจ้งเตือน"
                })
            }),
            /*#__PURE__*/ _jsx(Modal.Body, {
                children: /*#__PURE__*/ _jsx("div", {
                    className: "pt-4 text-break",
                    style: {
                        fontSize: "22px",
                        color: "#2F4858",
                        overflowY: "auto",
                        height: heightM && heightM > 0 ? heightM : 300
                    },
                    dangerouslySetInnerHTML: {
                        __html: msgText && msgText != "" ? msgText : "ข้อความแจ้งเตือน"
                    }
                })
            }),
            /*#__PURE__*/ _jsx(Modal.Footer, {
                children: /*#__PURE__*/ _jsx(Button, {
                    variant: "outline-secondary",
                    onClick: handleClose,
                    children: "ยืนยัน"
                })
            })
        ]
    }));
}
